

import { ITABLE_MAIN } from './types';

/**
 * Code generated from @lazy-cjk/jp-table-comparison;
 * DO NOT EDIT.
 * @see {@link @lazy-cjk/jp-table-comparison}
 */

export const TABLE_KEYS = [
	"jp",
	"zht",
	"zhs"
] as const;

/**
 * Code generated from @lazy-cjk/jp-table-comparison;
 * DO NOT EDIT.
 * @see {@link @lazy-cjk/jp-table-comparison}
 */

export const TABLE: ITABLE_MAIN = {
	"jp": {
		"会": {
			"jp": "会",
			"zht": "會",
			"zhs": "会"
		},
		"箋": {
			"jp": "箋",
			"zht": "箋",
			"zhs": "笺"
		},
		"網": {
			"jp": "網",
			"zht": "網",
			"zhs": "网"
		},
		"処": {
			"jp": "処",
			"zht": "處",
			"zhs": "处"
		},
		"話": {
			"jp": "話",
			"zht": "話",
			"zhs": "话"
		},
		"駄": {
			"jp": "駄",
			"zht": "馱",
			"zhs": "驮"
		},
		"馱": {
			"jp": "馱",
			"zht": "馱",
			"zhs": "驮"
		},
		"万": {
			"jp": "万",
			"zht": "萬",
			"zhs": "万"
		},
		"与": {
			"jp": "与",
			"zht": "與",
			"zhs": "与"
		},
		"醜": {
			"jp": "醜",
			"zht": "醜",
			"zhs": "丑"
		},
		"専": {
			"jp": "専",
			"zht": "專",
			"zhs": "专"
		},
		"業": {
			"jp": "業",
			"zht": "業",
			"zhs": "业"
		},
		"東": {
			"jp": "東",
			"zht": "東",
			"zhs": "东"
		},
		"絲": {
			"jp": "絲",
			"zht": "絲",
			"zhs": "丝"
		},
		"糸": {
			"jp": "糸",
			"zht": "絲",
			"zhs": "丝"
		},
		"両": {
			"jp": "両",
			"zht": "兩",
			"zhs": "两"
		},
		"厳": {
			"jp": "厳",
			"zht": "嚴",
			"zhs": "严"
		},
		"並": {
			"jp": "並",
			"zht": "並",
			"zhs": "并"
		},
		"喪": {
			"jp": "喪",
			"zht": "喪",
			"zhs": "丧"
		},
		"個": {
			"jp": "個",
			"zht": "個",
			"zhs": "个"
		},
		"豊": {
			"jp": "豊",
			"zht": "豐",
			"zhs": "丰"
		},
		"臨": {
			"jp": "臨",
			"zht": "臨",
			"zhs": "临"
		},
		"為": {
			"jp": "為",
			"zht": "為",
			"zhs": "为"
		},
		"麗": {
			"jp": "麗",
			"zht": "麗",
			"zhs": "丽"
		},
		"挙": {
			"jp": "挙",
			"zht": "舉",
			"zhs": "举"
		},
		"廼": {
			"jp": "廼",
			"zht": "迺",
			"zhs": "迺"
		},
		"義": {
			"jp": "義",
			"zht": "義",
			"zhs": "义"
		},
		"楽": {
			"jp": "楽",
			"zht": "樂",
			"zhs": "乐"
		},
		"乗": {
			"jp": "乗",
			"zht": "乘",
			"zhs": "乘"
		},
		"習": {
			"jp": "習",
			"zht": "習",
			"zhs": "习"
		},
		"郷": {
			"jp": "郷",
			"zht": "鄉",
			"zhs": "乡"
		},
		"書": {
			"jp": "書",
			"zht": "書",
			"zhs": "书"
		},
		"買": {
			"jp": "買",
			"zht": "買",
			"zhs": "买"
		},
		"乱": {
			"jp": "乱",
			"zht": "亂",
			"zhs": "乱"
		},
		"乾": {
			"jp": "乾",
			"zht": "乾",
			"zhs": "干"
		},
		"亀": {
			"jp": "亀",
			"zht": "龜",
			"zhs": "龟"
		},
		"予": {
			"jp": "予",
			"zht": "預",
			"zhs": "预"
		},
		"弐": {
			"jp": "弐",
			"zht": "貳",
			"zhs": "贰"
		},
		"雲": {
			"jp": "雲",
			"zht": "雲",
			"zhs": "云"
		},
		"亜": {
			"jp": "亜",
			"zht": "亞",
			"zhs": "亚"
		},
		"産": {
			"jp": "産",
			"zht": "產",
			"zhs": "产"
		},
		"畝": {
			"jp": "畝",
			"zht": "畝",
			"zhs": "亩"
		},
		"親": {
			"jp": "親",
			"zht": "親",
			"zhs": "亲"
		},
		"億": {
			"jp": "億",
			"zht": "億",
			"zhs": "亿"
		},
		"僕": {
			"jp": "僕",
			"zht": "僕",
			"zhs": "仆"
		},
		"従": {
			"jp": "従",
			"zht": "從",
			"zhs": "从"
		},
		"仏": {
			"jp": "仏",
			"zht": "佛",
			"zhs": "佛"
		},
		"倉": {
			"jp": "倉",
			"zht": "倉",
			"zhs": "仓"
		},
		"儀": {
			"jp": "儀",
			"zht": "儀",
			"zhs": "仪"
		},
		"仮": {
			"jp": "仮",
			"zht": "假",
			"zhs": "假"
		},
		"価": {
			"jp": "価",
			"zht": "價",
			"zhs": "价"
		},
		"衆": {
			"jp": "衆",
			"zht": "眾",
			"zhs": "众"
		},
		"優": {
			"jp": "優",
			"zht": "優",
			"zhs": "优"
		},
		"伝": {
			"jp": "伝",
			"zht": "傳",
			"zhs": "传"
		},
		"傘": {
			"jp": "傘",
			"zht": "傘",
			"zhs": "伞"
		},
		"偉": {
			"jp": "偉",
			"zht": "偉",
			"zhs": "伟"
		},
		"傷": {
			"jp": "傷",
			"zht": "傷",
			"zhs": "伤"
		},
		"倫": {
			"jp": "倫",
			"zht": "倫",
			"zhs": "伦"
		},
		"偽": {
			"jp": "偽",
			"zht": "偽",
			"zhs": "伪"
		},
		"体": {
			"jp": "体",
			"zht": "體",
			"zhs": "体"
		},
		"余": {
			"jp": "余",
			"zht": "餘",
			"zhs": "余"
		},
		"来": {
			"jp": "来",
			"zht": "來",
			"zhs": "来"
		},
		"偵": {
			"jp": "偵",
			"zht": "偵",
			"zhs": "侦"
		},
		"側": {
			"jp": "側",
			"zht": "側",
			"zhs": "侧"
		},
		"倹": {
			"jp": "倹",
			"zht": "儉",
			"zhs": "俭"
		},
		"倶": {
			"jp": "倶",
			"zht": "俱",
			"zhs": "俱"
		},
		"債": {
			"jp": "債",
			"zht": "債",
			"zhs": "债"
		},
		"傾": {
			"jp": "傾",
			"zht": "傾",
			"zhs": "倾"
		},
		"償": {
			"jp": "償",
			"zht": "償",
			"zhs": "偿"
		},
		"傑": {
			"jp": "傑",
			"zht": "傑",
			"zhs": "杰"
		},
		"備": {
			"jp": "備",
			"zht": "備",
			"zhs": "备"
		},
		"当": {
			"jp": "当",
			"zht": "當",
			"zhs": "当"
		},
		"尽": {
			"jp": "尽",
			"zht": "盡",
			"zhs": "尽"
		},
		"児": {
			"jp": "児",
			"zht": "兒",
			"zhs": "儿"
		},
		"党": {
			"jp": "党",
			"zht": "黨",
			"zhs": "党"
		},
		"内": {
			"jp": "内",
			"zht": "內",
			"zhs": "内"
		},
		"関": {
			"jp": "関",
			"zht": "關",
			"zhs": "关"
		},
		"興": {
			"jp": "興",
			"zht": "興",
			"zhs": "兴"
		},
		"養": {
			"jp": "養",
			"zht": "養",
			"zhs": "养"
		},
		"獣": {
			"jp": "獣",
			"zht": "獸",
			"zhs": "兽"
		},
		"円": {
			"jp": "円",
			"zht": "圓",
			"zhs": "圆"
		},
		"写": {
			"jp": "写",
			"zht": "寫",
			"zhs": "写"
		},
		"軍": {
			"jp": "軍",
			"zht": "軍",
			"zhs": "军"
		},
		"農": {
			"jp": "農",
			"zht": "農",
			"zhs": "农"
		},
		"冨": {
			"jp": "冨",
			"zht": "富",
			"zhs": "富"
		},
		"氷": {
			"jp": "氷",
			"zht": "冰",
			"zhs": "冰"
		},
		"衝": {
			"jp": "衝",
			"zht": "衝",
			"zhs": "冲"
		},
		"決": {
			"jp": "決",
			"zht": "決",
			"zhs": "决"
		},
		"凍": {
			"jp": "凍",
			"zht": "凍",
			"zhs": "冻"
		},
		"塗": {
			"jp": "塗",
			"zht": "塗",
			"zhs": "涂"
		},
		"凄": {
			"jp": "凄",
			"zht": "淒",
			"zhs": "凄"
		},
		"准": {
			"jp": "准",
			"zht": "準",
			"zhs": "准"
		},
		"準": {
			"jp": "準",
			"zht": "準",
			"zhs": "准"
		},
		"幾": {
			"jp": "幾",
			"zht": "幾",
			"zhs": "几"
		},
		"撃": {
			"jp": "撃",
			"zht": "擊",
			"zhs": "击"
		},
		"画": {
			"jp": "画",
			"zht": "劃",
			"zhs": "划"
		},
		"則": {
			"jp": "則",
			"zht": "則",
			"zhs": "则"
		},
		"剛": {
			"jp": "剛",
			"zht": "剛",
			"zhs": "刚"
		},
		"創": {
			"jp": "創",
			"zht": "創",
			"zhs": "创"
		},
		"別": {
			"jp": "別",
			"zht": "別",
			"zhs": "别"
		},
		"製": {
			"jp": "製",
			"zht": "製",
			"zhs": "制"
		},
		"券": {
			"jp": "券",
			"zht": "卷",
			"zhs": "卷"
		},
		"巻": {
			"jp": "巻",
			"zht": "卷",
			"zhs": "卷"
		},
		"刹": {
			"jp": "刹",
			"zht": "剎",
			"zhs": "刹"
		},
		"剤": {
			"jp": "剤",
			"zht": "劑",
			"zhs": "剂"
		},
		"剣": {
			"jp": "剣",
			"zht": "劍",
			"zhs": "剑"
		},
		"劇": {
			"jp": "劇",
			"zht": "劇",
			"zhs": "剧"
		},
		"剰": {
			"jp": "剰",
			"zht": "剩",
			"zhs": "剩"
		},
		"勧": {
			"jp": "勧",
			"zht": "勸",
			"zhs": "劝"
		},
		"務": {
			"jp": "務",
			"zht": "務",
			"zhs": "务"
		},
		"動": {
			"jp": "動",
			"zht": "動",
			"zhs": "动"
		},
		"励": {
			"jp": "励",
			"zht": "勵",
			"zhs": "励"
		},
		"労": {
			"jp": "労",
			"zht": "勞",
			"zhs": "劳"
		},
		"効": {
			"jp": "効",
			"zht": "效",
			"zhs": null
		},
		"勢": {
			"jp": "勢",
			"zht": "勢",
			"zhs": "势"
		},
		"勲": {
			"jp": "勲",
			"zht": "勳",
			"zhs": "勋"
		},
		"勝": {
			"jp": "勝",
			"zht": "勝",
			"zhs": "胜"
		},
		"区": {
			"jp": "区",
			"zht": "區",
			"zhs": "区"
		},
		"医": {
			"jp": "医",
			"zht": "醫",
			"zhs": "医"
		},
		"華": {
			"jp": "華",
			"zht": "華",
			"zhs": "华"
		},
		"協": {
			"jp": "協",
			"zht": "協",
			"zhs": "协"
		},
		"単": {
			"jp": "単",
			"zht": "單",
			"zhs": "单"
		},
		"売": {
			"jp": "売",
			"zht": "賣",
			"zhs": "卖"
		},
		"衛": {
			"jp": "衛",
			"zht": "衛",
			"zhs": "卫"
		},
		"庁": {
			"jp": "庁",
			"zht": "廳",
			"zhs": "厅"
		},
		"歴": {
			"jp": "歴",
			"zht": "歷",
			"zhs": "历"
		},
		"暦": {
			"jp": "暦",
			"zht": "曆",
			"zhs": "历"
		},
		"圧": {
			"jp": "圧",
			"zht": "壓",
			"zhs": "压"
		},
		"県": {
			"jp": "県",
			"zht": "縣",
			"zhs": "县"
		},
		"参": {
			"jp": "参",
			"zht": "參",
			"zhs": "参"
		},
		"双": {
			"jp": "双",
			"zht": "雙",
			"zhs": "双"
		},
		"収": {
			"jp": "収",
			"zht": "收",
			"zhs": "收"
		},
		"発": {
			"jp": "発",
			"zht": "發",
			"zhs": "发"
		},
		"変": {
			"jp": "変",
			"zht": "變",
			"zhs": "变"
		},
		"畳": {
			"jp": "畳",
			"zht": "疊",
			"zhs": "叠"
		},
		"号": {
			"jp": "号",
			"zht": "號",
			"zhs": "号"
		},
		"嘆": {
			"jp": "嘆",
			"zht": "嘆",
			"zhs": "叹"
		},
		"嚇": {
			"jp": "嚇",
			"zht": "嚇",
			"zhs": "吓"
		},
		"聴": {
			"jp": "聴",
			"zht": "聽",
			"zhs": "听"
		},
		"啓": {
			"jp": "啓",
			"zht": "啟",
			"zhs": "启"
		},
		"員": {
			"jp": "員",
			"zht": "員",
			"zhs": "员"
		},
		"諮": {
			"jp": "諮",
			"zht": "諮",
			"zhs": "谘"
		},
		"鹹": {
			"jp": "鹹",
			"zht": "鹹",
			"zhs": "咸"
		},
		"響": {
			"jp": "響",
			"zht": "響",
			"zhs": "响"
		},
		"問": {
			"jp": "問",
			"zht": "問",
			"zhs": "问"
		},
		"営": {
			"jp": "営",
			"zht": "營",
			"zhs": "营"
		},
		"噴": {
			"jp": "噴",
			"zht": "噴",
			"zhs": "喷"
		},
		"嘱": {
			"jp": "嘱",
			"zht": "囑",
			"zhs": "嘱"
		},
		"蘇": {
			"jp": "蘇",
			"zht": "蘇",
			"zhs": "苏"
		},
		"団": {
			"jp": "団",
			"zht": "團",
			"zhs": "团"
		},
		"園": {
			"jp": "園",
			"zht": "園",
			"zhs": "园"
		},
		"国": {
			"jp": "国",
			"zht": "國",
			"zhs": "国"
		},
		"囲": {
			"jp": "囲",
			"zht": "圍",
			"zhs": "围"
		},
		"図": {
			"jp": "図",
			"zht": "圖",
			"zhs": "图"
		},
		"圏": {
			"jp": "圏",
			"zht": "圈",
			"zhs": "圈"
		},
		"聖": {
			"jp": "聖",
			"zht": "聖",
			"zhs": "圣"
		},
		"場": {
			"jp": "場",
			"zht": "場",
			"zhs": "场"
		},
		"壊": {
			"jp": "壊",
			"zht": "壞",
			"zhs": "坏"
		},
		"塊": {
			"jp": "塊",
			"zht": "塊",
			"zhs": "块"
		},
		"堅": {
			"jp": "堅",
			"zht": "堅",
			"zhs": "坚"
		},
		"壇": {
			"jp": "壇",
			"zht": "壇",
			"zhs": "坛"
		},
		"墳": {
			"jp": "墳",
			"zht": "墳",
			"zhs": "坟"
		},
		"墜": {
			"jp": "墜",
			"zht": "墜",
			"zhs": "坠"
		},
		"塁": {
			"jp": "塁",
			"zht": "壘",
			"zhs": "垒"
		},
		"墾": {
			"jp": "墾",
			"zht": "墾",
			"zhs": "垦"
		},
		"執": {
			"jp": "執",
			"zht": "執",
			"zhs": "执"
		},
		"堕": {
			"jp": "堕",
			"zht": "墮",
			"zhs": "堕"
		},
		"報": {
			"jp": "報",
			"zht": "報",
			"zhs": "报"
		},
		"塩": {
			"jp": "塩",
			"zht": "鹽",
			"zhs": "盐"
		},
		"増": {
			"jp": "増",
			"zht": "增",
			"zhs": "增"
		},
		"壌": {
			"jp": "壌",
			"zht": "壤",
			"zhs": "壤"
		},
		"壮": {
			"jp": "壮",
			"zht": "壯",
			"zhs": "壮"
		},
		"声": {
			"jp": "声",
			"zht": "聲",
			"zhs": "声"
		},
		"壱": {
			"jp": "壱",
			"zht": "壹",
			"zhs": "壹"
		},
		"殻": {
			"jp": "殻",
			"zht": "殻",
			"zhs": "壳"
		},
		"殼": {
			"jp": "殼",
			"zht": "殼",
			"zhs": "壳"
		},
		"寿": {
			"jp": "寿",
			"zht": "壽",
			"zhs": "寿"
		},
		"復": {
			"jp": "復",
			"zht": "復",
			"zhs": "复"
		},
		"複": {
			"jp": "複",
			"zht": "複",
			"zhs": "复"
		},
		"夢": {
			"jp": "夢",
			"zht": "夢",
			"zhs": "梦"
		},
		"頭": {
			"jp": "頭",
			"zht": "頭",
			"zhs": "头"
		},
		"誇": {
			"jp": "誇",
			"zht": "誇",
			"zhs": "夸"
		},
		"奪": {
			"jp": "奪",
			"zht": "奪",
			"zhs": "夺"
		},
		"奮": {
			"jp": "奮",
			"zht": "奮",
			"zhs": "奋"
		},
		"奨": {
			"jp": "奨",
			"zht": "獎",
			"zhs": "奖"
		},
		"粧": {
			"jp": "粧",
			"zht": "妝",
			"zhs": "妆"
		},
		"婦": {
			"jp": "婦",
			"zht": "婦",
			"zhs": "妇"
		},
		"姉": {
			"jp": "姉",
			"zht": "姐",
			"zhs": "姐"
		},
		"姫": {
			"jp": "姫",
			"zht": "姬",
			"zhs": "姬"
		},
		"嬢": {
			"jp": "嬢",
			"zht": "孃",
			"zhs": "娘"
		},
		"娯": {
			"jp": "娯",
			"zht": "娛",
			"zhs": "娱"
		},
		"孫": {
			"jp": "孫",
			"zht": "孫",
			"zhs": "孙"
		},
		"学": {
			"jp": "学",
			"zht": "學",
			"zhs": "学"
		},
		"寧": {
			"jp": "寧",
			"zht": "寧",
			"zhs": "宁"
		},
		"宝": {
			"jp": "宝",
			"zht": "寶",
			"zhs": "宝"
		},
		"実": {
			"jp": "実",
			"zht": "實",
			"zhs": "实"
		},
		"審": {
			"jp": "審",
			"zht": "審",
			"zhs": "审"
		},
		"憲": {
			"jp": "憲",
			"zht": "憲",
			"zhs": "宪"
		},
		"宮": {
			"jp": "宮",
			"zht": "宮",
			"zhs": "宫"
		},
		"寬": {
			"jp": "寬",
			"zht": "寬",
			"zhs": "宽"
		},
		"賓": {
			"jp": "賓",
			"zht": "賓",
			"zhs": "宾"
		},
		"秘": {
			"jp": "秘",
			"zht": "祕",
			"zhs": "秘"
		},
		"寛": {
			"jp": "寛",
			"zht": "寬",
			"zhs": "宽"
		},
		"寝": {
			"jp": "寝",
			"zht": "寢",
			"zhs": "寝"
		},
		"対": {
			"jp": "対",
			"zht": "對",
			"zhs": "对"
		},
		"尋": {
			"jp": "尋",
			"zht": "尋",
			"zhs": "寻"
		},
		"導": {
			"jp": "導",
			"zht": "導",
			"zhs": "导"
		},
		"将": {
			"jp": "将",
			"zht": "將",
			"zhs": "将"
		},
		"層": {
			"jp": "層",
			"zht": "層",
			"zhs": "层"
		},
		"属": {
			"jp": "属",
			"zht": "屬",
			"zhs": "属"
		},
		"歳": {
			"jp": "歳",
			"zht": "歲",
			"zhs": "岁"
		},
		"島": {
			"jp": "島",
			"zht": "島",
			"zhs": "岛"
		},
		"巌": {
			"jp": "巌",
			"zht": "巖",
			"zhs": "巖"
		},
		"峡": {
			"jp": "峡",
			"zht": "峽",
			"zhs": "峡"
		},
		"険": {
			"jp": "険",
			"zht": "險",
			"zhs": "险"
		},
		"幣": {
			"jp": "幣",
			"zht": "幣",
			"zhs": "币"
		},
		"帥": {
			"jp": "帥",
			"zht": "帥",
			"zhs": "帅"
		},
		"師": {
			"jp": "師",
			"zht": "師",
			"zhs": "师"
		},
		"帳": {
			"jp": "帳",
			"zht": "帳",
			"zhs": "帐"
		},
		"帶": {
			"jp": "帶",
			"zht": "帶",
			"zhs": "带"
		},
		"帯": {
			"jp": "帯",
			"zht": "帶",
			"zhs": "带"
		},
		"帰": {
			"jp": "帰",
			"zht": "歸",
			"zhs": "归"
		},
		"幹": {
			"jp": "幹",
			"zht": "幹",
			"zhs": "干"
		},
		"広": {
			"jp": "広",
			"zht": "廣",
			"zhs": "广"
		},
		"庄": {
			"jp": "庄",
			"zht": "莊",
			"zhs": "庄"
		},
		"慶": {
			"jp": "慶",
			"zht": "慶",
			"zhs": "庆"
		},
		"庫": {
			"jp": "庫",
			"zht": "庫",
			"zhs": "库"
		},
		"応": {
			"jp": "応",
			"zht": "應",
			"zhs": "应"
		},
		"廃": {
			"jp": "廃",
			"zht": "廢",
			"zhs": "废"
		},
		"開": {
			"jp": "開",
			"zht": "開",
			"zhs": "开"
		},
		"弁": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辨"
		},
		"異": {
			"jp": "異",
			"zht": "異",
			"zhs": "异"
		},
		"棄": {
			"jp": "棄",
			"zht": "棄",
			"zhs": "弃"
		},
		"弍": {
			"jp": "弍",
			"zht": "貳",
			"zhs": "贰"
		},
		"張": {
			"jp": "張",
			"zht": "張",
			"zhs": "张"
		},
		"弥": {
			"jp": "弥",
			"zht": "彌",
			"zhs": "弥"
		},
		"強": {
			"jp": "強",
			"zht": "強",
			"zhs": "强"
		},
		"弾": {
			"jp": "弾",
			"zht": "彈",
			"zhs": "弹"
		},
		"録": {
			"jp": "録",
			"zht": "錄",
			"zhs": "录"
		},
		"彦": {
			"jp": "彦",
			"zht": "彥",
			"zhs": "彥"
		},
		"徹": {
			"jp": "徹",
			"zht": "徹",
			"zhs": "彻"
		},
		"徴": {
			"jp": "徴",
			"zht": "徵",
			"zhs": "征"
		},
		"径": {
			"jp": "径",
			"zht": "徑",
			"zhs": "径"
		},
		"徳": {
			"jp": "徳",
			"zht": "德",
			"zhs": "德"
		},
		"憶": {
			"jp": "憶",
			"zht": "憶",
			"zhs": "忆"
		},
		"誌": {
			"jp": "誌",
			"zht": "誌",
			"zhs": "志"
		},
		"憂": {
			"jp": "憂",
			"zht": "憂",
			"zhs": "忧"
		},
		"懐": {
			"jp": "懐",
			"zht": "懷",
			"zhs": "怀"
		},
		"態": {
			"jp": "態",
			"zht": "態",
			"zhs": "态"
		},
		"総": {
			"jp": "総",
			"zht": "總",
			"zhs": "总"
		},
		"恒": {
			"jp": "恒",
			"zht": "恆",
			"zhs": "恒"
		},
		"恋": {
			"jp": "恋",
			"zht": "戀",
			"zhs": "恋"
		},
		"懇": {
			"jp": "懇",
			"zht": "懇",
			"zhs": "恳"
		},
		"恵": {
			"jp": "恵",
			"zht": "惠",
			"zhs": "惠"
		},
		"悪": {
			"jp": "悪",
			"zht": "惡",
			"zhs": "恶"
		},
		"悩": {
			"jp": "悩",
			"zht": "惱",
			"zhs": "恼"
		},
		"悦": {
			"jp": "悦",
			"zht": "悅",
			"zhs": "悅"
		},
		"懸": {
			"jp": "懸",
			"zht": "懸",
			"zhs": "悬"
		},
		"驚": {
			"jp": "驚",
			"zht": "驚",
			"zhs": "惊"
		},
		"惨": {
			"jp": "惨",
			"zht": "慘",
			"zhs": "惨"
		},
		"懲": {
			"jp": "懲",
			"zht": "懲",
			"zhs": "惩"
		},
		"愛": {
			"jp": "愛",
			"zht": "愛",
			"zhs": "爱"
		},
		"憤": {
			"jp": "憤",
			"zht": "憤",
			"zhs": "愤"
		},
		"願": {
			"jp": "願",
			"zht": "願",
			"zhs": "愿"
		},
		"慮": {
			"jp": "慮",
			"zht": "慮",
			"zhs": "虑"
		},
		"戯": {
			"jp": "戯",
			"zht": "戲",
			"zhs": "戏"
		},
		"戦": {
			"jp": "戦",
			"zht": "戰",
			"zhs": "战"
		},
		"戸": {
			"jp": "戸",
			"zht": "戶",
			"zhs": "户"
		},
		"払": {
			"jp": "払",
			"zht": "拂",
			"zhs": "拂"
		},
		"拡": {
			"jp": "拡",
			"zht": "擴",
			"zhs": "扩"
		},
		"掃": {
			"jp": "掃",
			"zht": "掃",
			"zhs": "扫"
		},
		"揚": {
			"jp": "揚",
			"zht": "揚",
			"zhs": "扬"
		},
		"抜": {
			"jp": "抜",
			"zht": "拔",
			"zhs": null
		},
		"択": {
			"jp": "択",
			"zht": "擇",
			"zhs": "择"
		},
		"護": {
			"jp": "護",
			"zht": "護",
			"zhs": "护"
		},
		"担": {
			"jp": "担",
			"zht": "擔",
			"zhs": "担"
		},
		"拝": {
			"jp": "拝",
			"zht": "拜",
			"zhs": "拜"
		},
		"擬": {
			"jp": "擬",
			"zht": "擬",
			"zhs": "拟"
		},
		"拠": {
			"jp": "拠",
			"zht": "據",
			"zhs": "据"
		},
		"擁": {
			"jp": "擁",
			"zht": "擁",
			"zhs": "拥"
		},
		"挟": {
			"jp": "挟",
			"zht": "挾",
			"zhs": "挟"
		},
		"揮": {
			"jp": "揮",
			"zht": "揮",
			"zhs": "挥"
		},
		"揷": {
			"jp": "揷",
			"zht": "插",
			"zhs": "插"
		},
		"挿": {
			"jp": "挿",
			"zht": "插",
			"zhs": "插"
		},
		"損": {
			"jp": "損",
			"zht": "損",
			"zhs": "损"
		},
		"捨": {
			"jp": "捨",
			"zht": "捨",
			"zhs": "舍"
		},
		"掲": {
			"jp": "掲",
			"zht": "揭",
			"zhs": "揭"
		},
		"掴": {
			"jp": "掴",
			"zht": "摑",
			"zhs": "掴"
		},
		"揺": {
			"jp": "揺",
			"zht": "搖",
			"zhs": "摇"
		},
		"摂": {
			"jp": "摂",
			"zht": "攝",
			"zhs": "摄"
		},
		"撮": {
			"jp": "撮",
			"zht": "攝",
			"zhs": "摄"
		},
		"敵": {
			"jp": "敵",
			"zht": "敵",
			"zhs": "敌"
		},
		"敗": {
			"jp": "敗",
			"zht": "敗",
			"zhs": "败"
		},
		"数": {
			"jp": "数",
			"zht": "數",
			"zhs": "数"
		},
		"斉": {
			"jp": "斉",
			"zht": "齊",
			"zhs": "齐"
		},
		"斎": {
			"jp": "斎",
			"zht": "齋",
			"zhs": "斋"
		},
		"闘": {
			"jp": "闘",
			"zht": "鬥",
			"zhs": "斗"
		},
		"鬪": {
			"jp": "鬪",
			"zht": "鬥",
			"zhs": "斗"
		},
		"断": {
			"jp": "断",
			"zht": "斷",
			"zhs": "断"
		},
		"旧": {
			"jp": "旧",
			"zht": "舊",
			"zhs": "旧"
		},
		"時": {
			"jp": "時",
			"zht": "時",
			"zhs": "时"
		},
		"曇": {
			"jp": "曇",
			"zht": "曇",
			"zhs": "昙"
		},
		"昼": {
			"jp": "昼",
			"zht": "晝",
			"zhs": "昼"
		},
		"顕": {
			"jp": "顕",
			"zht": "顯",
			"zhs": "显"
		},
		"暁": {
			"jp": "暁",
			"zht": "曉",
			"zhs": "晓"
		},
		"晩": {
			"jp": "晩",
			"zht": "晚",
			"zhs": "晚"
		},
		"暫": {
			"jp": "暫",
			"zht": "暫",
			"zhs": "暂"
		},
		"曽": {
			"jp": "曽",
			"zht": "曾",
			"zhs": "曾"
		},
		"術": {
			"jp": "術",
			"zht": "術",
			"zhs": "术"
		},
		"樸": {
			"jp": "樸",
			"zht": "樸",
			"zhs": "朴"
		},
		"機": {
			"jp": "機",
			"zht": "機",
			"zhs": "机"
		},
		"殺": {
			"jp": "殺",
			"zht": "殺",
			"zhs": "杀"
		},
		"雑": {
			"jp": "雑",
			"zht": "雜",
			"zhs": "杂"
		},
		"権": {
			"jp": "権",
			"zht": "權",
			"zhs": "权"
		},
		"条": {
			"jp": "条",
			"zht": "條",
			"zhs": "条"
		},
		"極": {
			"jp": "極",
			"zht": "極",
			"zhs": "极"
		},
		"枢": {
			"jp": "枢",
			"zht": "樞",
			"zhs": "枢"
		},
		"槍": {
			"jp": "槍",
			"zht": "槍",
			"zhs": "枪"
		},
		"査": {
			"jp": "査",
			"zht": "查",
			"zhs": "查"
		},
		"栄": {
			"jp": "栄",
			"zht": "榮",
			"zhs": "荣"
		},
		"標": {
			"jp": "標",
			"zht": "標",
			"zhs": "标"
		},
		"桟": {
			"jp": "桟",
			"zht": "棧",
			"zhs": "栈"
		},
		"棟": {
			"jp": "棟",
			"zht": "棟",
			"zhs": "栋"
		},
		"欄": {
			"jp": "欄",
			"zht": "欄",
			"zhs": "栏"
		},
		"樹": {
			"jp": "樹",
			"zht": "樹",
			"zhs": "树"
		},
		"様": {
			"jp": "様",
			"zht": "樣",
			"zhs": "样"
		},
		"桜": {
			"jp": "桜",
			"zht": "櫻",
			"zhs": "樱"
		},
		"橋": {
			"jp": "橋",
			"zht": "橋",
			"zhs": "桥"
		},
		"検": {
			"jp": "検",
			"zht": "檢",
			"zhs": "检"
		},
		"楼": {
			"jp": "楼",
			"zht": "樓",
			"zhs": "楼"
		},
		"歓": {
			"jp": "歓",
			"zht": "歡",
			"zhs": "欢"
		},
		"欧": {
			"jp": "欧",
			"zht": "歐",
			"zhs": "欧"
		},
		"歩": {
			"jp": "歩",
			"zht": "步",
			"zhs": "步"
		},
		"歯": {
			"jp": "歯",
			"zht": "齒",
			"zhs": "齿"
		},
		"残": {
			"jp": "残",
			"zht": "殘",
			"zhs": "残"
		},
		"殴": {
			"jp": "殴",
			"zht": "毆",
			"zhs": "殴"
		},
		"気": {
			"jp": "気",
			"zht": "氣",
			"zhs": "气"
		},
		"漢": {
			"jp": "漢",
			"zht": "漢",
			"zhs": "汉"
		},
		"湯": {
			"jp": "湯",
			"zht": "湯",
			"zhs": "汤"
		},
		"溝": {
			"jp": "溝",
			"zht": "溝",
			"zhs": "沟"
		},
		"沢": {
			"jp": "沢",
			"zht": "澤",
			"zhs": "泽"
		},
		"涙": {
			"jp": "涙",
			"zht": "淚",
			"zhs": "泪"
		},
		"滝": {
			"jp": "滝",
			"zht": "瀧",
			"zhs": "泷"
		},
		"潔": {
			"jp": "潔",
			"zht": "潔",
			"zhs": "洁"
		},
		"浅": {
			"jp": "浅",
			"zht": "淺",
			"zhs": "浅"
		},
		"濁": {
			"jp": "濁",
			"zht": "濁",
			"zhs": "浊"
		},
		"測": {
			"jp": "測",
			"zht": "測",
			"zhs": "测"
		},
		"済": {
			"jp": "済",
			"zht": "濟",
			"zhs": "济"
		},
		"濃": {
			"jp": "濃",
			"zht": "濃",
			"zhs": "浓"
		},
		"浜": {
			"jp": "浜",
			"zht": "濱",
			"zhs": "滨"
		},
		"渋": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涉"
		},
		"渦": {
			"jp": "渦",
			"zht": "渦",
			"zhs": "涡"
		},
		"潤": {
			"jp": "潤",
			"zht": "潤",
			"zhs": "润"
		},
		"漬": {
			"jp": "漬",
			"zht": "漬",
			"zhs": "渍"
		},
		"漸": {
			"jp": "漸",
			"zht": "漸",
			"zhs": "渐"
		},
		"渓": {
			"jp": "渓",
			"zht": "溪",
			"zhs": "溪"
		},
		"漁": {
			"jp": "漁",
			"zht": "漁",
			"zhs": "渔"
		},
		"湾": {
			"jp": "湾",
			"zht": "灣",
			"zhs": "湾"
		},
		"湿": {
			"jp": "湿",
			"zht": "濕",
			"zhs": "湿"
		},
		"満": {
			"jp": "満",
			"zht": "滿",
			"zhs": "满"
		},
		"滅": {
			"jp": "滅",
			"zht": "滅",
			"zhs": "灭"
		},
		"滞": {
			"jp": "滞",
			"zht": "滯",
			"zhs": "滞"
		},
		"濫": {
			"jp": "濫",
			"zht": "濫",
			"zhs": "滥"
		},
		"瀬": {
			"jp": "瀬",
			"zht": "瀨",
			"zhs": "濑"
		},
		"灯": {
			"jp": "灯",
			"zht": "燈",
			"zhs": "灯"
		},
		"霊": {
			"jp": "霊",
			"zht": "靈",
			"zhs": "灵"
		},
		"炉": {
			"jp": "炉",
			"zht": "爐",
			"zhs": "炉"
		},
		"点": {
			"jp": "点",
			"zht": "點",
			"zhs": "点"
		},
		"錬": {
			"jp": "錬",
			"zht": "鍊",
			"zhs": "炼"
		},
		"練": {
			"jp": "練",
			"zht": "練",
			"zhs": "练"
		},
		"煙": {
			"jp": "煙",
			"zht": "煙",
			"zhs": "烟"
		},
		"煩": {
			"jp": "煩",
			"zht": "煩",
			"zhs": "烦"
		},
		"焼": {
			"jp": "焼",
			"zht": "燒",
			"zhs": "烧"
		},
		"熱": {
			"jp": "熱",
			"zht": "熱",
			"zhs": "热"
		},
		"焔": {
			"jp": "焔",
			"zht": "焰",
			"zhs": "焰"
		},
		"鍛": {
			"jp": "鍛",
			"zht": "鍛",
			"zhs": "锻"
		},
		"犠": {
			"jp": "犠",
			"zht": "犧",
			"zhs": "牺"
		},
		"状": {
			"jp": "状",
			"zht": "狀",
			"zhs": "状"
		},
		"猶": {
			"jp": "猶",
			"zht": "猶",
			"zhs": "犹"
		},
		"独": {
			"jp": "独",
			"zht": "獨",
			"zhs": "独"
		},
		"狭": {
			"jp": "狭",
			"zht": "狹",
			"zhs": "狭"
		},
		"獄": {
			"jp": "獄",
			"zht": "獄",
			"zhs": "狱"
		},
		"猟": {
			"jp": "猟",
			"zht": "獵",
			"zhs": "猎"
		},
		"猫": {
			"jp": "猫",
			"zht": "貓",
			"zhs": "猫"
		},
		"献": {
			"jp": "献",
			"zht": "獻",
			"zhs": "献"
		},
		"獲": {
			"jp": "獲",
			"zht": "獲",
			"zhs": "获"
		},
		"穫": {
			"jp": "穫",
			"zht": "穫",
			"zhs": "获"
		},
		"環": {
			"jp": "環",
			"zht": "環",
			"zhs": "环"
		},
		"現": {
			"jp": "現",
			"zht": "現",
			"zhs": "现"
		},
		"璽": {
			"jp": "璽",
			"zht": "璽",
			"zhs": "玺"
		},
		"甦": {
			"jp": "甦",
			"zht": "甦",
			"zhs": "苏"
		},
		"電": {
			"jp": "電",
			"zht": "電",
			"zhs": "电"
		},
		"療": {
			"jp": "療",
			"zht": "療",
			"zhs": "疗"
		},
		"監": {
			"jp": "監",
			"zht": "監",
			"zhs": "监"
		},
		"蓋": {
			"jp": "蓋",
			"zht": "蓋",
			"zhs": "盖"
		},
		"盤": {
			"jp": "盤",
			"zht": "盤",
			"zhs": "盘"
		},
		"視": {
			"jp": "視",
			"zht": "視",
			"zhs": "视"
		},
		"着": {
			"jp": "着",
			"zht": "著",
			"zhs": "著"
		},
		"矯": {
			"jp": "矯",
			"zht": "矯",
			"zhs": "矫"
		},
		"鉱": {
			"jp": "鉱",
			"zht": "礦",
			"zhs": "矿"
		},
		"砕": {
			"jp": "砕",
			"zht": "碎",
			"zhs": "碎"
		},
		"礎": {
			"jp": "礎",
			"zht": "礎",
			"zhs": "础"
		},
		"確": {
			"jp": "確",
			"zht": "確",
			"zhs": "确"
		},
		"礼": {
			"jp": "礼",
			"zht": "禮",
			"zhs": "礼"
		},
		"禍": {
			"jp": "禍",
			"zht": "禍",
			"zhs": "祸"
		},
		"禅": {
			"jp": "禅",
			"zht": "禪",
			"zhs": "禅"
		},
		"離": {
			"jp": "離",
			"zht": "離",
			"zhs": "离"
		},
		"種": {
			"jp": "種",
			"zht": "種",
			"zhs": "种"
		},
		"積": {
			"jp": "積",
			"zht": "積",
			"zhs": "积"
		},
		"称": {
			"jp": "称",
			"zht": "稱",
			"zhs": "称"
		},
		"稲": {
			"jp": "稲",
			"zht": "稻",
			"zhs": "稻"
		},
		"穏": {
			"jp": "穏",
			"zht": "穩",
			"zhs": "稳"
		},
		"穀": {
			"jp": "穀",
			"zht": "穀",
			"zhs": "谷"
		},
		"穂": {
			"jp": "穂",
			"zht": "穗",
			"zhs": "穗"
		},
		"窮": {
			"jp": "窮",
			"zht": "窮",
			"zhs": "穷"
		},
		"窃": {
			"jp": "窃",
			"zht": "竊",
			"zhs": "窃"
		},
		"窓": {
			"jp": "窓",
			"zht": "窗",
			"zhs": "窗"
		},
		"竜": {
			"jp": "竜",
			"zht": "龍",
			"zhs": "龙"
		},
		"競": {
			"jp": "競",
			"zht": "競",
			"zhs": "竞"
		},
		"篤": {
			"jp": "篤",
			"zht": "篤",
			"zhs": "笃"
		},
		"筆": {
			"jp": "筆",
			"zht": "筆",
			"zhs": "笔"
		},
		"築": {
			"jp": "築",
			"zht": "築",
			"zhs": "筑"
		},
		"簡": {
			"jp": "簡",
			"zht": "簡",
			"zhs": "简"
		},
		"箇": {
			"jp": "箇",
			"zht": "個",
			"zhs": "个"
		},
		"節": {
			"jp": "節",
			"zht": "節",
			"zhs": "节"
		},
		"範": {
			"jp": "範",
			"zht": "範",
			"zhs": "范"
		},
		"類": {
			"jp": "類",
			"zht": "類",
			"zhs": "类"
		},
		"粋": {
			"jp": "粋",
			"zht": "粹",
			"zhs": "粹"
		},
		"粛": {
			"jp": "粛",
			"zht": "肅",
			"zhs": "肃"
		},
		"糧": {
			"jp": "糧",
			"zht": "糧",
			"zhs": "粮"
		},
		"糾": {
			"jp": "糾",
			"zht": "糾",
			"zhs": "纠"
		},
		"紀": {
			"jp": "紀",
			"zht": "紀",
			"zhs": "纪"
		},
		"約": {
			"jp": "約",
			"zht": "約",
			"zhs": "约"
		},
		"紅": {
			"jp": "紅",
			"zht": "紅",
			"zhs": "红"
		},
		"紋": {
			"jp": "紋",
			"zht": "紋",
			"zhs": "纹"
		},
		"納": {
			"jp": "納",
			"zht": "納",
			"zhs": "纳"
		},
		"純": {
			"jp": "純",
			"zht": "純",
			"zhs": "纯"
		},
		"紙": {
			"jp": "紙",
			"zht": "紙",
			"zhs": "纸"
		},
		"級": {
			"jp": "級",
			"zht": "級",
			"zhs": "级"
		},
		"紛": {
			"jp": "紛",
			"zht": "紛",
			"zhs": "纷"
		},
		"紡": {
			"jp": "紡",
			"zht": "紡",
			"zhs": "纺"
		},
		"緊": {
			"jp": "緊",
			"zht": "緊",
			"zhs": "紧"
		},
		"細": {
			"jp": "細",
			"zht": "細",
			"zhs": "细"
		},
		"紳": {
			"jp": "紳",
			"zht": "紳",
			"zhs": "绅"
		},
		"紹": {
			"jp": "紹",
			"zht": "紹",
			"zhs": "绍"
		},
		"紺": {
			"jp": "紺",
			"zht": "紺",
			"zhs": "绀"
		},
		"終": {
			"jp": "終",
			"zht": "終",
			"zhs": "终"
		},
		"組": {
			"jp": "組",
			"zht": "組",
			"zhs": "组"
		},
		"経": {
			"jp": "経",
			"zht": "經",
			"zhs": "经"
		},
		"結": {
			"jp": "結",
			"zht": "結",
			"zhs": "结"
		},
		"絶": {
			"jp": "絶",
			"zht": "絶",
			"zhs": "绝"
		},
		"絞": {
			"jp": "絞",
			"zht": "絞",
			"zhs": "绞"
		},
		"絡": {
			"jp": "絡",
			"zht": "絡",
			"zhs": "络"
		},
		"給": {
			"jp": "給",
			"zht": "給",
			"zhs": "给"
		},
		"統": {
			"jp": "統",
			"zht": "統",
			"zhs": "统"
		},
		"絵": {
			"jp": "絵",
			"zht": "繪",
			"zhs": "绘"
		},
		"絹": {
			"jp": "絹",
			"zht": "絹",
			"zhs": "绢"
		},
		"継": {
			"jp": "継",
			"zht": "繼",
			"zhs": "继"
		},
		"続": {
			"jp": "続",
			"zht": "續",
			"zhs": "续"
		},
		"緑": {
			"jp": "緑",
			"zht": "綠",
			"zhs": "绿"
		},
		"線": {
			"jp": "線",
			"zht": "線",
			"zhs": "线"
		},
		"維": {
			"jp": "維",
			"zht": "維",
			"zhs": "维"
		},
		"綱": {
			"jp": "綱",
			"zht": "綱",
			"zhs": "纲"
		},
		"綿": {
			"jp": "綿",
			"zht": "綿",
			"zhs": "绵"
		},
		"緒": {
			"jp": "緒",
			"zht": "緒",
			"zhs": "绪"
		},
		"締": {
			"jp": "締",
			"zht": "締",
			"zhs": "缔"
		},
		"縁": {
			"jp": "縁",
			"zht": "緣",
			"zhs": "缘"
		},
		"編": {
			"jp": "編",
			"zht": "編",
			"zhs": "编"
		},
		"緩": {
			"jp": "緩",
			"zht": "緩",
			"zhs": "缓"
		},
		"緯": {
			"jp": "緯",
			"zht": "緯",
			"zhs": "纬"
		},
		"縄": {
			"jp": "縄",
			"zht": "繩",
			"zhs": "绳"
		},
		"縛": {
			"jp": "縛",
			"zht": "縛",
			"zhs": "缚"
		},
		"縦": {
			"jp": "縦",
			"zht": "縱",
			"zhs": "纵"
		},
		"縫": {
			"jp": "縫",
			"zht": "縫",
			"zhs": "缝"
		},
		"縮": {
			"jp": "縮",
			"zht": "縮",
			"zhs": "缩"
		},
		"繊": {
			"jp": "繊",
			"zht": "纖",
			"zhs": "纤"
		},
		"績": {
			"jp": "績",
			"zht": "績",
			"zhs": "绩"
		},
		"織": {
			"jp": "織",
			"zht": "織",
			"zhs": "织"
		},
		"繕": {
			"jp": "繕",
			"zht": "繕",
			"zhs": "缮"
		},
		"繭": {
			"jp": "繭",
			"zht": "繭",
			"zhs": "茧"
		},
		"繰": {
			"jp": "繰",
			"zht": "繰",
			"zhs": "缲"
		},
		"缶": {
			"jp": "缶",
			"zht": "罐",
			"zhs": "罐"
		},
		"鉢": {
			"jp": "鉢",
			"zht": "鉢",
			"zhs": "钵"
		},
		"羅": {
			"jp": "羅",
			"zht": "羅",
			"zhs": "罗"
		},
		"罸": {
			"jp": "罸",
			"zht": "罰",
			"zhs": "罚"
		},
		"罷": {
			"jp": "罷",
			"zht": "罷",
			"zhs": "罢"
		},
		"罵": {
			"jp": "罵",
			"zht": "罵",
			"zhs": "骂"
		},
		"職": {
			"jp": "職",
			"zht": "職",
			"zhs": "职"
		},
		"聞": {
			"jp": "聞",
			"zht": "聞",
			"zhs": "闻"
		},
		"聡": {
			"jp": "聡",
			"zht": "聰",
			"zhs": "聪"
		},
		"腸": {
			"jp": "腸",
			"zht": "腸",
			"zhs": "肠"
		},
		"膚": {
			"jp": "膚",
			"zht": "膚",
			"zhs": "肤"
		},
		"脹": {
			"jp": "脹",
			"zht": "脹",
			"zhs": "胀"
		},
		"脅": {
			"jp": "脅",
			"zht": "脅",
			"zhs": "胁"
		},
		"胆": {
			"jp": "胆",
			"zht": "膽",
			"zhs": "胆"
		},
		"臓": {
			"jp": "臓",
			"zht": "臟",
			"zhs": "脏"
		},
		"脳": {
			"jp": "脳",
			"zht": "腦",
			"zhs": "脑"
		},
		"脚": {
			"jp": "脚",
			"zht": "腳",
			"zhs": "脚"
		},
		"騰": {
			"jp": "騰",
			"zht": "騰",
			"zhs": "腾"
		},
		"舗": {
			"jp": "舗",
			"zht": "舖",
			"zhs": "铺"
		},
		"館": {
			"jp": "館",
			"zht": "館",
			"zhs": "馆"
		},
		"艦": {
			"jp": "艦",
			"zht": "艦",
			"zhs": "舰"
		},
		"芸": {
			"jp": "芸",
			"zht": "藝",
			"zhs": "艺"
		},
		"茎": {
			"jp": "茎",
			"zht": "莖",
			"zhs": "茎"
		},
		"薦": {
			"jp": "薦",
			"zht": "薦",
			"zhs": "荐"
		},
		"荘": {
			"jp": "荘",
			"zht": "莊",
			"zhs": "庄"
		},
		"薬": {
			"jp": "薬",
			"zht": "藥",
			"zhs": "药"
		},
		"蛍": {
			"jp": "蛍",
			"zht": "螢",
			"zhs": "萤"
		},
		"蒋": {
			"jp": "蒋",
			"zht": "蔣",
			"zhs": "蒋"
		},
		"蔵": {
			"jp": "蔵",
			"zht": "藏",
			"zhs": "藏"
		},
		"虜": {
			"jp": "虜",
			"zht": "虜",
			"zhs": "虏"
		},
		"虚": {
			"jp": "虚",
			"zht": "虛",
			"zhs": "虚"
		},
		"虫": {
			"jp": "虫",
			"zht": "蟲",
			"zhs": "虫"
		},
		"蝕": {
			"jp": "蝕",
			"zht": "蝕",
			"zhs": "蚀"
		},
		"蚕": {
			"jp": "蚕",
			"zht": "蠶",
			"zhs": "蚕"
		},
		"蛮": {
			"jp": "蛮",
			"zht": "蠻",
			"zhs": "蛮"
		},
		"補": {
			"jp": "補",
			"zht": "補",
			"zhs": "补"
		},
		"襲": {
			"jp": "襲",
			"zht": "襲",
			"zhs": "袭"
		},
		"装": {
			"jp": "装",
			"zht": "裝",
			"zhs": "装"
		},
		"裏": {
			"jp": "裏",
			"zht": "裡",
			"zhs": "里"
		},
		"覇": {
			"jp": "覇",
			"zht": "霸",
			"zhs": "霸"
		},
		"見": {
			"jp": "見",
			"zht": "見",
			"zhs": "见"
		},
		"観": {
			"jp": "観",
			"zht": "觀",
			"zhs": "观"
		},
		"規": {
			"jp": "規",
			"zht": "規",
			"zhs": "规"
		},
		"覚": {
			"jp": "覚",
			"zht": "覺",
			"zhs": "觉"
		},
		"覧": {
			"jp": "覧",
			"zht": "覽",
			"zhs": "览"
		},
		"触": {
			"jp": "触",
			"zht": "觸",
			"zhs": "触"
		},
		"訂": {
			"jp": "訂",
			"zht": "訂",
			"zhs": "订"
		},
		"計": {
			"jp": "計",
			"zht": "計",
			"zhs": "计"
		},
		"討": {
			"jp": "討",
			"zht": "討",
			"zhs": "讨"
		},
		"訓": {
			"jp": "訓",
			"zht": "訓",
			"zhs": "训"
		},
		"記": {
			"jp": "記",
			"zht": "記",
			"zhs": "记"
		},
		"訟": {
			"jp": "訟",
			"zht": "訟",
			"zhs": "讼"
		},
		"訪": {
			"jp": "訪",
			"zht": "訪",
			"zhs": "访"
		},
		"設": {
			"jp": "設",
			"zht": "設",
			"zhs": "设"
		},
		"許": {
			"jp": "許",
			"zht": "許",
			"zhs": "许"
		},
		"訳": {
			"jp": "訳",
			"zht": "譯",
			"zhs": "译"
		},
		"訴": {
			"jp": "訴",
			"zht": "訴",
			"zhs": "诉"
		},
		"診": {
			"jp": "診",
			"zht": "診",
			"zhs": "诊"
		},
		"証": {
			"jp": "証",
			"zht": "證",
			"zhs": "证"
		},
		"詐": {
			"jp": "詐",
			"zht": "詐",
			"zhs": "诈"
		},
		"詔": {
			"jp": "詔",
			"zht": "詔",
			"zhs": "诏"
		},
		"評": {
			"jp": "評",
			"zht": "評",
			"zhs": "评"
		},
		"詛": {
			"jp": "詛",
			"zht": "詛",
			"zhs": "诅"
		},
		"詞": {
			"jp": "詞",
			"zht": "詞",
			"zhs": "词"
		},
		"試": {
			"jp": "試",
			"zht": "試",
			"zhs": "试"
		},
		"詩": {
			"jp": "詩",
			"zht": "詩",
			"zhs": "诗"
		},
		"詰": {
			"jp": "詰",
			"zht": "詰",
			"zhs": "诘"
		},
		"該": {
			"jp": "該",
			"zht": "該",
			"zhs": "该"
		},
		"詳": {
			"jp": "詳",
			"zht": "詳",
			"zhs": "详"
		},
		"誉": {
			"jp": "誉",
			"zht": "譽",
			"zhs": "誉"
		},
		"謄": {
			"jp": "謄",
			"zht": "謄",
			"zhs": "誊"
		},
		"認": {
			"jp": "認",
			"zht": "認",
			"zhs": "认"
		},
		"誕": {
			"jp": "誕",
			"zht": "誕",
			"zhs": "诞"
		},
		"誘": {
			"jp": "誘",
			"zht": "誘",
			"zhs": "诱"
		},
		"語": {
			"jp": "語",
			"zht": "語",
			"zhs": "语"
		},
		"誠": {
			"jp": "誠",
			"zht": "誠",
			"zhs": "诚"
		},
		"誤": {
			"jp": "誤",
			"zht": "誤",
			"zhs": "误"
		},
		"説": {
			"jp": "説",
			"zht": "說",
			"zhs": "说"
		},
		"読": {
			"jp": "読",
			"zht": "讀",
			"zhs": "读"
		},
		"誰": {
			"jp": "誰",
			"zht": "誰",
			"zhs": "谁"
		},
		"課": {
			"jp": "課",
			"zht": "課",
			"zhs": "课"
		},
		"調": {
			"jp": "調",
			"zht": "調",
			"zhs": "调"
		},
		"談": {
			"jp": "談",
			"zht": "談",
			"zhs": "谈"
		},
		"請": {
			"jp": "請",
			"zht": "請",
			"zhs": "请"
		},
		"論": {
			"jp": "論",
			"zht": "論",
			"zhs": "论"
		},
		"諭": {
			"jp": "諭",
			"zht": "諭",
			"zhs": "谕"
		},
		"諸": {
			"jp": "諸",
			"zht": "諸",
			"zhs": "诸"
		},
		"諾": {
			"jp": "諾",
			"zht": "諾",
			"zhs": "诺"
		},
		"謀": {
			"jp": "謀",
			"zht": "謀",
			"zhs": "谋"
		},
		"謁": {
			"jp": "謁",
			"zht": "謁",
			"zhs": "谒"
		},
		"謎": {
			"jp": "謎",
			"zht": "謎",
			"zhs": "谜"
		},
		"謙": {
			"jp": "謙",
			"zht": "謙",
			"zhs": "谦"
		},
		"講": {
			"jp": "講",
			"zht": "講",
			"zhs": "讲"
		},
		"謝": {
			"jp": "謝",
			"zht": "謝",
			"zhs": "谢"
		},
		"謡": {
			"jp": "謡",
			"zht": "謠",
			"zhs": "谣"
		},
		"謹": {
			"jp": "謹",
			"zht": "謹",
			"zhs": "谨"
		},
		"識": {
			"jp": "識",
			"zht": "識",
			"zhs": "识"
		},
		"譜": {
			"jp": "譜",
			"zht": "譜",
			"zhs": "谱"
		},
		"議": {
			"jp": "議",
			"zht": "議",
			"zhs": "议"
		},
		"譲": {
			"jp": "譲",
			"zht": "讓",
			"zhs": "让"
		},
		"貝": {
			"jp": "貝",
			"zht": "貝",
			"zhs": "贝"
		},
		"貞": {
			"jp": "貞",
			"zht": "貞",
			"zhs": "贞"
		},
		"負": {
			"jp": "負",
			"zht": "負",
			"zhs": "负"
		},
		"財": {
			"jp": "財",
			"zht": "財",
			"zhs": "财"
		},
		"貢": {
			"jp": "貢",
			"zht": "貢",
			"zhs": "贡"
		},
		"貧": {
			"jp": "貧",
			"zht": "貧",
			"zhs": "贫"
		},
		"貨": {
			"jp": "貨",
			"zht": "貨",
			"zhs": "货"
		},
		"販": {
			"jp": "販",
			"zht": "販",
			"zhs": "贩"
		},
		"貪": {
			"jp": "貪",
			"zht": "貪",
			"zhs": "贪"
		},
		"責": {
			"jp": "責",
			"zht": "責",
			"zhs": "责"
		},
		"貯": {
			"jp": "貯",
			"zht": "貯",
			"zhs": "贮"
		},
		"貴": {
			"jp": "貴",
			"zht": "貴",
			"zhs": "贵"
		},
		"貸": {
			"jp": "貸",
			"zht": "貸",
			"zhs": "贷"
		},
		"費": {
			"jp": "費",
			"zht": "費",
			"zhs": "费"
		},
		"貿": {
			"jp": "貿",
			"zht": "貿",
			"zhs": "贸"
		},
		"賀": {
			"jp": "賀",
			"zht": "賀",
			"zhs": "贺"
		},
		"賃": {
			"jp": "賃",
			"zht": "賃",
			"zhs": "赁"
		},
		"賄": {
			"jp": "賄",
			"zht": "賄",
			"zhs": "贿"
		},
		"資": {
			"jp": "資",
			"zht": "資",
			"zhs": "资"
		},
		"賊": {
			"jp": "賊",
			"zht": "賊",
			"zhs": "贼"
		},
		"賎": {
			"jp": "賎",
			"zht": "賤",
			"zhs": "贱"
		},
		"賛": {
			"jp": "賛",
			"zht": "贊",
			"zhs": "赞"
		},
		"賜": {
			"jp": "賜",
			"zht": "賜",
			"zhs": "赐"
		},
		"賞": {
			"jp": "賞",
			"zht": "賞",
			"zhs": "赏"
		},
		"賠": {
			"jp": "賠",
			"zht": "賠",
			"zhs": "赔"
		},
		"賢": {
			"jp": "賢",
			"zht": "賢",
			"zhs": "贤"
		},
		"賦": {
			"jp": "賦",
			"zht": "賦",
			"zhs": "赋"
		},
		"質": {
			"jp": "質",
			"zht": "質",
			"zhs": "质"
		},
		"頼": {
			"jp": "頼",
			"zht": "賴",
			"zhs": "赖"
		},
		"贈": {
			"jp": "贈",
			"zht": "贈",
			"zhs": "赠"
		},
		"贓": {
			"jp": "贓",
			"zht": "贓",
			"zhs": "赃"
		},
		"躍": {
			"jp": "躍",
			"zht": "躍",
			"zhs": "跃"
		},
		"践": {
			"jp": "践",
			"zht": "踐",
			"zhs": "践"
		},
		"踪": {
			"jp": "踪",
			"zht": "蹤",
			"zhs": "踪"
		},
		"車": {
			"jp": "車",
			"zht": "車",
			"zhs": "车"
		},
		"軌": {
			"jp": "軌",
			"zht": "軌",
			"zhs": "轨"
		},
		"軒": {
			"jp": "軒",
			"zht": "軒",
			"zhs": "轩"
		},
		"軟": {
			"jp": "軟",
			"zht": "軟",
			"zhs": "软"
		},
		"転": {
			"jp": "転",
			"zht": "轉",
			"zhs": "转"
		},
		"軸": {
			"jp": "軸",
			"zht": "軸",
			"zhs": "轴"
		},
		"軽": {
			"jp": "軽",
			"zht": "輕",
			"zhs": "轻"
		},
		"較": {
			"jp": "較",
			"zht": "較",
			"zhs": "较"
		},
		"載": {
			"jp": "載",
			"zht": "載",
			"zhs": "载"
		},
		"輝": {
			"jp": "輝",
			"zht": "輝",
			"zhs": "辉"
		},
		"輩": {
			"jp": "輩",
			"zht": "輩",
			"zhs": "辈"
		},
		"輪": {
			"jp": "輪",
			"zht": "輪",
			"zhs": "轮"
		},
		"輸": {
			"jp": "輸",
			"zht": "輸",
			"zhs": "输"
		},
		"轄": {
			"jp": "轄",
			"zht": "轄",
			"zhs": "辖"
		},
		"辞": {
			"jp": "辞",
			"zht": "辭",
			"zhs": "辞"
		},
		"辺": {
			"jp": "辺",
			"zht": "邊",
			"zhs": "边"
		},
		"達": {
			"jp": "達",
			"zht": "達",
			"zhs": "达"
		},
		"遷": {
			"jp": "遷",
			"zht": "遷",
			"zhs": "迁"
		},
		"過": {
			"jp": "過",
			"zht": "過",
			"zhs": "过"
		},
		"運": {
			"jp": "運",
			"zht": "運",
			"zhs": "运"
		},
		"還": {
			"jp": "還",
			"zht": "還",
			"zhs": "还"
		},
		"進": {
			"jp": "進",
			"zht": "進",
			"zhs": "进"
		},
		"遠": {
			"jp": "遠",
			"zht": "遠",
			"zhs": "远"
		},
		"違": {
			"jp": "違",
			"zht": "違",
			"zhs": "违"
		},
		"連": {
			"jp": "連",
			"zht": "連",
			"zhs": "连"
		},
		"遅": {
			"jp": "遅",
			"zht": "遲",
			"zhs": "迟"
		},
		"適": {
			"jp": "適",
			"zht": "適",
			"zhs": "适"
		},
		"選": {
			"jp": "選",
			"zht": "選",
			"zhs": "选"
		},
		"逓": {
			"jp": "逓",
			"zht": "遞",
			"zhs": "递"
		},
		"遺": {
			"jp": "遺",
			"zht": "遺",
			"zhs": "遗"
		},
		"遥": {
			"jp": "遥",
			"zht": "遙",
			"zhs": "遥"
		},
		"郵": {
			"jp": "郵",
			"zht": "郵",
			"zhs": "邮"
		},
		"隣": {
			"jp": "隣",
			"zht": "鄰",
			"zhs": "邻"
		},
		"酔": {
			"jp": "酔",
			"zht": "醉",
			"zhs": "醉"
		},
		"醸": {
			"jp": "醸",
			"zht": "釀",
			"zhs": "酿"
		},
		"釈": {
			"jp": "釈",
			"zht": "釋",
			"zhs": "释"
		},
		"針": {
			"jp": "針",
			"zht": "針",
			"zhs": "针"
		},
		"釣": {
			"jp": "釣",
			"zht": "釣",
			"zhs": "钓"
		},
		"鈍": {
			"jp": "鈍",
			"zht": "鈍",
			"zhs": "钝"
		},
		"鈴": {
			"jp": "鈴",
			"zht": "鈴",
			"zhs": "铃"
		},
		"鉄": {
			"jp": "鉄",
			"zht": "鐵",
			"zhs": "铁"
		},
		"鉛": {
			"jp": "鉛",
			"zht": "鉛",
			"zhs": "铅"
		},
		"鑑": {
			"jp": "鑑",
			"zht": "鑑",
			"zhs": "鉴"
		},
		"銀": {
			"jp": "銀",
			"zht": "銀",
			"zhs": "银"
		},
		"銃": {
			"jp": "銃",
			"zht": "銃",
			"zhs": "铳"
		},
		"銅": {
			"jp": "銅",
			"zht": "銅",
			"zhs": "铜"
		},
		"銑": {
			"jp": "銑",
			"zht": "銑",
			"zhs": "铣"
		},
		"銘": {
			"jp": "銘",
			"zht": "銘",
			"zhs": "铭"
		},
		"銭": {
			"jp": "銭",
			"zht": "錢",
			"zhs": "钱"
		},
		"鋭": {
			"jp": "鋭",
			"zht": "鋭",
			"zhs": "锐"
		},
		"鋳": {
			"jp": "鋳",
			"zht": "鑄",
			"zhs": "铸"
		},
		"鋼": {
			"jp": "鋼",
			"zht": "鋼",
			"zhs": "钢"
		},
		"錘": {
			"jp": "錘",
			"zht": "錘",
			"zhs": "锤"
		},
		"錠": {
			"jp": "錠",
			"zht": "錠",
			"zhs": "锭"
		},
		"錯": {
			"jp": "錯",
			"zht": "錯",
			"zhs": "错"
		},
		"鍾": {
			"jp": "鍾",
			"zht": "鍾",
			"zhs": "钟"
		},
		"鎖": {
			"jp": "鎖",
			"zht": "鎖",
			"zhs": "锁"
		},
		"鎮": {
			"jp": "鎮",
			"zht": "鎮",
			"zhs": "镇"
		},
		"鏡": {
			"jp": "鏡",
			"zht": "鏡",
			"zhs": "镜"
		},
		"長": {
			"jp": "長",
			"zht": "長",
			"zhs": "长"
		},
		"門": {
			"jp": "門",
			"zht": "門",
			"zhs": "门"
		},
		"閉": {
			"jp": "閉",
			"zht": "閉",
			"zhs": "闭"
		},
		"閑": {
			"jp": "閑",
			"zht": "閒",
			"zhs": "闲"
		},
		"間": {
			"jp": "間",
			"zht": "間",
			"zhs": "间"
		},
		"閣": {
			"jp": "閣",
			"zht": "閣",
			"zhs": "阁"
		},
		"閥": {
			"jp": "閥",
			"zht": "閥",
			"zhs": "阀"
		},
		"閲": {
			"jp": "閲",
			"zht": "閲",
			"zhs": "阅"
		},
		"隊": {
			"jp": "隊",
			"zht": "隊",
			"zhs": "队"
		},
		"陽": {
			"jp": "陽",
			"zht": "陽",
			"zhs": "阳"
		},
		"陰": {
			"jp": "陰",
			"zht": "陰",
			"zhs": "阴"
		},
		"陣": {
			"jp": "陣",
			"zht": "陣",
			"zhs": "阵"
		},
		"階": {
			"jp": "階",
			"zht": "階",
			"zhs": "阶"
		},
		"際": {
			"jp": "際",
			"zht": "際",
			"zhs": "际"
		},
		"陸": {
			"jp": "陸",
			"zht": "陸",
			"zhs": "陆"
		},
		"陳": {
			"jp": "陳",
			"zht": "陳",
			"zhs": "陈"
		},
		"陥": {
			"jp": "陥",
			"zht": "陷",
			"zhs": "陷"
		},
		"随": {
			"jp": "随",
			"zht": "隨",
			"zhs": "随"
		},
		"隠": {
			"jp": "隠",
			"zht": "隱",
			"zhs": "隐"
		},
		"隷": {
			"jp": "隷",
			"zht": "隷",
			"zhs": "隶"
		},
		"難": {
			"jp": "難",
			"zht": "難",
			"zhs": "难"
		},
		"鶏": {
			"jp": "鶏",
			"zht": "雞",
			"zhs": "鸡"
		},
		"霧": {
			"jp": "霧",
			"zht": "霧",
			"zhs": "雾"
		},
		"静": {
			"jp": "静",
			"zht": "靜",
			"zhs": "静"
		},
		"頂": {
			"jp": "頂",
			"zht": "頂",
			"zhs": "顶"
		},
		"項": {
			"jp": "項",
			"zht": "項",
			"zhs": "项"
		},
		"順": {
			"jp": "順",
			"zht": "順",
			"zhs": "顺"
		},
		"預": {
			"jp": "預",
			"zht": "預",
			"zhs": "预"
		},
		"頑": {
			"jp": "頑",
			"zht": "頑",
			"zhs": "顽"
		},
		"頒": {
			"jp": "頒",
			"zht": "頒",
			"zhs": "颁"
		},
		"領": {
			"jp": "領",
			"zht": "領",
			"zhs": "领"
		},
		"頻": {
			"jp": "頻",
			"zht": "頻",
			"zhs": "频"
		},
		"題": {
			"jp": "題",
			"zht": "題",
			"zhs": "题"
		},
		"額": {
			"jp": "額",
			"zht": "額",
			"zhs": "额"
		},
		"顔": {
			"jp": "顔",
			"zht": "顏",
			"zhs": "颜"
		},
		"風": {
			"jp": "風",
			"zht": "風",
			"zhs": "风"
		},
		"飛": {
			"jp": "飛",
			"zht": "飛",
			"zhs": "飞"
		},
		"飢": {
			"jp": "飢",
			"zht": "饑",
			"zhs": "饥"
		},
		"飯": {
			"jp": "飯",
			"zht": "飯",
			"zhs": "饭"
		},
		"飲": {
			"jp": "飲",
			"zht": "飲",
			"zhs": "饮"
		},
		"飼": {
			"jp": "飼",
			"zht": "飼",
			"zhs": "饲"
		},
		"飽": {
			"jp": "飽",
			"zht": "飽",
			"zhs": "饱"
		},
		"飾": {
			"jp": "飾",
			"zht": "飾",
			"zhs": "饰"
		},
		"餓": {
			"jp": "餓",
			"zht": "餓",
			"zhs": "饿"
		},
		"馬": {
			"jp": "馬",
			"zht": "馬",
			"zhs": "马"
		},
		"駅": {
			"jp": "駅",
			"zht": "驛",
			"zhs": "驿"
		},
		"駆": {
			"jp": "駆",
			"zht": "驅",
			"zhs": "驱"
		},
		"駐": {
			"jp": "駐",
			"zht": "駐",
			"zhs": "驻"
		},
		"騎": {
			"jp": "騎",
			"zht": "騎",
			"zhs": "骑"
		},
		"験": {
			"jp": "験",
			"zht": "驗",
			"zhs": "验"
		},
		"騒": {
			"jp": "騒",
			"zht": "騷",
			"zhs": "骚"
		},
		"騨": {
			"jp": "騨",
			"zht": "驔",
			"zhs": "驔"
		},
		"髄": {
			"jp": "髄",
			"zht": "髓",
			"zhs": "髓"
		},
		"髪": {
			"jp": "髪",
			"zht": "髮",
			"zhs": null
		},
		"魚": {
			"jp": "魚",
			"zht": "魚",
			"zhs": "鱼"
		},
		"魯": {
			"jp": "魯",
			"zht": "魯",
			"zhs": "鲁"
		},
		"鮮": {
			"jp": "鮮",
			"zht": "鮮",
			"zhs": "鲜"
		},
		"鯨": {
			"jp": "鯨",
			"zht": "鯨",
			"zhs": "鲸"
		},
		"鳥": {
			"jp": "鳥",
			"zht": "鳥",
			"zhs": "鸟"
		},
		"鳴": {
			"jp": "鳴",
			"zht": "鳴",
			"zhs": "鸣"
		},
		"鶫": {
			"jp": "鶫",
			"zht": "鶇",
			"zhs": "鸫"
		},
		"鶇": {
			"jp": "鶇",
			"zht": "鶇",
			"zhs": "鸫"
		},
		"麦": {
			"jp": "麦",
			"zht": "麥",
			"zhs": "麦"
		},
		"黄": {
			"jp": "黄",
			"zht": "黃",
			"zhs": "黄"
		},
		"黒": {
			"jp": "黒",
			"zht": "黑",
			"zhs": "黑"
		},
		"黙": {
			"jp": "黙",
			"zht": "默",
			"zhs": "默"
		},
		"齢": {
			"jp": "齢",
			"zht": "齡",
			"zhs": "龄"
		}
	},
	"zht": {
		"會": {
			"jp": "会",
			"zht": "會",
			"zhs": "会"
		},
		"箋": {
			"jp": "箋",
			"zht": "箋",
			"zhs": "笺"
		},
		"網": {
			"jp": "網",
			"zht": "網",
			"zhs": "网"
		},
		"處": {
			"jp": "処",
			"zht": "處",
			"zhs": "处"
		},
		"話": {
			"jp": "話",
			"zht": "話",
			"zhs": "话"
		},
		"馱": {
			"jp": "駄",
			"zht": "馱",
			"zhs": "驮"
		},
		"萬": {
			"jp": "万",
			"zht": "萬",
			"zhs": "万"
		},
		"與": {
			"jp": "与",
			"zht": "與",
			"zhs": "与"
		},
		"醜": {
			"jp": "醜",
			"zht": "醜",
			"zhs": "丑"
		},
		"專": {
			"jp": "専",
			"zht": "專",
			"zhs": "专"
		},
		"業": {
			"jp": "業",
			"zht": "業",
			"zhs": "业"
		},
		"東": {
			"jp": "東",
			"zht": "東",
			"zhs": "东"
		},
		"絲": {
			"jp": "絲",
			"zht": "絲",
			"zhs": "丝"
		},
		"兩": {
			"jp": "両",
			"zht": "兩",
			"zhs": "两"
		},
		"嚴": {
			"jp": "厳",
			"zht": "嚴",
			"zhs": "严"
		},
		"並": {
			"jp": "並",
			"zht": "並",
			"zhs": "并"
		},
		"喪": {
			"jp": "喪",
			"zht": "喪",
			"zhs": "丧"
		},
		"個": {
			"jp": "個",
			"zht": "個",
			"zhs": "个"
		},
		"豐": {
			"jp": "豊",
			"zht": "豐",
			"zhs": "丰"
		},
		"臨": {
			"jp": "臨",
			"zht": "臨",
			"zhs": "临"
		},
		"為": {
			"jp": "為",
			"zht": "為",
			"zhs": "为"
		},
		"麗": {
			"jp": "麗",
			"zht": "麗",
			"zhs": "丽"
		},
		"舉": {
			"jp": "挙",
			"zht": "舉",
			"zhs": "举"
		},
		"迺": {
			"jp": "廼",
			"zht": "迺",
			"zhs": "迺"
		},
		"義": {
			"jp": "義",
			"zht": "義",
			"zhs": "义"
		},
		"樂": {
			"jp": "楽",
			"zht": "樂",
			"zhs": "乐"
		},
		"乘": {
			"jp": "乗",
			"zht": "乘",
			"zhs": "乘"
		},
		"習": {
			"jp": "習",
			"zht": "習",
			"zhs": "习"
		},
		"鄉": {
			"jp": "郷",
			"zht": "鄉",
			"zhs": "乡"
		},
		"書": {
			"jp": "書",
			"zht": "書",
			"zhs": "书"
		},
		"買": {
			"jp": "買",
			"zht": "買",
			"zhs": "买"
		},
		"亂": {
			"jp": "乱",
			"zht": "亂",
			"zhs": "乱"
		},
		"乾": {
			"jp": "乾",
			"zht": "乾",
			"zhs": "干"
		},
		"龜": {
			"jp": "亀",
			"zht": "龜",
			"zhs": "龟"
		},
		"預": {
			"jp": "予",
			"zht": "預",
			"zhs": "预"
		},
		"貳": {
			"jp": "弐",
			"zht": "貳",
			"zhs": "贰"
		},
		"雲": {
			"jp": "雲",
			"zht": "雲",
			"zhs": "云"
		},
		"亞": {
			"jp": "亜",
			"zht": "亞",
			"zhs": "亚"
		},
		"產": {
			"jp": "産",
			"zht": "產",
			"zhs": "产"
		},
		"畝": {
			"jp": "畝",
			"zht": "畝",
			"zhs": "亩"
		},
		"親": {
			"jp": "親",
			"zht": "親",
			"zhs": "亲"
		},
		"億": {
			"jp": "億",
			"zht": "億",
			"zhs": "亿"
		},
		"僕": {
			"jp": "僕",
			"zht": "僕",
			"zhs": "仆"
		},
		"從": {
			"jp": "従",
			"zht": "從",
			"zhs": "从"
		},
		"佛": {
			"jp": "仏",
			"zht": "佛",
			"zhs": "佛"
		},
		"倉": {
			"jp": "倉",
			"zht": "倉",
			"zhs": "仓"
		},
		"儀": {
			"jp": "儀",
			"zht": "儀",
			"zhs": "仪"
		},
		"假": {
			"jp": "仮",
			"zht": "假",
			"zhs": "假"
		},
		"價": {
			"jp": "価",
			"zht": "價",
			"zhs": "价"
		},
		"眾": {
			"jp": "衆",
			"zht": "眾",
			"zhs": "众"
		},
		"優": {
			"jp": "優",
			"zht": "優",
			"zhs": "优"
		},
		"傳": {
			"jp": "伝",
			"zht": "傳",
			"zhs": "传"
		},
		"傘": {
			"jp": "傘",
			"zht": "傘",
			"zhs": "伞"
		},
		"偉": {
			"jp": "偉",
			"zht": "偉",
			"zhs": "伟"
		},
		"傷": {
			"jp": "傷",
			"zht": "傷",
			"zhs": "伤"
		},
		"倫": {
			"jp": "倫",
			"zht": "倫",
			"zhs": "伦"
		},
		"偽": {
			"jp": "偽",
			"zht": "偽",
			"zhs": "伪"
		},
		"體": {
			"jp": "体",
			"zht": "體",
			"zhs": "体"
		},
		"餘": {
			"jp": "余",
			"zht": "餘",
			"zhs": "余"
		},
		"來": {
			"jp": "来",
			"zht": "來",
			"zhs": "来"
		},
		"偵": {
			"jp": "偵",
			"zht": "偵",
			"zhs": "侦"
		},
		"側": {
			"jp": "側",
			"zht": "側",
			"zhs": "侧"
		},
		"儉": {
			"jp": "倹",
			"zht": "儉",
			"zhs": "俭"
		},
		"俱": {
			"jp": "倶",
			"zht": "俱",
			"zhs": "俱"
		},
		"債": {
			"jp": "債",
			"zht": "債",
			"zhs": "债"
		},
		"傾": {
			"jp": "傾",
			"zht": "傾",
			"zhs": "倾"
		},
		"償": {
			"jp": "償",
			"zht": "償",
			"zhs": "偿"
		},
		"傑": {
			"jp": "傑",
			"zht": "傑",
			"zhs": "杰"
		},
		"備": {
			"jp": "備",
			"zht": "備",
			"zhs": "备"
		},
		"當": {
			"jp": "当",
			"zht": "當",
			"zhs": "当"
		},
		"盡": {
			"jp": "尽",
			"zht": "盡",
			"zhs": "尽"
		},
		"兒": {
			"jp": "児",
			"zht": "兒",
			"zhs": "儿"
		},
		"黨": {
			"jp": "党",
			"zht": "黨",
			"zhs": "党"
		},
		"內": {
			"jp": "内",
			"zht": "內",
			"zhs": "内"
		},
		"關": {
			"jp": "関",
			"zht": "關",
			"zhs": "关"
		},
		"興": {
			"jp": "興",
			"zht": "興",
			"zhs": "兴"
		},
		"養": {
			"jp": "養",
			"zht": "養",
			"zhs": "养"
		},
		"獸": {
			"jp": "獣",
			"zht": "獸",
			"zhs": "兽"
		},
		"圓": {
			"jp": "円",
			"zht": "圓",
			"zhs": "圆"
		},
		"寫": {
			"jp": "写",
			"zht": "寫",
			"zhs": "写"
		},
		"軍": {
			"jp": "軍",
			"zht": "軍",
			"zhs": "军"
		},
		"農": {
			"jp": "農",
			"zht": "農",
			"zhs": "农"
		},
		"富": {
			"jp": "冨",
			"zht": "富",
			"zhs": "富"
		},
		"冰": {
			"jp": "氷",
			"zht": "冰",
			"zhs": "冰"
		},
		"衝": {
			"jp": "衝",
			"zht": "衝",
			"zhs": "冲"
		},
		"決": {
			"jp": "決",
			"zht": "決",
			"zhs": "决"
		},
		"凍": {
			"jp": "凍",
			"zht": "凍",
			"zhs": "冻"
		},
		"塗": {
			"jp": "塗",
			"zht": "塗",
			"zhs": "涂"
		},
		"淒": {
			"jp": "凄",
			"zht": "淒",
			"zhs": "凄"
		},
		"悽": {
			"jp": "凄",
			"zht": "悽",
			"zhs": "凄"
		},
		"準": {
			"jp": "准",
			"zht": "準",
			"zhs": "准"
		},
		"幾": {
			"jp": "幾",
			"zht": "幾",
			"zhs": "几"
		},
		"擊": {
			"jp": "撃",
			"zht": "擊",
			"zhs": "击"
		},
		"劃": {
			"jp": "画",
			"zht": "劃",
			"zhs": "划"
		},
		"畫": {
			"jp": "画",
			"zht": "畫",
			"zhs": "画"
		},
		"則": {
			"jp": "則",
			"zht": "則",
			"zhs": "则"
		},
		"剛": {
			"jp": "剛",
			"zht": "剛",
			"zhs": "刚"
		},
		"創": {
			"jp": "創",
			"zht": "創",
			"zhs": "创"
		},
		"別": {
			"jp": "別",
			"zht": "別",
			"zhs": "别"
		},
		"製": {
			"jp": "製",
			"zht": "製",
			"zhs": "制"
		},
		"卷": {
			"jp": "券",
			"zht": "卷",
			"zhs": "卷"
		},
		"剎": {
			"jp": "刹",
			"zht": "剎",
			"zhs": "刹"
		},
		"劑": {
			"jp": "剤",
			"zht": "劑",
			"zhs": "剂"
		},
		"劍": {
			"jp": "剣",
			"zht": "劍",
			"zhs": "剑"
		},
		"劇": {
			"jp": "劇",
			"zht": "劇",
			"zhs": "剧"
		},
		"剩": {
			"jp": "剰",
			"zht": "剩",
			"zhs": "剩"
		},
		"勸": {
			"jp": "勧",
			"zht": "勸",
			"zhs": "劝"
		},
		"務": {
			"jp": "務",
			"zht": "務",
			"zhs": "务"
		},
		"動": {
			"jp": "動",
			"zht": "動",
			"zhs": "动"
		},
		"勵": {
			"jp": "励",
			"zht": "勵",
			"zhs": "励"
		},
		"勞": {
			"jp": "労",
			"zht": "勞",
			"zhs": "劳"
		},
		"效": {
			"jp": "効",
			"zht": "效",
			"zhs": null
		},
		"勢": {
			"jp": "勢",
			"zht": "勢",
			"zhs": "势"
		},
		"勳": {
			"jp": "勲",
			"zht": "勳",
			"zhs": "勋"
		},
		"勝": {
			"jp": "勝",
			"zht": "勝",
			"zhs": "胜"
		},
		"區": {
			"jp": "区",
			"zht": "區",
			"zhs": "区"
		},
		"醫": {
			"jp": "医",
			"zht": "醫",
			"zhs": "医"
		},
		"華": {
			"jp": "華",
			"zht": "華",
			"zhs": "华"
		},
		"協": {
			"jp": "協",
			"zht": "協",
			"zhs": "协"
		},
		"單": {
			"jp": "単",
			"zht": "單",
			"zhs": "单"
		},
		"賣": {
			"jp": "売",
			"zht": "賣",
			"zhs": "卖"
		},
		"衛": {
			"jp": "衛",
			"zht": "衛",
			"zhs": "卫"
		},
		"廳": {
			"jp": "庁",
			"zht": "廳",
			"zhs": "厅"
		},
		"歷": {
			"jp": "歴",
			"zht": "歷",
			"zhs": "历"
		},
		"曆": {
			"jp": "暦",
			"zht": "曆",
			"zhs": "历"
		},
		"壓": {
			"jp": "圧",
			"zht": "壓",
			"zhs": "压"
		},
		"縣": {
			"jp": "県",
			"zht": "縣",
			"zhs": "县"
		},
		"參": {
			"jp": "参",
			"zht": "參",
			"zhs": "参"
		},
		"雙": {
			"jp": "双",
			"zht": "雙",
			"zhs": "双"
		},
		"收": {
			"jp": "収",
			"zht": "收",
			"zhs": "收"
		},
		"發": {
			"jp": "発",
			"zht": "發",
			"zhs": "发"
		},
		"變": {
			"jp": "変",
			"zht": "變",
			"zhs": "变"
		},
		"疊": {
			"jp": "畳",
			"zht": "疊",
			"zhs": "叠"
		},
		"號": {
			"jp": "号",
			"zht": "號",
			"zhs": "号"
		},
		"嘆": {
			"jp": "嘆",
			"zht": "嘆",
			"zhs": "叹"
		},
		"嚇": {
			"jp": "嚇",
			"zht": "嚇",
			"zhs": "吓"
		},
		"聽": {
			"jp": "聴",
			"zht": "聽",
			"zhs": "听"
		},
		"啟": {
			"jp": "啓",
			"zht": "啟",
			"zhs": "启"
		},
		"員": {
			"jp": "員",
			"zht": "員",
			"zhs": "员"
		},
		"諮": {
			"jp": "諮",
			"zht": "諮",
			"zhs": "谘"
		},
		"鹹": {
			"jp": "鹹",
			"zht": "鹹",
			"zhs": "咸"
		},
		"響": {
			"jp": "響",
			"zht": "響",
			"zhs": "响"
		},
		"問": {
			"jp": "問",
			"zht": "問",
			"zhs": "问"
		},
		"營": {
			"jp": "営",
			"zht": "營",
			"zhs": "营"
		},
		"噴": {
			"jp": "噴",
			"zht": "噴",
			"zhs": "喷"
		},
		"囑": {
			"jp": "嘱",
			"zht": "囑",
			"zhs": "嘱"
		},
		"蘇": {
			"jp": "蘇",
			"zht": "蘇",
			"zhs": "苏"
		},
		"團": {
			"jp": "団",
			"zht": "團",
			"zhs": "团"
		},
		"園": {
			"jp": "園",
			"zht": "園",
			"zhs": "园"
		},
		"國": {
			"jp": "国",
			"zht": "國",
			"zhs": "国"
		},
		"圍": {
			"jp": "囲",
			"zht": "圍",
			"zhs": "围"
		},
		"圖": {
			"jp": "図",
			"zht": "圖",
			"zhs": "图"
		},
		"圈": {
			"jp": "圏",
			"zht": "圈",
			"zhs": "圈"
		},
		"聖": {
			"jp": "聖",
			"zht": "聖",
			"zhs": "圣"
		},
		"場": {
			"jp": "場",
			"zht": "場",
			"zhs": "场"
		},
		"壞": {
			"jp": "壊",
			"zht": "壞",
			"zhs": "坏"
		},
		"塊": {
			"jp": "塊",
			"zht": "塊",
			"zhs": "块"
		},
		"堅": {
			"jp": "堅",
			"zht": "堅",
			"zhs": "坚"
		},
		"壇": {
			"jp": "壇",
			"zht": "壇",
			"zhs": "坛"
		},
		"墳": {
			"jp": "墳",
			"zht": "墳",
			"zhs": "坟"
		},
		"墜": {
			"jp": "墜",
			"zht": "墜",
			"zhs": "坠"
		},
		"壘": {
			"jp": "塁",
			"zht": "壘",
			"zhs": "垒"
		},
		"墾": {
			"jp": "墾",
			"zht": "墾",
			"zhs": "垦"
		},
		"執": {
			"jp": "執",
			"zht": "執",
			"zhs": "执"
		},
		"墮": {
			"jp": "堕",
			"zht": "墮",
			"zhs": "堕"
		},
		"報": {
			"jp": "報",
			"zht": "報",
			"zhs": "报"
		},
		"鹽": {
			"jp": "塩",
			"zht": "鹽",
			"zhs": "盐"
		},
		"增": {
			"jp": "増",
			"zht": "增",
			"zhs": "增"
		},
		"壤": {
			"jp": "壌",
			"zht": "壤",
			"zhs": "壤"
		},
		"壯": {
			"jp": "壮",
			"zht": "壯",
			"zhs": "壮"
		},
		"聲": {
			"jp": "声",
			"zht": "聲",
			"zhs": "声"
		},
		"壹": {
			"jp": "壱",
			"zht": "壹",
			"zhs": "壹"
		},
		"殻": {
			"jp": "殻",
			"zht": "殻",
			"zhs": "壳"
		},
		"殼": {
			"jp": "殼",
			"zht": "殼",
			"zhs": "壳"
		},
		"壽": {
			"jp": "寿",
			"zht": "壽",
			"zhs": "寿"
		},
		"復": {
			"jp": "復",
			"zht": "復",
			"zhs": "复"
		},
		"複": {
			"jp": "複",
			"zht": "複",
			"zhs": "复"
		},
		"夢": {
			"jp": "夢",
			"zht": "夢",
			"zhs": "梦"
		},
		"頭": {
			"jp": "頭",
			"zht": "頭",
			"zhs": "头"
		},
		"誇": {
			"jp": "誇",
			"zht": "誇",
			"zhs": "夸"
		},
		"奪": {
			"jp": "奪",
			"zht": "奪",
			"zhs": "夺"
		},
		"奮": {
			"jp": "奮",
			"zht": "奮",
			"zhs": "奋"
		},
		"獎": {
			"jp": "奨",
			"zht": "獎",
			"zhs": "奖"
		},
		"妝": {
			"jp": "粧",
			"zht": "妝",
			"zhs": "妆"
		},
		"婦": {
			"jp": "婦",
			"zht": "婦",
			"zhs": "妇"
		},
		"姐": {
			"jp": "姉",
			"zht": "姐",
			"zhs": "姐"
		},
		"姬": {
			"jp": "姫",
			"zht": "姬",
			"zhs": "姬"
		},
		"孃": {
			"jp": "嬢",
			"zht": "孃",
			"zhs": "娘"
		},
		"娛": {
			"jp": "娯",
			"zht": "娛",
			"zhs": "娱"
		},
		"孫": {
			"jp": "孫",
			"zht": "孫",
			"zhs": "孙"
		},
		"學": {
			"jp": "学",
			"zht": "學",
			"zhs": "学"
		},
		"寧": {
			"jp": "寧",
			"zht": "寧",
			"zhs": "宁"
		},
		"寶": {
			"jp": "宝",
			"zht": "寶",
			"zhs": "宝"
		},
		"實": {
			"jp": "実",
			"zht": "實",
			"zhs": "实"
		},
		"審": {
			"jp": "審",
			"zht": "審",
			"zhs": "审"
		},
		"憲": {
			"jp": "憲",
			"zht": "憲",
			"zhs": "宪"
		},
		"宮": {
			"jp": "宮",
			"zht": "宮",
			"zhs": "宫"
		},
		"寬": {
			"jp": "寬",
			"zht": "寬",
			"zhs": "宽"
		},
		"賓": {
			"jp": "賓",
			"zht": "賓",
			"zhs": "宾"
		},
		"祕": {
			"jp": "秘",
			"zht": "祕",
			"zhs": "秘"
		},
		"寢": {
			"jp": "寝",
			"zht": "寢",
			"zhs": "寝"
		},
		"對": {
			"jp": "対",
			"zht": "對",
			"zhs": "对"
		},
		"尋": {
			"jp": "尋",
			"zht": "尋",
			"zhs": "寻"
		},
		"導": {
			"jp": "導",
			"zht": "導",
			"zhs": "导"
		},
		"將": {
			"jp": "将",
			"zht": "將",
			"zhs": "将"
		},
		"層": {
			"jp": "層",
			"zht": "層",
			"zhs": "层"
		},
		"屬": {
			"jp": "属",
			"zht": "屬",
			"zhs": "属"
		},
		"歲": {
			"jp": "歳",
			"zht": "歲",
			"zhs": "岁"
		},
		"島": {
			"jp": "島",
			"zht": "島",
			"zhs": "岛"
		},
		"巖": {
			"jp": "巌",
			"zht": "巖",
			"zhs": "巖"
		},
		"峽": {
			"jp": "峡",
			"zht": "峽",
			"zhs": "峡"
		},
		"險": {
			"jp": "険",
			"zht": "險",
			"zhs": "险"
		},
		"幣": {
			"jp": "幣",
			"zht": "幣",
			"zhs": "币"
		},
		"帥": {
			"jp": "帥",
			"zht": "帥",
			"zhs": "帅"
		},
		"師": {
			"jp": "師",
			"zht": "師",
			"zhs": "师"
		},
		"帳": {
			"jp": "帳",
			"zht": "帳",
			"zhs": "帐"
		},
		"帶": {
			"jp": "帶",
			"zht": "帶",
			"zhs": "带"
		},
		"歸": {
			"jp": "帰",
			"zht": "歸",
			"zhs": "归"
		},
		"幹": {
			"jp": "幹",
			"zht": "幹",
			"zhs": "干"
		},
		"廣": {
			"jp": "広",
			"zht": "廣",
			"zhs": "广"
		},
		"莊": {
			"jp": "庄",
			"zht": "莊",
			"zhs": "庄"
		},
		"慶": {
			"jp": "慶",
			"zht": "慶",
			"zhs": "庆"
		},
		"庫": {
			"jp": "庫",
			"zht": "庫",
			"zhs": "库"
		},
		"應": {
			"jp": "応",
			"zht": "應",
			"zhs": "应"
		},
		"廢": {
			"jp": "廃",
			"zht": "廢",
			"zhs": "废"
		},
		"開": {
			"jp": "開",
			"zht": "開",
			"zhs": "开"
		},
		"辨": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辨"
		},
		"瓣": {
			"jp": "弁",
			"zht": "瓣",
			"zhs": "辨"
		},
		"辯": {
			"jp": "弁",
			"zht": "辯",
			"zhs": "辨"
		},
		"異": {
			"jp": "異",
			"zht": "異",
			"zhs": "异"
		},
		"棄": {
			"jp": "棄",
			"zht": "棄",
			"zhs": "弃"
		},
		"張": {
			"jp": "張",
			"zht": "張",
			"zhs": "张"
		},
		"彌": {
			"jp": "弥",
			"zht": "彌",
			"zhs": "弥"
		},
		"強": {
			"jp": "強",
			"zht": "強",
			"zhs": "强"
		},
		"彈": {
			"jp": "弾",
			"zht": "彈",
			"zhs": "弹"
		},
		"錄": {
			"jp": "録",
			"zht": "錄",
			"zhs": "录"
		},
		"彥": {
			"jp": "彦",
			"zht": "彥",
			"zhs": "彥"
		},
		"徹": {
			"jp": "徹",
			"zht": "徹",
			"zhs": "彻"
		},
		"徵": {
			"jp": "徴",
			"zht": "徵",
			"zhs": "征"
		},
		"徑": {
			"jp": "径",
			"zht": "徑",
			"zhs": "径"
		},
		"德": {
			"jp": "徳",
			"zht": "德",
			"zhs": "德"
		},
		"憶": {
			"jp": "憶",
			"zht": "憶",
			"zhs": "忆"
		},
		"誌": {
			"jp": "誌",
			"zht": "誌",
			"zhs": "志"
		},
		"憂": {
			"jp": "憂",
			"zht": "憂",
			"zhs": "忧"
		},
		"懷": {
			"jp": "懐",
			"zht": "懷",
			"zhs": "怀"
		},
		"態": {
			"jp": "態",
			"zht": "態",
			"zhs": "态"
		},
		"總": {
			"jp": "総",
			"zht": "總",
			"zhs": "总"
		},
		"恆": {
			"jp": "恒",
			"zht": "恆",
			"zhs": "恒"
		},
		"戀": {
			"jp": "恋",
			"zht": "戀",
			"zhs": "恋"
		},
		"懇": {
			"jp": "懇",
			"zht": "懇",
			"zhs": "恳"
		},
		"惠": {
			"jp": "恵",
			"zht": "惠",
			"zhs": "惠"
		},
		"惡": {
			"jp": "悪",
			"zht": "惡",
			"zhs": "恶"
		},
		"惱": {
			"jp": "悩",
			"zht": "惱",
			"zhs": "恼"
		},
		"悅": {
			"jp": "悦",
			"zht": "悅",
			"zhs": "悅"
		},
		"懸": {
			"jp": "懸",
			"zht": "懸",
			"zhs": "悬"
		},
		"驚": {
			"jp": "驚",
			"zht": "驚",
			"zhs": "惊"
		},
		"慘": {
			"jp": "惨",
			"zht": "慘",
			"zhs": "惨"
		},
		"懲": {
			"jp": "懲",
			"zht": "懲",
			"zhs": "惩"
		},
		"愛": {
			"jp": "愛",
			"zht": "愛",
			"zhs": "爱"
		},
		"憤": {
			"jp": "憤",
			"zht": "憤",
			"zhs": "愤"
		},
		"願": {
			"jp": "願",
			"zht": "願",
			"zhs": "愿"
		},
		"慮": {
			"jp": "慮",
			"zht": "慮",
			"zhs": "虑"
		},
		"戲": {
			"jp": "戯",
			"zht": "戲",
			"zhs": "戏"
		},
		"戰": {
			"jp": "戦",
			"zht": "戰",
			"zhs": "战"
		},
		"戶": {
			"jp": "戸",
			"zht": "戶",
			"zhs": "户"
		},
		"拂": {
			"jp": "払",
			"zht": "拂",
			"zhs": "拂"
		},
		"擴": {
			"jp": "拡",
			"zht": "擴",
			"zhs": "扩"
		},
		"掃": {
			"jp": "掃",
			"zht": "掃",
			"zhs": "扫"
		},
		"揚": {
			"jp": "揚",
			"zht": "揚",
			"zhs": "扬"
		},
		"拔": {
			"jp": "抜",
			"zht": "拔",
			"zhs": null
		},
		"擇": {
			"jp": "択",
			"zht": "擇",
			"zhs": "择"
		},
		"護": {
			"jp": "護",
			"zht": "護",
			"zhs": "护"
		},
		"擔": {
			"jp": "担",
			"zht": "擔",
			"zhs": "担"
		},
		"拜": {
			"jp": "拝",
			"zht": "拜",
			"zhs": "拜"
		},
		"擬": {
			"jp": "擬",
			"zht": "擬",
			"zhs": "拟"
		},
		"據": {
			"jp": "拠",
			"zht": "據",
			"zhs": "据"
		},
		"擁": {
			"jp": "擁",
			"zht": "擁",
			"zhs": "拥"
		},
		"挾": {
			"jp": "挟",
			"zht": "挾",
			"zhs": "挟"
		},
		"揮": {
			"jp": "揮",
			"zht": "揮",
			"zhs": "挥"
		},
		"插": {
			"jp": "揷",
			"zht": "插",
			"zhs": "插"
		},
		"損": {
			"jp": "損",
			"zht": "損",
			"zhs": "损"
		},
		"捨": {
			"jp": "捨",
			"zht": "捨",
			"zhs": "舍"
		},
		"揭": {
			"jp": "掲",
			"zht": "揭",
			"zhs": "揭"
		},
		"摑": {
			"jp": "掴",
			"zht": "摑",
			"zhs": "掴"
		},
		"搖": {
			"jp": "揺",
			"zht": "搖",
			"zhs": "摇"
		},
		"攝": {
			"jp": "摂",
			"zht": "攝",
			"zhs": "摄"
		},
		"敵": {
			"jp": "敵",
			"zht": "敵",
			"zhs": "敌"
		},
		"敗": {
			"jp": "敗",
			"zht": "敗",
			"zhs": "败"
		},
		"數": {
			"jp": "数",
			"zht": "數",
			"zhs": "数"
		},
		"齊": {
			"jp": "斉",
			"zht": "齊",
			"zhs": "齐"
		},
		"齋": {
			"jp": "斎",
			"zht": "齋",
			"zhs": "斋"
		},
		"鬥": {
			"jp": "闘",
			"zht": "鬥",
			"zhs": "斗"
		},
		"斷": {
			"jp": "断",
			"zht": "斷",
			"zhs": "断"
		},
		"舊": {
			"jp": "旧",
			"zht": "舊",
			"zhs": "旧"
		},
		"時": {
			"jp": "時",
			"zht": "時",
			"zhs": "时"
		},
		"曇": {
			"jp": "曇",
			"zht": "曇",
			"zhs": "昙"
		},
		"晝": {
			"jp": "昼",
			"zht": "晝",
			"zhs": "昼"
		},
		"顯": {
			"jp": "顕",
			"zht": "顯",
			"zhs": "显"
		},
		"曉": {
			"jp": "暁",
			"zht": "曉",
			"zhs": "晓"
		},
		"晚": {
			"jp": "晩",
			"zht": "晚",
			"zhs": "晚"
		},
		"暫": {
			"jp": "暫",
			"zht": "暫",
			"zhs": "暂"
		},
		"曾": {
			"jp": "曽",
			"zht": "曾",
			"zhs": "曾"
		},
		"術": {
			"jp": "術",
			"zht": "術",
			"zhs": "术"
		},
		"樸": {
			"jp": "樸",
			"zht": "樸",
			"zhs": "朴"
		},
		"機": {
			"jp": "機",
			"zht": "機",
			"zhs": "机"
		},
		"殺": {
			"jp": "殺",
			"zht": "殺",
			"zhs": "杀"
		},
		"雜": {
			"jp": "雑",
			"zht": "雜",
			"zhs": "杂"
		},
		"權": {
			"jp": "権",
			"zht": "權",
			"zhs": "权"
		},
		"條": {
			"jp": "条",
			"zht": "條",
			"zhs": "条"
		},
		"極": {
			"jp": "極",
			"zht": "極",
			"zhs": "极"
		},
		"樞": {
			"jp": "枢",
			"zht": "樞",
			"zhs": "枢"
		},
		"槍": {
			"jp": "槍",
			"zht": "槍",
			"zhs": "枪"
		},
		"查": {
			"jp": "査",
			"zht": "查",
			"zhs": "查"
		},
		"榮": {
			"jp": "栄",
			"zht": "榮",
			"zhs": "荣"
		},
		"標": {
			"jp": "標",
			"zht": "標",
			"zhs": "标"
		},
		"棧": {
			"jp": "桟",
			"zht": "棧",
			"zhs": "栈"
		},
		"棟": {
			"jp": "棟",
			"zht": "棟",
			"zhs": "栋"
		},
		"欄": {
			"jp": "欄",
			"zht": "欄",
			"zhs": "栏"
		},
		"樹": {
			"jp": "樹",
			"zht": "樹",
			"zhs": "树"
		},
		"樣": {
			"jp": "様",
			"zht": "樣",
			"zhs": "样"
		},
		"櫻": {
			"jp": "桜",
			"zht": "櫻",
			"zhs": "樱"
		},
		"橋": {
			"jp": "橋",
			"zht": "橋",
			"zhs": "桥"
		},
		"檢": {
			"jp": "検",
			"zht": "檢",
			"zhs": "检"
		},
		"樓": {
			"jp": "楼",
			"zht": "樓",
			"zhs": "楼"
		},
		"歡": {
			"jp": "歓",
			"zht": "歡",
			"zhs": "欢"
		},
		"歐": {
			"jp": "欧",
			"zht": "歐",
			"zhs": "欧"
		},
		"步": {
			"jp": "歩",
			"zht": "步",
			"zhs": "步"
		},
		"齒": {
			"jp": "歯",
			"zht": "齒",
			"zhs": "齿"
		},
		"殘": {
			"jp": "残",
			"zht": "殘",
			"zhs": "残"
		},
		"毆": {
			"jp": "殴",
			"zht": "毆",
			"zhs": "殴"
		},
		"氣": {
			"jp": "気",
			"zht": "氣",
			"zhs": "气"
		},
		"漢": {
			"jp": "漢",
			"zht": "漢",
			"zhs": "汉"
		},
		"湯": {
			"jp": "湯",
			"zht": "湯",
			"zhs": "汤"
		},
		"溝": {
			"jp": "溝",
			"zht": "溝",
			"zhs": "沟"
		},
		"澤": {
			"jp": "沢",
			"zht": "澤",
			"zhs": "泽"
		},
		"淚": {
			"jp": "涙",
			"zht": "淚",
			"zhs": "泪"
		},
		"瀧": {
			"jp": "滝",
			"zht": "瀧",
			"zhs": "泷"
		},
		"潔": {
			"jp": "潔",
			"zht": "潔",
			"zhs": "洁"
		},
		"淺": {
			"jp": "浅",
			"zht": "淺",
			"zhs": "浅"
		},
		"濁": {
			"jp": "濁",
			"zht": "濁",
			"zhs": "浊"
		},
		"測": {
			"jp": "測",
			"zht": "測",
			"zhs": "测"
		},
		"濟": {
			"jp": "済",
			"zht": "濟",
			"zhs": "济"
		},
		"濃": {
			"jp": "濃",
			"zht": "濃",
			"zhs": "浓"
		},
		"濱": {
			"jp": "浜",
			"zht": "濱",
			"zhs": "滨"
		},
		"涉": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涉"
		},
		"澀": {
			"jp": "渋",
			"zht": "澀",
			"zhs": "涉"
		},
		"渦": {
			"jp": "渦",
			"zht": "渦",
			"zhs": "涡"
		},
		"潤": {
			"jp": "潤",
			"zht": "潤",
			"zhs": "润"
		},
		"漬": {
			"jp": "漬",
			"zht": "漬",
			"zhs": "渍"
		},
		"漸": {
			"jp": "漸",
			"zht": "漸",
			"zhs": "渐"
		},
		"溪": {
			"jp": "渓",
			"zht": "溪",
			"zhs": "溪"
		},
		"漁": {
			"jp": "漁",
			"zht": "漁",
			"zhs": "渔"
		},
		"灣": {
			"jp": "湾",
			"zht": "灣",
			"zhs": "湾"
		},
		"濕": {
			"jp": "湿",
			"zht": "濕",
			"zhs": "湿"
		},
		"滿": {
			"jp": "満",
			"zht": "滿",
			"zhs": "满"
		},
		"滅": {
			"jp": "滅",
			"zht": "滅",
			"zhs": "灭"
		},
		"滯": {
			"jp": "滞",
			"zht": "滯",
			"zhs": "滞"
		},
		"濫": {
			"jp": "濫",
			"zht": "濫",
			"zhs": "滥"
		},
		"瀨": {
			"jp": "瀬",
			"zht": "瀨",
			"zhs": "濑"
		},
		"燈": {
			"jp": "灯",
			"zht": "燈",
			"zhs": "灯"
		},
		"靈": {
			"jp": "霊",
			"zht": "靈",
			"zhs": "灵"
		},
		"爐": {
			"jp": "炉",
			"zht": "爐",
			"zhs": "炉"
		},
		"點": {
			"jp": "点",
			"zht": "點",
			"zhs": "点"
		},
		"鍊": {
			"jp": "錬",
			"zht": "鍊",
			"zhs": "炼"
		},
		"練": {
			"jp": "練",
			"zht": "練",
			"zhs": "练"
		},
		"煙": {
			"jp": "煙",
			"zht": "煙",
			"zhs": "烟"
		},
		"煩": {
			"jp": "煩",
			"zht": "煩",
			"zhs": "烦"
		},
		"燒": {
			"jp": "焼",
			"zht": "燒",
			"zhs": "烧"
		},
		"熱": {
			"jp": "熱",
			"zht": "熱",
			"zhs": "热"
		},
		"焰": {
			"jp": "焔",
			"zht": "焰",
			"zhs": "焰"
		},
		"鍛": {
			"jp": "鍛",
			"zht": "鍛",
			"zhs": "锻"
		},
		"犧": {
			"jp": "犠",
			"zht": "犧",
			"zhs": "牺"
		},
		"狀": {
			"jp": "状",
			"zht": "狀",
			"zhs": "状"
		},
		"猶": {
			"jp": "猶",
			"zht": "猶",
			"zhs": "犹"
		},
		"獨": {
			"jp": "独",
			"zht": "獨",
			"zhs": "独"
		},
		"狹": {
			"jp": "狭",
			"zht": "狹",
			"zhs": "狭"
		},
		"獄": {
			"jp": "獄",
			"zht": "獄",
			"zhs": "狱"
		},
		"獵": {
			"jp": "猟",
			"zht": "獵",
			"zhs": "猎"
		},
		"貓": {
			"jp": "猫",
			"zht": "貓",
			"zhs": "猫"
		},
		"獻": {
			"jp": "献",
			"zht": "獻",
			"zhs": "献"
		},
		"獲": {
			"jp": "獲",
			"zht": "獲",
			"zhs": "获"
		},
		"穫": {
			"jp": "穫",
			"zht": "穫",
			"zhs": "获"
		},
		"環": {
			"jp": "環",
			"zht": "環",
			"zhs": "环"
		},
		"現": {
			"jp": "現",
			"zht": "現",
			"zhs": "现"
		},
		"璽": {
			"jp": "璽",
			"zht": "璽",
			"zhs": "玺"
		},
		"甦": {
			"jp": "甦",
			"zht": "甦",
			"zhs": "苏"
		},
		"電": {
			"jp": "電",
			"zht": "電",
			"zhs": "电"
		},
		"療": {
			"jp": "療",
			"zht": "療",
			"zhs": "疗"
		},
		"監": {
			"jp": "監",
			"zht": "監",
			"zhs": "监"
		},
		"蓋": {
			"jp": "蓋",
			"zht": "蓋",
			"zhs": "盖"
		},
		"盤": {
			"jp": "盤",
			"zht": "盤",
			"zhs": "盘"
		},
		"視": {
			"jp": "視",
			"zht": "視",
			"zhs": "视"
		},
		"著": {
			"jp": "着",
			"zht": "著",
			"zhs": "著"
		},
		"矯": {
			"jp": "矯",
			"zht": "矯",
			"zhs": "矫"
		},
		"礦": {
			"jp": "鉱",
			"zht": "礦",
			"zhs": "矿"
		},
		"碎": {
			"jp": "砕",
			"zht": "碎",
			"zhs": "碎"
		},
		"礎": {
			"jp": "礎",
			"zht": "礎",
			"zhs": "础"
		},
		"確": {
			"jp": "確",
			"zht": "確",
			"zhs": "确"
		},
		"禮": {
			"jp": "礼",
			"zht": "禮",
			"zhs": "礼"
		},
		"禍": {
			"jp": "禍",
			"zht": "禍",
			"zhs": "祸"
		},
		"禪": {
			"jp": "禅",
			"zht": "禪",
			"zhs": "禅"
		},
		"離": {
			"jp": "離",
			"zht": "離",
			"zhs": "离"
		},
		"種": {
			"jp": "種",
			"zht": "種",
			"zhs": "种"
		},
		"積": {
			"jp": "積",
			"zht": "積",
			"zhs": "积"
		},
		"稱": {
			"jp": "称",
			"zht": "稱",
			"zhs": "称"
		},
		"稻": {
			"jp": "稲",
			"zht": "稻",
			"zhs": "稻"
		},
		"穩": {
			"jp": "穏",
			"zht": "穩",
			"zhs": "稳"
		},
		"穀": {
			"jp": "穀",
			"zht": "穀",
			"zhs": "谷"
		},
		"穗": {
			"jp": "穂",
			"zht": "穗",
			"zhs": "穗"
		},
		"窮": {
			"jp": "窮",
			"zht": "窮",
			"zhs": "穷"
		},
		"竊": {
			"jp": "窃",
			"zht": "竊",
			"zhs": "窃"
		},
		"窗": {
			"jp": "窓",
			"zht": "窗",
			"zhs": "窗"
		},
		"龍": {
			"jp": "竜",
			"zht": "龍",
			"zhs": "龙"
		},
		"競": {
			"jp": "競",
			"zht": "競",
			"zhs": "竞"
		},
		"篤": {
			"jp": "篤",
			"zht": "篤",
			"zhs": "笃"
		},
		"筆": {
			"jp": "筆",
			"zht": "筆",
			"zhs": "笔"
		},
		"築": {
			"jp": "築",
			"zht": "築",
			"zhs": "筑"
		},
		"簡": {
			"jp": "簡",
			"zht": "簡",
			"zhs": "简"
		},
		"節": {
			"jp": "節",
			"zht": "節",
			"zhs": "节"
		},
		"範": {
			"jp": "範",
			"zht": "範",
			"zhs": "范"
		},
		"類": {
			"jp": "類",
			"zht": "類",
			"zhs": "类"
		},
		"粹": {
			"jp": "粋",
			"zht": "粹",
			"zhs": "粹"
		},
		"肅": {
			"jp": "粛",
			"zht": "肅",
			"zhs": "肃"
		},
		"糧": {
			"jp": "糧",
			"zht": "糧",
			"zhs": "粮"
		},
		"糾": {
			"jp": "糾",
			"zht": "糾",
			"zhs": "纠"
		},
		"紀": {
			"jp": "紀",
			"zht": "紀",
			"zhs": "纪"
		},
		"約": {
			"jp": "約",
			"zht": "約",
			"zhs": "约"
		},
		"紅": {
			"jp": "紅",
			"zht": "紅",
			"zhs": "红"
		},
		"紋": {
			"jp": "紋",
			"zht": "紋",
			"zhs": "纹"
		},
		"納": {
			"jp": "納",
			"zht": "納",
			"zhs": "纳"
		},
		"純": {
			"jp": "純",
			"zht": "純",
			"zhs": "纯"
		},
		"紙": {
			"jp": "紙",
			"zht": "紙",
			"zhs": "纸"
		},
		"級": {
			"jp": "級",
			"zht": "級",
			"zhs": "级"
		},
		"紛": {
			"jp": "紛",
			"zht": "紛",
			"zhs": "纷"
		},
		"紡": {
			"jp": "紡",
			"zht": "紡",
			"zhs": "纺"
		},
		"緊": {
			"jp": "緊",
			"zht": "緊",
			"zhs": "紧"
		},
		"細": {
			"jp": "細",
			"zht": "細",
			"zhs": "细"
		},
		"紳": {
			"jp": "紳",
			"zht": "紳",
			"zhs": "绅"
		},
		"紹": {
			"jp": "紹",
			"zht": "紹",
			"zhs": "绍"
		},
		"紺": {
			"jp": "紺",
			"zht": "紺",
			"zhs": "绀"
		},
		"終": {
			"jp": "終",
			"zht": "終",
			"zhs": "终"
		},
		"組": {
			"jp": "組",
			"zht": "組",
			"zhs": "组"
		},
		"經": {
			"jp": "経",
			"zht": "經",
			"zhs": "经"
		},
		"結": {
			"jp": "結",
			"zht": "結",
			"zhs": "结"
		},
		"絶": {
			"jp": "絶",
			"zht": "絶",
			"zhs": "绝"
		},
		"絕": {
			"jp": "絶",
			"zht": "絕",
			"zhs": "绝"
		},
		"絞": {
			"jp": "絞",
			"zht": "絞",
			"zhs": "绞"
		},
		"絡": {
			"jp": "絡",
			"zht": "絡",
			"zhs": "络"
		},
		"給": {
			"jp": "給",
			"zht": "給",
			"zhs": "给"
		},
		"統": {
			"jp": "統",
			"zht": "統",
			"zhs": "统"
		},
		"繪": {
			"jp": "絵",
			"zht": "繪",
			"zhs": "绘"
		},
		"絹": {
			"jp": "絹",
			"zht": "絹",
			"zhs": "绢"
		},
		"繼": {
			"jp": "継",
			"zht": "繼",
			"zhs": "继"
		},
		"續": {
			"jp": "続",
			"zht": "續",
			"zhs": "续"
		},
		"綠": {
			"jp": "緑",
			"zht": "綠",
			"zhs": "绿"
		},
		"線": {
			"jp": "線",
			"zht": "線",
			"zhs": "线"
		},
		"維": {
			"jp": "維",
			"zht": "維",
			"zhs": "维"
		},
		"綱": {
			"jp": "綱",
			"zht": "綱",
			"zhs": "纲"
		},
		"綿": {
			"jp": "綿",
			"zht": "綿",
			"zhs": "绵"
		},
		"緒": {
			"jp": "緒",
			"zht": "緒",
			"zhs": "绪"
		},
		"締": {
			"jp": "締",
			"zht": "締",
			"zhs": "缔"
		},
		"緣": {
			"jp": "縁",
			"zht": "緣",
			"zhs": "缘"
		},
		"編": {
			"jp": "編",
			"zht": "編",
			"zhs": "编"
		},
		"緩": {
			"jp": "緩",
			"zht": "緩",
			"zhs": "缓"
		},
		"緯": {
			"jp": "緯",
			"zht": "緯",
			"zhs": "纬"
		},
		"繩": {
			"jp": "縄",
			"zht": "繩",
			"zhs": "绳"
		},
		"縛": {
			"jp": "縛",
			"zht": "縛",
			"zhs": "缚"
		},
		"縱": {
			"jp": "縦",
			"zht": "縱",
			"zhs": "纵"
		},
		"縫": {
			"jp": "縫",
			"zht": "縫",
			"zhs": "缝"
		},
		"縮": {
			"jp": "縮",
			"zht": "縮",
			"zhs": "缩"
		},
		"纖": {
			"jp": "繊",
			"zht": "纖",
			"zhs": "纤"
		},
		"績": {
			"jp": "績",
			"zht": "績",
			"zhs": "绩"
		},
		"織": {
			"jp": "織",
			"zht": "織",
			"zhs": "织"
		},
		"繕": {
			"jp": "繕",
			"zht": "繕",
			"zhs": "缮"
		},
		"繭": {
			"jp": "繭",
			"zht": "繭",
			"zhs": "茧"
		},
		"繰": {
			"jp": "繰",
			"zht": "繰",
			"zhs": "缲"
		},
		"罐": {
			"jp": "缶",
			"zht": "罐",
			"zhs": "罐"
		},
		"鉢": {
			"jp": "鉢",
			"zht": "鉢",
			"zhs": "钵"
		},
		"羅": {
			"jp": "羅",
			"zht": "羅",
			"zhs": "罗"
		},
		"罰": {
			"jp": "罸",
			"zht": "罰",
			"zhs": "罚"
		},
		"罷": {
			"jp": "罷",
			"zht": "罷",
			"zhs": "罢"
		},
		"罵": {
			"jp": "罵",
			"zht": "罵",
			"zhs": "骂"
		},
		"職": {
			"jp": "職",
			"zht": "職",
			"zhs": "职"
		},
		"聞": {
			"jp": "聞",
			"zht": "聞",
			"zhs": "闻"
		},
		"聰": {
			"jp": "聡",
			"zht": "聰",
			"zhs": "聪"
		},
		"腸": {
			"jp": "腸",
			"zht": "腸",
			"zhs": "肠"
		},
		"膚": {
			"jp": "膚",
			"zht": "膚",
			"zhs": "肤"
		},
		"脹": {
			"jp": "脹",
			"zht": "脹",
			"zhs": "胀"
		},
		"脅": {
			"jp": "脅",
			"zht": "脅",
			"zhs": "胁"
		},
		"膽": {
			"jp": "胆",
			"zht": "膽",
			"zhs": "胆"
		},
		"臟": {
			"jp": "臓",
			"zht": "臟",
			"zhs": "脏"
		},
		"腦": {
			"jp": "脳",
			"zht": "腦",
			"zhs": "脑"
		},
		"腳": {
			"jp": "脚",
			"zht": "腳",
			"zhs": "脚"
		},
		"騰": {
			"jp": "騰",
			"zht": "騰",
			"zhs": "腾"
		},
		"舖": {
			"jp": "舗",
			"zht": "舖",
			"zhs": "铺"
		},
		"館": {
			"jp": "館",
			"zht": "館",
			"zhs": "馆"
		},
		"艦": {
			"jp": "艦",
			"zht": "艦",
			"zhs": "舰"
		},
		"藝": {
			"jp": "芸",
			"zht": "藝",
			"zhs": "艺"
		},
		"莖": {
			"jp": "茎",
			"zht": "莖",
			"zhs": "茎"
		},
		"薦": {
			"jp": "薦",
			"zht": "薦",
			"zhs": "荐"
		},
		"藥": {
			"jp": "薬",
			"zht": "藥",
			"zhs": "药"
		},
		"螢": {
			"jp": "蛍",
			"zht": "螢",
			"zhs": "萤"
		},
		"蔣": {
			"jp": "蒋",
			"zht": "蔣",
			"zhs": "蒋"
		},
		"藏": {
			"jp": "蔵",
			"zht": "藏",
			"zhs": "藏"
		},
		"虜": {
			"jp": "虜",
			"zht": "虜",
			"zhs": "虏"
		},
		"虛": {
			"jp": "虚",
			"zht": "虛",
			"zhs": "虚"
		},
		"蟲": {
			"jp": "虫",
			"zht": "蟲",
			"zhs": "虫"
		},
		"蝕": {
			"jp": "蝕",
			"zht": "蝕",
			"zhs": "蚀"
		},
		"蠶": {
			"jp": "蚕",
			"zht": "蠶",
			"zhs": "蚕"
		},
		"蠻": {
			"jp": "蛮",
			"zht": "蠻",
			"zhs": "蛮"
		},
		"補": {
			"jp": "補",
			"zht": "補",
			"zhs": "补"
		},
		"襲": {
			"jp": "襲",
			"zht": "襲",
			"zhs": "袭"
		},
		"裝": {
			"jp": "装",
			"zht": "裝",
			"zhs": "装"
		},
		"裡": {
			"jp": "裏",
			"zht": "裡",
			"zhs": "里"
		},
		"霸": {
			"jp": "覇",
			"zht": "霸",
			"zhs": "霸"
		},
		"見": {
			"jp": "見",
			"zht": "見",
			"zhs": "见"
		},
		"觀": {
			"jp": "観",
			"zht": "觀",
			"zhs": "观"
		},
		"規": {
			"jp": "規",
			"zht": "規",
			"zhs": "规"
		},
		"覺": {
			"jp": "覚",
			"zht": "覺",
			"zhs": "觉"
		},
		"覽": {
			"jp": "覧",
			"zht": "覽",
			"zhs": "览"
		},
		"觸": {
			"jp": "触",
			"zht": "觸",
			"zhs": "触"
		},
		"訂": {
			"jp": "訂",
			"zht": "訂",
			"zhs": "订"
		},
		"計": {
			"jp": "計",
			"zht": "計",
			"zhs": "计"
		},
		"討": {
			"jp": "討",
			"zht": "討",
			"zhs": "讨"
		},
		"訓": {
			"jp": "訓",
			"zht": "訓",
			"zhs": "训"
		},
		"記": {
			"jp": "記",
			"zht": "記",
			"zhs": "记"
		},
		"訟": {
			"jp": "訟",
			"zht": "訟",
			"zhs": "讼"
		},
		"訪": {
			"jp": "訪",
			"zht": "訪",
			"zhs": "访"
		},
		"設": {
			"jp": "設",
			"zht": "設",
			"zhs": "设"
		},
		"許": {
			"jp": "許",
			"zht": "許",
			"zhs": "许"
		},
		"譯": {
			"jp": "訳",
			"zht": "譯",
			"zhs": "译"
		},
		"訴": {
			"jp": "訴",
			"zht": "訴",
			"zhs": "诉"
		},
		"診": {
			"jp": "診",
			"zht": "診",
			"zhs": "诊"
		},
		"證": {
			"jp": "証",
			"zht": "證",
			"zhs": "证"
		},
		"詐": {
			"jp": "詐",
			"zht": "詐",
			"zhs": "诈"
		},
		"詔": {
			"jp": "詔",
			"zht": "詔",
			"zhs": "诏"
		},
		"評": {
			"jp": "評",
			"zht": "評",
			"zhs": "评"
		},
		"詛": {
			"jp": "詛",
			"zht": "詛",
			"zhs": "诅"
		},
		"詞": {
			"jp": "詞",
			"zht": "詞",
			"zhs": "词"
		},
		"試": {
			"jp": "試",
			"zht": "試",
			"zhs": "试"
		},
		"詩": {
			"jp": "詩",
			"zht": "詩",
			"zhs": "诗"
		},
		"詰": {
			"jp": "詰",
			"zht": "詰",
			"zhs": "诘"
		},
		"該": {
			"jp": "該",
			"zht": "該",
			"zhs": "该"
		},
		"詳": {
			"jp": "詳",
			"zht": "詳",
			"zhs": "详"
		},
		"譽": {
			"jp": "誉",
			"zht": "譽",
			"zhs": "誉"
		},
		"謄": {
			"jp": "謄",
			"zht": "謄",
			"zhs": "誊"
		},
		"認": {
			"jp": "認",
			"zht": "認",
			"zhs": "认"
		},
		"誕": {
			"jp": "誕",
			"zht": "誕",
			"zhs": "诞"
		},
		"誘": {
			"jp": "誘",
			"zht": "誘",
			"zhs": "诱"
		},
		"語": {
			"jp": "語",
			"zht": "語",
			"zhs": "语"
		},
		"誠": {
			"jp": "誠",
			"zht": "誠",
			"zhs": "诚"
		},
		"誤": {
			"jp": "誤",
			"zht": "誤",
			"zhs": "误"
		},
		"說": {
			"jp": "説",
			"zht": "說",
			"zhs": "说"
		},
		"讀": {
			"jp": "読",
			"zht": "讀",
			"zhs": "读"
		},
		"誰": {
			"jp": "誰",
			"zht": "誰",
			"zhs": "谁"
		},
		"課": {
			"jp": "課",
			"zht": "課",
			"zhs": "课"
		},
		"調": {
			"jp": "調",
			"zht": "調",
			"zhs": "调"
		},
		"談": {
			"jp": "談",
			"zht": "談",
			"zhs": "谈"
		},
		"請": {
			"jp": "請",
			"zht": "請",
			"zhs": "请"
		},
		"論": {
			"jp": "論",
			"zht": "論",
			"zhs": "论"
		},
		"諭": {
			"jp": "諭",
			"zht": "諭",
			"zhs": "谕"
		},
		"諸": {
			"jp": "諸",
			"zht": "諸",
			"zhs": "诸"
		},
		"諾": {
			"jp": "諾",
			"zht": "諾",
			"zhs": "诺"
		},
		"謀": {
			"jp": "謀",
			"zht": "謀",
			"zhs": "谋"
		},
		"謁": {
			"jp": "謁",
			"zht": "謁",
			"zhs": "谒"
		},
		"謎": {
			"jp": "謎",
			"zht": "謎",
			"zhs": "谜"
		},
		"謙": {
			"jp": "謙",
			"zht": "謙",
			"zhs": "谦"
		},
		"講": {
			"jp": "講",
			"zht": "講",
			"zhs": "讲"
		},
		"謝": {
			"jp": "謝",
			"zht": "謝",
			"zhs": "谢"
		},
		"謠": {
			"jp": "謡",
			"zht": "謠",
			"zhs": "谣"
		},
		"謹": {
			"jp": "謹",
			"zht": "謹",
			"zhs": "谨"
		},
		"識": {
			"jp": "識",
			"zht": "識",
			"zhs": "识"
		},
		"譜": {
			"jp": "譜",
			"zht": "譜",
			"zhs": "谱"
		},
		"議": {
			"jp": "議",
			"zht": "議",
			"zhs": "议"
		},
		"讓": {
			"jp": "譲",
			"zht": "讓",
			"zhs": "让"
		},
		"貝": {
			"jp": "貝",
			"zht": "貝",
			"zhs": "贝"
		},
		"貞": {
			"jp": "貞",
			"zht": "貞",
			"zhs": "贞"
		},
		"負": {
			"jp": "負",
			"zht": "負",
			"zhs": "负"
		},
		"財": {
			"jp": "財",
			"zht": "財",
			"zhs": "财"
		},
		"貢": {
			"jp": "貢",
			"zht": "貢",
			"zhs": "贡"
		},
		"貧": {
			"jp": "貧",
			"zht": "貧",
			"zhs": "贫"
		},
		"貨": {
			"jp": "貨",
			"zht": "貨",
			"zhs": "货"
		},
		"販": {
			"jp": "販",
			"zht": "販",
			"zhs": "贩"
		},
		"貪": {
			"jp": "貪",
			"zht": "貪",
			"zhs": "贪"
		},
		"責": {
			"jp": "責",
			"zht": "責",
			"zhs": "责"
		},
		"貯": {
			"jp": "貯",
			"zht": "貯",
			"zhs": "贮"
		},
		"貴": {
			"jp": "貴",
			"zht": "貴",
			"zhs": "贵"
		},
		"貸": {
			"jp": "貸",
			"zht": "貸",
			"zhs": "贷"
		},
		"費": {
			"jp": "費",
			"zht": "費",
			"zhs": "费"
		},
		"貿": {
			"jp": "貿",
			"zht": "貿",
			"zhs": "贸"
		},
		"賀": {
			"jp": "賀",
			"zht": "賀",
			"zhs": "贺"
		},
		"賃": {
			"jp": "賃",
			"zht": "賃",
			"zhs": "赁"
		},
		"賄": {
			"jp": "賄",
			"zht": "賄",
			"zhs": "贿"
		},
		"資": {
			"jp": "資",
			"zht": "資",
			"zhs": "资"
		},
		"賊": {
			"jp": "賊",
			"zht": "賊",
			"zhs": "贼"
		},
		"賤": {
			"jp": "賎",
			"zht": "賤",
			"zhs": "贱"
		},
		"贊": {
			"jp": "賛",
			"zht": "贊",
			"zhs": "赞"
		},
		"賜": {
			"jp": "賜",
			"zht": "賜",
			"zhs": "赐"
		},
		"賞": {
			"jp": "賞",
			"zht": "賞",
			"zhs": "赏"
		},
		"賠": {
			"jp": "賠",
			"zht": "賠",
			"zhs": "赔"
		},
		"賢": {
			"jp": "賢",
			"zht": "賢",
			"zhs": "贤"
		},
		"賦": {
			"jp": "賦",
			"zht": "賦",
			"zhs": "赋"
		},
		"質": {
			"jp": "質",
			"zht": "質",
			"zhs": "质"
		},
		"賴": {
			"jp": "頼",
			"zht": "賴",
			"zhs": "赖"
		},
		"贈": {
			"jp": "贈",
			"zht": "贈",
			"zhs": "赠"
		},
		"贓": {
			"jp": "贓",
			"zht": "贓",
			"zhs": "赃"
		},
		"躍": {
			"jp": "躍",
			"zht": "躍",
			"zhs": "跃"
		},
		"踐": {
			"jp": "践",
			"zht": "踐",
			"zhs": "践"
		},
		"蹤": {
			"jp": "踪",
			"zht": "蹤",
			"zhs": "踪"
		},
		"車": {
			"jp": "車",
			"zht": "車",
			"zhs": "车"
		},
		"軌": {
			"jp": "軌",
			"zht": "軌",
			"zhs": "轨"
		},
		"軒": {
			"jp": "軒",
			"zht": "軒",
			"zhs": "轩"
		},
		"軟": {
			"jp": "軟",
			"zht": "軟",
			"zhs": "软"
		},
		"轉": {
			"jp": "転",
			"zht": "轉",
			"zhs": "转"
		},
		"軸": {
			"jp": "軸",
			"zht": "軸",
			"zhs": "轴"
		},
		"輕": {
			"jp": "軽",
			"zht": "輕",
			"zhs": "轻"
		},
		"較": {
			"jp": "較",
			"zht": "較",
			"zhs": "较"
		},
		"載": {
			"jp": "載",
			"zht": "載",
			"zhs": "载"
		},
		"輝": {
			"jp": "輝",
			"zht": "輝",
			"zhs": "辉"
		},
		"輩": {
			"jp": "輩",
			"zht": "輩",
			"zhs": "辈"
		},
		"輪": {
			"jp": "輪",
			"zht": "輪",
			"zhs": "轮"
		},
		"輸": {
			"jp": "輸",
			"zht": "輸",
			"zhs": "输"
		},
		"轄": {
			"jp": "轄",
			"zht": "轄",
			"zhs": "辖"
		},
		"辭": {
			"jp": "辞",
			"zht": "辭",
			"zhs": "辞"
		},
		"邊": {
			"jp": "辺",
			"zht": "邊",
			"zhs": "边"
		},
		"達": {
			"jp": "達",
			"zht": "達",
			"zhs": "达"
		},
		"遷": {
			"jp": "遷",
			"zht": "遷",
			"zhs": "迁"
		},
		"過": {
			"jp": "過",
			"zht": "過",
			"zhs": "过"
		},
		"運": {
			"jp": "運",
			"zht": "運",
			"zhs": "运"
		},
		"還": {
			"jp": "還",
			"zht": "還",
			"zhs": "还"
		},
		"進": {
			"jp": "進",
			"zht": "進",
			"zhs": "进"
		},
		"遠": {
			"jp": "遠",
			"zht": "遠",
			"zhs": "远"
		},
		"違": {
			"jp": "違",
			"zht": "違",
			"zhs": "违"
		},
		"連": {
			"jp": "連",
			"zht": "連",
			"zhs": "连"
		},
		"遲": {
			"jp": "遅",
			"zht": "遲",
			"zhs": "迟"
		},
		"適": {
			"jp": "適",
			"zht": "適",
			"zhs": "适"
		},
		"選": {
			"jp": "選",
			"zht": "選",
			"zhs": "选"
		},
		"遞": {
			"jp": "逓",
			"zht": "遞",
			"zhs": "递"
		},
		"遺": {
			"jp": "遺",
			"zht": "遺",
			"zhs": "遗"
		},
		"遙": {
			"jp": "遥",
			"zht": "遙",
			"zhs": "遥"
		},
		"郵": {
			"jp": "郵",
			"zht": "郵",
			"zhs": "邮"
		},
		"鄰": {
			"jp": "隣",
			"zht": "鄰",
			"zhs": "邻"
		},
		"醉": {
			"jp": "酔",
			"zht": "醉",
			"zhs": "醉"
		},
		"釀": {
			"jp": "醸",
			"zht": "釀",
			"zhs": "酿"
		},
		"釋": {
			"jp": "釈",
			"zht": "釋",
			"zhs": "释"
		},
		"針": {
			"jp": "針",
			"zht": "針",
			"zhs": "针"
		},
		"釣": {
			"jp": "釣",
			"zht": "釣",
			"zhs": "钓"
		},
		"鈍": {
			"jp": "鈍",
			"zht": "鈍",
			"zhs": "钝"
		},
		"鈴": {
			"jp": "鈴",
			"zht": "鈴",
			"zhs": "铃"
		},
		"鐵": {
			"jp": "鉄",
			"zht": "鐵",
			"zhs": "铁"
		},
		"鉛": {
			"jp": "鉛",
			"zht": "鉛",
			"zhs": "铅"
		},
		"鑑": {
			"jp": "鑑",
			"zht": "鑑",
			"zhs": "鉴"
		},
		"銀": {
			"jp": "銀",
			"zht": "銀",
			"zhs": "银"
		},
		"銃": {
			"jp": "銃",
			"zht": "銃",
			"zhs": "铳"
		},
		"銅": {
			"jp": "銅",
			"zht": "銅",
			"zhs": "铜"
		},
		"銑": {
			"jp": "銑",
			"zht": "銑",
			"zhs": "铣"
		},
		"銘": {
			"jp": "銘",
			"zht": "銘",
			"zhs": "铭"
		},
		"錢": {
			"jp": "銭",
			"zht": "錢",
			"zhs": "钱"
		},
		"鋭": {
			"jp": "鋭",
			"zht": "鋭",
			"zhs": "锐"
		},
		"鑄": {
			"jp": "鋳",
			"zht": "鑄",
			"zhs": "铸"
		},
		"鋼": {
			"jp": "鋼",
			"zht": "鋼",
			"zhs": "钢"
		},
		"錘": {
			"jp": "錘",
			"zht": "錘",
			"zhs": "锤"
		},
		"錠": {
			"jp": "錠",
			"zht": "錠",
			"zhs": "锭"
		},
		"錯": {
			"jp": "錯",
			"zht": "錯",
			"zhs": "错"
		},
		"鍾": {
			"jp": "鍾",
			"zht": "鍾",
			"zhs": "钟"
		},
		"鎖": {
			"jp": "鎖",
			"zht": "鎖",
			"zhs": "锁"
		},
		"鎮": {
			"jp": "鎮",
			"zht": "鎮",
			"zhs": "镇"
		},
		"鏡": {
			"jp": "鏡",
			"zht": "鏡",
			"zhs": "镜"
		},
		"長": {
			"jp": "長",
			"zht": "長",
			"zhs": "长"
		},
		"門": {
			"jp": "門",
			"zht": "門",
			"zhs": "门"
		},
		"閉": {
			"jp": "閉",
			"zht": "閉",
			"zhs": "闭"
		},
		"閒": {
			"jp": "閑",
			"zht": "閒",
			"zhs": "闲"
		},
		"間": {
			"jp": "間",
			"zht": "間",
			"zhs": "间"
		},
		"閣": {
			"jp": "閣",
			"zht": "閣",
			"zhs": "阁"
		},
		"閥": {
			"jp": "閥",
			"zht": "閥",
			"zhs": "阀"
		},
		"閲": {
			"jp": "閲",
			"zht": "閲",
			"zhs": "阅"
		},
		"隊": {
			"jp": "隊",
			"zht": "隊",
			"zhs": "队"
		},
		"陽": {
			"jp": "陽",
			"zht": "陽",
			"zhs": "阳"
		},
		"陰": {
			"jp": "陰",
			"zht": "陰",
			"zhs": "阴"
		},
		"陣": {
			"jp": "陣",
			"zht": "陣",
			"zhs": "阵"
		},
		"階": {
			"jp": "階",
			"zht": "階",
			"zhs": "阶"
		},
		"際": {
			"jp": "際",
			"zht": "際",
			"zhs": "际"
		},
		"陸": {
			"jp": "陸",
			"zht": "陸",
			"zhs": "陆"
		},
		"陳": {
			"jp": "陳",
			"zht": "陳",
			"zhs": "陈"
		},
		"陷": {
			"jp": "陥",
			"zht": "陷",
			"zhs": "陷"
		},
		"隨": {
			"jp": "随",
			"zht": "隨",
			"zhs": "随"
		},
		"隱": {
			"jp": "隠",
			"zht": "隱",
			"zhs": "隐"
		},
		"隷": {
			"jp": "隷",
			"zht": "隷",
			"zhs": "隶"
		},
		"隸": {
			"jp": "隷",
			"zht": "隸",
			"zhs": "隶"
		},
		"難": {
			"jp": "難",
			"zht": "難",
			"zhs": "难"
		},
		"雞": {
			"jp": "鶏",
			"zht": "雞",
			"zhs": "鸡"
		},
		"鷄": {
			"jp": "鶏",
			"zht": "鷄",
			"zhs": "鸡"
		},
		"霧": {
			"jp": "霧",
			"zht": "霧",
			"zhs": "雾"
		},
		"靜": {
			"jp": "静",
			"zht": "靜",
			"zhs": "静"
		},
		"頂": {
			"jp": "頂",
			"zht": "頂",
			"zhs": "顶"
		},
		"項": {
			"jp": "項",
			"zht": "項",
			"zhs": "项"
		},
		"順": {
			"jp": "順",
			"zht": "順",
			"zhs": "顺"
		},
		"頑": {
			"jp": "頑",
			"zht": "頑",
			"zhs": "顽"
		},
		"頒": {
			"jp": "頒",
			"zht": "頒",
			"zhs": "颁"
		},
		"領": {
			"jp": "領",
			"zht": "領",
			"zhs": "领"
		},
		"頻": {
			"jp": "頻",
			"zht": "頻",
			"zhs": "频"
		},
		"題": {
			"jp": "題",
			"zht": "題",
			"zhs": "题"
		},
		"額": {
			"jp": "額",
			"zht": "額",
			"zhs": "额"
		},
		"顏": {
			"jp": "顔",
			"zht": "顏",
			"zhs": "颜"
		},
		"風": {
			"jp": "風",
			"zht": "風",
			"zhs": "风"
		},
		"飛": {
			"jp": "飛",
			"zht": "飛",
			"zhs": "飞"
		},
		"饑": {
			"jp": "飢",
			"zht": "饑",
			"zhs": "饥"
		},
		"飯": {
			"jp": "飯",
			"zht": "飯",
			"zhs": "饭"
		},
		"飲": {
			"jp": "飲",
			"zht": "飲",
			"zhs": "饮"
		},
		"飼": {
			"jp": "飼",
			"zht": "飼",
			"zhs": "饲"
		},
		"飽": {
			"jp": "飽",
			"zht": "飽",
			"zhs": "饱"
		},
		"飾": {
			"jp": "飾",
			"zht": "飾",
			"zhs": "饰"
		},
		"餓": {
			"jp": "餓",
			"zht": "餓",
			"zhs": "饿"
		},
		"馬": {
			"jp": "馬",
			"zht": "馬",
			"zhs": "马"
		},
		"驛": {
			"jp": "駅",
			"zht": "驛",
			"zhs": "驿"
		},
		"驅": {
			"jp": "駆",
			"zht": "驅",
			"zhs": "驱"
		},
		"駐": {
			"jp": "駐",
			"zht": "駐",
			"zhs": "驻"
		},
		"騎": {
			"jp": "騎",
			"zht": "騎",
			"zhs": "骑"
		},
		"驗": {
			"jp": "験",
			"zht": "驗",
			"zhs": "验"
		},
		"騷": {
			"jp": "騒",
			"zht": "騷",
			"zhs": "骚"
		},
		"驔": {
			"jp": "騨",
			"zht": "驔",
			"zhs": "驔"
		},
		"髓": {
			"jp": "髄",
			"zht": "髓",
			"zhs": "髓"
		},
		"髮": {
			"jp": "髪",
			"zht": "髮",
			"zhs": null
		},
		"魚": {
			"jp": "魚",
			"zht": "魚",
			"zhs": "鱼"
		},
		"魯": {
			"jp": "魯",
			"zht": "魯",
			"zhs": "鲁"
		},
		"鮮": {
			"jp": "鮮",
			"zht": "鮮",
			"zhs": "鲜"
		},
		"鯨": {
			"jp": "鯨",
			"zht": "鯨",
			"zhs": "鲸"
		},
		"鳥": {
			"jp": "鳥",
			"zht": "鳥",
			"zhs": "鸟"
		},
		"鳴": {
			"jp": "鳴",
			"zht": "鳴",
			"zhs": "鸣"
		},
		"鶇": {
			"jp": "鶫",
			"zht": "鶇",
			"zhs": "鸫"
		},
		"麥": {
			"jp": "麦",
			"zht": "麥",
			"zhs": "麦"
		},
		"黃": {
			"jp": "黄",
			"zht": "黃",
			"zhs": "黄"
		},
		"黑": {
			"jp": "黒",
			"zht": "黑",
			"zhs": "黑"
		},
		"默": {
			"jp": "黙",
			"zht": "默",
			"zhs": "默"
		},
		"齡": {
			"jp": "齢",
			"zht": "齡",
			"zhs": "龄"
		}
	},
	"zhs": {
		"会": {
			"jp": "会",
			"zht": "會",
			"zhs": "会"
		},
		"笺": {
			"jp": "箋",
			"zht": "箋",
			"zhs": "笺"
		},
		"网": {
			"jp": "網",
			"zht": "網",
			"zhs": "网"
		},
		"处": {
			"jp": "処",
			"zht": "處",
			"zhs": "处"
		},
		"话": {
			"jp": "話",
			"zht": "話",
			"zhs": "话"
		},
		"驮": {
			"jp": "駄",
			"zht": "馱",
			"zhs": "驮"
		},
		"万": {
			"jp": "万",
			"zht": "萬",
			"zhs": "万"
		},
		"与": {
			"jp": "与",
			"zht": "與",
			"zhs": "与"
		},
		"丑": {
			"jp": "醜",
			"zht": "醜",
			"zhs": "丑"
		},
		"专": {
			"jp": "専",
			"zht": "專",
			"zhs": "专"
		},
		"业": {
			"jp": "業",
			"zht": "業",
			"zhs": "业"
		},
		"东": {
			"jp": "東",
			"zht": "東",
			"zhs": "东"
		},
		"丝": {
			"jp": "絲",
			"zht": "絲",
			"zhs": "丝"
		},
		"两": {
			"jp": "両",
			"zht": "兩",
			"zhs": "两"
		},
		"严": {
			"jp": "厳",
			"zht": "嚴",
			"zhs": "严"
		},
		"并": {
			"jp": "並",
			"zht": "並",
			"zhs": "并"
		},
		"丧": {
			"jp": "喪",
			"zht": "喪",
			"zhs": "丧"
		},
		"个": {
			"jp": "個",
			"zht": "個",
			"zhs": "个"
		},
		"丰": {
			"jp": "豊",
			"zht": "豐",
			"zhs": "丰"
		},
		"临": {
			"jp": "臨",
			"zht": "臨",
			"zhs": "临"
		},
		"为": {
			"jp": "為",
			"zht": "為",
			"zhs": "为"
		},
		"丽": {
			"jp": "麗",
			"zht": "麗",
			"zhs": "丽"
		},
		"举": {
			"jp": "挙",
			"zht": "舉",
			"zhs": "举"
		},
		"迺": {
			"jp": "廼",
			"zht": "迺",
			"zhs": "迺"
		},
		"义": {
			"jp": "義",
			"zht": "義",
			"zhs": "义"
		},
		"乐": {
			"jp": "楽",
			"zht": "樂",
			"zhs": "乐"
		},
		"乘": {
			"jp": "乗",
			"zht": "乘",
			"zhs": "乘"
		},
		"习": {
			"jp": "習",
			"zht": "習",
			"zhs": "习"
		},
		"乡": {
			"jp": "郷",
			"zht": "鄉",
			"zhs": "乡"
		},
		"书": {
			"jp": "書",
			"zht": "書",
			"zhs": "书"
		},
		"买": {
			"jp": "買",
			"zht": "買",
			"zhs": "买"
		},
		"乱": {
			"jp": "乱",
			"zht": "亂",
			"zhs": "乱"
		},
		"干": {
			"jp": "乾",
			"zht": "乾",
			"zhs": "干"
		},
		"龟": {
			"jp": "亀",
			"zht": "龜",
			"zhs": "龟"
		},
		"预": {
			"jp": "予",
			"zht": "預",
			"zhs": "预"
		},
		"贰": {
			"jp": "弐",
			"zht": "貳",
			"zhs": "贰"
		},
		"云": {
			"jp": "雲",
			"zht": "雲",
			"zhs": "云"
		},
		"亚": {
			"jp": "亜",
			"zht": "亞",
			"zhs": "亚"
		},
		"产": {
			"jp": "産",
			"zht": "產",
			"zhs": "产"
		},
		"亩": {
			"jp": "畝",
			"zht": "畝",
			"zhs": "亩"
		},
		"亲": {
			"jp": "親",
			"zht": "親",
			"zhs": "亲"
		},
		"亿": {
			"jp": "億",
			"zht": "億",
			"zhs": "亿"
		},
		"仆": {
			"jp": "僕",
			"zht": "僕",
			"zhs": "仆"
		},
		"从": {
			"jp": "従",
			"zht": "從",
			"zhs": "从"
		},
		"佛": {
			"jp": "仏",
			"zht": "佛",
			"zhs": "佛"
		},
		"仓": {
			"jp": "倉",
			"zht": "倉",
			"zhs": "仓"
		},
		"仪": {
			"jp": "儀",
			"zht": "儀",
			"zhs": "仪"
		},
		"假": {
			"jp": "仮",
			"zht": "假",
			"zhs": "假"
		},
		"价": {
			"jp": "価",
			"zht": "價",
			"zhs": "价"
		},
		"众": {
			"jp": "衆",
			"zht": "眾",
			"zhs": "众"
		},
		"优": {
			"jp": "優",
			"zht": "優",
			"zhs": "优"
		},
		"传": {
			"jp": "伝",
			"zht": "傳",
			"zhs": "传"
		},
		"伞": {
			"jp": "傘",
			"zht": "傘",
			"zhs": "伞"
		},
		"伟": {
			"jp": "偉",
			"zht": "偉",
			"zhs": "伟"
		},
		"伤": {
			"jp": "傷",
			"zht": "傷",
			"zhs": "伤"
		},
		"伦": {
			"jp": "倫",
			"zht": "倫",
			"zhs": "伦"
		},
		"伪": {
			"jp": "偽",
			"zht": "偽",
			"zhs": "伪"
		},
		"体": {
			"jp": "体",
			"zht": "體",
			"zhs": "体"
		},
		"余": {
			"jp": "余",
			"zht": "餘",
			"zhs": "余"
		},
		"来": {
			"jp": "来",
			"zht": "來",
			"zhs": "来"
		},
		"侦": {
			"jp": "偵",
			"zht": "偵",
			"zhs": "侦"
		},
		"侧": {
			"jp": "側",
			"zht": "側",
			"zhs": "侧"
		},
		"俭": {
			"jp": "倹",
			"zht": "儉",
			"zhs": "俭"
		},
		"俱": {
			"jp": "倶",
			"zht": "俱",
			"zhs": "俱"
		},
		"债": {
			"jp": "債",
			"zht": "債",
			"zhs": "债"
		},
		"倾": {
			"jp": "傾",
			"zht": "傾",
			"zhs": "倾"
		},
		"偿": {
			"jp": "償",
			"zht": "償",
			"zhs": "偿"
		},
		"杰": {
			"jp": "傑",
			"zht": "傑",
			"zhs": "杰"
		},
		"备": {
			"jp": "備",
			"zht": "備",
			"zhs": "备"
		},
		"当": {
			"jp": "当",
			"zht": "當",
			"zhs": "当"
		},
		"尽": {
			"jp": "尽",
			"zht": "盡",
			"zhs": "尽"
		},
		"儿": {
			"jp": "児",
			"zht": "兒",
			"zhs": "儿"
		},
		"党": {
			"jp": "党",
			"zht": "黨",
			"zhs": "党"
		},
		"内": {
			"jp": "内",
			"zht": "內",
			"zhs": "内"
		},
		"关": {
			"jp": "関",
			"zht": "關",
			"zhs": "关"
		},
		"兴": {
			"jp": "興",
			"zht": "興",
			"zhs": "兴"
		},
		"养": {
			"jp": "養",
			"zht": "養",
			"zhs": "养"
		},
		"兽": {
			"jp": "獣",
			"zht": "獸",
			"zhs": "兽"
		},
		"圆": {
			"jp": "円",
			"zht": "圓",
			"zhs": "圆"
		},
		"写": {
			"jp": "写",
			"zht": "寫",
			"zhs": "写"
		},
		"军": {
			"jp": "軍",
			"zht": "軍",
			"zhs": "军"
		},
		"农": {
			"jp": "農",
			"zht": "農",
			"zhs": "农"
		},
		"富": {
			"jp": "冨",
			"zht": "富",
			"zhs": "富"
		},
		"冰": {
			"jp": "氷",
			"zht": "冰",
			"zhs": "冰"
		},
		"冲": {
			"jp": "衝",
			"zht": "衝",
			"zhs": "冲"
		},
		"决": {
			"jp": "決",
			"zht": "決",
			"zhs": "决"
		},
		"冻": {
			"jp": "凍",
			"zht": "凍",
			"zhs": "冻"
		},
		"涂": {
			"jp": "塗",
			"zht": "塗",
			"zhs": "涂"
		},
		"凄": {
			"jp": "凄",
			"zht": "淒",
			"zhs": "凄"
		},
		"准": {
			"jp": "准",
			"zht": "準",
			"zhs": "准"
		},
		"几": {
			"jp": "幾",
			"zht": "幾",
			"zhs": "几"
		},
		"击": {
			"jp": "撃",
			"zht": "擊",
			"zhs": "击"
		},
		"划": {
			"jp": "画",
			"zht": "劃",
			"zhs": "划"
		},
		"画": {
			"jp": "画",
			"zht": "畫",
			"zhs": "画"
		},
		"则": {
			"jp": "則",
			"zht": "則",
			"zhs": "则"
		},
		"刚": {
			"jp": "剛",
			"zht": "剛",
			"zhs": "刚"
		},
		"创": {
			"jp": "創",
			"zht": "創",
			"zhs": "创"
		},
		"别": {
			"jp": "別",
			"zht": "別",
			"zhs": "别"
		},
		"制": {
			"jp": "製",
			"zht": "製",
			"zhs": "制"
		},
		"卷": {
			"jp": "券",
			"zht": "卷",
			"zhs": "卷"
		},
		"刹": {
			"jp": "刹",
			"zht": "剎",
			"zhs": "刹"
		},
		"剂": {
			"jp": "剤",
			"zht": "劑",
			"zhs": "剂"
		},
		"剑": {
			"jp": "剣",
			"zht": "劍",
			"zhs": "剑"
		},
		"剧": {
			"jp": "劇",
			"zht": "劇",
			"zhs": "剧"
		},
		"剩": {
			"jp": "剰",
			"zht": "剩",
			"zhs": "剩"
		},
		"劝": {
			"jp": "勧",
			"zht": "勸",
			"zhs": "劝"
		},
		"务": {
			"jp": "務",
			"zht": "務",
			"zhs": "务"
		},
		"动": {
			"jp": "動",
			"zht": "動",
			"zhs": "动"
		},
		"励": {
			"jp": "励",
			"zht": "勵",
			"zhs": "励"
		},
		"劳": {
			"jp": "労",
			"zht": "勞",
			"zhs": "劳"
		},
		"势": {
			"jp": "勢",
			"zht": "勢",
			"zhs": "势"
		},
		"勋": {
			"jp": "勲",
			"zht": "勳",
			"zhs": "勋"
		},
		"胜": {
			"jp": "勝",
			"zht": "勝",
			"zhs": "胜"
		},
		"区": {
			"jp": "区",
			"zht": "區",
			"zhs": "区"
		},
		"医": {
			"jp": "医",
			"zht": "醫",
			"zhs": "医"
		},
		"华": {
			"jp": "華",
			"zht": "華",
			"zhs": "华"
		},
		"协": {
			"jp": "協",
			"zht": "協",
			"zhs": "协"
		},
		"单": {
			"jp": "単",
			"zht": "單",
			"zhs": "单"
		},
		"卖": {
			"jp": "売",
			"zht": "賣",
			"zhs": "卖"
		},
		"卫": {
			"jp": "衛",
			"zht": "衛",
			"zhs": "卫"
		},
		"厅": {
			"jp": "庁",
			"zht": "廳",
			"zhs": "厅"
		},
		"历": {
			"jp": "歴",
			"zht": "歷",
			"zhs": "历"
		},
		"压": {
			"jp": "圧",
			"zht": "壓",
			"zhs": "压"
		},
		"县": {
			"jp": "県",
			"zht": "縣",
			"zhs": "县"
		},
		"参": {
			"jp": "参",
			"zht": "參",
			"zhs": "参"
		},
		"双": {
			"jp": "双",
			"zht": "雙",
			"zhs": "双"
		},
		"收": {
			"jp": "収",
			"zht": "收",
			"zhs": "收"
		},
		"发": {
			"jp": "発",
			"zht": "發",
			"zhs": "发"
		},
		"变": {
			"jp": "変",
			"zht": "變",
			"zhs": "变"
		},
		"叠": {
			"jp": "畳",
			"zht": "疊",
			"zhs": "叠"
		},
		"号": {
			"jp": "号",
			"zht": "號",
			"zhs": "号"
		},
		"叹": {
			"jp": "嘆",
			"zht": "嘆",
			"zhs": "叹"
		},
		"吓": {
			"jp": "嚇",
			"zht": "嚇",
			"zhs": "吓"
		},
		"听": {
			"jp": "聴",
			"zht": "聽",
			"zhs": "听"
		},
		"启": {
			"jp": "啓",
			"zht": "啟",
			"zhs": "启"
		},
		"员": {
			"jp": "員",
			"zht": "員",
			"zhs": "员"
		},
		"谘": {
			"jp": "諮",
			"zht": "諮",
			"zhs": "谘"
		},
		"咸": {
			"jp": "鹹",
			"zht": "鹹",
			"zhs": "咸"
		},
		"响": {
			"jp": "響",
			"zht": "響",
			"zhs": "响"
		},
		"问": {
			"jp": "問",
			"zht": "問",
			"zhs": "问"
		},
		"营": {
			"jp": "営",
			"zht": "營",
			"zhs": "营"
		},
		"喷": {
			"jp": "噴",
			"zht": "噴",
			"zhs": "喷"
		},
		"嘱": {
			"jp": "嘱",
			"zht": "囑",
			"zhs": "嘱"
		},
		"苏": {
			"jp": "蘇",
			"zht": "蘇",
			"zhs": "苏"
		},
		"团": {
			"jp": "団",
			"zht": "團",
			"zhs": "团"
		},
		"园": {
			"jp": "園",
			"zht": "園",
			"zhs": "园"
		},
		"国": {
			"jp": "国",
			"zht": "國",
			"zhs": "国"
		},
		"围": {
			"jp": "囲",
			"zht": "圍",
			"zhs": "围"
		},
		"图": {
			"jp": "図",
			"zht": "圖",
			"zhs": "图"
		},
		"圈": {
			"jp": "圏",
			"zht": "圈",
			"zhs": "圈"
		},
		"圣": {
			"jp": "聖",
			"zht": "聖",
			"zhs": "圣"
		},
		"场": {
			"jp": "場",
			"zht": "場",
			"zhs": "场"
		},
		"坏": {
			"jp": "壊",
			"zht": "壞",
			"zhs": "坏"
		},
		"块": {
			"jp": "塊",
			"zht": "塊",
			"zhs": "块"
		},
		"坚": {
			"jp": "堅",
			"zht": "堅",
			"zhs": "坚"
		},
		"坛": {
			"jp": "壇",
			"zht": "壇",
			"zhs": "坛"
		},
		"坟": {
			"jp": "墳",
			"zht": "墳",
			"zhs": "坟"
		},
		"坠": {
			"jp": "墜",
			"zht": "墜",
			"zhs": "坠"
		},
		"垒": {
			"jp": "塁",
			"zht": "壘",
			"zhs": "垒"
		},
		"垦": {
			"jp": "墾",
			"zht": "墾",
			"zhs": "垦"
		},
		"执": {
			"jp": "執",
			"zht": "執",
			"zhs": "执"
		},
		"堕": {
			"jp": "堕",
			"zht": "墮",
			"zhs": "堕"
		},
		"报": {
			"jp": "報",
			"zht": "報",
			"zhs": "报"
		},
		"盐": {
			"jp": "塩",
			"zht": "鹽",
			"zhs": "盐"
		},
		"增": {
			"jp": "増",
			"zht": "增",
			"zhs": "增"
		},
		"壤": {
			"jp": "壌",
			"zht": "壤",
			"zhs": "壤"
		},
		"壮": {
			"jp": "壮",
			"zht": "壯",
			"zhs": "壮"
		},
		"声": {
			"jp": "声",
			"zht": "聲",
			"zhs": "声"
		},
		"壹": {
			"jp": "壱",
			"zht": "壹",
			"zhs": "壹"
		},
		"壳": {
			"jp": "殻",
			"zht": "殻",
			"zhs": "壳"
		},
		"寿": {
			"jp": "寿",
			"zht": "壽",
			"zhs": "寿"
		},
		"复": {
			"jp": "復",
			"zht": "復",
			"zhs": "复"
		},
		"梦": {
			"jp": "夢",
			"zht": "夢",
			"zhs": "梦"
		},
		"头": {
			"jp": "頭",
			"zht": "頭",
			"zhs": "头"
		},
		"夸": {
			"jp": "誇",
			"zht": "誇",
			"zhs": "夸"
		},
		"夺": {
			"jp": "奪",
			"zht": "奪",
			"zhs": "夺"
		},
		"奋": {
			"jp": "奮",
			"zht": "奮",
			"zhs": "奋"
		},
		"奖": {
			"jp": "奨",
			"zht": "獎",
			"zhs": "奖"
		},
		"妆": {
			"jp": "粧",
			"zht": "妝",
			"zhs": "妆"
		},
		"妇": {
			"jp": "婦",
			"zht": "婦",
			"zhs": "妇"
		},
		"姐": {
			"jp": "姉",
			"zht": "姐",
			"zhs": "姐"
		},
		"姬": {
			"jp": "姫",
			"zht": "姬",
			"zhs": "姬"
		},
		"娘": {
			"jp": "嬢",
			"zht": "孃",
			"zhs": "娘"
		},
		"娱": {
			"jp": "娯",
			"zht": "娛",
			"zhs": "娱"
		},
		"孙": {
			"jp": "孫",
			"zht": "孫",
			"zhs": "孙"
		},
		"学": {
			"jp": "学",
			"zht": "學",
			"zhs": "学"
		},
		"宁": {
			"jp": "寧",
			"zht": "寧",
			"zhs": "宁"
		},
		"宝": {
			"jp": "宝",
			"zht": "寶",
			"zhs": "宝"
		},
		"实": {
			"jp": "実",
			"zht": "實",
			"zhs": "实"
		},
		"审": {
			"jp": "審",
			"zht": "審",
			"zhs": "审"
		},
		"宪": {
			"jp": "憲",
			"zht": "憲",
			"zhs": "宪"
		},
		"宫": {
			"jp": "宮",
			"zht": "宮",
			"zhs": "宫"
		},
		"宽": {
			"jp": "寬",
			"zht": "寬",
			"zhs": "宽"
		},
		"宾": {
			"jp": "賓",
			"zht": "賓",
			"zhs": "宾"
		},
		"秘": {
			"jp": "秘",
			"zht": "祕",
			"zhs": "秘"
		},
		"寝": {
			"jp": "寝",
			"zht": "寢",
			"zhs": "寝"
		},
		"对": {
			"jp": "対",
			"zht": "對",
			"zhs": "对"
		},
		"寻": {
			"jp": "尋",
			"zht": "尋",
			"zhs": "寻"
		},
		"导": {
			"jp": "導",
			"zht": "導",
			"zhs": "导"
		},
		"将": {
			"jp": "将",
			"zht": "將",
			"zhs": "将"
		},
		"层": {
			"jp": "層",
			"zht": "層",
			"zhs": "层"
		},
		"属": {
			"jp": "属",
			"zht": "屬",
			"zhs": "属"
		},
		"岁": {
			"jp": "歳",
			"zht": "歲",
			"zhs": "岁"
		},
		"岛": {
			"jp": "島",
			"zht": "島",
			"zhs": "岛"
		},
		"巖": {
			"jp": "巌",
			"zht": "巖",
			"zhs": "巖"
		},
		"峡": {
			"jp": "峡",
			"zht": "峽",
			"zhs": "峡"
		},
		"险": {
			"jp": "険",
			"zht": "險",
			"zhs": "险"
		},
		"币": {
			"jp": "幣",
			"zht": "幣",
			"zhs": "币"
		},
		"帅": {
			"jp": "帥",
			"zht": "帥",
			"zhs": "帅"
		},
		"师": {
			"jp": "師",
			"zht": "師",
			"zhs": "师"
		},
		"帐": {
			"jp": "帳",
			"zht": "帳",
			"zhs": "帐"
		},
		"带": {
			"jp": "帶",
			"zht": "帶",
			"zhs": "带"
		},
		"归": {
			"jp": "帰",
			"zht": "歸",
			"zhs": "归"
		},
		"广": {
			"jp": "広",
			"zht": "廣",
			"zhs": "广"
		},
		"庄": {
			"jp": "庄",
			"zht": "莊",
			"zhs": "庄"
		},
		"庆": {
			"jp": "慶",
			"zht": "慶",
			"zhs": "庆"
		},
		"库": {
			"jp": "庫",
			"zht": "庫",
			"zhs": "库"
		},
		"应": {
			"jp": "応",
			"zht": "應",
			"zhs": "应"
		},
		"废": {
			"jp": "廃",
			"zht": "廢",
			"zhs": "废"
		},
		"开": {
			"jp": "開",
			"zht": "開",
			"zhs": "开"
		},
		"辨": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辨"
		},
		"瓣": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "瓣"
		},
		"辩": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辩"
		},
		"异": {
			"jp": "異",
			"zht": "異",
			"zhs": "异"
		},
		"弃": {
			"jp": "棄",
			"zht": "棄",
			"zhs": "弃"
		},
		"张": {
			"jp": "張",
			"zht": "張",
			"zhs": "张"
		},
		"弥": {
			"jp": "弥",
			"zht": "彌",
			"zhs": "弥"
		},
		"强": {
			"jp": "強",
			"zht": "強",
			"zhs": "强"
		},
		"弹": {
			"jp": "弾",
			"zht": "彈",
			"zhs": "弹"
		},
		"录": {
			"jp": "録",
			"zht": "錄",
			"zhs": "录"
		},
		"彥": {
			"jp": "彦",
			"zht": "彥",
			"zhs": "彥"
		},
		"彻": {
			"jp": "徹",
			"zht": "徹",
			"zhs": "彻"
		},
		"征": {
			"jp": "徴",
			"zht": "徵",
			"zhs": "征"
		},
		"径": {
			"jp": "径",
			"zht": "徑",
			"zhs": "径"
		},
		"德": {
			"jp": "徳",
			"zht": "德",
			"zhs": "德"
		},
		"忆": {
			"jp": "憶",
			"zht": "憶",
			"zhs": "忆"
		},
		"志": {
			"jp": "誌",
			"zht": "誌",
			"zhs": "志"
		},
		"忧": {
			"jp": "憂",
			"zht": "憂",
			"zhs": "忧"
		},
		"怀": {
			"jp": "懐",
			"zht": "懷",
			"zhs": "怀"
		},
		"态": {
			"jp": "態",
			"zht": "態",
			"zhs": "态"
		},
		"总": {
			"jp": "総",
			"zht": "總",
			"zhs": "总"
		},
		"恒": {
			"jp": "恒",
			"zht": "恆",
			"zhs": "恒"
		},
		"恋": {
			"jp": "恋",
			"zht": "戀",
			"zhs": "恋"
		},
		"恳": {
			"jp": "懇",
			"zht": "懇",
			"zhs": "恳"
		},
		"惠": {
			"jp": "恵",
			"zht": "惠",
			"zhs": "惠"
		},
		"恶": {
			"jp": "悪",
			"zht": "惡",
			"zhs": "恶"
		},
		"恼": {
			"jp": "悩",
			"zht": "惱",
			"zhs": "恼"
		},
		"悅": {
			"jp": "悦",
			"zht": "悅",
			"zhs": "悅"
		},
		"悬": {
			"jp": "懸",
			"zht": "懸",
			"zhs": "悬"
		},
		"惊": {
			"jp": "驚",
			"zht": "驚",
			"zhs": "惊"
		},
		"惨": {
			"jp": "惨",
			"zht": "慘",
			"zhs": "惨"
		},
		"惩": {
			"jp": "懲",
			"zht": "懲",
			"zhs": "惩"
		},
		"爱": {
			"jp": "愛",
			"zht": "愛",
			"zhs": "爱"
		},
		"愤": {
			"jp": "憤",
			"zht": "憤",
			"zhs": "愤"
		},
		"愿": {
			"jp": "願",
			"zht": "願",
			"zhs": "愿"
		},
		"虑": {
			"jp": "慮",
			"zht": "慮",
			"zhs": "虑"
		},
		"戏": {
			"jp": "戯",
			"zht": "戲",
			"zhs": "戏"
		},
		"战": {
			"jp": "戦",
			"zht": "戰",
			"zhs": "战"
		},
		"户": {
			"jp": "戸",
			"zht": "戶",
			"zhs": "户"
		},
		"拂": {
			"jp": "払",
			"zht": "拂",
			"zhs": "拂"
		},
		"扩": {
			"jp": "拡",
			"zht": "擴",
			"zhs": "扩"
		},
		"扫": {
			"jp": "掃",
			"zht": "掃",
			"zhs": "扫"
		},
		"扬": {
			"jp": "揚",
			"zht": "揚",
			"zhs": "扬"
		},
		"择": {
			"jp": "択",
			"zht": "擇",
			"zhs": "择"
		},
		"护": {
			"jp": "護",
			"zht": "護",
			"zhs": "护"
		},
		"担": {
			"jp": "担",
			"zht": "擔",
			"zhs": "担"
		},
		"拜": {
			"jp": "拝",
			"zht": "拜",
			"zhs": "拜"
		},
		"拟": {
			"jp": "擬",
			"zht": "擬",
			"zhs": "拟"
		},
		"据": {
			"jp": "拠",
			"zht": "據",
			"zhs": "据"
		},
		"拥": {
			"jp": "擁",
			"zht": "擁",
			"zhs": "拥"
		},
		"挟": {
			"jp": "挟",
			"zht": "挾",
			"zhs": "挟"
		},
		"挥": {
			"jp": "揮",
			"zht": "揮",
			"zhs": "挥"
		},
		"插": {
			"jp": "揷",
			"zht": "插",
			"zhs": "插"
		},
		"损": {
			"jp": "損",
			"zht": "損",
			"zhs": "损"
		},
		"舍": {
			"jp": "捨",
			"zht": "捨",
			"zhs": "舍"
		},
		"揭": {
			"jp": "掲",
			"zht": "揭",
			"zhs": "揭"
		},
		"掴": {
			"jp": "掴",
			"zht": "摑",
			"zhs": "掴"
		},
		"摇": {
			"jp": "揺",
			"zht": "搖",
			"zhs": "摇"
		},
		"摄": {
			"jp": "摂",
			"zht": "攝",
			"zhs": "摄"
		},
		"敌": {
			"jp": "敵",
			"zht": "敵",
			"zhs": "敌"
		},
		"败": {
			"jp": "敗",
			"zht": "敗",
			"zhs": "败"
		},
		"数": {
			"jp": "数",
			"zht": "數",
			"zhs": "数"
		},
		"齐": {
			"jp": "斉",
			"zht": "齊",
			"zhs": "齐"
		},
		"斋": {
			"jp": "斎",
			"zht": "齋",
			"zhs": "斋"
		},
		"斗": {
			"jp": "闘",
			"zht": "鬥",
			"zhs": "斗"
		},
		"断": {
			"jp": "断",
			"zht": "斷",
			"zhs": "断"
		},
		"旧": {
			"jp": "旧",
			"zht": "舊",
			"zhs": "旧"
		},
		"时": {
			"jp": "時",
			"zht": "時",
			"zhs": "时"
		},
		"昙": {
			"jp": "曇",
			"zht": "曇",
			"zhs": "昙"
		},
		"昼": {
			"jp": "昼",
			"zht": "晝",
			"zhs": "昼"
		},
		"显": {
			"jp": "顕",
			"zht": "顯",
			"zhs": "显"
		},
		"晓": {
			"jp": "暁",
			"zht": "曉",
			"zhs": "晓"
		},
		"晚": {
			"jp": "晩",
			"zht": "晚",
			"zhs": "晚"
		},
		"暂": {
			"jp": "暫",
			"zht": "暫",
			"zhs": "暂"
		},
		"曾": {
			"jp": "曽",
			"zht": "曾",
			"zhs": "曾"
		},
		"术": {
			"jp": "術",
			"zht": "術",
			"zhs": "术"
		},
		"朴": {
			"jp": "樸",
			"zht": "樸",
			"zhs": "朴"
		},
		"机": {
			"jp": "機",
			"zht": "機",
			"zhs": "机"
		},
		"杀": {
			"jp": "殺",
			"zht": "殺",
			"zhs": "杀"
		},
		"杂": {
			"jp": "雑",
			"zht": "雜",
			"zhs": "杂"
		},
		"权": {
			"jp": "権",
			"zht": "權",
			"zhs": "权"
		},
		"条": {
			"jp": "条",
			"zht": "條",
			"zhs": "条"
		},
		"极": {
			"jp": "極",
			"zht": "極",
			"zhs": "极"
		},
		"枢": {
			"jp": "枢",
			"zht": "樞",
			"zhs": "枢"
		},
		"枪": {
			"jp": "槍",
			"zht": "槍",
			"zhs": "枪"
		},
		"查": {
			"jp": "査",
			"zht": "查",
			"zhs": "查"
		},
		"荣": {
			"jp": "栄",
			"zht": "榮",
			"zhs": "荣"
		},
		"标": {
			"jp": "標",
			"zht": "標",
			"zhs": "标"
		},
		"栈": {
			"jp": "桟",
			"zht": "棧",
			"zhs": "栈"
		},
		"栋": {
			"jp": "棟",
			"zht": "棟",
			"zhs": "栋"
		},
		"栏": {
			"jp": "欄",
			"zht": "欄",
			"zhs": "栏"
		},
		"树": {
			"jp": "樹",
			"zht": "樹",
			"zhs": "树"
		},
		"样": {
			"jp": "様",
			"zht": "樣",
			"zhs": "样"
		},
		"樱": {
			"jp": "桜",
			"zht": "櫻",
			"zhs": "樱"
		},
		"桥": {
			"jp": "橋",
			"zht": "橋",
			"zhs": "桥"
		},
		"检": {
			"jp": "検",
			"zht": "檢",
			"zhs": "检"
		},
		"楼": {
			"jp": "楼",
			"zht": "樓",
			"zhs": "楼"
		},
		"欢": {
			"jp": "歓",
			"zht": "歡",
			"zhs": "欢"
		},
		"欧": {
			"jp": "欧",
			"zht": "歐",
			"zhs": "欧"
		},
		"步": {
			"jp": "歩",
			"zht": "步",
			"zhs": "步"
		},
		"齿": {
			"jp": "歯",
			"zht": "齒",
			"zhs": "齿"
		},
		"残": {
			"jp": "残",
			"zht": "殘",
			"zhs": "残"
		},
		"殴": {
			"jp": "殴",
			"zht": "毆",
			"zhs": "殴"
		},
		"气": {
			"jp": "気",
			"zht": "氣",
			"zhs": "气"
		},
		"汉": {
			"jp": "漢",
			"zht": "漢",
			"zhs": "汉"
		},
		"汤": {
			"jp": "湯",
			"zht": "湯",
			"zhs": "汤"
		},
		"沟": {
			"jp": "溝",
			"zht": "溝",
			"zhs": "沟"
		},
		"泽": {
			"jp": "沢",
			"zht": "澤",
			"zhs": "泽"
		},
		"泪": {
			"jp": "涙",
			"zht": "淚",
			"zhs": "泪"
		},
		"泷": {
			"jp": "滝",
			"zht": "瀧",
			"zhs": "泷"
		},
		"洁": {
			"jp": "潔",
			"zht": "潔",
			"zhs": "洁"
		},
		"浅": {
			"jp": "浅",
			"zht": "淺",
			"zhs": "浅"
		},
		"浊": {
			"jp": "濁",
			"zht": "濁",
			"zhs": "浊"
		},
		"测": {
			"jp": "測",
			"zht": "測",
			"zhs": "测"
		},
		"济": {
			"jp": "済",
			"zht": "濟",
			"zhs": "济"
		},
		"浓": {
			"jp": "濃",
			"zht": "濃",
			"zhs": "浓"
		},
		"滨": {
			"jp": "浜",
			"zht": "濱",
			"zhs": "滨"
		},
		"涉": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涉"
		},
		"涩": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涩"
		},
		"涡": {
			"jp": "渦",
			"zht": "渦",
			"zhs": "涡"
		},
		"润": {
			"jp": "潤",
			"zht": "潤",
			"zhs": "润"
		},
		"渍": {
			"jp": "漬",
			"zht": "漬",
			"zhs": "渍"
		},
		"渐": {
			"jp": "漸",
			"zht": "漸",
			"zhs": "渐"
		},
		"溪": {
			"jp": "渓",
			"zht": "溪",
			"zhs": "溪"
		},
		"渔": {
			"jp": "漁",
			"zht": "漁",
			"zhs": "渔"
		},
		"湾": {
			"jp": "湾",
			"zht": "灣",
			"zhs": "湾"
		},
		"湿": {
			"jp": "湿",
			"zht": "濕",
			"zhs": "湿"
		},
		"满": {
			"jp": "満",
			"zht": "滿",
			"zhs": "满"
		},
		"灭": {
			"jp": "滅",
			"zht": "滅",
			"zhs": "灭"
		},
		"滞": {
			"jp": "滞",
			"zht": "滯",
			"zhs": "滞"
		},
		"滥": {
			"jp": "濫",
			"zht": "濫",
			"zhs": "滥"
		},
		"濑": {
			"jp": "瀬",
			"zht": "瀨",
			"zhs": "濑"
		},
		"灯": {
			"jp": "灯",
			"zht": "燈",
			"zhs": "灯"
		},
		"灵": {
			"jp": "霊",
			"zht": "靈",
			"zhs": "灵"
		},
		"炉": {
			"jp": "炉",
			"zht": "爐",
			"zhs": "炉"
		},
		"点": {
			"jp": "点",
			"zht": "點",
			"zhs": "点"
		},
		"炼": {
			"jp": "錬",
			"zht": "鍊",
			"zhs": "炼"
		},
		"练": {
			"jp": "練",
			"zht": "練",
			"zhs": "练"
		},
		"烟": {
			"jp": "煙",
			"zht": "煙",
			"zhs": "烟"
		},
		"烦": {
			"jp": "煩",
			"zht": "煩",
			"zhs": "烦"
		},
		"烧": {
			"jp": "焼",
			"zht": "燒",
			"zhs": "烧"
		},
		"热": {
			"jp": "熱",
			"zht": "熱",
			"zhs": "热"
		},
		"焰": {
			"jp": "焔",
			"zht": "焰",
			"zhs": "焰"
		},
		"锻": {
			"jp": "鍛",
			"zht": "鍛",
			"zhs": "锻"
		},
		"牺": {
			"jp": "犠",
			"zht": "犧",
			"zhs": "牺"
		},
		"状": {
			"jp": "状",
			"zht": "狀",
			"zhs": "状"
		},
		"犹": {
			"jp": "猶",
			"zht": "猶",
			"zhs": "犹"
		},
		"独": {
			"jp": "独",
			"zht": "獨",
			"zhs": "独"
		},
		"狭": {
			"jp": "狭",
			"zht": "狹",
			"zhs": "狭"
		},
		"狱": {
			"jp": "獄",
			"zht": "獄",
			"zhs": "狱"
		},
		"猎": {
			"jp": "猟",
			"zht": "獵",
			"zhs": "猎"
		},
		"猫": {
			"jp": "猫",
			"zht": "貓",
			"zhs": "猫"
		},
		"献": {
			"jp": "献",
			"zht": "獻",
			"zhs": "献"
		},
		"获": {
			"jp": "獲",
			"zht": "獲",
			"zhs": "获"
		},
		"环": {
			"jp": "環",
			"zht": "環",
			"zhs": "环"
		},
		"现": {
			"jp": "現",
			"zht": "現",
			"zhs": "现"
		},
		"玺": {
			"jp": "璽",
			"zht": "璽",
			"zhs": "玺"
		},
		"电": {
			"jp": "電",
			"zht": "電",
			"zhs": "电"
		},
		"疗": {
			"jp": "療",
			"zht": "療",
			"zhs": "疗"
		},
		"监": {
			"jp": "監",
			"zht": "監",
			"zhs": "监"
		},
		"盖": {
			"jp": "蓋",
			"zht": "蓋",
			"zhs": "盖"
		},
		"盘": {
			"jp": "盤",
			"zht": "盤",
			"zhs": "盘"
		},
		"视": {
			"jp": "視",
			"zht": "視",
			"zhs": "视"
		},
		"著": {
			"jp": "着",
			"zht": "著",
			"zhs": "著"
		},
		"矫": {
			"jp": "矯",
			"zht": "矯",
			"zhs": "矫"
		},
		"矿": {
			"jp": "鉱",
			"zht": "礦",
			"zhs": "矿"
		},
		"碎": {
			"jp": "砕",
			"zht": "碎",
			"zhs": "碎"
		},
		"础": {
			"jp": "礎",
			"zht": "礎",
			"zhs": "础"
		},
		"确": {
			"jp": "確",
			"zht": "確",
			"zhs": "确"
		},
		"礼": {
			"jp": "礼",
			"zht": "禮",
			"zhs": "礼"
		},
		"祸": {
			"jp": "禍",
			"zht": "禍",
			"zhs": "祸"
		},
		"禅": {
			"jp": "禅",
			"zht": "禪",
			"zhs": "禅"
		},
		"离": {
			"jp": "離",
			"zht": "離",
			"zhs": "离"
		},
		"种": {
			"jp": "種",
			"zht": "種",
			"zhs": "种"
		},
		"积": {
			"jp": "積",
			"zht": "積",
			"zhs": "积"
		},
		"称": {
			"jp": "称",
			"zht": "稱",
			"zhs": "称"
		},
		"稻": {
			"jp": "稲",
			"zht": "稻",
			"zhs": "稻"
		},
		"稳": {
			"jp": "穏",
			"zht": "穩",
			"zhs": "稳"
		},
		"谷": {
			"jp": "穀",
			"zht": "穀",
			"zhs": "谷"
		},
		"穗": {
			"jp": "穂",
			"zht": "穗",
			"zhs": "穗"
		},
		"穷": {
			"jp": "窮",
			"zht": "窮",
			"zhs": "穷"
		},
		"窃": {
			"jp": "窃",
			"zht": "竊",
			"zhs": "窃"
		},
		"窗": {
			"jp": "窓",
			"zht": "窗",
			"zhs": "窗"
		},
		"龙": {
			"jp": "竜",
			"zht": "龍",
			"zhs": "龙"
		},
		"竞": {
			"jp": "競",
			"zht": "競",
			"zhs": "竞"
		},
		"笃": {
			"jp": "篤",
			"zht": "篤",
			"zhs": "笃"
		},
		"笔": {
			"jp": "筆",
			"zht": "筆",
			"zhs": "笔"
		},
		"筑": {
			"jp": "築",
			"zht": "築",
			"zhs": "筑"
		},
		"简": {
			"jp": "簡",
			"zht": "簡",
			"zhs": "简"
		},
		"节": {
			"jp": "節",
			"zht": "節",
			"zhs": "节"
		},
		"范": {
			"jp": "範",
			"zht": "範",
			"zhs": "范"
		},
		"类": {
			"jp": "類",
			"zht": "類",
			"zhs": "类"
		},
		"粹": {
			"jp": "粋",
			"zht": "粹",
			"zhs": "粹"
		},
		"肃": {
			"jp": "粛",
			"zht": "肅",
			"zhs": "肃"
		},
		"粮": {
			"jp": "糧",
			"zht": "糧",
			"zhs": "粮"
		},
		"纠": {
			"jp": "糾",
			"zht": "糾",
			"zhs": "纠"
		},
		"纪": {
			"jp": "紀",
			"zht": "紀",
			"zhs": "纪"
		},
		"约": {
			"jp": "約",
			"zht": "約",
			"zhs": "约"
		},
		"红": {
			"jp": "紅",
			"zht": "紅",
			"zhs": "红"
		},
		"纹": {
			"jp": "紋",
			"zht": "紋",
			"zhs": "纹"
		},
		"纳": {
			"jp": "納",
			"zht": "納",
			"zhs": "纳"
		},
		"纯": {
			"jp": "純",
			"zht": "純",
			"zhs": "纯"
		},
		"纸": {
			"jp": "紙",
			"zht": "紙",
			"zhs": "纸"
		},
		"级": {
			"jp": "級",
			"zht": "級",
			"zhs": "级"
		},
		"纷": {
			"jp": "紛",
			"zht": "紛",
			"zhs": "纷"
		},
		"纺": {
			"jp": "紡",
			"zht": "紡",
			"zhs": "纺"
		},
		"紧": {
			"jp": "緊",
			"zht": "緊",
			"zhs": "紧"
		},
		"细": {
			"jp": "細",
			"zht": "細",
			"zhs": "细"
		},
		"绅": {
			"jp": "紳",
			"zht": "紳",
			"zhs": "绅"
		},
		"绍": {
			"jp": "紹",
			"zht": "紹",
			"zhs": "绍"
		},
		"绀": {
			"jp": "紺",
			"zht": "紺",
			"zhs": "绀"
		},
		"终": {
			"jp": "終",
			"zht": "終",
			"zhs": "终"
		},
		"组": {
			"jp": "組",
			"zht": "組",
			"zhs": "组"
		},
		"经": {
			"jp": "経",
			"zht": "經",
			"zhs": "经"
		},
		"结": {
			"jp": "結",
			"zht": "結",
			"zhs": "结"
		},
		"绝": {
			"jp": "絶",
			"zht": "絶",
			"zhs": "绝"
		},
		"绞": {
			"jp": "絞",
			"zht": "絞",
			"zhs": "绞"
		},
		"络": {
			"jp": "絡",
			"zht": "絡",
			"zhs": "络"
		},
		"给": {
			"jp": "給",
			"zht": "給",
			"zhs": "给"
		},
		"统": {
			"jp": "統",
			"zht": "統",
			"zhs": "统"
		},
		"绘": {
			"jp": "絵",
			"zht": "繪",
			"zhs": "绘"
		},
		"绢": {
			"jp": "絹",
			"zht": "絹",
			"zhs": "绢"
		},
		"继": {
			"jp": "継",
			"zht": "繼",
			"zhs": "继"
		},
		"续": {
			"jp": "続",
			"zht": "續",
			"zhs": "续"
		},
		"绿": {
			"jp": "緑",
			"zht": "綠",
			"zhs": "绿"
		},
		"线": {
			"jp": "線",
			"zht": "線",
			"zhs": "线"
		},
		"维": {
			"jp": "維",
			"zht": "維",
			"zhs": "维"
		},
		"纲": {
			"jp": "綱",
			"zht": "綱",
			"zhs": "纲"
		},
		"绵": {
			"jp": "綿",
			"zht": "綿",
			"zhs": "绵"
		},
		"绪": {
			"jp": "緒",
			"zht": "緒",
			"zhs": "绪"
		},
		"缔": {
			"jp": "締",
			"zht": "締",
			"zhs": "缔"
		},
		"缘": {
			"jp": "縁",
			"zht": "緣",
			"zhs": "缘"
		},
		"编": {
			"jp": "編",
			"zht": "編",
			"zhs": "编"
		},
		"缓": {
			"jp": "緩",
			"zht": "緩",
			"zhs": "缓"
		},
		"纬": {
			"jp": "緯",
			"zht": "緯",
			"zhs": "纬"
		},
		"绳": {
			"jp": "縄",
			"zht": "繩",
			"zhs": "绳"
		},
		"缚": {
			"jp": "縛",
			"zht": "縛",
			"zhs": "缚"
		},
		"纵": {
			"jp": "縦",
			"zht": "縱",
			"zhs": "纵"
		},
		"缝": {
			"jp": "縫",
			"zht": "縫",
			"zhs": "缝"
		},
		"缩": {
			"jp": "縮",
			"zht": "縮",
			"zhs": "缩"
		},
		"纤": {
			"jp": "繊",
			"zht": "纖",
			"zhs": "纤"
		},
		"绩": {
			"jp": "績",
			"zht": "績",
			"zhs": "绩"
		},
		"织": {
			"jp": "織",
			"zht": "織",
			"zhs": "织"
		},
		"缮": {
			"jp": "繕",
			"zht": "繕",
			"zhs": "缮"
		},
		"茧": {
			"jp": "繭",
			"zht": "繭",
			"zhs": "茧"
		},
		"缲": {
			"jp": "繰",
			"zht": "繰",
			"zhs": "缲"
		},
		"罐": {
			"jp": "缶",
			"zht": "罐",
			"zhs": "罐"
		},
		"钵": {
			"jp": "鉢",
			"zht": "鉢",
			"zhs": "钵"
		},
		"罗": {
			"jp": "羅",
			"zht": "羅",
			"zhs": "罗"
		},
		"罚": {
			"jp": "罸",
			"zht": "罰",
			"zhs": "罚"
		},
		"罢": {
			"jp": "罷",
			"zht": "罷",
			"zhs": "罢"
		},
		"骂": {
			"jp": "罵",
			"zht": "罵",
			"zhs": "骂"
		},
		"职": {
			"jp": "職",
			"zht": "職",
			"zhs": "职"
		},
		"闻": {
			"jp": "聞",
			"zht": "聞",
			"zhs": "闻"
		},
		"聪": {
			"jp": "聡",
			"zht": "聰",
			"zhs": "聪"
		},
		"肠": {
			"jp": "腸",
			"zht": "腸",
			"zhs": "肠"
		},
		"肤": {
			"jp": "膚",
			"zht": "膚",
			"zhs": "肤"
		},
		"胀": {
			"jp": "脹",
			"zht": "脹",
			"zhs": "胀"
		},
		"胁": {
			"jp": "脅",
			"zht": "脅",
			"zhs": "胁"
		},
		"胆": {
			"jp": "胆",
			"zht": "膽",
			"zhs": "胆"
		},
		"脏": {
			"jp": "臓",
			"zht": "臟",
			"zhs": "脏"
		},
		"脑": {
			"jp": "脳",
			"zht": "腦",
			"zhs": "脑"
		},
		"脚": {
			"jp": "脚",
			"zht": "腳",
			"zhs": "脚"
		},
		"腾": {
			"jp": "騰",
			"zht": "騰",
			"zhs": "腾"
		},
		"铺": {
			"jp": "舗",
			"zht": "舖",
			"zhs": "铺"
		},
		"馆": {
			"jp": "館",
			"zht": "館",
			"zhs": "馆"
		},
		"舰": {
			"jp": "艦",
			"zht": "艦",
			"zhs": "舰"
		},
		"艺": {
			"jp": "芸",
			"zht": "藝",
			"zhs": "艺"
		},
		"茎": {
			"jp": "茎",
			"zht": "莖",
			"zhs": "茎"
		},
		"荐": {
			"jp": "薦",
			"zht": "薦",
			"zhs": "荐"
		},
		"药": {
			"jp": "薬",
			"zht": "藥",
			"zhs": "药"
		},
		"萤": {
			"jp": "蛍",
			"zht": "螢",
			"zhs": "萤"
		},
		"蒋": {
			"jp": "蒋",
			"zht": "蔣",
			"zhs": "蒋"
		},
		"藏": {
			"jp": "蔵",
			"zht": "藏",
			"zhs": "藏"
		},
		"虏": {
			"jp": "虜",
			"zht": "虜",
			"zhs": "虏"
		},
		"虚": {
			"jp": "虚",
			"zht": "虛",
			"zhs": "虚"
		},
		"虫": {
			"jp": "虫",
			"zht": "蟲",
			"zhs": "虫"
		},
		"蚀": {
			"jp": "蝕",
			"zht": "蝕",
			"zhs": "蚀"
		},
		"蚕": {
			"jp": "蚕",
			"zht": "蠶",
			"zhs": "蚕"
		},
		"蛮": {
			"jp": "蛮",
			"zht": "蠻",
			"zhs": "蛮"
		},
		"补": {
			"jp": "補",
			"zht": "補",
			"zhs": "补"
		},
		"袭": {
			"jp": "襲",
			"zht": "襲",
			"zhs": "袭"
		},
		"装": {
			"jp": "装",
			"zht": "裝",
			"zhs": "装"
		},
		"里": {
			"jp": "裏",
			"zht": "裡",
			"zhs": "里"
		},
		"霸": {
			"jp": "覇",
			"zht": "霸",
			"zhs": "霸"
		},
		"见": {
			"jp": "見",
			"zht": "見",
			"zhs": "见"
		},
		"观": {
			"jp": "観",
			"zht": "觀",
			"zhs": "观"
		},
		"规": {
			"jp": "規",
			"zht": "規",
			"zhs": "规"
		},
		"觉": {
			"jp": "覚",
			"zht": "覺",
			"zhs": "觉"
		},
		"览": {
			"jp": "覧",
			"zht": "覽",
			"zhs": "览"
		},
		"触": {
			"jp": "触",
			"zht": "觸",
			"zhs": "触"
		},
		"订": {
			"jp": "訂",
			"zht": "訂",
			"zhs": "订"
		},
		"计": {
			"jp": "計",
			"zht": "計",
			"zhs": "计"
		},
		"讨": {
			"jp": "討",
			"zht": "討",
			"zhs": "讨"
		},
		"训": {
			"jp": "訓",
			"zht": "訓",
			"zhs": "训"
		},
		"记": {
			"jp": "記",
			"zht": "記",
			"zhs": "记"
		},
		"讼": {
			"jp": "訟",
			"zht": "訟",
			"zhs": "讼"
		},
		"访": {
			"jp": "訪",
			"zht": "訪",
			"zhs": "访"
		},
		"设": {
			"jp": "設",
			"zht": "設",
			"zhs": "设"
		},
		"许": {
			"jp": "許",
			"zht": "許",
			"zhs": "许"
		},
		"译": {
			"jp": "訳",
			"zht": "譯",
			"zhs": "译"
		},
		"诉": {
			"jp": "訴",
			"zht": "訴",
			"zhs": "诉"
		},
		"诊": {
			"jp": "診",
			"zht": "診",
			"zhs": "诊"
		},
		"证": {
			"jp": "証",
			"zht": "證",
			"zhs": "证"
		},
		"诈": {
			"jp": "詐",
			"zht": "詐",
			"zhs": "诈"
		},
		"诏": {
			"jp": "詔",
			"zht": "詔",
			"zhs": "诏"
		},
		"评": {
			"jp": "評",
			"zht": "評",
			"zhs": "评"
		},
		"诅": {
			"jp": "詛",
			"zht": "詛",
			"zhs": "诅"
		},
		"词": {
			"jp": "詞",
			"zht": "詞",
			"zhs": "词"
		},
		"试": {
			"jp": "試",
			"zht": "試",
			"zhs": "试"
		},
		"诗": {
			"jp": "詩",
			"zht": "詩",
			"zhs": "诗"
		},
		"诘": {
			"jp": "詰",
			"zht": "詰",
			"zhs": "诘"
		},
		"该": {
			"jp": "該",
			"zht": "該",
			"zhs": "该"
		},
		"详": {
			"jp": "詳",
			"zht": "詳",
			"zhs": "详"
		},
		"誉": {
			"jp": "誉",
			"zht": "譽",
			"zhs": "誉"
		},
		"誊": {
			"jp": "謄",
			"zht": "謄",
			"zhs": "誊"
		},
		"认": {
			"jp": "認",
			"zht": "認",
			"zhs": "认"
		},
		"诞": {
			"jp": "誕",
			"zht": "誕",
			"zhs": "诞"
		},
		"诱": {
			"jp": "誘",
			"zht": "誘",
			"zhs": "诱"
		},
		"语": {
			"jp": "語",
			"zht": "語",
			"zhs": "语"
		},
		"诚": {
			"jp": "誠",
			"zht": "誠",
			"zhs": "诚"
		},
		"误": {
			"jp": "誤",
			"zht": "誤",
			"zhs": "误"
		},
		"说": {
			"jp": "説",
			"zht": "說",
			"zhs": "说"
		},
		"读": {
			"jp": "読",
			"zht": "讀",
			"zhs": "读"
		},
		"谁": {
			"jp": "誰",
			"zht": "誰",
			"zhs": "谁"
		},
		"课": {
			"jp": "課",
			"zht": "課",
			"zhs": "课"
		},
		"调": {
			"jp": "調",
			"zht": "調",
			"zhs": "调"
		},
		"谈": {
			"jp": "談",
			"zht": "談",
			"zhs": "谈"
		},
		"请": {
			"jp": "請",
			"zht": "請",
			"zhs": "请"
		},
		"论": {
			"jp": "論",
			"zht": "論",
			"zhs": "论"
		},
		"谕": {
			"jp": "諭",
			"zht": "諭",
			"zhs": "谕"
		},
		"诸": {
			"jp": "諸",
			"zht": "諸",
			"zhs": "诸"
		},
		"诺": {
			"jp": "諾",
			"zht": "諾",
			"zhs": "诺"
		},
		"谋": {
			"jp": "謀",
			"zht": "謀",
			"zhs": "谋"
		},
		"谒": {
			"jp": "謁",
			"zht": "謁",
			"zhs": "谒"
		},
		"谜": {
			"jp": "謎",
			"zht": "謎",
			"zhs": "谜"
		},
		"谦": {
			"jp": "謙",
			"zht": "謙",
			"zhs": "谦"
		},
		"讲": {
			"jp": "講",
			"zht": "講",
			"zhs": "讲"
		},
		"谢": {
			"jp": "謝",
			"zht": "謝",
			"zhs": "谢"
		},
		"谣": {
			"jp": "謡",
			"zht": "謠",
			"zhs": "谣"
		},
		"谨": {
			"jp": "謹",
			"zht": "謹",
			"zhs": "谨"
		},
		"识": {
			"jp": "識",
			"zht": "識",
			"zhs": "识"
		},
		"谱": {
			"jp": "譜",
			"zht": "譜",
			"zhs": "谱"
		},
		"议": {
			"jp": "議",
			"zht": "議",
			"zhs": "议"
		},
		"让": {
			"jp": "譲",
			"zht": "讓",
			"zhs": "让"
		},
		"贝": {
			"jp": "貝",
			"zht": "貝",
			"zhs": "贝"
		},
		"贞": {
			"jp": "貞",
			"zht": "貞",
			"zhs": "贞"
		},
		"负": {
			"jp": "負",
			"zht": "負",
			"zhs": "负"
		},
		"财": {
			"jp": "財",
			"zht": "財",
			"zhs": "财"
		},
		"贡": {
			"jp": "貢",
			"zht": "貢",
			"zhs": "贡"
		},
		"贫": {
			"jp": "貧",
			"zht": "貧",
			"zhs": "贫"
		},
		"货": {
			"jp": "貨",
			"zht": "貨",
			"zhs": "货"
		},
		"贩": {
			"jp": "販",
			"zht": "販",
			"zhs": "贩"
		},
		"贪": {
			"jp": "貪",
			"zht": "貪",
			"zhs": "贪"
		},
		"责": {
			"jp": "責",
			"zht": "責",
			"zhs": "责"
		},
		"贮": {
			"jp": "貯",
			"zht": "貯",
			"zhs": "贮"
		},
		"贵": {
			"jp": "貴",
			"zht": "貴",
			"zhs": "贵"
		},
		"贷": {
			"jp": "貸",
			"zht": "貸",
			"zhs": "贷"
		},
		"费": {
			"jp": "費",
			"zht": "費",
			"zhs": "费"
		},
		"贸": {
			"jp": "貿",
			"zht": "貿",
			"zhs": "贸"
		},
		"贺": {
			"jp": "賀",
			"zht": "賀",
			"zhs": "贺"
		},
		"赁": {
			"jp": "賃",
			"zht": "賃",
			"zhs": "赁"
		},
		"贿": {
			"jp": "賄",
			"zht": "賄",
			"zhs": "贿"
		},
		"资": {
			"jp": "資",
			"zht": "資",
			"zhs": "资"
		},
		"贼": {
			"jp": "賊",
			"zht": "賊",
			"zhs": "贼"
		},
		"贱": {
			"jp": "賎",
			"zht": "賤",
			"zhs": "贱"
		},
		"赞": {
			"jp": "賛",
			"zht": "贊",
			"zhs": "赞"
		},
		"赐": {
			"jp": "賜",
			"zht": "賜",
			"zhs": "赐"
		},
		"赏": {
			"jp": "賞",
			"zht": "賞",
			"zhs": "赏"
		},
		"赔": {
			"jp": "賠",
			"zht": "賠",
			"zhs": "赔"
		},
		"贤": {
			"jp": "賢",
			"zht": "賢",
			"zhs": "贤"
		},
		"赋": {
			"jp": "賦",
			"zht": "賦",
			"zhs": "赋"
		},
		"质": {
			"jp": "質",
			"zht": "質",
			"zhs": "质"
		},
		"赖": {
			"jp": "頼",
			"zht": "賴",
			"zhs": "赖"
		},
		"赠": {
			"jp": "贈",
			"zht": "贈",
			"zhs": "赠"
		},
		"赃": {
			"jp": "贓",
			"zht": "贓",
			"zhs": "赃"
		},
		"跃": {
			"jp": "躍",
			"zht": "躍",
			"zhs": "跃"
		},
		"践": {
			"jp": "践",
			"zht": "踐",
			"zhs": "践"
		},
		"踪": {
			"jp": "踪",
			"zht": "蹤",
			"zhs": "踪"
		},
		"车": {
			"jp": "車",
			"zht": "車",
			"zhs": "车"
		},
		"轨": {
			"jp": "軌",
			"zht": "軌",
			"zhs": "轨"
		},
		"轩": {
			"jp": "軒",
			"zht": "軒",
			"zhs": "轩"
		},
		"软": {
			"jp": "軟",
			"zht": "軟",
			"zhs": "软"
		},
		"转": {
			"jp": "転",
			"zht": "轉",
			"zhs": "转"
		},
		"轴": {
			"jp": "軸",
			"zht": "軸",
			"zhs": "轴"
		},
		"轻": {
			"jp": "軽",
			"zht": "輕",
			"zhs": "轻"
		},
		"较": {
			"jp": "較",
			"zht": "較",
			"zhs": "较"
		},
		"载": {
			"jp": "載",
			"zht": "載",
			"zhs": "载"
		},
		"辉": {
			"jp": "輝",
			"zht": "輝",
			"zhs": "辉"
		},
		"辈": {
			"jp": "輩",
			"zht": "輩",
			"zhs": "辈"
		},
		"轮": {
			"jp": "輪",
			"zht": "輪",
			"zhs": "轮"
		},
		"输": {
			"jp": "輸",
			"zht": "輸",
			"zhs": "输"
		},
		"辖": {
			"jp": "轄",
			"zht": "轄",
			"zhs": "辖"
		},
		"辞": {
			"jp": "辞",
			"zht": "辭",
			"zhs": "辞"
		},
		"边": {
			"jp": "辺",
			"zht": "邊",
			"zhs": "边"
		},
		"达": {
			"jp": "達",
			"zht": "達",
			"zhs": "达"
		},
		"迁": {
			"jp": "遷",
			"zht": "遷",
			"zhs": "迁"
		},
		"过": {
			"jp": "過",
			"zht": "過",
			"zhs": "过"
		},
		"运": {
			"jp": "運",
			"zht": "運",
			"zhs": "运"
		},
		"还": {
			"jp": "還",
			"zht": "還",
			"zhs": "还"
		},
		"进": {
			"jp": "進",
			"zht": "進",
			"zhs": "进"
		},
		"远": {
			"jp": "遠",
			"zht": "遠",
			"zhs": "远"
		},
		"违": {
			"jp": "違",
			"zht": "違",
			"zhs": "违"
		},
		"连": {
			"jp": "連",
			"zht": "連",
			"zhs": "连"
		},
		"迟": {
			"jp": "遅",
			"zht": "遲",
			"zhs": "迟"
		},
		"适": {
			"jp": "適",
			"zht": "適",
			"zhs": "适"
		},
		"选": {
			"jp": "選",
			"zht": "選",
			"zhs": "选"
		},
		"递": {
			"jp": "逓",
			"zht": "遞",
			"zhs": "递"
		},
		"遗": {
			"jp": "遺",
			"zht": "遺",
			"zhs": "遗"
		},
		"遥": {
			"jp": "遥",
			"zht": "遙",
			"zhs": "遥"
		},
		"邮": {
			"jp": "郵",
			"zht": "郵",
			"zhs": "邮"
		},
		"邻": {
			"jp": "隣",
			"zht": "鄰",
			"zhs": "邻"
		},
		"醉": {
			"jp": "酔",
			"zht": "醉",
			"zhs": "醉"
		},
		"酿": {
			"jp": "醸",
			"zht": "釀",
			"zhs": "酿"
		},
		"释": {
			"jp": "釈",
			"zht": "釋",
			"zhs": "释"
		},
		"针": {
			"jp": "針",
			"zht": "針",
			"zhs": "针"
		},
		"钓": {
			"jp": "釣",
			"zht": "釣",
			"zhs": "钓"
		},
		"钝": {
			"jp": "鈍",
			"zht": "鈍",
			"zhs": "钝"
		},
		"铃": {
			"jp": "鈴",
			"zht": "鈴",
			"zhs": "铃"
		},
		"铁": {
			"jp": "鉄",
			"zht": "鐵",
			"zhs": "铁"
		},
		"铅": {
			"jp": "鉛",
			"zht": "鉛",
			"zhs": "铅"
		},
		"鉴": {
			"jp": "鑑",
			"zht": "鑑",
			"zhs": "鉴"
		},
		"银": {
			"jp": "銀",
			"zht": "銀",
			"zhs": "银"
		},
		"铳": {
			"jp": "銃",
			"zht": "銃",
			"zhs": "铳"
		},
		"铜": {
			"jp": "銅",
			"zht": "銅",
			"zhs": "铜"
		},
		"铣": {
			"jp": "銑",
			"zht": "銑",
			"zhs": "铣"
		},
		"铭": {
			"jp": "銘",
			"zht": "銘",
			"zhs": "铭"
		},
		"钱": {
			"jp": "銭",
			"zht": "錢",
			"zhs": "钱"
		},
		"锐": {
			"jp": "鋭",
			"zht": "鋭",
			"zhs": "锐"
		},
		"铸": {
			"jp": "鋳",
			"zht": "鑄",
			"zhs": "铸"
		},
		"钢": {
			"jp": "鋼",
			"zht": "鋼",
			"zhs": "钢"
		},
		"锤": {
			"jp": "錘",
			"zht": "錘",
			"zhs": "锤"
		},
		"锭": {
			"jp": "錠",
			"zht": "錠",
			"zhs": "锭"
		},
		"错": {
			"jp": "錯",
			"zht": "錯",
			"zhs": "错"
		},
		"钟": {
			"jp": "鍾",
			"zht": "鍾",
			"zhs": "钟"
		},
		"锁": {
			"jp": "鎖",
			"zht": "鎖",
			"zhs": "锁"
		},
		"镇": {
			"jp": "鎮",
			"zht": "鎮",
			"zhs": "镇"
		},
		"镜": {
			"jp": "鏡",
			"zht": "鏡",
			"zhs": "镜"
		},
		"长": {
			"jp": "長",
			"zht": "長",
			"zhs": "长"
		},
		"门": {
			"jp": "門",
			"zht": "門",
			"zhs": "门"
		},
		"闭": {
			"jp": "閉",
			"zht": "閉",
			"zhs": "闭"
		},
		"闲": {
			"jp": "閑",
			"zht": "閒",
			"zhs": "闲"
		},
		"间": {
			"jp": "間",
			"zht": "間",
			"zhs": "间"
		},
		"阁": {
			"jp": "閣",
			"zht": "閣",
			"zhs": "阁"
		},
		"阀": {
			"jp": "閥",
			"zht": "閥",
			"zhs": "阀"
		},
		"阅": {
			"jp": "閲",
			"zht": "閲",
			"zhs": "阅"
		},
		"队": {
			"jp": "隊",
			"zht": "隊",
			"zhs": "队"
		},
		"阳": {
			"jp": "陽",
			"zht": "陽",
			"zhs": "阳"
		},
		"阴": {
			"jp": "陰",
			"zht": "陰",
			"zhs": "阴"
		},
		"阵": {
			"jp": "陣",
			"zht": "陣",
			"zhs": "阵"
		},
		"阶": {
			"jp": "階",
			"zht": "階",
			"zhs": "阶"
		},
		"际": {
			"jp": "際",
			"zht": "際",
			"zhs": "际"
		},
		"陆": {
			"jp": "陸",
			"zht": "陸",
			"zhs": "陆"
		},
		"陈": {
			"jp": "陳",
			"zht": "陳",
			"zhs": "陈"
		},
		"陷": {
			"jp": "陥",
			"zht": "陷",
			"zhs": "陷"
		},
		"随": {
			"jp": "随",
			"zht": "隨",
			"zhs": "随"
		},
		"隐": {
			"jp": "隠",
			"zht": "隱",
			"zhs": "隐"
		},
		"隶": {
			"jp": "隷",
			"zht": "隷",
			"zhs": "隶"
		},
		"难": {
			"jp": "難",
			"zht": "難",
			"zhs": "难"
		},
		"鸡": {
			"jp": "鶏",
			"zht": "雞",
			"zhs": "鸡"
		},
		"雾": {
			"jp": "霧",
			"zht": "霧",
			"zhs": "雾"
		},
		"静": {
			"jp": "静",
			"zht": "靜",
			"zhs": "静"
		},
		"顶": {
			"jp": "頂",
			"zht": "頂",
			"zhs": "顶"
		},
		"项": {
			"jp": "項",
			"zht": "項",
			"zhs": "项"
		},
		"顺": {
			"jp": "順",
			"zht": "順",
			"zhs": "顺"
		},
		"顽": {
			"jp": "頑",
			"zht": "頑",
			"zhs": "顽"
		},
		"颁": {
			"jp": "頒",
			"zht": "頒",
			"zhs": "颁"
		},
		"领": {
			"jp": "領",
			"zht": "領",
			"zhs": "领"
		},
		"频": {
			"jp": "頻",
			"zht": "頻",
			"zhs": "频"
		},
		"题": {
			"jp": "題",
			"zht": "題",
			"zhs": "题"
		},
		"额": {
			"jp": "額",
			"zht": "額",
			"zhs": "额"
		},
		"颜": {
			"jp": "顔",
			"zht": "顏",
			"zhs": "颜"
		},
		"风": {
			"jp": "風",
			"zht": "風",
			"zhs": "风"
		},
		"飞": {
			"jp": "飛",
			"zht": "飛",
			"zhs": "飞"
		},
		"饥": {
			"jp": "飢",
			"zht": "饑",
			"zhs": "饥"
		},
		"饭": {
			"jp": "飯",
			"zht": "飯",
			"zhs": "饭"
		},
		"饮": {
			"jp": "飲",
			"zht": "飲",
			"zhs": "饮"
		},
		"饲": {
			"jp": "飼",
			"zht": "飼",
			"zhs": "饲"
		},
		"饱": {
			"jp": "飽",
			"zht": "飽",
			"zhs": "饱"
		},
		"饰": {
			"jp": "飾",
			"zht": "飾",
			"zhs": "饰"
		},
		"饿": {
			"jp": "餓",
			"zht": "餓",
			"zhs": "饿"
		},
		"马": {
			"jp": "馬",
			"zht": "馬",
			"zhs": "马"
		},
		"驿": {
			"jp": "駅",
			"zht": "驛",
			"zhs": "驿"
		},
		"驱": {
			"jp": "駆",
			"zht": "驅",
			"zhs": "驱"
		},
		"驻": {
			"jp": "駐",
			"zht": "駐",
			"zhs": "驻"
		},
		"骑": {
			"jp": "騎",
			"zht": "騎",
			"zhs": "骑"
		},
		"验": {
			"jp": "験",
			"zht": "驗",
			"zhs": "验"
		},
		"骚": {
			"jp": "騒",
			"zht": "騷",
			"zhs": "骚"
		},
		"驔": {
			"jp": "騨",
			"zht": "驔",
			"zhs": "驔"
		},
		"髓": {
			"jp": "髄",
			"zht": "髓",
			"zhs": "髓"
		},
		"鱼": {
			"jp": "魚",
			"zht": "魚",
			"zhs": "鱼"
		},
		"鲁": {
			"jp": "魯",
			"zht": "魯",
			"zhs": "鲁"
		},
		"鲜": {
			"jp": "鮮",
			"zht": "鮮",
			"zhs": "鲜"
		},
		"鲸": {
			"jp": "鯨",
			"zht": "鯨",
			"zhs": "鲸"
		},
		"鸟": {
			"jp": "鳥",
			"zht": "鳥",
			"zhs": "鸟"
		},
		"鸣": {
			"jp": "鳴",
			"zht": "鳴",
			"zhs": "鸣"
		},
		"鸫": {
			"jp": "鶫",
			"zht": "鶇",
			"zhs": "鸫"
		},
		"麦": {
			"jp": "麦",
			"zht": "麥",
			"zhs": "麦"
		},
		"黄": {
			"jp": "黄",
			"zht": "黃",
			"zhs": "黄"
		},
		"黑": {
			"jp": "黒",
			"zht": "黑",
			"zhs": "黑"
		},
		"默": {
			"jp": "黙",
			"zht": "默",
			"zhs": "默"
		},
		"龄": {
			"jp": "齢",
			"zht": "齡",
			"zhs": "龄"
		}
	}
};

/**
 * Code generated from @lazy-cjk/jp-table-comparison;
 * DO NOT EDIT.
 * @see {@link @lazy-cjk/jp-table-comparison}
 */

export const TABLE_SAFE: ITABLE_MAIN = {
	"jp": {
		"会": {
			"jp": "会",
			"zht": "會",
			"zhs": "会"
		},
		"箋": {
			"jp": "箋",
			"zht": "箋",
			"zhs": "笺"
		},
		"網": {
			"jp": "網",
			"zht": "網",
			"zhs": "网"
		},
		"処": {
			"jp": "処",
			"zht": "處",
			"zhs": "处"
		},
		"話": {
			"jp": "話",
			"zht": "話",
			"zhs": "话"
		},
		"万": {
			"jp": "万",
			"zht": "萬",
			"zhs": "万"
		},
		"与": {
			"jp": "与",
			"zht": "與",
			"zhs": "与"
		},
		"醜": {
			"jp": "醜",
			"zht": "醜",
			"zhs": "丑"
		},
		"専": {
			"jp": "専",
			"zht": "專",
			"zhs": "专"
		},
		"業": {
			"jp": "業",
			"zht": "業",
			"zhs": "业"
		},
		"東": {
			"jp": "東",
			"zht": "東",
			"zhs": "东"
		},
		"両": {
			"jp": "両",
			"zht": "兩",
			"zhs": "两"
		},
		"厳": {
			"jp": "厳",
			"zht": "嚴",
			"zhs": "严"
		},
		"並": {
			"jp": "並",
			"zht": "並",
			"zhs": "并"
		},
		"喪": {
			"jp": "喪",
			"zht": "喪",
			"zhs": "丧"
		},
		"豊": {
			"jp": "豊",
			"zht": "豐",
			"zhs": "丰"
		},
		"臨": {
			"jp": "臨",
			"zht": "臨",
			"zhs": "临"
		},
		"為": {
			"jp": "為",
			"zht": "為",
			"zhs": "为"
		},
		"麗": {
			"jp": "麗",
			"zht": "麗",
			"zhs": "丽"
		},
		"挙": {
			"jp": "挙",
			"zht": "舉",
			"zhs": "举"
		},
		"廼": {
			"jp": "廼",
			"zht": "迺",
			"zhs": "迺"
		},
		"義": {
			"jp": "義",
			"zht": "義",
			"zhs": "义"
		},
		"楽": {
			"jp": "楽",
			"zht": "樂",
			"zhs": "乐"
		},
		"乗": {
			"jp": "乗",
			"zht": "乘",
			"zhs": "乘"
		},
		"習": {
			"jp": "習",
			"zht": "習",
			"zhs": "习"
		},
		"郷": {
			"jp": "郷",
			"zht": "鄉",
			"zhs": "乡"
		},
		"書": {
			"jp": "書",
			"zht": "書",
			"zhs": "书"
		},
		"買": {
			"jp": "買",
			"zht": "買",
			"zhs": "买"
		},
		"乱": {
			"jp": "乱",
			"zht": "亂",
			"zhs": "乱"
		},
		"亀": {
			"jp": "亀",
			"zht": "龜",
			"zhs": "龟"
		},
		"弐": {
			"jp": "弐",
			"zht": "貳",
			"zhs": "贰"
		},
		"雲": {
			"jp": "雲",
			"zht": "雲",
			"zhs": "云"
		},
		"亜": {
			"jp": "亜",
			"zht": "亞",
			"zhs": "亚"
		},
		"産": {
			"jp": "産",
			"zht": "產",
			"zhs": "产"
		},
		"畝": {
			"jp": "畝",
			"zht": "畝",
			"zhs": "亩"
		},
		"親": {
			"jp": "親",
			"zht": "親",
			"zhs": "亲"
		},
		"億": {
			"jp": "億",
			"zht": "億",
			"zhs": "亿"
		},
		"僕": {
			"jp": "僕",
			"zht": "僕",
			"zhs": "仆"
		},
		"従": {
			"jp": "従",
			"zht": "從",
			"zhs": "从"
		},
		"仏": {
			"jp": "仏",
			"zht": "佛",
			"zhs": "佛"
		},
		"倉": {
			"jp": "倉",
			"zht": "倉",
			"zhs": "仓"
		},
		"儀": {
			"jp": "儀",
			"zht": "儀",
			"zhs": "仪"
		},
		"仮": {
			"jp": "仮",
			"zht": "假",
			"zhs": "假"
		},
		"価": {
			"jp": "価",
			"zht": "價",
			"zhs": "价"
		},
		"衆": {
			"jp": "衆",
			"zht": "眾",
			"zhs": "众"
		},
		"優": {
			"jp": "優",
			"zht": "優",
			"zhs": "优"
		},
		"伝": {
			"jp": "伝",
			"zht": "傳",
			"zhs": "传"
		},
		"傘": {
			"jp": "傘",
			"zht": "傘",
			"zhs": "伞"
		},
		"偉": {
			"jp": "偉",
			"zht": "偉",
			"zhs": "伟"
		},
		"傷": {
			"jp": "傷",
			"zht": "傷",
			"zhs": "伤"
		},
		"倫": {
			"jp": "倫",
			"zht": "倫",
			"zhs": "伦"
		},
		"偽": {
			"jp": "偽",
			"zht": "偽",
			"zhs": "伪"
		},
		"体": {
			"jp": "体",
			"zht": "體",
			"zhs": "体"
		},
		"余": {
			"jp": "余",
			"zht": "餘",
			"zhs": "余"
		},
		"来": {
			"jp": "来",
			"zht": "來",
			"zhs": "来"
		},
		"偵": {
			"jp": "偵",
			"zht": "偵",
			"zhs": "侦"
		},
		"側": {
			"jp": "側",
			"zht": "側",
			"zhs": "侧"
		},
		"倹": {
			"jp": "倹",
			"zht": "儉",
			"zhs": "俭"
		},
		"倶": {
			"jp": "倶",
			"zht": "俱",
			"zhs": "俱"
		},
		"債": {
			"jp": "債",
			"zht": "債",
			"zhs": "债"
		},
		"傾": {
			"jp": "傾",
			"zht": "傾",
			"zhs": "倾"
		},
		"償": {
			"jp": "償",
			"zht": "償",
			"zhs": "偿"
		},
		"傑": {
			"jp": "傑",
			"zht": "傑",
			"zhs": "杰"
		},
		"備": {
			"jp": "備",
			"zht": "備",
			"zhs": "备"
		},
		"当": {
			"jp": "当",
			"zht": "當",
			"zhs": "当"
		},
		"尽": {
			"jp": "尽",
			"zht": "盡",
			"zhs": "尽"
		},
		"児": {
			"jp": "児",
			"zht": "兒",
			"zhs": "儿"
		},
		"党": {
			"jp": "党",
			"zht": "黨",
			"zhs": "党"
		},
		"内": {
			"jp": "内",
			"zht": "內",
			"zhs": "内"
		},
		"関": {
			"jp": "関",
			"zht": "關",
			"zhs": "关"
		},
		"興": {
			"jp": "興",
			"zht": "興",
			"zhs": "兴"
		},
		"養": {
			"jp": "養",
			"zht": "養",
			"zhs": "养"
		},
		"獣": {
			"jp": "獣",
			"zht": "獸",
			"zhs": "兽"
		},
		"円": {
			"jp": "円",
			"zht": "圓",
			"zhs": "圆"
		},
		"写": {
			"jp": "写",
			"zht": "寫",
			"zhs": "写"
		},
		"軍": {
			"jp": "軍",
			"zht": "軍",
			"zhs": "军"
		},
		"農": {
			"jp": "農",
			"zht": "農",
			"zhs": "农"
		},
		"冨": {
			"jp": "冨",
			"zht": "富",
			"zhs": "富"
		},
		"氷": {
			"jp": "氷",
			"zht": "冰",
			"zhs": "冰"
		},
		"衝": {
			"jp": "衝",
			"zht": "衝",
			"zhs": "冲"
		},
		"決": {
			"jp": "決",
			"zht": "決",
			"zhs": "决"
		},
		"凍": {
			"jp": "凍",
			"zht": "凍",
			"zhs": "冻"
		},
		"塗": {
			"jp": "塗",
			"zht": "塗",
			"zhs": "涂"
		},
		"幾": {
			"jp": "幾",
			"zht": "幾",
			"zhs": "几"
		},
		"撃": {
			"jp": "撃",
			"zht": "擊",
			"zhs": "击"
		},
		"画": {
			"jp": "画",
			"zht": "劃",
			"zhs": "划"
		},
		"則": {
			"jp": "則",
			"zht": "則",
			"zhs": "则"
		},
		"剛": {
			"jp": "剛",
			"zht": "剛",
			"zhs": "刚"
		},
		"創": {
			"jp": "創",
			"zht": "創",
			"zhs": "创"
		},
		"別": {
			"jp": "別",
			"zht": "別",
			"zhs": "别"
		},
		"製": {
			"jp": "製",
			"zht": "製",
			"zhs": "制"
		},
		"巻": {
			"jp": "巻",
			"zht": "卷",
			"zhs": "卷"
		},
		"刹": {
			"jp": "刹",
			"zht": "剎",
			"zhs": "刹"
		},
		"剤": {
			"jp": "剤",
			"zht": "劑",
			"zhs": "剂"
		},
		"剣": {
			"jp": "剣",
			"zht": "劍",
			"zhs": "剑"
		},
		"劇": {
			"jp": "劇",
			"zht": "劇",
			"zhs": "剧"
		},
		"剰": {
			"jp": "剰",
			"zht": "剩",
			"zhs": "剩"
		},
		"勧": {
			"jp": "勧",
			"zht": "勸",
			"zhs": "劝"
		},
		"務": {
			"jp": "務",
			"zht": "務",
			"zhs": "务"
		},
		"動": {
			"jp": "動",
			"zht": "動",
			"zhs": "动"
		},
		"励": {
			"jp": "励",
			"zht": "勵",
			"zhs": "励"
		},
		"労": {
			"jp": "労",
			"zht": "勞",
			"zhs": "劳"
		},
		"勢": {
			"jp": "勢",
			"zht": "勢",
			"zhs": "势"
		},
		"勲": {
			"jp": "勲",
			"zht": "勳",
			"zhs": "勋"
		},
		"勝": {
			"jp": "勝",
			"zht": "勝",
			"zhs": "胜"
		},
		"区": {
			"jp": "区",
			"zht": "區",
			"zhs": "区"
		},
		"医": {
			"jp": "医",
			"zht": "醫",
			"zhs": "医"
		},
		"華": {
			"jp": "華",
			"zht": "華",
			"zhs": "华"
		},
		"協": {
			"jp": "協",
			"zht": "協",
			"zhs": "协"
		},
		"単": {
			"jp": "単",
			"zht": "單",
			"zhs": "单"
		},
		"売": {
			"jp": "売",
			"zht": "賣",
			"zhs": "卖"
		},
		"衛": {
			"jp": "衛",
			"zht": "衛",
			"zhs": "卫"
		},
		"庁": {
			"jp": "庁",
			"zht": "廳",
			"zhs": "厅"
		},
		"圧": {
			"jp": "圧",
			"zht": "壓",
			"zhs": "压"
		},
		"県": {
			"jp": "県",
			"zht": "縣",
			"zhs": "县"
		},
		"参": {
			"jp": "参",
			"zht": "參",
			"zhs": "参"
		},
		"双": {
			"jp": "双",
			"zht": "雙",
			"zhs": "双"
		},
		"収": {
			"jp": "収",
			"zht": "收",
			"zhs": "收"
		},
		"発": {
			"jp": "発",
			"zht": "發",
			"zhs": "发"
		},
		"変": {
			"jp": "変",
			"zht": "變",
			"zhs": "变"
		},
		"畳": {
			"jp": "畳",
			"zht": "疊",
			"zhs": "叠"
		},
		"号": {
			"jp": "号",
			"zht": "號",
			"zhs": "号"
		},
		"嘆": {
			"jp": "嘆",
			"zht": "嘆",
			"zhs": "叹"
		},
		"嚇": {
			"jp": "嚇",
			"zht": "嚇",
			"zhs": "吓"
		},
		"聴": {
			"jp": "聴",
			"zht": "聽",
			"zhs": "听"
		},
		"啓": {
			"jp": "啓",
			"zht": "啟",
			"zhs": "启"
		},
		"員": {
			"jp": "員",
			"zht": "員",
			"zhs": "员"
		},
		"諮": {
			"jp": "諮",
			"zht": "諮",
			"zhs": "谘"
		},
		"鹹": {
			"jp": "鹹",
			"zht": "鹹",
			"zhs": "咸"
		},
		"響": {
			"jp": "響",
			"zht": "響",
			"zhs": "响"
		},
		"問": {
			"jp": "問",
			"zht": "問",
			"zhs": "问"
		},
		"営": {
			"jp": "営",
			"zht": "營",
			"zhs": "营"
		},
		"噴": {
			"jp": "噴",
			"zht": "噴",
			"zhs": "喷"
		},
		"嘱": {
			"jp": "嘱",
			"zht": "囑",
			"zhs": "嘱"
		},
		"蘇": {
			"jp": "蘇",
			"zht": "蘇",
			"zhs": "苏"
		},
		"団": {
			"jp": "団",
			"zht": "團",
			"zhs": "团"
		},
		"園": {
			"jp": "園",
			"zht": "園",
			"zhs": "园"
		},
		"国": {
			"jp": "国",
			"zht": "國",
			"zhs": "国"
		},
		"囲": {
			"jp": "囲",
			"zht": "圍",
			"zhs": "围"
		},
		"図": {
			"jp": "図",
			"zht": "圖",
			"zhs": "图"
		},
		"圏": {
			"jp": "圏",
			"zht": "圈",
			"zhs": "圈"
		},
		"聖": {
			"jp": "聖",
			"zht": "聖",
			"zhs": "圣"
		},
		"場": {
			"jp": "場",
			"zht": "場",
			"zhs": "场"
		},
		"壊": {
			"jp": "壊",
			"zht": "壞",
			"zhs": "坏"
		},
		"塊": {
			"jp": "塊",
			"zht": "塊",
			"zhs": "块"
		},
		"堅": {
			"jp": "堅",
			"zht": "堅",
			"zhs": "坚"
		},
		"壇": {
			"jp": "壇",
			"zht": "壇",
			"zhs": "坛"
		},
		"墳": {
			"jp": "墳",
			"zht": "墳",
			"zhs": "坟"
		},
		"墜": {
			"jp": "墜",
			"zht": "墜",
			"zhs": "坠"
		},
		"塁": {
			"jp": "塁",
			"zht": "壘",
			"zhs": "垒"
		},
		"墾": {
			"jp": "墾",
			"zht": "墾",
			"zhs": "垦"
		},
		"執": {
			"jp": "執",
			"zht": "執",
			"zhs": "执"
		},
		"堕": {
			"jp": "堕",
			"zht": "墮",
			"zhs": "堕"
		},
		"報": {
			"jp": "報",
			"zht": "報",
			"zhs": "报"
		},
		"塩": {
			"jp": "塩",
			"zht": "鹽",
			"zhs": "盐"
		},
		"増": {
			"jp": "増",
			"zht": "增",
			"zhs": "增"
		},
		"壌": {
			"jp": "壌",
			"zht": "壤",
			"zhs": "壤"
		},
		"壮": {
			"jp": "壮",
			"zht": "壯",
			"zhs": "壮"
		},
		"声": {
			"jp": "声",
			"zht": "聲",
			"zhs": "声"
		},
		"壱": {
			"jp": "壱",
			"zht": "壹",
			"zhs": "壹"
		},
		"寿": {
			"jp": "寿",
			"zht": "壽",
			"zhs": "寿"
		},
		"夢": {
			"jp": "夢",
			"zht": "夢",
			"zhs": "梦"
		},
		"頭": {
			"jp": "頭",
			"zht": "頭",
			"zhs": "头"
		},
		"誇": {
			"jp": "誇",
			"zht": "誇",
			"zhs": "夸"
		},
		"奪": {
			"jp": "奪",
			"zht": "奪",
			"zhs": "夺"
		},
		"奮": {
			"jp": "奮",
			"zht": "奮",
			"zhs": "奋"
		},
		"奨": {
			"jp": "奨",
			"zht": "獎",
			"zhs": "奖"
		},
		"粧": {
			"jp": "粧",
			"zht": "妝",
			"zhs": "妆"
		},
		"婦": {
			"jp": "婦",
			"zht": "婦",
			"zhs": "妇"
		},
		"姉": {
			"jp": "姉",
			"zht": "姐",
			"zhs": "姐"
		},
		"姫": {
			"jp": "姫",
			"zht": "姬",
			"zhs": "姬"
		},
		"嬢": {
			"jp": "嬢",
			"zht": "孃",
			"zhs": "娘"
		},
		"娯": {
			"jp": "娯",
			"zht": "娛",
			"zhs": "娱"
		},
		"孫": {
			"jp": "孫",
			"zht": "孫",
			"zhs": "孙"
		},
		"学": {
			"jp": "学",
			"zht": "學",
			"zhs": "学"
		},
		"寧": {
			"jp": "寧",
			"zht": "寧",
			"zhs": "宁"
		},
		"宝": {
			"jp": "宝",
			"zht": "寶",
			"zhs": "宝"
		},
		"実": {
			"jp": "実",
			"zht": "實",
			"zhs": "实"
		},
		"審": {
			"jp": "審",
			"zht": "審",
			"zhs": "审"
		},
		"憲": {
			"jp": "憲",
			"zht": "憲",
			"zhs": "宪"
		},
		"宮": {
			"jp": "宮",
			"zht": "宮",
			"zhs": "宫"
		},
		"賓": {
			"jp": "賓",
			"zht": "賓",
			"zhs": "宾"
		},
		"秘": {
			"jp": "秘",
			"zht": "祕",
			"zhs": "秘"
		},
		"寝": {
			"jp": "寝",
			"zht": "寢",
			"zhs": "寝"
		},
		"対": {
			"jp": "対",
			"zht": "對",
			"zhs": "对"
		},
		"尋": {
			"jp": "尋",
			"zht": "尋",
			"zhs": "寻"
		},
		"導": {
			"jp": "導",
			"zht": "導",
			"zhs": "导"
		},
		"将": {
			"jp": "将",
			"zht": "將",
			"zhs": "将"
		},
		"層": {
			"jp": "層",
			"zht": "層",
			"zhs": "层"
		},
		"属": {
			"jp": "属",
			"zht": "屬",
			"zhs": "属"
		},
		"歳": {
			"jp": "歳",
			"zht": "歲",
			"zhs": "岁"
		},
		"島": {
			"jp": "島",
			"zht": "島",
			"zhs": "岛"
		},
		"巌": {
			"jp": "巌",
			"zht": "巖",
			"zhs": "巖"
		},
		"峡": {
			"jp": "峡",
			"zht": "峽",
			"zhs": "峡"
		},
		"険": {
			"jp": "険",
			"zht": "險",
			"zhs": "险"
		},
		"幣": {
			"jp": "幣",
			"zht": "幣",
			"zhs": "币"
		},
		"帥": {
			"jp": "帥",
			"zht": "帥",
			"zhs": "帅"
		},
		"師": {
			"jp": "師",
			"zht": "師",
			"zhs": "师"
		},
		"帳": {
			"jp": "帳",
			"zht": "帳",
			"zhs": "帐"
		},
		"帰": {
			"jp": "帰",
			"zht": "歸",
			"zhs": "归"
		},
		"広": {
			"jp": "広",
			"zht": "廣",
			"zhs": "广"
		},
		"慶": {
			"jp": "慶",
			"zht": "慶",
			"zhs": "庆"
		},
		"庫": {
			"jp": "庫",
			"zht": "庫",
			"zhs": "库"
		},
		"応": {
			"jp": "応",
			"zht": "應",
			"zhs": "应"
		},
		"廃": {
			"jp": "廃",
			"zht": "廢",
			"zhs": "废"
		},
		"開": {
			"jp": "開",
			"zht": "開",
			"zhs": "开"
		},
		"弁": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辨"
		},
		"異": {
			"jp": "異",
			"zht": "異",
			"zhs": "异"
		},
		"棄": {
			"jp": "棄",
			"zht": "棄",
			"zhs": "弃"
		},
		"張": {
			"jp": "張",
			"zht": "張",
			"zhs": "张"
		},
		"弥": {
			"jp": "弥",
			"zht": "彌",
			"zhs": "弥"
		},
		"強": {
			"jp": "強",
			"zht": "強",
			"zhs": "强"
		},
		"弾": {
			"jp": "弾",
			"zht": "彈",
			"zhs": "弹"
		},
		"録": {
			"jp": "録",
			"zht": "錄",
			"zhs": "录"
		},
		"彦": {
			"jp": "彦",
			"zht": "彥",
			"zhs": "彥"
		},
		"徹": {
			"jp": "徹",
			"zht": "徹",
			"zhs": "彻"
		},
		"徴": {
			"jp": "徴",
			"zht": "徵",
			"zhs": "征"
		},
		"径": {
			"jp": "径",
			"zht": "徑",
			"zhs": "径"
		},
		"徳": {
			"jp": "徳",
			"zht": "德",
			"zhs": "德"
		},
		"憶": {
			"jp": "憶",
			"zht": "憶",
			"zhs": "忆"
		},
		"誌": {
			"jp": "誌",
			"zht": "誌",
			"zhs": "志"
		},
		"憂": {
			"jp": "憂",
			"zht": "憂",
			"zhs": "忧"
		},
		"懐": {
			"jp": "懐",
			"zht": "懷",
			"zhs": "怀"
		},
		"態": {
			"jp": "態",
			"zht": "態",
			"zhs": "态"
		},
		"総": {
			"jp": "総",
			"zht": "總",
			"zhs": "总"
		},
		"恒": {
			"jp": "恒",
			"zht": "恆",
			"zhs": "恒"
		},
		"恋": {
			"jp": "恋",
			"zht": "戀",
			"zhs": "恋"
		},
		"懇": {
			"jp": "懇",
			"zht": "懇",
			"zhs": "恳"
		},
		"恵": {
			"jp": "恵",
			"zht": "惠",
			"zhs": "惠"
		},
		"悪": {
			"jp": "悪",
			"zht": "惡",
			"zhs": "恶"
		},
		"悩": {
			"jp": "悩",
			"zht": "惱",
			"zhs": "恼"
		},
		"悦": {
			"jp": "悦",
			"zht": "悅",
			"zhs": "悅"
		},
		"懸": {
			"jp": "懸",
			"zht": "懸",
			"zhs": "悬"
		},
		"驚": {
			"jp": "驚",
			"zht": "驚",
			"zhs": "惊"
		},
		"惨": {
			"jp": "惨",
			"zht": "慘",
			"zhs": "惨"
		},
		"懲": {
			"jp": "懲",
			"zht": "懲",
			"zhs": "惩"
		},
		"愛": {
			"jp": "愛",
			"zht": "愛",
			"zhs": "爱"
		},
		"憤": {
			"jp": "憤",
			"zht": "憤",
			"zhs": "愤"
		},
		"願": {
			"jp": "願",
			"zht": "願",
			"zhs": "愿"
		},
		"慮": {
			"jp": "慮",
			"zht": "慮",
			"zhs": "虑"
		},
		"戯": {
			"jp": "戯",
			"zht": "戲",
			"zhs": "戏"
		},
		"戦": {
			"jp": "戦",
			"zht": "戰",
			"zhs": "战"
		},
		"戸": {
			"jp": "戸",
			"zht": "戶",
			"zhs": "户"
		},
		"払": {
			"jp": "払",
			"zht": "拂",
			"zhs": "拂"
		},
		"拡": {
			"jp": "拡",
			"zht": "擴",
			"zhs": "扩"
		},
		"掃": {
			"jp": "掃",
			"zht": "掃",
			"zhs": "扫"
		},
		"揚": {
			"jp": "揚",
			"zht": "揚",
			"zhs": "扬"
		},
		"択": {
			"jp": "択",
			"zht": "擇",
			"zhs": "择"
		},
		"護": {
			"jp": "護",
			"zht": "護",
			"zhs": "护"
		},
		"担": {
			"jp": "担",
			"zht": "擔",
			"zhs": "担"
		},
		"拝": {
			"jp": "拝",
			"zht": "拜",
			"zhs": "拜"
		},
		"擬": {
			"jp": "擬",
			"zht": "擬",
			"zhs": "拟"
		},
		"拠": {
			"jp": "拠",
			"zht": "據",
			"zhs": "据"
		},
		"擁": {
			"jp": "擁",
			"zht": "擁",
			"zhs": "拥"
		},
		"挟": {
			"jp": "挟",
			"zht": "挾",
			"zhs": "挟"
		},
		"揮": {
			"jp": "揮",
			"zht": "揮",
			"zhs": "挥"
		},
		"挿": {
			"jp": "挿",
			"zht": "插",
			"zhs": "插"
		},
		"損": {
			"jp": "損",
			"zht": "損",
			"zhs": "损"
		},
		"捨": {
			"jp": "捨",
			"zht": "捨",
			"zhs": "舍"
		},
		"掲": {
			"jp": "掲",
			"zht": "揭",
			"zhs": "揭"
		},
		"掴": {
			"jp": "掴",
			"zht": "摑",
			"zhs": "掴"
		},
		"揺": {
			"jp": "揺",
			"zht": "搖",
			"zhs": "摇"
		},
		"敵": {
			"jp": "敵",
			"zht": "敵",
			"zhs": "敌"
		},
		"敗": {
			"jp": "敗",
			"zht": "敗",
			"zhs": "败"
		},
		"数": {
			"jp": "数",
			"zht": "數",
			"zhs": "数"
		},
		"斉": {
			"jp": "斉",
			"zht": "齊",
			"zhs": "齐"
		},
		"斎": {
			"jp": "斎",
			"zht": "齋",
			"zhs": "斋"
		},
		"断": {
			"jp": "断",
			"zht": "斷",
			"zhs": "断"
		},
		"旧": {
			"jp": "旧",
			"zht": "舊",
			"zhs": "旧"
		},
		"時": {
			"jp": "時",
			"zht": "時",
			"zhs": "时"
		},
		"曇": {
			"jp": "曇",
			"zht": "曇",
			"zhs": "昙"
		},
		"昼": {
			"jp": "昼",
			"zht": "晝",
			"zhs": "昼"
		},
		"顕": {
			"jp": "顕",
			"zht": "顯",
			"zhs": "显"
		},
		"暁": {
			"jp": "暁",
			"zht": "曉",
			"zhs": "晓"
		},
		"晩": {
			"jp": "晩",
			"zht": "晚",
			"zhs": "晚"
		},
		"暫": {
			"jp": "暫",
			"zht": "暫",
			"zhs": "暂"
		},
		"曽": {
			"jp": "曽",
			"zht": "曾",
			"zhs": "曾"
		},
		"術": {
			"jp": "術",
			"zht": "術",
			"zhs": "术"
		},
		"樸": {
			"jp": "樸",
			"zht": "樸",
			"zhs": "朴"
		},
		"機": {
			"jp": "機",
			"zht": "機",
			"zhs": "机"
		},
		"殺": {
			"jp": "殺",
			"zht": "殺",
			"zhs": "杀"
		},
		"雑": {
			"jp": "雑",
			"zht": "雜",
			"zhs": "杂"
		},
		"権": {
			"jp": "権",
			"zht": "權",
			"zhs": "权"
		},
		"条": {
			"jp": "条",
			"zht": "條",
			"zhs": "条"
		},
		"極": {
			"jp": "極",
			"zht": "極",
			"zhs": "极"
		},
		"枢": {
			"jp": "枢",
			"zht": "樞",
			"zhs": "枢"
		},
		"槍": {
			"jp": "槍",
			"zht": "槍",
			"zhs": "枪"
		},
		"査": {
			"jp": "査",
			"zht": "查",
			"zhs": "查"
		},
		"栄": {
			"jp": "栄",
			"zht": "榮",
			"zhs": "荣"
		},
		"標": {
			"jp": "標",
			"zht": "標",
			"zhs": "标"
		},
		"桟": {
			"jp": "桟",
			"zht": "棧",
			"zhs": "栈"
		},
		"棟": {
			"jp": "棟",
			"zht": "棟",
			"zhs": "栋"
		},
		"欄": {
			"jp": "欄",
			"zht": "欄",
			"zhs": "栏"
		},
		"樹": {
			"jp": "樹",
			"zht": "樹",
			"zhs": "树"
		},
		"様": {
			"jp": "様",
			"zht": "樣",
			"zhs": "样"
		},
		"桜": {
			"jp": "桜",
			"zht": "櫻",
			"zhs": "樱"
		},
		"橋": {
			"jp": "橋",
			"zht": "橋",
			"zhs": "桥"
		},
		"検": {
			"jp": "検",
			"zht": "檢",
			"zhs": "检"
		},
		"楼": {
			"jp": "楼",
			"zht": "樓",
			"zhs": "楼"
		},
		"歓": {
			"jp": "歓",
			"zht": "歡",
			"zhs": "欢"
		},
		"欧": {
			"jp": "欧",
			"zht": "歐",
			"zhs": "欧"
		},
		"歩": {
			"jp": "歩",
			"zht": "步",
			"zhs": "步"
		},
		"歯": {
			"jp": "歯",
			"zht": "齒",
			"zhs": "齿"
		},
		"残": {
			"jp": "残",
			"zht": "殘",
			"zhs": "残"
		},
		"殴": {
			"jp": "殴",
			"zht": "毆",
			"zhs": "殴"
		},
		"気": {
			"jp": "気",
			"zht": "氣",
			"zhs": "气"
		},
		"漢": {
			"jp": "漢",
			"zht": "漢",
			"zhs": "汉"
		},
		"湯": {
			"jp": "湯",
			"zht": "湯",
			"zhs": "汤"
		},
		"溝": {
			"jp": "溝",
			"zht": "溝",
			"zhs": "沟"
		},
		"沢": {
			"jp": "沢",
			"zht": "澤",
			"zhs": "泽"
		},
		"涙": {
			"jp": "涙",
			"zht": "淚",
			"zhs": "泪"
		},
		"滝": {
			"jp": "滝",
			"zht": "瀧",
			"zhs": "泷"
		},
		"潔": {
			"jp": "潔",
			"zht": "潔",
			"zhs": "洁"
		},
		"浅": {
			"jp": "浅",
			"zht": "淺",
			"zhs": "浅"
		},
		"濁": {
			"jp": "濁",
			"zht": "濁",
			"zhs": "浊"
		},
		"測": {
			"jp": "測",
			"zht": "測",
			"zhs": "测"
		},
		"済": {
			"jp": "済",
			"zht": "濟",
			"zhs": "济"
		},
		"濃": {
			"jp": "濃",
			"zht": "濃",
			"zhs": "浓"
		},
		"浜": {
			"jp": "浜",
			"zht": "濱",
			"zhs": "滨"
		},
		"渋": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涉"
		},
		"渦": {
			"jp": "渦",
			"zht": "渦",
			"zhs": "涡"
		},
		"潤": {
			"jp": "潤",
			"zht": "潤",
			"zhs": "润"
		},
		"漬": {
			"jp": "漬",
			"zht": "漬",
			"zhs": "渍"
		},
		"漸": {
			"jp": "漸",
			"zht": "漸",
			"zhs": "渐"
		},
		"渓": {
			"jp": "渓",
			"zht": "溪",
			"zhs": "溪"
		},
		"漁": {
			"jp": "漁",
			"zht": "漁",
			"zhs": "渔"
		},
		"湾": {
			"jp": "湾",
			"zht": "灣",
			"zhs": "湾"
		},
		"湿": {
			"jp": "湿",
			"zht": "濕",
			"zhs": "湿"
		},
		"満": {
			"jp": "満",
			"zht": "滿",
			"zhs": "满"
		},
		"滅": {
			"jp": "滅",
			"zht": "滅",
			"zhs": "灭"
		},
		"滞": {
			"jp": "滞",
			"zht": "滯",
			"zhs": "滞"
		},
		"濫": {
			"jp": "濫",
			"zht": "濫",
			"zhs": "滥"
		},
		"瀬": {
			"jp": "瀬",
			"zht": "瀨",
			"zhs": "濑"
		},
		"灯": {
			"jp": "灯",
			"zht": "燈",
			"zhs": "灯"
		},
		"霊": {
			"jp": "霊",
			"zht": "靈",
			"zhs": "灵"
		},
		"炉": {
			"jp": "炉",
			"zht": "爐",
			"zhs": "炉"
		},
		"点": {
			"jp": "点",
			"zht": "點",
			"zhs": "点"
		},
		"錬": {
			"jp": "錬",
			"zht": "鍊",
			"zhs": "炼"
		},
		"練": {
			"jp": "練",
			"zht": "練",
			"zhs": "练"
		},
		"煙": {
			"jp": "煙",
			"zht": "煙",
			"zhs": "烟"
		},
		"煩": {
			"jp": "煩",
			"zht": "煩",
			"zhs": "烦"
		},
		"焼": {
			"jp": "焼",
			"zht": "燒",
			"zhs": "烧"
		},
		"熱": {
			"jp": "熱",
			"zht": "熱",
			"zhs": "热"
		},
		"焔": {
			"jp": "焔",
			"zht": "焰",
			"zhs": "焰"
		},
		"鍛": {
			"jp": "鍛",
			"zht": "鍛",
			"zhs": "锻"
		},
		"犠": {
			"jp": "犠",
			"zht": "犧",
			"zhs": "牺"
		},
		"状": {
			"jp": "状",
			"zht": "狀",
			"zhs": "状"
		},
		"猶": {
			"jp": "猶",
			"zht": "猶",
			"zhs": "犹"
		},
		"独": {
			"jp": "独",
			"zht": "獨",
			"zhs": "独"
		},
		"狭": {
			"jp": "狭",
			"zht": "狹",
			"zhs": "狭"
		},
		"獄": {
			"jp": "獄",
			"zht": "獄",
			"zhs": "狱"
		},
		"猟": {
			"jp": "猟",
			"zht": "獵",
			"zhs": "猎"
		},
		"猫": {
			"jp": "猫",
			"zht": "貓",
			"zhs": "猫"
		},
		"献": {
			"jp": "献",
			"zht": "獻",
			"zhs": "献"
		},
		"環": {
			"jp": "環",
			"zht": "環",
			"zhs": "环"
		},
		"現": {
			"jp": "現",
			"zht": "現",
			"zhs": "现"
		},
		"璽": {
			"jp": "璽",
			"zht": "璽",
			"zhs": "玺"
		},
		"電": {
			"jp": "電",
			"zht": "電",
			"zhs": "电"
		},
		"療": {
			"jp": "療",
			"zht": "療",
			"zhs": "疗"
		},
		"監": {
			"jp": "監",
			"zht": "監",
			"zhs": "监"
		},
		"蓋": {
			"jp": "蓋",
			"zht": "蓋",
			"zhs": "盖"
		},
		"盤": {
			"jp": "盤",
			"zht": "盤",
			"zhs": "盘"
		},
		"視": {
			"jp": "視",
			"zht": "視",
			"zhs": "视"
		},
		"着": {
			"jp": "着",
			"zht": "著",
			"zhs": "著"
		},
		"矯": {
			"jp": "矯",
			"zht": "矯",
			"zhs": "矫"
		},
		"鉱": {
			"jp": "鉱",
			"zht": "礦",
			"zhs": "矿"
		},
		"砕": {
			"jp": "砕",
			"zht": "碎",
			"zhs": "碎"
		},
		"礎": {
			"jp": "礎",
			"zht": "礎",
			"zhs": "础"
		},
		"確": {
			"jp": "確",
			"zht": "確",
			"zhs": "确"
		},
		"礼": {
			"jp": "礼",
			"zht": "禮",
			"zhs": "礼"
		},
		"禍": {
			"jp": "禍",
			"zht": "禍",
			"zhs": "祸"
		},
		"禅": {
			"jp": "禅",
			"zht": "禪",
			"zhs": "禅"
		},
		"離": {
			"jp": "離",
			"zht": "離",
			"zhs": "离"
		},
		"種": {
			"jp": "種",
			"zht": "種",
			"zhs": "种"
		},
		"積": {
			"jp": "積",
			"zht": "積",
			"zhs": "积"
		},
		"称": {
			"jp": "称",
			"zht": "稱",
			"zhs": "称"
		},
		"稲": {
			"jp": "稲",
			"zht": "稻",
			"zhs": "稻"
		},
		"穏": {
			"jp": "穏",
			"zht": "穩",
			"zhs": "稳"
		},
		"穀": {
			"jp": "穀",
			"zht": "穀",
			"zhs": "谷"
		},
		"穂": {
			"jp": "穂",
			"zht": "穗",
			"zhs": "穗"
		},
		"窮": {
			"jp": "窮",
			"zht": "窮",
			"zhs": "穷"
		},
		"窃": {
			"jp": "窃",
			"zht": "竊",
			"zhs": "窃"
		},
		"窓": {
			"jp": "窓",
			"zht": "窗",
			"zhs": "窗"
		},
		"竜": {
			"jp": "竜",
			"zht": "龍",
			"zhs": "龙"
		},
		"競": {
			"jp": "競",
			"zht": "競",
			"zhs": "竞"
		},
		"篤": {
			"jp": "篤",
			"zht": "篤",
			"zhs": "笃"
		},
		"筆": {
			"jp": "筆",
			"zht": "筆",
			"zhs": "笔"
		},
		"築": {
			"jp": "築",
			"zht": "築",
			"zhs": "筑"
		},
		"簡": {
			"jp": "簡",
			"zht": "簡",
			"zhs": "简"
		},
		"節": {
			"jp": "節",
			"zht": "節",
			"zhs": "节"
		},
		"範": {
			"jp": "範",
			"zht": "範",
			"zhs": "范"
		},
		"類": {
			"jp": "類",
			"zht": "類",
			"zhs": "类"
		},
		"粋": {
			"jp": "粋",
			"zht": "粹",
			"zhs": "粹"
		},
		"粛": {
			"jp": "粛",
			"zht": "肅",
			"zhs": "肃"
		},
		"糧": {
			"jp": "糧",
			"zht": "糧",
			"zhs": "粮"
		},
		"糾": {
			"jp": "糾",
			"zht": "糾",
			"zhs": "纠"
		},
		"紀": {
			"jp": "紀",
			"zht": "紀",
			"zhs": "纪"
		},
		"約": {
			"jp": "約",
			"zht": "約",
			"zhs": "约"
		},
		"紅": {
			"jp": "紅",
			"zht": "紅",
			"zhs": "红"
		},
		"紋": {
			"jp": "紋",
			"zht": "紋",
			"zhs": "纹"
		},
		"納": {
			"jp": "納",
			"zht": "納",
			"zhs": "纳"
		},
		"純": {
			"jp": "純",
			"zht": "純",
			"zhs": "纯"
		},
		"紙": {
			"jp": "紙",
			"zht": "紙",
			"zhs": "纸"
		},
		"級": {
			"jp": "級",
			"zht": "級",
			"zhs": "级"
		},
		"紛": {
			"jp": "紛",
			"zht": "紛",
			"zhs": "纷"
		},
		"紡": {
			"jp": "紡",
			"zht": "紡",
			"zhs": "纺"
		},
		"緊": {
			"jp": "緊",
			"zht": "緊",
			"zhs": "紧"
		},
		"細": {
			"jp": "細",
			"zht": "細",
			"zhs": "细"
		},
		"紳": {
			"jp": "紳",
			"zht": "紳",
			"zhs": "绅"
		},
		"紹": {
			"jp": "紹",
			"zht": "紹",
			"zhs": "绍"
		},
		"紺": {
			"jp": "紺",
			"zht": "紺",
			"zhs": "绀"
		},
		"終": {
			"jp": "終",
			"zht": "終",
			"zhs": "终"
		},
		"組": {
			"jp": "組",
			"zht": "組",
			"zhs": "组"
		},
		"経": {
			"jp": "経",
			"zht": "經",
			"zhs": "经"
		},
		"結": {
			"jp": "結",
			"zht": "結",
			"zhs": "结"
		},
		"絶": {
			"jp": "絶",
			"zht": "絕",
			"zhs": "绝"
		},
		"絞": {
			"jp": "絞",
			"zht": "絞",
			"zhs": "绞"
		},
		"絡": {
			"jp": "絡",
			"zht": "絡",
			"zhs": "络"
		},
		"給": {
			"jp": "給",
			"zht": "給",
			"zhs": "给"
		},
		"統": {
			"jp": "統",
			"zht": "統",
			"zhs": "统"
		},
		"絵": {
			"jp": "絵",
			"zht": "繪",
			"zhs": "绘"
		},
		"絹": {
			"jp": "絹",
			"zht": "絹",
			"zhs": "绢"
		},
		"継": {
			"jp": "継",
			"zht": "繼",
			"zhs": "继"
		},
		"続": {
			"jp": "続",
			"zht": "續",
			"zhs": "续"
		},
		"緑": {
			"jp": "緑",
			"zht": "綠",
			"zhs": "绿"
		},
		"線": {
			"jp": "線",
			"zht": "線",
			"zhs": "线"
		},
		"維": {
			"jp": "維",
			"zht": "維",
			"zhs": "维"
		},
		"綱": {
			"jp": "綱",
			"zht": "綱",
			"zhs": "纲"
		},
		"綿": {
			"jp": "綿",
			"zht": "綿",
			"zhs": "绵"
		},
		"緒": {
			"jp": "緒",
			"zht": "緒",
			"zhs": "绪"
		},
		"締": {
			"jp": "締",
			"zht": "締",
			"zhs": "缔"
		},
		"縁": {
			"jp": "縁",
			"zht": "緣",
			"zhs": "缘"
		},
		"編": {
			"jp": "編",
			"zht": "編",
			"zhs": "编"
		},
		"緩": {
			"jp": "緩",
			"zht": "緩",
			"zhs": "缓"
		},
		"緯": {
			"jp": "緯",
			"zht": "緯",
			"zhs": "纬"
		},
		"縄": {
			"jp": "縄",
			"zht": "繩",
			"zhs": "绳"
		},
		"縛": {
			"jp": "縛",
			"zht": "縛",
			"zhs": "缚"
		},
		"縦": {
			"jp": "縦",
			"zht": "縱",
			"zhs": "纵"
		},
		"縫": {
			"jp": "縫",
			"zht": "縫",
			"zhs": "缝"
		},
		"縮": {
			"jp": "縮",
			"zht": "縮",
			"zhs": "缩"
		},
		"繊": {
			"jp": "繊",
			"zht": "纖",
			"zhs": "纤"
		},
		"績": {
			"jp": "績",
			"zht": "績",
			"zhs": "绩"
		},
		"織": {
			"jp": "織",
			"zht": "織",
			"zhs": "织"
		},
		"繕": {
			"jp": "繕",
			"zht": "繕",
			"zhs": "缮"
		},
		"繭": {
			"jp": "繭",
			"zht": "繭",
			"zhs": "茧"
		},
		"繰": {
			"jp": "繰",
			"zht": "繰",
			"zhs": "缲"
		},
		"缶": {
			"jp": "缶",
			"zht": "罐",
			"zhs": "罐"
		},
		"鉢": {
			"jp": "鉢",
			"zht": "鉢",
			"zhs": "钵"
		},
		"羅": {
			"jp": "羅",
			"zht": "羅",
			"zhs": "罗"
		},
		"罸": {
			"jp": "罸",
			"zht": "罰",
			"zhs": "罚"
		},
		"罷": {
			"jp": "罷",
			"zht": "罷",
			"zhs": "罢"
		},
		"罵": {
			"jp": "罵",
			"zht": "罵",
			"zhs": "骂"
		},
		"職": {
			"jp": "職",
			"zht": "職",
			"zhs": "职"
		},
		"聞": {
			"jp": "聞",
			"zht": "聞",
			"zhs": "闻"
		},
		"聡": {
			"jp": "聡",
			"zht": "聰",
			"zhs": "聪"
		},
		"腸": {
			"jp": "腸",
			"zht": "腸",
			"zhs": "肠"
		},
		"膚": {
			"jp": "膚",
			"zht": "膚",
			"zhs": "肤"
		},
		"脹": {
			"jp": "脹",
			"zht": "脹",
			"zhs": "胀"
		},
		"脅": {
			"jp": "脅",
			"zht": "脅",
			"zhs": "胁"
		},
		"胆": {
			"jp": "胆",
			"zht": "膽",
			"zhs": "胆"
		},
		"臓": {
			"jp": "臓",
			"zht": "臟",
			"zhs": "脏"
		},
		"脳": {
			"jp": "脳",
			"zht": "腦",
			"zhs": "脑"
		},
		"脚": {
			"jp": "脚",
			"zht": "腳",
			"zhs": "脚"
		},
		"騰": {
			"jp": "騰",
			"zht": "騰",
			"zhs": "腾"
		},
		"舗": {
			"jp": "舗",
			"zht": "舖",
			"zhs": "铺"
		},
		"館": {
			"jp": "館",
			"zht": "館",
			"zhs": "馆"
		},
		"艦": {
			"jp": "艦",
			"zht": "艦",
			"zhs": "舰"
		},
		"芸": {
			"jp": "芸",
			"zht": "藝",
			"zhs": "艺"
		},
		"茎": {
			"jp": "茎",
			"zht": "莖",
			"zhs": "茎"
		},
		"薦": {
			"jp": "薦",
			"zht": "薦",
			"zhs": "荐"
		},
		"薬": {
			"jp": "薬",
			"zht": "藥",
			"zhs": "药"
		},
		"蛍": {
			"jp": "蛍",
			"zht": "螢",
			"zhs": "萤"
		},
		"蒋": {
			"jp": "蒋",
			"zht": "蔣",
			"zhs": "蒋"
		},
		"蔵": {
			"jp": "蔵",
			"zht": "藏",
			"zhs": "藏"
		},
		"虜": {
			"jp": "虜",
			"zht": "虜",
			"zhs": "虏"
		},
		"虚": {
			"jp": "虚",
			"zht": "虛",
			"zhs": "虚"
		},
		"虫": {
			"jp": "虫",
			"zht": "蟲",
			"zhs": "虫"
		},
		"蝕": {
			"jp": "蝕",
			"zht": "蝕",
			"zhs": "蚀"
		},
		"蚕": {
			"jp": "蚕",
			"zht": "蠶",
			"zhs": "蚕"
		},
		"蛮": {
			"jp": "蛮",
			"zht": "蠻",
			"zhs": "蛮"
		},
		"補": {
			"jp": "補",
			"zht": "補",
			"zhs": "补"
		},
		"襲": {
			"jp": "襲",
			"zht": "襲",
			"zhs": "袭"
		},
		"装": {
			"jp": "装",
			"zht": "裝",
			"zhs": "装"
		},
		"裏": {
			"jp": "裏",
			"zht": "裡",
			"zhs": "里"
		},
		"覇": {
			"jp": "覇",
			"zht": "霸",
			"zhs": "霸"
		},
		"見": {
			"jp": "見",
			"zht": "見",
			"zhs": "见"
		},
		"観": {
			"jp": "観",
			"zht": "觀",
			"zhs": "观"
		},
		"規": {
			"jp": "規",
			"zht": "規",
			"zhs": "规"
		},
		"覚": {
			"jp": "覚",
			"zht": "覺",
			"zhs": "觉"
		},
		"覧": {
			"jp": "覧",
			"zht": "覽",
			"zhs": "览"
		},
		"触": {
			"jp": "触",
			"zht": "觸",
			"zhs": "触"
		},
		"訂": {
			"jp": "訂",
			"zht": "訂",
			"zhs": "订"
		},
		"計": {
			"jp": "計",
			"zht": "計",
			"zhs": "计"
		},
		"討": {
			"jp": "討",
			"zht": "討",
			"zhs": "讨"
		},
		"訓": {
			"jp": "訓",
			"zht": "訓",
			"zhs": "训"
		},
		"記": {
			"jp": "記",
			"zht": "記",
			"zhs": "记"
		},
		"訟": {
			"jp": "訟",
			"zht": "訟",
			"zhs": "讼"
		},
		"訪": {
			"jp": "訪",
			"zht": "訪",
			"zhs": "访"
		},
		"設": {
			"jp": "設",
			"zht": "設",
			"zhs": "设"
		},
		"許": {
			"jp": "許",
			"zht": "許",
			"zhs": "许"
		},
		"訳": {
			"jp": "訳",
			"zht": "譯",
			"zhs": "译"
		},
		"訴": {
			"jp": "訴",
			"zht": "訴",
			"zhs": "诉"
		},
		"診": {
			"jp": "診",
			"zht": "診",
			"zhs": "诊"
		},
		"証": {
			"jp": "証",
			"zht": "證",
			"zhs": "证"
		},
		"詐": {
			"jp": "詐",
			"zht": "詐",
			"zhs": "诈"
		},
		"詔": {
			"jp": "詔",
			"zht": "詔",
			"zhs": "诏"
		},
		"評": {
			"jp": "評",
			"zht": "評",
			"zhs": "评"
		},
		"詛": {
			"jp": "詛",
			"zht": "詛",
			"zhs": "诅"
		},
		"詞": {
			"jp": "詞",
			"zht": "詞",
			"zhs": "词"
		},
		"試": {
			"jp": "試",
			"zht": "試",
			"zhs": "试"
		},
		"詩": {
			"jp": "詩",
			"zht": "詩",
			"zhs": "诗"
		},
		"詰": {
			"jp": "詰",
			"zht": "詰",
			"zhs": "诘"
		},
		"該": {
			"jp": "該",
			"zht": "該",
			"zhs": "该"
		},
		"詳": {
			"jp": "詳",
			"zht": "詳",
			"zhs": "详"
		},
		"誉": {
			"jp": "誉",
			"zht": "譽",
			"zhs": "誉"
		},
		"謄": {
			"jp": "謄",
			"zht": "謄",
			"zhs": "誊"
		},
		"認": {
			"jp": "認",
			"zht": "認",
			"zhs": "认"
		},
		"誕": {
			"jp": "誕",
			"zht": "誕",
			"zhs": "诞"
		},
		"誘": {
			"jp": "誘",
			"zht": "誘",
			"zhs": "诱"
		},
		"語": {
			"jp": "語",
			"zht": "語",
			"zhs": "语"
		},
		"誠": {
			"jp": "誠",
			"zht": "誠",
			"zhs": "诚"
		},
		"誤": {
			"jp": "誤",
			"zht": "誤",
			"zhs": "误"
		},
		"説": {
			"jp": "説",
			"zht": "說",
			"zhs": "说"
		},
		"読": {
			"jp": "読",
			"zht": "讀",
			"zhs": "读"
		},
		"誰": {
			"jp": "誰",
			"zht": "誰",
			"zhs": "谁"
		},
		"課": {
			"jp": "課",
			"zht": "課",
			"zhs": "课"
		},
		"調": {
			"jp": "調",
			"zht": "調",
			"zhs": "调"
		},
		"談": {
			"jp": "談",
			"zht": "談",
			"zhs": "谈"
		},
		"請": {
			"jp": "請",
			"zht": "請",
			"zhs": "请"
		},
		"論": {
			"jp": "論",
			"zht": "論",
			"zhs": "论"
		},
		"諭": {
			"jp": "諭",
			"zht": "諭",
			"zhs": "谕"
		},
		"諸": {
			"jp": "諸",
			"zht": "諸",
			"zhs": "诸"
		},
		"諾": {
			"jp": "諾",
			"zht": "諾",
			"zhs": "诺"
		},
		"謀": {
			"jp": "謀",
			"zht": "謀",
			"zhs": "谋"
		},
		"謁": {
			"jp": "謁",
			"zht": "謁",
			"zhs": "谒"
		},
		"謎": {
			"jp": "謎",
			"zht": "謎",
			"zhs": "谜"
		},
		"謙": {
			"jp": "謙",
			"zht": "謙",
			"zhs": "谦"
		},
		"講": {
			"jp": "講",
			"zht": "講",
			"zhs": "讲"
		},
		"謝": {
			"jp": "謝",
			"zht": "謝",
			"zhs": "谢"
		},
		"謡": {
			"jp": "謡",
			"zht": "謠",
			"zhs": "谣"
		},
		"謹": {
			"jp": "謹",
			"zht": "謹",
			"zhs": "谨"
		},
		"識": {
			"jp": "識",
			"zht": "識",
			"zhs": "识"
		},
		"譜": {
			"jp": "譜",
			"zht": "譜",
			"zhs": "谱"
		},
		"議": {
			"jp": "議",
			"zht": "議",
			"zhs": "议"
		},
		"譲": {
			"jp": "譲",
			"zht": "讓",
			"zhs": "让"
		},
		"貝": {
			"jp": "貝",
			"zht": "貝",
			"zhs": "贝"
		},
		"貞": {
			"jp": "貞",
			"zht": "貞",
			"zhs": "贞"
		},
		"負": {
			"jp": "負",
			"zht": "負",
			"zhs": "负"
		},
		"財": {
			"jp": "財",
			"zht": "財",
			"zhs": "财"
		},
		"貢": {
			"jp": "貢",
			"zht": "貢",
			"zhs": "贡"
		},
		"貧": {
			"jp": "貧",
			"zht": "貧",
			"zhs": "贫"
		},
		"貨": {
			"jp": "貨",
			"zht": "貨",
			"zhs": "货"
		},
		"販": {
			"jp": "販",
			"zht": "販",
			"zhs": "贩"
		},
		"貪": {
			"jp": "貪",
			"zht": "貪",
			"zhs": "贪"
		},
		"責": {
			"jp": "責",
			"zht": "責",
			"zhs": "责"
		},
		"貯": {
			"jp": "貯",
			"zht": "貯",
			"zhs": "贮"
		},
		"貴": {
			"jp": "貴",
			"zht": "貴",
			"zhs": "贵"
		},
		"貸": {
			"jp": "貸",
			"zht": "貸",
			"zhs": "贷"
		},
		"費": {
			"jp": "費",
			"zht": "費",
			"zhs": "费"
		},
		"貿": {
			"jp": "貿",
			"zht": "貿",
			"zhs": "贸"
		},
		"賀": {
			"jp": "賀",
			"zht": "賀",
			"zhs": "贺"
		},
		"賃": {
			"jp": "賃",
			"zht": "賃",
			"zhs": "赁"
		},
		"賄": {
			"jp": "賄",
			"zht": "賄",
			"zhs": "贿"
		},
		"資": {
			"jp": "資",
			"zht": "資",
			"zhs": "资"
		},
		"賊": {
			"jp": "賊",
			"zht": "賊",
			"zhs": "贼"
		},
		"賎": {
			"jp": "賎",
			"zht": "賤",
			"zhs": "贱"
		},
		"賛": {
			"jp": "賛",
			"zht": "贊",
			"zhs": "赞"
		},
		"賜": {
			"jp": "賜",
			"zht": "賜",
			"zhs": "赐"
		},
		"賞": {
			"jp": "賞",
			"zht": "賞",
			"zhs": "赏"
		},
		"賠": {
			"jp": "賠",
			"zht": "賠",
			"zhs": "赔"
		},
		"賢": {
			"jp": "賢",
			"zht": "賢",
			"zhs": "贤"
		},
		"賦": {
			"jp": "賦",
			"zht": "賦",
			"zhs": "赋"
		},
		"質": {
			"jp": "質",
			"zht": "質",
			"zhs": "质"
		},
		"頼": {
			"jp": "頼",
			"zht": "賴",
			"zhs": "赖"
		},
		"贈": {
			"jp": "贈",
			"zht": "贈",
			"zhs": "赠"
		},
		"贓": {
			"jp": "贓",
			"zht": "贓",
			"zhs": "赃"
		},
		"躍": {
			"jp": "躍",
			"zht": "躍",
			"zhs": "跃"
		},
		"践": {
			"jp": "践",
			"zht": "踐",
			"zhs": "践"
		},
		"踪": {
			"jp": "踪",
			"zht": "蹤",
			"zhs": "踪"
		},
		"車": {
			"jp": "車",
			"zht": "車",
			"zhs": "车"
		},
		"軌": {
			"jp": "軌",
			"zht": "軌",
			"zhs": "轨"
		},
		"軒": {
			"jp": "軒",
			"zht": "軒",
			"zhs": "轩"
		},
		"軟": {
			"jp": "軟",
			"zht": "軟",
			"zhs": "软"
		},
		"転": {
			"jp": "転",
			"zht": "轉",
			"zhs": "转"
		},
		"軸": {
			"jp": "軸",
			"zht": "軸",
			"zhs": "轴"
		},
		"軽": {
			"jp": "軽",
			"zht": "輕",
			"zhs": "轻"
		},
		"較": {
			"jp": "較",
			"zht": "較",
			"zhs": "较"
		},
		"載": {
			"jp": "載",
			"zht": "載",
			"zhs": "载"
		},
		"輝": {
			"jp": "輝",
			"zht": "輝",
			"zhs": "辉"
		},
		"輩": {
			"jp": "輩",
			"zht": "輩",
			"zhs": "辈"
		},
		"輪": {
			"jp": "輪",
			"zht": "輪",
			"zhs": "轮"
		},
		"輸": {
			"jp": "輸",
			"zht": "輸",
			"zhs": "输"
		},
		"轄": {
			"jp": "轄",
			"zht": "轄",
			"zhs": "辖"
		},
		"辞": {
			"jp": "辞",
			"zht": "辭",
			"zhs": "辞"
		},
		"辺": {
			"jp": "辺",
			"zht": "邊",
			"zhs": "边"
		},
		"達": {
			"jp": "達",
			"zht": "達",
			"zhs": "达"
		},
		"遷": {
			"jp": "遷",
			"zht": "遷",
			"zhs": "迁"
		},
		"過": {
			"jp": "過",
			"zht": "過",
			"zhs": "过"
		},
		"運": {
			"jp": "運",
			"zht": "運",
			"zhs": "运"
		},
		"還": {
			"jp": "還",
			"zht": "還",
			"zhs": "还"
		},
		"進": {
			"jp": "進",
			"zht": "進",
			"zhs": "进"
		},
		"遠": {
			"jp": "遠",
			"zht": "遠",
			"zhs": "远"
		},
		"違": {
			"jp": "違",
			"zht": "違",
			"zhs": "违"
		},
		"連": {
			"jp": "連",
			"zht": "連",
			"zhs": "连"
		},
		"遅": {
			"jp": "遅",
			"zht": "遲",
			"zhs": "迟"
		},
		"適": {
			"jp": "適",
			"zht": "適",
			"zhs": "适"
		},
		"選": {
			"jp": "選",
			"zht": "選",
			"zhs": "选"
		},
		"逓": {
			"jp": "逓",
			"zht": "遞",
			"zhs": "递"
		},
		"遺": {
			"jp": "遺",
			"zht": "遺",
			"zhs": "遗"
		},
		"遥": {
			"jp": "遥",
			"zht": "遙",
			"zhs": "遥"
		},
		"郵": {
			"jp": "郵",
			"zht": "郵",
			"zhs": "邮"
		},
		"隣": {
			"jp": "隣",
			"zht": "鄰",
			"zhs": "邻"
		},
		"酔": {
			"jp": "酔",
			"zht": "醉",
			"zhs": "醉"
		},
		"醸": {
			"jp": "醸",
			"zht": "釀",
			"zhs": "酿"
		},
		"釈": {
			"jp": "釈",
			"zht": "釋",
			"zhs": "释"
		},
		"針": {
			"jp": "針",
			"zht": "針",
			"zhs": "针"
		},
		"釣": {
			"jp": "釣",
			"zht": "釣",
			"zhs": "钓"
		},
		"鈍": {
			"jp": "鈍",
			"zht": "鈍",
			"zhs": "钝"
		},
		"鈴": {
			"jp": "鈴",
			"zht": "鈴",
			"zhs": "铃"
		},
		"鉄": {
			"jp": "鉄",
			"zht": "鐵",
			"zhs": "铁"
		},
		"鉛": {
			"jp": "鉛",
			"zht": "鉛",
			"zhs": "铅"
		},
		"鑑": {
			"jp": "鑑",
			"zht": "鑑",
			"zhs": "鉴"
		},
		"銀": {
			"jp": "銀",
			"zht": "銀",
			"zhs": "银"
		},
		"銃": {
			"jp": "銃",
			"zht": "銃",
			"zhs": "铳"
		},
		"銅": {
			"jp": "銅",
			"zht": "銅",
			"zhs": "铜"
		},
		"銑": {
			"jp": "銑",
			"zht": "銑",
			"zhs": "铣"
		},
		"銘": {
			"jp": "銘",
			"zht": "銘",
			"zhs": "铭"
		},
		"銭": {
			"jp": "銭",
			"zht": "錢",
			"zhs": "钱"
		},
		"鋭": {
			"jp": "鋭",
			"zht": "鋭",
			"zhs": "锐"
		},
		"鋳": {
			"jp": "鋳",
			"zht": "鑄",
			"zhs": "铸"
		},
		"鋼": {
			"jp": "鋼",
			"zht": "鋼",
			"zhs": "钢"
		},
		"錘": {
			"jp": "錘",
			"zht": "錘",
			"zhs": "锤"
		},
		"錠": {
			"jp": "錠",
			"zht": "錠",
			"zhs": "锭"
		},
		"錯": {
			"jp": "錯",
			"zht": "錯",
			"zhs": "错"
		},
		"鍾": {
			"jp": "鍾",
			"zht": "鍾",
			"zhs": "钟"
		},
		"鎖": {
			"jp": "鎖",
			"zht": "鎖",
			"zhs": "锁"
		},
		"鎮": {
			"jp": "鎮",
			"zht": "鎮",
			"zhs": "镇"
		},
		"鏡": {
			"jp": "鏡",
			"zht": "鏡",
			"zhs": "镜"
		},
		"長": {
			"jp": "長",
			"zht": "長",
			"zhs": "长"
		},
		"門": {
			"jp": "門",
			"zht": "門",
			"zhs": "门"
		},
		"閉": {
			"jp": "閉",
			"zht": "閉",
			"zhs": "闭"
		},
		"閑": {
			"jp": "閑",
			"zht": "閒",
			"zhs": "闲"
		},
		"間": {
			"jp": "間",
			"zht": "間",
			"zhs": "间"
		},
		"閣": {
			"jp": "閣",
			"zht": "閣",
			"zhs": "阁"
		},
		"閥": {
			"jp": "閥",
			"zht": "閥",
			"zhs": "阀"
		},
		"閲": {
			"jp": "閲",
			"zht": "閲",
			"zhs": "阅"
		},
		"隊": {
			"jp": "隊",
			"zht": "隊",
			"zhs": "队"
		},
		"陽": {
			"jp": "陽",
			"zht": "陽",
			"zhs": "阳"
		},
		"陰": {
			"jp": "陰",
			"zht": "陰",
			"zhs": "阴"
		},
		"陣": {
			"jp": "陣",
			"zht": "陣",
			"zhs": "阵"
		},
		"階": {
			"jp": "階",
			"zht": "階",
			"zhs": "阶"
		},
		"際": {
			"jp": "際",
			"zht": "際",
			"zhs": "际"
		},
		"陸": {
			"jp": "陸",
			"zht": "陸",
			"zhs": "陆"
		},
		"陳": {
			"jp": "陳",
			"zht": "陳",
			"zhs": "陈"
		},
		"陥": {
			"jp": "陥",
			"zht": "陷",
			"zhs": "陷"
		},
		"随": {
			"jp": "随",
			"zht": "隨",
			"zhs": "随"
		},
		"隠": {
			"jp": "隠",
			"zht": "隱",
			"zhs": "隐"
		},
		"隷": {
			"jp": "隷",
			"zht": "隸",
			"zhs": "隶"
		},
		"難": {
			"jp": "難",
			"zht": "難",
			"zhs": "难"
		},
		"霧": {
			"jp": "霧",
			"zht": "霧",
			"zhs": "雾"
		},
		"静": {
			"jp": "静",
			"zht": "靜",
			"zhs": "静"
		},
		"頂": {
			"jp": "頂",
			"zht": "頂",
			"zhs": "顶"
		},
		"項": {
			"jp": "項",
			"zht": "項",
			"zhs": "项"
		},
		"順": {
			"jp": "順",
			"zht": "順",
			"zhs": "顺"
		},
		"頑": {
			"jp": "頑",
			"zht": "頑",
			"zhs": "顽"
		},
		"頒": {
			"jp": "頒",
			"zht": "頒",
			"zhs": "颁"
		},
		"領": {
			"jp": "領",
			"zht": "領",
			"zhs": "领"
		},
		"頻": {
			"jp": "頻",
			"zht": "頻",
			"zhs": "频"
		},
		"題": {
			"jp": "題",
			"zht": "題",
			"zhs": "题"
		},
		"額": {
			"jp": "額",
			"zht": "額",
			"zhs": "额"
		},
		"顔": {
			"jp": "顔",
			"zht": "顏",
			"zhs": "颜"
		},
		"風": {
			"jp": "風",
			"zht": "風",
			"zhs": "风"
		},
		"飛": {
			"jp": "飛",
			"zht": "飛",
			"zhs": "飞"
		},
		"飢": {
			"jp": "飢",
			"zht": "饑",
			"zhs": "饥"
		},
		"飯": {
			"jp": "飯",
			"zht": "飯",
			"zhs": "饭"
		},
		"飲": {
			"jp": "飲",
			"zht": "飲",
			"zhs": "饮"
		},
		"飼": {
			"jp": "飼",
			"zht": "飼",
			"zhs": "饲"
		},
		"飽": {
			"jp": "飽",
			"zht": "飽",
			"zhs": "饱"
		},
		"飾": {
			"jp": "飾",
			"zht": "飾",
			"zhs": "饰"
		},
		"餓": {
			"jp": "餓",
			"zht": "餓",
			"zhs": "饿"
		},
		"馬": {
			"jp": "馬",
			"zht": "馬",
			"zhs": "马"
		},
		"駅": {
			"jp": "駅",
			"zht": "驛",
			"zhs": "驿"
		},
		"駆": {
			"jp": "駆",
			"zht": "驅",
			"zhs": "驱"
		},
		"駐": {
			"jp": "駐",
			"zht": "駐",
			"zhs": "驻"
		},
		"騎": {
			"jp": "騎",
			"zht": "騎",
			"zhs": "骑"
		},
		"験": {
			"jp": "験",
			"zht": "驗",
			"zhs": "验"
		},
		"騒": {
			"jp": "騒",
			"zht": "騷",
			"zhs": "骚"
		},
		"騨": {
			"jp": "騨",
			"zht": "驔",
			"zhs": "驔"
		},
		"髄": {
			"jp": "髄",
			"zht": "髓",
			"zhs": "髓"
		},
		"魚": {
			"jp": "魚",
			"zht": "魚",
			"zhs": "鱼"
		},
		"魯": {
			"jp": "魯",
			"zht": "魯",
			"zhs": "鲁"
		},
		"鮮": {
			"jp": "鮮",
			"zht": "鮮",
			"zhs": "鲜"
		},
		"鯨": {
			"jp": "鯨",
			"zht": "鯨",
			"zhs": "鲸"
		},
		"鳥": {
			"jp": "鳥",
			"zht": "鳥",
			"zhs": "鸟"
		},
		"鳴": {
			"jp": "鳴",
			"zht": "鳴",
			"zhs": "鸣"
		},
		"麦": {
			"jp": "麦",
			"zht": "麥",
			"zhs": "麦"
		},
		"黄": {
			"jp": "黄",
			"zht": "黃",
			"zhs": "黄"
		},
		"黒": {
			"jp": "黒",
			"zht": "黑",
			"zhs": "黑"
		},
		"黙": {
			"jp": "黙",
			"zht": "默",
			"zhs": "默"
		},
		"齢": {
			"jp": "齢",
			"zht": "齡",
			"zhs": "龄"
		}
	},
	"zht": {
		"會": {
			"jp": "会",
			"zht": "會",
			"zhs": "会"
		},
		"箋": {
			"jp": "箋",
			"zht": "箋",
			"zhs": "笺"
		},
		"網": {
			"jp": "網",
			"zht": "網",
			"zhs": "网"
		},
		"處": {
			"jp": "処",
			"zht": "處",
			"zhs": "处"
		},
		"話": {
			"jp": "話",
			"zht": "話",
			"zhs": "话"
		},
		"萬": {
			"jp": "万",
			"zht": "萬",
			"zhs": "万"
		},
		"與": {
			"jp": "与",
			"zht": "與",
			"zhs": "与"
		},
		"醜": {
			"jp": "醜",
			"zht": "醜",
			"zhs": "丑"
		},
		"專": {
			"jp": "専",
			"zht": "專",
			"zhs": "专"
		},
		"業": {
			"jp": "業",
			"zht": "業",
			"zhs": "业"
		},
		"東": {
			"jp": "東",
			"zht": "東",
			"zhs": "东"
		},
		"兩": {
			"jp": "両",
			"zht": "兩",
			"zhs": "两"
		},
		"嚴": {
			"jp": "厳",
			"zht": "嚴",
			"zhs": "严"
		},
		"並": {
			"jp": "並",
			"zht": "並",
			"zhs": "并"
		},
		"喪": {
			"jp": "喪",
			"zht": "喪",
			"zhs": "丧"
		},
		"豐": {
			"jp": "豊",
			"zht": "豐",
			"zhs": "丰"
		},
		"臨": {
			"jp": "臨",
			"zht": "臨",
			"zhs": "临"
		},
		"為": {
			"jp": "為",
			"zht": "為",
			"zhs": "为"
		},
		"麗": {
			"jp": "麗",
			"zht": "麗",
			"zhs": "丽"
		},
		"舉": {
			"jp": "挙",
			"zht": "舉",
			"zhs": "举"
		},
		"迺": {
			"jp": "廼",
			"zht": "迺",
			"zhs": "迺"
		},
		"義": {
			"jp": "義",
			"zht": "義",
			"zhs": "义"
		},
		"樂": {
			"jp": "楽",
			"zht": "樂",
			"zhs": "乐"
		},
		"乘": {
			"jp": "乗",
			"zht": "乘",
			"zhs": "乘"
		},
		"習": {
			"jp": "習",
			"zht": "習",
			"zhs": "习"
		},
		"鄉": {
			"jp": "郷",
			"zht": "鄉",
			"zhs": "乡"
		},
		"書": {
			"jp": "書",
			"zht": "書",
			"zhs": "书"
		},
		"買": {
			"jp": "買",
			"zht": "買",
			"zhs": "买"
		},
		"亂": {
			"jp": "乱",
			"zht": "亂",
			"zhs": "乱"
		},
		"龜": {
			"jp": "亀",
			"zht": "龜",
			"zhs": "龟"
		},
		"貳": {
			"jp": "弐",
			"zht": "貳",
			"zhs": "贰"
		},
		"雲": {
			"jp": "雲",
			"zht": "雲",
			"zhs": "云"
		},
		"亞": {
			"jp": "亜",
			"zht": "亞",
			"zhs": "亚"
		},
		"產": {
			"jp": "産",
			"zht": "產",
			"zhs": "产"
		},
		"畝": {
			"jp": "畝",
			"zht": "畝",
			"zhs": "亩"
		},
		"親": {
			"jp": "親",
			"zht": "親",
			"zhs": "亲"
		},
		"億": {
			"jp": "億",
			"zht": "億",
			"zhs": "亿"
		},
		"僕": {
			"jp": "僕",
			"zht": "僕",
			"zhs": "仆"
		},
		"從": {
			"jp": "従",
			"zht": "從",
			"zhs": "从"
		},
		"佛": {
			"jp": "仏",
			"zht": "佛",
			"zhs": "佛"
		},
		"倉": {
			"jp": "倉",
			"zht": "倉",
			"zhs": "仓"
		},
		"儀": {
			"jp": "儀",
			"zht": "儀",
			"zhs": "仪"
		},
		"假": {
			"jp": "仮",
			"zht": "假",
			"zhs": "假"
		},
		"價": {
			"jp": "価",
			"zht": "價",
			"zhs": "价"
		},
		"眾": {
			"jp": "衆",
			"zht": "眾",
			"zhs": "众"
		},
		"優": {
			"jp": "優",
			"zht": "優",
			"zhs": "优"
		},
		"傳": {
			"jp": "伝",
			"zht": "傳",
			"zhs": "传"
		},
		"傘": {
			"jp": "傘",
			"zht": "傘",
			"zhs": "伞"
		},
		"偉": {
			"jp": "偉",
			"zht": "偉",
			"zhs": "伟"
		},
		"傷": {
			"jp": "傷",
			"zht": "傷",
			"zhs": "伤"
		},
		"倫": {
			"jp": "倫",
			"zht": "倫",
			"zhs": "伦"
		},
		"偽": {
			"jp": "偽",
			"zht": "偽",
			"zhs": "伪"
		},
		"體": {
			"jp": "体",
			"zht": "體",
			"zhs": "体"
		},
		"餘": {
			"jp": "余",
			"zht": "餘",
			"zhs": "余"
		},
		"來": {
			"jp": "来",
			"zht": "來",
			"zhs": "来"
		},
		"偵": {
			"jp": "偵",
			"zht": "偵",
			"zhs": "侦"
		},
		"側": {
			"jp": "側",
			"zht": "側",
			"zhs": "侧"
		},
		"儉": {
			"jp": "倹",
			"zht": "儉",
			"zhs": "俭"
		},
		"俱": {
			"jp": "倶",
			"zht": "俱",
			"zhs": "俱"
		},
		"債": {
			"jp": "債",
			"zht": "債",
			"zhs": "债"
		},
		"傾": {
			"jp": "傾",
			"zht": "傾",
			"zhs": "倾"
		},
		"償": {
			"jp": "償",
			"zht": "償",
			"zhs": "偿"
		},
		"傑": {
			"jp": "傑",
			"zht": "傑",
			"zhs": "杰"
		},
		"備": {
			"jp": "備",
			"zht": "備",
			"zhs": "备"
		},
		"當": {
			"jp": "当",
			"zht": "當",
			"zhs": "当"
		},
		"盡": {
			"jp": "尽",
			"zht": "盡",
			"zhs": "尽"
		},
		"兒": {
			"jp": "児",
			"zht": "兒",
			"zhs": "儿"
		},
		"黨": {
			"jp": "党",
			"zht": "黨",
			"zhs": "党"
		},
		"內": {
			"jp": "内",
			"zht": "內",
			"zhs": "内"
		},
		"關": {
			"jp": "関",
			"zht": "關",
			"zhs": "关"
		},
		"興": {
			"jp": "興",
			"zht": "興",
			"zhs": "兴"
		},
		"養": {
			"jp": "養",
			"zht": "養",
			"zhs": "养"
		},
		"獸": {
			"jp": "獣",
			"zht": "獸",
			"zhs": "兽"
		},
		"圓": {
			"jp": "円",
			"zht": "圓",
			"zhs": "圆"
		},
		"寫": {
			"jp": "写",
			"zht": "寫",
			"zhs": "写"
		},
		"軍": {
			"jp": "軍",
			"zht": "軍",
			"zhs": "军"
		},
		"農": {
			"jp": "農",
			"zht": "農",
			"zhs": "农"
		},
		"富": {
			"jp": "冨",
			"zht": "富",
			"zhs": "富"
		},
		"冰": {
			"jp": "氷",
			"zht": "冰",
			"zhs": "冰"
		},
		"衝": {
			"jp": "衝",
			"zht": "衝",
			"zhs": "冲"
		},
		"決": {
			"jp": "決",
			"zht": "決",
			"zhs": "决"
		},
		"凍": {
			"jp": "凍",
			"zht": "凍",
			"zhs": "冻"
		},
		"塗": {
			"jp": "塗",
			"zht": "塗",
			"zhs": "涂"
		},
		"幾": {
			"jp": "幾",
			"zht": "幾",
			"zhs": "几"
		},
		"擊": {
			"jp": "撃",
			"zht": "擊",
			"zhs": "击"
		},
		"劃": {
			"jp": "画",
			"zht": "劃",
			"zhs": "划"
		},
		"畫": {
			"jp": "画",
			"zht": "畫",
			"zhs": "画"
		},
		"則": {
			"jp": "則",
			"zht": "則",
			"zhs": "则"
		},
		"剛": {
			"jp": "剛",
			"zht": "剛",
			"zhs": "刚"
		},
		"創": {
			"jp": "創",
			"zht": "創",
			"zhs": "创"
		},
		"別": {
			"jp": "別",
			"zht": "別",
			"zhs": "别"
		},
		"製": {
			"jp": "製",
			"zht": "製",
			"zhs": "制"
		},
		"卷": {
			"jp": "巻",
			"zht": "卷",
			"zhs": "卷"
		},
		"剎": {
			"jp": "刹",
			"zht": "剎",
			"zhs": "刹"
		},
		"劑": {
			"jp": "剤",
			"zht": "劑",
			"zhs": "剂"
		},
		"劍": {
			"jp": "剣",
			"zht": "劍",
			"zhs": "剑"
		},
		"劇": {
			"jp": "劇",
			"zht": "劇",
			"zhs": "剧"
		},
		"剩": {
			"jp": "剰",
			"zht": "剩",
			"zhs": "剩"
		},
		"勸": {
			"jp": "勧",
			"zht": "勸",
			"zhs": "劝"
		},
		"務": {
			"jp": "務",
			"zht": "務",
			"zhs": "务"
		},
		"動": {
			"jp": "動",
			"zht": "動",
			"zhs": "动"
		},
		"勵": {
			"jp": "励",
			"zht": "勵",
			"zhs": "励"
		},
		"勞": {
			"jp": "労",
			"zht": "勞",
			"zhs": "劳"
		},
		"勢": {
			"jp": "勢",
			"zht": "勢",
			"zhs": "势"
		},
		"勳": {
			"jp": "勲",
			"zht": "勳",
			"zhs": "勋"
		},
		"勝": {
			"jp": "勝",
			"zht": "勝",
			"zhs": "胜"
		},
		"區": {
			"jp": "区",
			"zht": "區",
			"zhs": "区"
		},
		"醫": {
			"jp": "医",
			"zht": "醫",
			"zhs": "医"
		},
		"華": {
			"jp": "華",
			"zht": "華",
			"zhs": "华"
		},
		"協": {
			"jp": "協",
			"zht": "協",
			"zhs": "协"
		},
		"單": {
			"jp": "単",
			"zht": "單",
			"zhs": "单"
		},
		"賣": {
			"jp": "売",
			"zht": "賣",
			"zhs": "卖"
		},
		"衛": {
			"jp": "衛",
			"zht": "衛",
			"zhs": "卫"
		},
		"廳": {
			"jp": "庁",
			"zht": "廳",
			"zhs": "厅"
		},
		"壓": {
			"jp": "圧",
			"zht": "壓",
			"zhs": "压"
		},
		"縣": {
			"jp": "県",
			"zht": "縣",
			"zhs": "县"
		},
		"參": {
			"jp": "参",
			"zht": "參",
			"zhs": "参"
		},
		"雙": {
			"jp": "双",
			"zht": "雙",
			"zhs": "双"
		},
		"收": {
			"jp": "収",
			"zht": "收",
			"zhs": "收"
		},
		"發": {
			"jp": "発",
			"zht": "發",
			"zhs": "发"
		},
		"變": {
			"jp": "変",
			"zht": "變",
			"zhs": "变"
		},
		"疊": {
			"jp": "畳",
			"zht": "疊",
			"zhs": "叠"
		},
		"號": {
			"jp": "号",
			"zht": "號",
			"zhs": "号"
		},
		"嘆": {
			"jp": "嘆",
			"zht": "嘆",
			"zhs": "叹"
		},
		"嚇": {
			"jp": "嚇",
			"zht": "嚇",
			"zhs": "吓"
		},
		"聽": {
			"jp": "聴",
			"zht": "聽",
			"zhs": "听"
		},
		"啟": {
			"jp": "啓",
			"zht": "啟",
			"zhs": "启"
		},
		"員": {
			"jp": "員",
			"zht": "員",
			"zhs": "员"
		},
		"諮": {
			"jp": "諮",
			"zht": "諮",
			"zhs": "谘"
		},
		"鹹": {
			"jp": "鹹",
			"zht": "鹹",
			"zhs": "咸"
		},
		"響": {
			"jp": "響",
			"zht": "響",
			"zhs": "响"
		},
		"問": {
			"jp": "問",
			"zht": "問",
			"zhs": "问"
		},
		"營": {
			"jp": "営",
			"zht": "營",
			"zhs": "营"
		},
		"噴": {
			"jp": "噴",
			"zht": "噴",
			"zhs": "喷"
		},
		"囑": {
			"jp": "嘱",
			"zht": "囑",
			"zhs": "嘱"
		},
		"蘇": {
			"jp": "蘇",
			"zht": "蘇",
			"zhs": "苏"
		},
		"團": {
			"jp": "団",
			"zht": "團",
			"zhs": "团"
		},
		"園": {
			"jp": "園",
			"zht": "園",
			"zhs": "园"
		},
		"國": {
			"jp": "国",
			"zht": "國",
			"zhs": "国"
		},
		"圍": {
			"jp": "囲",
			"zht": "圍",
			"zhs": "围"
		},
		"圖": {
			"jp": "図",
			"zht": "圖",
			"zhs": "图"
		},
		"圈": {
			"jp": "圏",
			"zht": "圈",
			"zhs": "圈"
		},
		"聖": {
			"jp": "聖",
			"zht": "聖",
			"zhs": "圣"
		},
		"場": {
			"jp": "場",
			"zht": "場",
			"zhs": "场"
		},
		"壞": {
			"jp": "壊",
			"zht": "壞",
			"zhs": "坏"
		},
		"塊": {
			"jp": "塊",
			"zht": "塊",
			"zhs": "块"
		},
		"堅": {
			"jp": "堅",
			"zht": "堅",
			"zhs": "坚"
		},
		"壇": {
			"jp": "壇",
			"zht": "壇",
			"zhs": "坛"
		},
		"墳": {
			"jp": "墳",
			"zht": "墳",
			"zhs": "坟"
		},
		"墜": {
			"jp": "墜",
			"zht": "墜",
			"zhs": "坠"
		},
		"壘": {
			"jp": "塁",
			"zht": "壘",
			"zhs": "垒"
		},
		"墾": {
			"jp": "墾",
			"zht": "墾",
			"zhs": "垦"
		},
		"執": {
			"jp": "執",
			"zht": "執",
			"zhs": "执"
		},
		"墮": {
			"jp": "堕",
			"zht": "墮",
			"zhs": "堕"
		},
		"報": {
			"jp": "報",
			"zht": "報",
			"zhs": "报"
		},
		"鹽": {
			"jp": "塩",
			"zht": "鹽",
			"zhs": "盐"
		},
		"增": {
			"jp": "増",
			"zht": "增",
			"zhs": "增"
		},
		"壤": {
			"jp": "壌",
			"zht": "壤",
			"zhs": "壤"
		},
		"壯": {
			"jp": "壮",
			"zht": "壯",
			"zhs": "壮"
		},
		"聲": {
			"jp": "声",
			"zht": "聲",
			"zhs": "声"
		},
		"壹": {
			"jp": "壱",
			"zht": "壹",
			"zhs": "壹"
		},
		"壽": {
			"jp": "寿",
			"zht": "壽",
			"zhs": "寿"
		},
		"夢": {
			"jp": "夢",
			"zht": "夢",
			"zhs": "梦"
		},
		"頭": {
			"jp": "頭",
			"zht": "頭",
			"zhs": "头"
		},
		"誇": {
			"jp": "誇",
			"zht": "誇",
			"zhs": "夸"
		},
		"奪": {
			"jp": "奪",
			"zht": "奪",
			"zhs": "夺"
		},
		"奮": {
			"jp": "奮",
			"zht": "奮",
			"zhs": "奋"
		},
		"獎": {
			"jp": "奨",
			"zht": "獎",
			"zhs": "奖"
		},
		"妝": {
			"jp": "粧",
			"zht": "妝",
			"zhs": "妆"
		},
		"婦": {
			"jp": "婦",
			"zht": "婦",
			"zhs": "妇"
		},
		"姐": {
			"jp": "姉",
			"zht": "姐",
			"zhs": "姐"
		},
		"姬": {
			"jp": "姫",
			"zht": "姬",
			"zhs": "姬"
		},
		"孃": {
			"jp": "嬢",
			"zht": "孃",
			"zhs": "娘"
		},
		"娛": {
			"jp": "娯",
			"zht": "娛",
			"zhs": "娱"
		},
		"孫": {
			"jp": "孫",
			"zht": "孫",
			"zhs": "孙"
		},
		"學": {
			"jp": "学",
			"zht": "學",
			"zhs": "学"
		},
		"寧": {
			"jp": "寧",
			"zht": "寧",
			"zhs": "宁"
		},
		"寶": {
			"jp": "宝",
			"zht": "寶",
			"zhs": "宝"
		},
		"實": {
			"jp": "実",
			"zht": "實",
			"zhs": "实"
		},
		"審": {
			"jp": "審",
			"zht": "審",
			"zhs": "审"
		},
		"憲": {
			"jp": "憲",
			"zht": "憲",
			"zhs": "宪"
		},
		"宮": {
			"jp": "宮",
			"zht": "宮",
			"zhs": "宫"
		},
		"賓": {
			"jp": "賓",
			"zht": "賓",
			"zhs": "宾"
		},
		"祕": {
			"jp": "秘",
			"zht": "祕",
			"zhs": "秘"
		},
		"寢": {
			"jp": "寝",
			"zht": "寢",
			"zhs": "寝"
		},
		"對": {
			"jp": "対",
			"zht": "對",
			"zhs": "对"
		},
		"尋": {
			"jp": "尋",
			"zht": "尋",
			"zhs": "寻"
		},
		"導": {
			"jp": "導",
			"zht": "導",
			"zhs": "导"
		},
		"將": {
			"jp": "将",
			"zht": "將",
			"zhs": "将"
		},
		"層": {
			"jp": "層",
			"zht": "層",
			"zhs": "层"
		},
		"屬": {
			"jp": "属",
			"zht": "屬",
			"zhs": "属"
		},
		"歲": {
			"jp": "歳",
			"zht": "歲",
			"zhs": "岁"
		},
		"島": {
			"jp": "島",
			"zht": "島",
			"zhs": "岛"
		},
		"巖": {
			"jp": "巌",
			"zht": "巖",
			"zhs": "巖"
		},
		"峽": {
			"jp": "峡",
			"zht": "峽",
			"zhs": "峡"
		},
		"險": {
			"jp": "険",
			"zht": "險",
			"zhs": "险"
		},
		"幣": {
			"jp": "幣",
			"zht": "幣",
			"zhs": "币"
		},
		"帥": {
			"jp": "帥",
			"zht": "帥",
			"zhs": "帅"
		},
		"師": {
			"jp": "師",
			"zht": "師",
			"zhs": "师"
		},
		"帳": {
			"jp": "帳",
			"zht": "帳",
			"zhs": "帐"
		},
		"歸": {
			"jp": "帰",
			"zht": "歸",
			"zhs": "归"
		},
		"廣": {
			"jp": "広",
			"zht": "廣",
			"zhs": "广"
		},
		"慶": {
			"jp": "慶",
			"zht": "慶",
			"zhs": "庆"
		},
		"庫": {
			"jp": "庫",
			"zht": "庫",
			"zhs": "库"
		},
		"應": {
			"jp": "応",
			"zht": "應",
			"zhs": "应"
		},
		"廢": {
			"jp": "廃",
			"zht": "廢",
			"zhs": "废"
		},
		"開": {
			"jp": "開",
			"zht": "開",
			"zhs": "开"
		},
		"辨": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辨"
		},
		"瓣": {
			"jp": "弁",
			"zht": "瓣",
			"zhs": "辨"
		},
		"辯": {
			"jp": "弁",
			"zht": "辯",
			"zhs": "辨"
		},
		"異": {
			"jp": "異",
			"zht": "異",
			"zhs": "异"
		},
		"棄": {
			"jp": "棄",
			"zht": "棄",
			"zhs": "弃"
		},
		"張": {
			"jp": "張",
			"zht": "張",
			"zhs": "张"
		},
		"彌": {
			"jp": "弥",
			"zht": "彌",
			"zhs": "弥"
		},
		"強": {
			"jp": "強",
			"zht": "強",
			"zhs": "强"
		},
		"彈": {
			"jp": "弾",
			"zht": "彈",
			"zhs": "弹"
		},
		"錄": {
			"jp": "録",
			"zht": "錄",
			"zhs": "录"
		},
		"彥": {
			"jp": "彦",
			"zht": "彥",
			"zhs": "彥"
		},
		"徹": {
			"jp": "徹",
			"zht": "徹",
			"zhs": "彻"
		},
		"徵": {
			"jp": "徴",
			"zht": "徵",
			"zhs": "征"
		},
		"徑": {
			"jp": "径",
			"zht": "徑",
			"zhs": "径"
		},
		"德": {
			"jp": "徳",
			"zht": "德",
			"zhs": "德"
		},
		"憶": {
			"jp": "憶",
			"zht": "憶",
			"zhs": "忆"
		},
		"誌": {
			"jp": "誌",
			"zht": "誌",
			"zhs": "志"
		},
		"憂": {
			"jp": "憂",
			"zht": "憂",
			"zhs": "忧"
		},
		"懷": {
			"jp": "懐",
			"zht": "懷",
			"zhs": "怀"
		},
		"態": {
			"jp": "態",
			"zht": "態",
			"zhs": "态"
		},
		"總": {
			"jp": "総",
			"zht": "總",
			"zhs": "总"
		},
		"恆": {
			"jp": "恒",
			"zht": "恆",
			"zhs": "恒"
		},
		"戀": {
			"jp": "恋",
			"zht": "戀",
			"zhs": "恋"
		},
		"懇": {
			"jp": "懇",
			"zht": "懇",
			"zhs": "恳"
		},
		"惠": {
			"jp": "恵",
			"zht": "惠",
			"zhs": "惠"
		},
		"惡": {
			"jp": "悪",
			"zht": "惡",
			"zhs": "恶"
		},
		"惱": {
			"jp": "悩",
			"zht": "惱",
			"zhs": "恼"
		},
		"悅": {
			"jp": "悦",
			"zht": "悅",
			"zhs": "悅"
		},
		"懸": {
			"jp": "懸",
			"zht": "懸",
			"zhs": "悬"
		},
		"驚": {
			"jp": "驚",
			"zht": "驚",
			"zhs": "惊"
		},
		"慘": {
			"jp": "惨",
			"zht": "慘",
			"zhs": "惨"
		},
		"懲": {
			"jp": "懲",
			"zht": "懲",
			"zhs": "惩"
		},
		"愛": {
			"jp": "愛",
			"zht": "愛",
			"zhs": "爱"
		},
		"憤": {
			"jp": "憤",
			"zht": "憤",
			"zhs": "愤"
		},
		"願": {
			"jp": "願",
			"zht": "願",
			"zhs": "愿"
		},
		"慮": {
			"jp": "慮",
			"zht": "慮",
			"zhs": "虑"
		},
		"戲": {
			"jp": "戯",
			"zht": "戲",
			"zhs": "戏"
		},
		"戰": {
			"jp": "戦",
			"zht": "戰",
			"zhs": "战"
		},
		"戶": {
			"jp": "戸",
			"zht": "戶",
			"zhs": "户"
		},
		"拂": {
			"jp": "払",
			"zht": "拂",
			"zhs": "拂"
		},
		"擴": {
			"jp": "拡",
			"zht": "擴",
			"zhs": "扩"
		},
		"掃": {
			"jp": "掃",
			"zht": "掃",
			"zhs": "扫"
		},
		"揚": {
			"jp": "揚",
			"zht": "揚",
			"zhs": "扬"
		},
		"擇": {
			"jp": "択",
			"zht": "擇",
			"zhs": "择"
		},
		"護": {
			"jp": "護",
			"zht": "護",
			"zhs": "护"
		},
		"擔": {
			"jp": "担",
			"zht": "擔",
			"zhs": "担"
		},
		"拜": {
			"jp": "拝",
			"zht": "拜",
			"zhs": "拜"
		},
		"擬": {
			"jp": "擬",
			"zht": "擬",
			"zhs": "拟"
		},
		"據": {
			"jp": "拠",
			"zht": "據",
			"zhs": "据"
		},
		"擁": {
			"jp": "擁",
			"zht": "擁",
			"zhs": "拥"
		},
		"挾": {
			"jp": "挟",
			"zht": "挾",
			"zhs": "挟"
		},
		"揮": {
			"jp": "揮",
			"zht": "揮",
			"zhs": "挥"
		},
		"插": {
			"jp": "挿",
			"zht": "插",
			"zhs": "插"
		},
		"損": {
			"jp": "損",
			"zht": "損",
			"zhs": "损"
		},
		"捨": {
			"jp": "捨",
			"zht": "捨",
			"zhs": "舍"
		},
		"揭": {
			"jp": "掲",
			"zht": "揭",
			"zhs": "揭"
		},
		"摑": {
			"jp": "掴",
			"zht": "摑",
			"zhs": "掴"
		},
		"搖": {
			"jp": "揺",
			"zht": "搖",
			"zhs": "摇"
		},
		"敵": {
			"jp": "敵",
			"zht": "敵",
			"zhs": "敌"
		},
		"敗": {
			"jp": "敗",
			"zht": "敗",
			"zhs": "败"
		},
		"數": {
			"jp": "数",
			"zht": "數",
			"zhs": "数"
		},
		"齊": {
			"jp": "斉",
			"zht": "齊",
			"zhs": "齐"
		},
		"齋": {
			"jp": "斎",
			"zht": "齋",
			"zhs": "斋"
		},
		"斷": {
			"jp": "断",
			"zht": "斷",
			"zhs": "断"
		},
		"舊": {
			"jp": "旧",
			"zht": "舊",
			"zhs": "旧"
		},
		"時": {
			"jp": "時",
			"zht": "時",
			"zhs": "时"
		},
		"曇": {
			"jp": "曇",
			"zht": "曇",
			"zhs": "昙"
		},
		"晝": {
			"jp": "昼",
			"zht": "晝",
			"zhs": "昼"
		},
		"顯": {
			"jp": "顕",
			"zht": "顯",
			"zhs": "显"
		},
		"曉": {
			"jp": "暁",
			"zht": "曉",
			"zhs": "晓"
		},
		"晚": {
			"jp": "晩",
			"zht": "晚",
			"zhs": "晚"
		},
		"暫": {
			"jp": "暫",
			"zht": "暫",
			"zhs": "暂"
		},
		"曾": {
			"jp": "曽",
			"zht": "曾",
			"zhs": "曾"
		},
		"術": {
			"jp": "術",
			"zht": "術",
			"zhs": "术"
		},
		"樸": {
			"jp": "樸",
			"zht": "樸",
			"zhs": "朴"
		},
		"機": {
			"jp": "機",
			"zht": "機",
			"zhs": "机"
		},
		"殺": {
			"jp": "殺",
			"zht": "殺",
			"zhs": "杀"
		},
		"雜": {
			"jp": "雑",
			"zht": "雜",
			"zhs": "杂"
		},
		"權": {
			"jp": "権",
			"zht": "權",
			"zhs": "权"
		},
		"條": {
			"jp": "条",
			"zht": "條",
			"zhs": "条"
		},
		"極": {
			"jp": "極",
			"zht": "極",
			"zhs": "极"
		},
		"樞": {
			"jp": "枢",
			"zht": "樞",
			"zhs": "枢"
		},
		"槍": {
			"jp": "槍",
			"zht": "槍",
			"zhs": "枪"
		},
		"查": {
			"jp": "査",
			"zht": "查",
			"zhs": "查"
		},
		"榮": {
			"jp": "栄",
			"zht": "榮",
			"zhs": "荣"
		},
		"標": {
			"jp": "標",
			"zht": "標",
			"zhs": "标"
		},
		"棧": {
			"jp": "桟",
			"zht": "棧",
			"zhs": "栈"
		},
		"棟": {
			"jp": "棟",
			"zht": "棟",
			"zhs": "栋"
		},
		"欄": {
			"jp": "欄",
			"zht": "欄",
			"zhs": "栏"
		},
		"樹": {
			"jp": "樹",
			"zht": "樹",
			"zhs": "树"
		},
		"樣": {
			"jp": "様",
			"zht": "樣",
			"zhs": "样"
		},
		"櫻": {
			"jp": "桜",
			"zht": "櫻",
			"zhs": "樱"
		},
		"橋": {
			"jp": "橋",
			"zht": "橋",
			"zhs": "桥"
		},
		"檢": {
			"jp": "検",
			"zht": "檢",
			"zhs": "检"
		},
		"樓": {
			"jp": "楼",
			"zht": "樓",
			"zhs": "楼"
		},
		"歡": {
			"jp": "歓",
			"zht": "歡",
			"zhs": "欢"
		},
		"歐": {
			"jp": "欧",
			"zht": "歐",
			"zhs": "欧"
		},
		"步": {
			"jp": "歩",
			"zht": "步",
			"zhs": "步"
		},
		"齒": {
			"jp": "歯",
			"zht": "齒",
			"zhs": "齿"
		},
		"殘": {
			"jp": "残",
			"zht": "殘",
			"zhs": "残"
		},
		"毆": {
			"jp": "殴",
			"zht": "毆",
			"zhs": "殴"
		},
		"氣": {
			"jp": "気",
			"zht": "氣",
			"zhs": "气"
		},
		"漢": {
			"jp": "漢",
			"zht": "漢",
			"zhs": "汉"
		},
		"湯": {
			"jp": "湯",
			"zht": "湯",
			"zhs": "汤"
		},
		"溝": {
			"jp": "溝",
			"zht": "溝",
			"zhs": "沟"
		},
		"澤": {
			"jp": "沢",
			"zht": "澤",
			"zhs": "泽"
		},
		"淚": {
			"jp": "涙",
			"zht": "淚",
			"zhs": "泪"
		},
		"瀧": {
			"jp": "滝",
			"zht": "瀧",
			"zhs": "泷"
		},
		"潔": {
			"jp": "潔",
			"zht": "潔",
			"zhs": "洁"
		},
		"淺": {
			"jp": "浅",
			"zht": "淺",
			"zhs": "浅"
		},
		"濁": {
			"jp": "濁",
			"zht": "濁",
			"zhs": "浊"
		},
		"測": {
			"jp": "測",
			"zht": "測",
			"zhs": "测"
		},
		"濟": {
			"jp": "済",
			"zht": "濟",
			"zhs": "济"
		},
		"濃": {
			"jp": "濃",
			"zht": "濃",
			"zhs": "浓"
		},
		"濱": {
			"jp": "浜",
			"zht": "濱",
			"zhs": "滨"
		},
		"涉": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涉"
		},
		"澀": {
			"jp": "渋",
			"zht": "澀",
			"zhs": "涉"
		},
		"渦": {
			"jp": "渦",
			"zht": "渦",
			"zhs": "涡"
		},
		"潤": {
			"jp": "潤",
			"zht": "潤",
			"zhs": "润"
		},
		"漬": {
			"jp": "漬",
			"zht": "漬",
			"zhs": "渍"
		},
		"漸": {
			"jp": "漸",
			"zht": "漸",
			"zhs": "渐"
		},
		"溪": {
			"jp": "渓",
			"zht": "溪",
			"zhs": "溪"
		},
		"漁": {
			"jp": "漁",
			"zht": "漁",
			"zhs": "渔"
		},
		"灣": {
			"jp": "湾",
			"zht": "灣",
			"zhs": "湾"
		},
		"濕": {
			"jp": "湿",
			"zht": "濕",
			"zhs": "湿"
		},
		"滿": {
			"jp": "満",
			"zht": "滿",
			"zhs": "满"
		},
		"滅": {
			"jp": "滅",
			"zht": "滅",
			"zhs": "灭"
		},
		"滯": {
			"jp": "滞",
			"zht": "滯",
			"zhs": "滞"
		},
		"濫": {
			"jp": "濫",
			"zht": "濫",
			"zhs": "滥"
		},
		"瀨": {
			"jp": "瀬",
			"zht": "瀨",
			"zhs": "濑"
		},
		"燈": {
			"jp": "灯",
			"zht": "燈",
			"zhs": "灯"
		},
		"靈": {
			"jp": "霊",
			"zht": "靈",
			"zhs": "灵"
		},
		"爐": {
			"jp": "炉",
			"zht": "爐",
			"zhs": "炉"
		},
		"點": {
			"jp": "点",
			"zht": "點",
			"zhs": "点"
		},
		"鍊": {
			"jp": "錬",
			"zht": "鍊",
			"zhs": "炼"
		},
		"練": {
			"jp": "練",
			"zht": "練",
			"zhs": "练"
		},
		"煙": {
			"jp": "煙",
			"zht": "煙",
			"zhs": "烟"
		},
		"煩": {
			"jp": "煩",
			"zht": "煩",
			"zhs": "烦"
		},
		"燒": {
			"jp": "焼",
			"zht": "燒",
			"zhs": "烧"
		},
		"熱": {
			"jp": "熱",
			"zht": "熱",
			"zhs": "热"
		},
		"焰": {
			"jp": "焔",
			"zht": "焰",
			"zhs": "焰"
		},
		"鍛": {
			"jp": "鍛",
			"zht": "鍛",
			"zhs": "锻"
		},
		"犧": {
			"jp": "犠",
			"zht": "犧",
			"zhs": "牺"
		},
		"狀": {
			"jp": "状",
			"zht": "狀",
			"zhs": "状"
		},
		"猶": {
			"jp": "猶",
			"zht": "猶",
			"zhs": "犹"
		},
		"獨": {
			"jp": "独",
			"zht": "獨",
			"zhs": "独"
		},
		"狹": {
			"jp": "狭",
			"zht": "狹",
			"zhs": "狭"
		},
		"獄": {
			"jp": "獄",
			"zht": "獄",
			"zhs": "狱"
		},
		"獵": {
			"jp": "猟",
			"zht": "獵",
			"zhs": "猎"
		},
		"貓": {
			"jp": "猫",
			"zht": "貓",
			"zhs": "猫"
		},
		"獻": {
			"jp": "献",
			"zht": "獻",
			"zhs": "献"
		},
		"環": {
			"jp": "環",
			"zht": "環",
			"zhs": "环"
		},
		"現": {
			"jp": "現",
			"zht": "現",
			"zhs": "现"
		},
		"璽": {
			"jp": "璽",
			"zht": "璽",
			"zhs": "玺"
		},
		"電": {
			"jp": "電",
			"zht": "電",
			"zhs": "电"
		},
		"療": {
			"jp": "療",
			"zht": "療",
			"zhs": "疗"
		},
		"監": {
			"jp": "監",
			"zht": "監",
			"zhs": "监"
		},
		"蓋": {
			"jp": "蓋",
			"zht": "蓋",
			"zhs": "盖"
		},
		"盤": {
			"jp": "盤",
			"zht": "盤",
			"zhs": "盘"
		},
		"視": {
			"jp": "視",
			"zht": "視",
			"zhs": "视"
		},
		"著": {
			"jp": "着",
			"zht": "著",
			"zhs": "著"
		},
		"矯": {
			"jp": "矯",
			"zht": "矯",
			"zhs": "矫"
		},
		"礦": {
			"jp": "鉱",
			"zht": "礦",
			"zhs": "矿"
		},
		"碎": {
			"jp": "砕",
			"zht": "碎",
			"zhs": "碎"
		},
		"礎": {
			"jp": "礎",
			"zht": "礎",
			"zhs": "础"
		},
		"確": {
			"jp": "確",
			"zht": "確",
			"zhs": "确"
		},
		"禮": {
			"jp": "礼",
			"zht": "禮",
			"zhs": "礼"
		},
		"禍": {
			"jp": "禍",
			"zht": "禍",
			"zhs": "祸"
		},
		"禪": {
			"jp": "禅",
			"zht": "禪",
			"zhs": "禅"
		},
		"離": {
			"jp": "離",
			"zht": "離",
			"zhs": "离"
		},
		"種": {
			"jp": "種",
			"zht": "種",
			"zhs": "种"
		},
		"積": {
			"jp": "積",
			"zht": "積",
			"zhs": "积"
		},
		"稱": {
			"jp": "称",
			"zht": "稱",
			"zhs": "称"
		},
		"稻": {
			"jp": "稲",
			"zht": "稻",
			"zhs": "稻"
		},
		"穩": {
			"jp": "穏",
			"zht": "穩",
			"zhs": "稳"
		},
		"穀": {
			"jp": "穀",
			"zht": "穀",
			"zhs": "谷"
		},
		"穗": {
			"jp": "穂",
			"zht": "穗",
			"zhs": "穗"
		},
		"窮": {
			"jp": "窮",
			"zht": "窮",
			"zhs": "穷"
		},
		"竊": {
			"jp": "窃",
			"zht": "竊",
			"zhs": "窃"
		},
		"窗": {
			"jp": "窓",
			"zht": "窗",
			"zhs": "窗"
		},
		"龍": {
			"jp": "竜",
			"zht": "龍",
			"zhs": "龙"
		},
		"競": {
			"jp": "競",
			"zht": "競",
			"zhs": "竞"
		},
		"篤": {
			"jp": "篤",
			"zht": "篤",
			"zhs": "笃"
		},
		"筆": {
			"jp": "筆",
			"zht": "筆",
			"zhs": "笔"
		},
		"築": {
			"jp": "築",
			"zht": "築",
			"zhs": "筑"
		},
		"簡": {
			"jp": "簡",
			"zht": "簡",
			"zhs": "简"
		},
		"節": {
			"jp": "節",
			"zht": "節",
			"zhs": "节"
		},
		"範": {
			"jp": "範",
			"zht": "範",
			"zhs": "范"
		},
		"類": {
			"jp": "類",
			"zht": "類",
			"zhs": "类"
		},
		"粹": {
			"jp": "粋",
			"zht": "粹",
			"zhs": "粹"
		},
		"肅": {
			"jp": "粛",
			"zht": "肅",
			"zhs": "肃"
		},
		"糧": {
			"jp": "糧",
			"zht": "糧",
			"zhs": "粮"
		},
		"糾": {
			"jp": "糾",
			"zht": "糾",
			"zhs": "纠"
		},
		"紀": {
			"jp": "紀",
			"zht": "紀",
			"zhs": "纪"
		},
		"約": {
			"jp": "約",
			"zht": "約",
			"zhs": "约"
		},
		"紅": {
			"jp": "紅",
			"zht": "紅",
			"zhs": "红"
		},
		"紋": {
			"jp": "紋",
			"zht": "紋",
			"zhs": "纹"
		},
		"納": {
			"jp": "納",
			"zht": "納",
			"zhs": "纳"
		},
		"純": {
			"jp": "純",
			"zht": "純",
			"zhs": "纯"
		},
		"紙": {
			"jp": "紙",
			"zht": "紙",
			"zhs": "纸"
		},
		"級": {
			"jp": "級",
			"zht": "級",
			"zhs": "级"
		},
		"紛": {
			"jp": "紛",
			"zht": "紛",
			"zhs": "纷"
		},
		"紡": {
			"jp": "紡",
			"zht": "紡",
			"zhs": "纺"
		},
		"緊": {
			"jp": "緊",
			"zht": "緊",
			"zhs": "紧"
		},
		"細": {
			"jp": "細",
			"zht": "細",
			"zhs": "细"
		},
		"紳": {
			"jp": "紳",
			"zht": "紳",
			"zhs": "绅"
		},
		"紹": {
			"jp": "紹",
			"zht": "紹",
			"zhs": "绍"
		},
		"紺": {
			"jp": "紺",
			"zht": "紺",
			"zhs": "绀"
		},
		"終": {
			"jp": "終",
			"zht": "終",
			"zhs": "终"
		},
		"組": {
			"jp": "組",
			"zht": "組",
			"zhs": "组"
		},
		"經": {
			"jp": "経",
			"zht": "經",
			"zhs": "经"
		},
		"結": {
			"jp": "結",
			"zht": "結",
			"zhs": "结"
		},
		"絕": {
			"jp": "絶",
			"zht": "絕",
			"zhs": "绝"
		},
		"絞": {
			"jp": "絞",
			"zht": "絞",
			"zhs": "绞"
		},
		"絡": {
			"jp": "絡",
			"zht": "絡",
			"zhs": "络"
		},
		"給": {
			"jp": "給",
			"zht": "給",
			"zhs": "给"
		},
		"統": {
			"jp": "統",
			"zht": "統",
			"zhs": "统"
		},
		"繪": {
			"jp": "絵",
			"zht": "繪",
			"zhs": "绘"
		},
		"絹": {
			"jp": "絹",
			"zht": "絹",
			"zhs": "绢"
		},
		"繼": {
			"jp": "継",
			"zht": "繼",
			"zhs": "继"
		},
		"續": {
			"jp": "続",
			"zht": "續",
			"zhs": "续"
		},
		"綠": {
			"jp": "緑",
			"zht": "綠",
			"zhs": "绿"
		},
		"線": {
			"jp": "線",
			"zht": "線",
			"zhs": "线"
		},
		"維": {
			"jp": "維",
			"zht": "維",
			"zhs": "维"
		},
		"綱": {
			"jp": "綱",
			"zht": "綱",
			"zhs": "纲"
		},
		"綿": {
			"jp": "綿",
			"zht": "綿",
			"zhs": "绵"
		},
		"緒": {
			"jp": "緒",
			"zht": "緒",
			"zhs": "绪"
		},
		"締": {
			"jp": "締",
			"zht": "締",
			"zhs": "缔"
		},
		"緣": {
			"jp": "縁",
			"zht": "緣",
			"zhs": "缘"
		},
		"編": {
			"jp": "編",
			"zht": "編",
			"zhs": "编"
		},
		"緩": {
			"jp": "緩",
			"zht": "緩",
			"zhs": "缓"
		},
		"緯": {
			"jp": "緯",
			"zht": "緯",
			"zhs": "纬"
		},
		"繩": {
			"jp": "縄",
			"zht": "繩",
			"zhs": "绳"
		},
		"縛": {
			"jp": "縛",
			"zht": "縛",
			"zhs": "缚"
		},
		"縱": {
			"jp": "縦",
			"zht": "縱",
			"zhs": "纵"
		},
		"縫": {
			"jp": "縫",
			"zht": "縫",
			"zhs": "缝"
		},
		"縮": {
			"jp": "縮",
			"zht": "縮",
			"zhs": "缩"
		},
		"纖": {
			"jp": "繊",
			"zht": "纖",
			"zhs": "纤"
		},
		"績": {
			"jp": "績",
			"zht": "績",
			"zhs": "绩"
		},
		"織": {
			"jp": "織",
			"zht": "織",
			"zhs": "织"
		},
		"繕": {
			"jp": "繕",
			"zht": "繕",
			"zhs": "缮"
		},
		"繭": {
			"jp": "繭",
			"zht": "繭",
			"zhs": "茧"
		},
		"繰": {
			"jp": "繰",
			"zht": "繰",
			"zhs": "缲"
		},
		"罐": {
			"jp": "缶",
			"zht": "罐",
			"zhs": "罐"
		},
		"鉢": {
			"jp": "鉢",
			"zht": "鉢",
			"zhs": "钵"
		},
		"羅": {
			"jp": "羅",
			"zht": "羅",
			"zhs": "罗"
		},
		"罰": {
			"jp": "罸",
			"zht": "罰",
			"zhs": "罚"
		},
		"罷": {
			"jp": "罷",
			"zht": "罷",
			"zhs": "罢"
		},
		"罵": {
			"jp": "罵",
			"zht": "罵",
			"zhs": "骂"
		},
		"職": {
			"jp": "職",
			"zht": "職",
			"zhs": "职"
		},
		"聞": {
			"jp": "聞",
			"zht": "聞",
			"zhs": "闻"
		},
		"聰": {
			"jp": "聡",
			"zht": "聰",
			"zhs": "聪"
		},
		"腸": {
			"jp": "腸",
			"zht": "腸",
			"zhs": "肠"
		},
		"膚": {
			"jp": "膚",
			"zht": "膚",
			"zhs": "肤"
		},
		"脹": {
			"jp": "脹",
			"zht": "脹",
			"zhs": "胀"
		},
		"脅": {
			"jp": "脅",
			"zht": "脅",
			"zhs": "胁"
		},
		"膽": {
			"jp": "胆",
			"zht": "膽",
			"zhs": "胆"
		},
		"臟": {
			"jp": "臓",
			"zht": "臟",
			"zhs": "脏"
		},
		"腦": {
			"jp": "脳",
			"zht": "腦",
			"zhs": "脑"
		},
		"腳": {
			"jp": "脚",
			"zht": "腳",
			"zhs": "脚"
		},
		"騰": {
			"jp": "騰",
			"zht": "騰",
			"zhs": "腾"
		},
		"舖": {
			"jp": "舗",
			"zht": "舖",
			"zhs": "铺"
		},
		"館": {
			"jp": "館",
			"zht": "館",
			"zhs": "馆"
		},
		"艦": {
			"jp": "艦",
			"zht": "艦",
			"zhs": "舰"
		},
		"藝": {
			"jp": "芸",
			"zht": "藝",
			"zhs": "艺"
		},
		"莖": {
			"jp": "茎",
			"zht": "莖",
			"zhs": "茎"
		},
		"薦": {
			"jp": "薦",
			"zht": "薦",
			"zhs": "荐"
		},
		"藥": {
			"jp": "薬",
			"zht": "藥",
			"zhs": "药"
		},
		"螢": {
			"jp": "蛍",
			"zht": "螢",
			"zhs": "萤"
		},
		"蔣": {
			"jp": "蒋",
			"zht": "蔣",
			"zhs": "蒋"
		},
		"藏": {
			"jp": "蔵",
			"zht": "藏",
			"zhs": "藏"
		},
		"虜": {
			"jp": "虜",
			"zht": "虜",
			"zhs": "虏"
		},
		"虛": {
			"jp": "虚",
			"zht": "虛",
			"zhs": "虚"
		},
		"蟲": {
			"jp": "虫",
			"zht": "蟲",
			"zhs": "虫"
		},
		"蝕": {
			"jp": "蝕",
			"zht": "蝕",
			"zhs": "蚀"
		},
		"蠶": {
			"jp": "蚕",
			"zht": "蠶",
			"zhs": "蚕"
		},
		"蠻": {
			"jp": "蛮",
			"zht": "蠻",
			"zhs": "蛮"
		},
		"補": {
			"jp": "補",
			"zht": "補",
			"zhs": "补"
		},
		"襲": {
			"jp": "襲",
			"zht": "襲",
			"zhs": "袭"
		},
		"裝": {
			"jp": "装",
			"zht": "裝",
			"zhs": "装"
		},
		"裡": {
			"jp": "裏",
			"zht": "裡",
			"zhs": "里"
		},
		"霸": {
			"jp": "覇",
			"zht": "霸",
			"zhs": "霸"
		},
		"見": {
			"jp": "見",
			"zht": "見",
			"zhs": "见"
		},
		"觀": {
			"jp": "観",
			"zht": "觀",
			"zhs": "观"
		},
		"規": {
			"jp": "規",
			"zht": "規",
			"zhs": "规"
		},
		"覺": {
			"jp": "覚",
			"zht": "覺",
			"zhs": "觉"
		},
		"覽": {
			"jp": "覧",
			"zht": "覽",
			"zhs": "览"
		},
		"觸": {
			"jp": "触",
			"zht": "觸",
			"zhs": "触"
		},
		"訂": {
			"jp": "訂",
			"zht": "訂",
			"zhs": "订"
		},
		"計": {
			"jp": "計",
			"zht": "計",
			"zhs": "计"
		},
		"討": {
			"jp": "討",
			"zht": "討",
			"zhs": "讨"
		},
		"訓": {
			"jp": "訓",
			"zht": "訓",
			"zhs": "训"
		},
		"記": {
			"jp": "記",
			"zht": "記",
			"zhs": "记"
		},
		"訟": {
			"jp": "訟",
			"zht": "訟",
			"zhs": "讼"
		},
		"訪": {
			"jp": "訪",
			"zht": "訪",
			"zhs": "访"
		},
		"設": {
			"jp": "設",
			"zht": "設",
			"zhs": "设"
		},
		"許": {
			"jp": "許",
			"zht": "許",
			"zhs": "许"
		},
		"譯": {
			"jp": "訳",
			"zht": "譯",
			"zhs": "译"
		},
		"訴": {
			"jp": "訴",
			"zht": "訴",
			"zhs": "诉"
		},
		"診": {
			"jp": "診",
			"zht": "診",
			"zhs": "诊"
		},
		"證": {
			"jp": "証",
			"zht": "證",
			"zhs": "证"
		},
		"詐": {
			"jp": "詐",
			"zht": "詐",
			"zhs": "诈"
		},
		"詔": {
			"jp": "詔",
			"zht": "詔",
			"zhs": "诏"
		},
		"評": {
			"jp": "評",
			"zht": "評",
			"zhs": "评"
		},
		"詛": {
			"jp": "詛",
			"zht": "詛",
			"zhs": "诅"
		},
		"詞": {
			"jp": "詞",
			"zht": "詞",
			"zhs": "词"
		},
		"試": {
			"jp": "試",
			"zht": "試",
			"zhs": "试"
		},
		"詩": {
			"jp": "詩",
			"zht": "詩",
			"zhs": "诗"
		},
		"詰": {
			"jp": "詰",
			"zht": "詰",
			"zhs": "诘"
		},
		"該": {
			"jp": "該",
			"zht": "該",
			"zhs": "该"
		},
		"詳": {
			"jp": "詳",
			"zht": "詳",
			"zhs": "详"
		},
		"譽": {
			"jp": "誉",
			"zht": "譽",
			"zhs": "誉"
		},
		"謄": {
			"jp": "謄",
			"zht": "謄",
			"zhs": "誊"
		},
		"認": {
			"jp": "認",
			"zht": "認",
			"zhs": "认"
		},
		"誕": {
			"jp": "誕",
			"zht": "誕",
			"zhs": "诞"
		},
		"誘": {
			"jp": "誘",
			"zht": "誘",
			"zhs": "诱"
		},
		"語": {
			"jp": "語",
			"zht": "語",
			"zhs": "语"
		},
		"誠": {
			"jp": "誠",
			"zht": "誠",
			"zhs": "诚"
		},
		"誤": {
			"jp": "誤",
			"zht": "誤",
			"zhs": "误"
		},
		"說": {
			"jp": "説",
			"zht": "說",
			"zhs": "说"
		},
		"讀": {
			"jp": "読",
			"zht": "讀",
			"zhs": "读"
		},
		"誰": {
			"jp": "誰",
			"zht": "誰",
			"zhs": "谁"
		},
		"課": {
			"jp": "課",
			"zht": "課",
			"zhs": "课"
		},
		"調": {
			"jp": "調",
			"zht": "調",
			"zhs": "调"
		},
		"談": {
			"jp": "談",
			"zht": "談",
			"zhs": "谈"
		},
		"請": {
			"jp": "請",
			"zht": "請",
			"zhs": "请"
		},
		"論": {
			"jp": "論",
			"zht": "論",
			"zhs": "论"
		},
		"諭": {
			"jp": "諭",
			"zht": "諭",
			"zhs": "谕"
		},
		"諸": {
			"jp": "諸",
			"zht": "諸",
			"zhs": "诸"
		},
		"諾": {
			"jp": "諾",
			"zht": "諾",
			"zhs": "诺"
		},
		"謀": {
			"jp": "謀",
			"zht": "謀",
			"zhs": "谋"
		},
		"謁": {
			"jp": "謁",
			"zht": "謁",
			"zhs": "谒"
		},
		"謎": {
			"jp": "謎",
			"zht": "謎",
			"zhs": "谜"
		},
		"謙": {
			"jp": "謙",
			"zht": "謙",
			"zhs": "谦"
		},
		"講": {
			"jp": "講",
			"zht": "講",
			"zhs": "讲"
		},
		"謝": {
			"jp": "謝",
			"zht": "謝",
			"zhs": "谢"
		},
		"謠": {
			"jp": "謡",
			"zht": "謠",
			"zhs": "谣"
		},
		"謹": {
			"jp": "謹",
			"zht": "謹",
			"zhs": "谨"
		},
		"識": {
			"jp": "識",
			"zht": "識",
			"zhs": "识"
		},
		"譜": {
			"jp": "譜",
			"zht": "譜",
			"zhs": "谱"
		},
		"議": {
			"jp": "議",
			"zht": "議",
			"zhs": "议"
		},
		"讓": {
			"jp": "譲",
			"zht": "讓",
			"zhs": "让"
		},
		"貝": {
			"jp": "貝",
			"zht": "貝",
			"zhs": "贝"
		},
		"貞": {
			"jp": "貞",
			"zht": "貞",
			"zhs": "贞"
		},
		"負": {
			"jp": "負",
			"zht": "負",
			"zhs": "负"
		},
		"財": {
			"jp": "財",
			"zht": "財",
			"zhs": "财"
		},
		"貢": {
			"jp": "貢",
			"zht": "貢",
			"zhs": "贡"
		},
		"貧": {
			"jp": "貧",
			"zht": "貧",
			"zhs": "贫"
		},
		"貨": {
			"jp": "貨",
			"zht": "貨",
			"zhs": "货"
		},
		"販": {
			"jp": "販",
			"zht": "販",
			"zhs": "贩"
		},
		"貪": {
			"jp": "貪",
			"zht": "貪",
			"zhs": "贪"
		},
		"責": {
			"jp": "責",
			"zht": "責",
			"zhs": "责"
		},
		"貯": {
			"jp": "貯",
			"zht": "貯",
			"zhs": "贮"
		},
		"貴": {
			"jp": "貴",
			"zht": "貴",
			"zhs": "贵"
		},
		"貸": {
			"jp": "貸",
			"zht": "貸",
			"zhs": "贷"
		},
		"費": {
			"jp": "費",
			"zht": "費",
			"zhs": "费"
		},
		"貿": {
			"jp": "貿",
			"zht": "貿",
			"zhs": "贸"
		},
		"賀": {
			"jp": "賀",
			"zht": "賀",
			"zhs": "贺"
		},
		"賃": {
			"jp": "賃",
			"zht": "賃",
			"zhs": "赁"
		},
		"賄": {
			"jp": "賄",
			"zht": "賄",
			"zhs": "贿"
		},
		"資": {
			"jp": "資",
			"zht": "資",
			"zhs": "资"
		},
		"賊": {
			"jp": "賊",
			"zht": "賊",
			"zhs": "贼"
		},
		"賤": {
			"jp": "賎",
			"zht": "賤",
			"zhs": "贱"
		},
		"贊": {
			"jp": "賛",
			"zht": "贊",
			"zhs": "赞"
		},
		"賜": {
			"jp": "賜",
			"zht": "賜",
			"zhs": "赐"
		},
		"賞": {
			"jp": "賞",
			"zht": "賞",
			"zhs": "赏"
		},
		"賠": {
			"jp": "賠",
			"zht": "賠",
			"zhs": "赔"
		},
		"賢": {
			"jp": "賢",
			"zht": "賢",
			"zhs": "贤"
		},
		"賦": {
			"jp": "賦",
			"zht": "賦",
			"zhs": "赋"
		},
		"質": {
			"jp": "質",
			"zht": "質",
			"zhs": "质"
		},
		"賴": {
			"jp": "頼",
			"zht": "賴",
			"zhs": "赖"
		},
		"贈": {
			"jp": "贈",
			"zht": "贈",
			"zhs": "赠"
		},
		"贓": {
			"jp": "贓",
			"zht": "贓",
			"zhs": "赃"
		},
		"躍": {
			"jp": "躍",
			"zht": "躍",
			"zhs": "跃"
		},
		"踐": {
			"jp": "践",
			"zht": "踐",
			"zhs": "践"
		},
		"蹤": {
			"jp": "踪",
			"zht": "蹤",
			"zhs": "踪"
		},
		"車": {
			"jp": "車",
			"zht": "車",
			"zhs": "车"
		},
		"軌": {
			"jp": "軌",
			"zht": "軌",
			"zhs": "轨"
		},
		"軒": {
			"jp": "軒",
			"zht": "軒",
			"zhs": "轩"
		},
		"軟": {
			"jp": "軟",
			"zht": "軟",
			"zhs": "软"
		},
		"轉": {
			"jp": "転",
			"zht": "轉",
			"zhs": "转"
		},
		"軸": {
			"jp": "軸",
			"zht": "軸",
			"zhs": "轴"
		},
		"輕": {
			"jp": "軽",
			"zht": "輕",
			"zhs": "轻"
		},
		"較": {
			"jp": "較",
			"zht": "較",
			"zhs": "较"
		},
		"載": {
			"jp": "載",
			"zht": "載",
			"zhs": "载"
		},
		"輝": {
			"jp": "輝",
			"zht": "輝",
			"zhs": "辉"
		},
		"輩": {
			"jp": "輩",
			"zht": "輩",
			"zhs": "辈"
		},
		"輪": {
			"jp": "輪",
			"zht": "輪",
			"zhs": "轮"
		},
		"輸": {
			"jp": "輸",
			"zht": "輸",
			"zhs": "输"
		},
		"轄": {
			"jp": "轄",
			"zht": "轄",
			"zhs": "辖"
		},
		"辭": {
			"jp": "辞",
			"zht": "辭",
			"zhs": "辞"
		},
		"邊": {
			"jp": "辺",
			"zht": "邊",
			"zhs": "边"
		},
		"達": {
			"jp": "達",
			"zht": "達",
			"zhs": "达"
		},
		"遷": {
			"jp": "遷",
			"zht": "遷",
			"zhs": "迁"
		},
		"過": {
			"jp": "過",
			"zht": "過",
			"zhs": "过"
		},
		"運": {
			"jp": "運",
			"zht": "運",
			"zhs": "运"
		},
		"還": {
			"jp": "還",
			"zht": "還",
			"zhs": "还"
		},
		"進": {
			"jp": "進",
			"zht": "進",
			"zhs": "进"
		},
		"遠": {
			"jp": "遠",
			"zht": "遠",
			"zhs": "远"
		},
		"違": {
			"jp": "違",
			"zht": "違",
			"zhs": "违"
		},
		"連": {
			"jp": "連",
			"zht": "連",
			"zhs": "连"
		},
		"遲": {
			"jp": "遅",
			"zht": "遲",
			"zhs": "迟"
		},
		"適": {
			"jp": "適",
			"zht": "適",
			"zhs": "适"
		},
		"選": {
			"jp": "選",
			"zht": "選",
			"zhs": "选"
		},
		"遞": {
			"jp": "逓",
			"zht": "遞",
			"zhs": "递"
		},
		"遺": {
			"jp": "遺",
			"zht": "遺",
			"zhs": "遗"
		},
		"遙": {
			"jp": "遥",
			"zht": "遙",
			"zhs": "遥"
		},
		"郵": {
			"jp": "郵",
			"zht": "郵",
			"zhs": "邮"
		},
		"鄰": {
			"jp": "隣",
			"zht": "鄰",
			"zhs": "邻"
		},
		"醉": {
			"jp": "酔",
			"zht": "醉",
			"zhs": "醉"
		},
		"釀": {
			"jp": "醸",
			"zht": "釀",
			"zhs": "酿"
		},
		"釋": {
			"jp": "釈",
			"zht": "釋",
			"zhs": "释"
		},
		"針": {
			"jp": "針",
			"zht": "針",
			"zhs": "针"
		},
		"釣": {
			"jp": "釣",
			"zht": "釣",
			"zhs": "钓"
		},
		"鈍": {
			"jp": "鈍",
			"zht": "鈍",
			"zhs": "钝"
		},
		"鈴": {
			"jp": "鈴",
			"zht": "鈴",
			"zhs": "铃"
		},
		"鐵": {
			"jp": "鉄",
			"zht": "鐵",
			"zhs": "铁"
		},
		"鉛": {
			"jp": "鉛",
			"zht": "鉛",
			"zhs": "铅"
		},
		"鑑": {
			"jp": "鑑",
			"zht": "鑑",
			"zhs": "鉴"
		},
		"銀": {
			"jp": "銀",
			"zht": "銀",
			"zhs": "银"
		},
		"銃": {
			"jp": "銃",
			"zht": "銃",
			"zhs": "铳"
		},
		"銅": {
			"jp": "銅",
			"zht": "銅",
			"zhs": "铜"
		},
		"銑": {
			"jp": "銑",
			"zht": "銑",
			"zhs": "铣"
		},
		"銘": {
			"jp": "銘",
			"zht": "銘",
			"zhs": "铭"
		},
		"錢": {
			"jp": "銭",
			"zht": "錢",
			"zhs": "钱"
		},
		"鋭": {
			"jp": "鋭",
			"zht": "鋭",
			"zhs": "锐"
		},
		"鑄": {
			"jp": "鋳",
			"zht": "鑄",
			"zhs": "铸"
		},
		"鋼": {
			"jp": "鋼",
			"zht": "鋼",
			"zhs": "钢"
		},
		"錘": {
			"jp": "錘",
			"zht": "錘",
			"zhs": "锤"
		},
		"錠": {
			"jp": "錠",
			"zht": "錠",
			"zhs": "锭"
		},
		"錯": {
			"jp": "錯",
			"zht": "錯",
			"zhs": "错"
		},
		"鍾": {
			"jp": "鍾",
			"zht": "鍾",
			"zhs": "钟"
		},
		"鎖": {
			"jp": "鎖",
			"zht": "鎖",
			"zhs": "锁"
		},
		"鎮": {
			"jp": "鎮",
			"zht": "鎮",
			"zhs": "镇"
		},
		"鏡": {
			"jp": "鏡",
			"zht": "鏡",
			"zhs": "镜"
		},
		"長": {
			"jp": "長",
			"zht": "長",
			"zhs": "长"
		},
		"門": {
			"jp": "門",
			"zht": "門",
			"zhs": "门"
		},
		"閉": {
			"jp": "閉",
			"zht": "閉",
			"zhs": "闭"
		},
		"閒": {
			"jp": "閑",
			"zht": "閒",
			"zhs": "闲"
		},
		"間": {
			"jp": "間",
			"zht": "間",
			"zhs": "间"
		},
		"閣": {
			"jp": "閣",
			"zht": "閣",
			"zhs": "阁"
		},
		"閥": {
			"jp": "閥",
			"zht": "閥",
			"zhs": "阀"
		},
		"閲": {
			"jp": "閲",
			"zht": "閲",
			"zhs": "阅"
		},
		"隊": {
			"jp": "隊",
			"zht": "隊",
			"zhs": "队"
		},
		"陽": {
			"jp": "陽",
			"zht": "陽",
			"zhs": "阳"
		},
		"陰": {
			"jp": "陰",
			"zht": "陰",
			"zhs": "阴"
		},
		"陣": {
			"jp": "陣",
			"zht": "陣",
			"zhs": "阵"
		},
		"階": {
			"jp": "階",
			"zht": "階",
			"zhs": "阶"
		},
		"際": {
			"jp": "際",
			"zht": "際",
			"zhs": "际"
		},
		"陸": {
			"jp": "陸",
			"zht": "陸",
			"zhs": "陆"
		},
		"陳": {
			"jp": "陳",
			"zht": "陳",
			"zhs": "陈"
		},
		"陷": {
			"jp": "陥",
			"zht": "陷",
			"zhs": "陷"
		},
		"隨": {
			"jp": "随",
			"zht": "隨",
			"zhs": "随"
		},
		"隱": {
			"jp": "隠",
			"zht": "隱",
			"zhs": "隐"
		},
		"隸": {
			"jp": "隷",
			"zht": "隸",
			"zhs": "隶"
		},
		"難": {
			"jp": "難",
			"zht": "難",
			"zhs": "难"
		},
		"霧": {
			"jp": "霧",
			"zht": "霧",
			"zhs": "雾"
		},
		"靜": {
			"jp": "静",
			"zht": "靜",
			"zhs": "静"
		},
		"頂": {
			"jp": "頂",
			"zht": "頂",
			"zhs": "顶"
		},
		"項": {
			"jp": "項",
			"zht": "項",
			"zhs": "项"
		},
		"順": {
			"jp": "順",
			"zht": "順",
			"zhs": "顺"
		},
		"頑": {
			"jp": "頑",
			"zht": "頑",
			"zhs": "顽"
		},
		"頒": {
			"jp": "頒",
			"zht": "頒",
			"zhs": "颁"
		},
		"領": {
			"jp": "領",
			"zht": "領",
			"zhs": "领"
		},
		"頻": {
			"jp": "頻",
			"zht": "頻",
			"zhs": "频"
		},
		"題": {
			"jp": "題",
			"zht": "題",
			"zhs": "题"
		},
		"額": {
			"jp": "額",
			"zht": "額",
			"zhs": "额"
		},
		"顏": {
			"jp": "顔",
			"zht": "顏",
			"zhs": "颜"
		},
		"風": {
			"jp": "風",
			"zht": "風",
			"zhs": "风"
		},
		"飛": {
			"jp": "飛",
			"zht": "飛",
			"zhs": "飞"
		},
		"饑": {
			"jp": "飢",
			"zht": "饑",
			"zhs": "饥"
		},
		"飯": {
			"jp": "飯",
			"zht": "飯",
			"zhs": "饭"
		},
		"飲": {
			"jp": "飲",
			"zht": "飲",
			"zhs": "饮"
		},
		"飼": {
			"jp": "飼",
			"zht": "飼",
			"zhs": "饲"
		},
		"飽": {
			"jp": "飽",
			"zht": "飽",
			"zhs": "饱"
		},
		"飾": {
			"jp": "飾",
			"zht": "飾",
			"zhs": "饰"
		},
		"餓": {
			"jp": "餓",
			"zht": "餓",
			"zhs": "饿"
		},
		"馬": {
			"jp": "馬",
			"zht": "馬",
			"zhs": "马"
		},
		"驛": {
			"jp": "駅",
			"zht": "驛",
			"zhs": "驿"
		},
		"驅": {
			"jp": "駆",
			"zht": "驅",
			"zhs": "驱"
		},
		"駐": {
			"jp": "駐",
			"zht": "駐",
			"zhs": "驻"
		},
		"騎": {
			"jp": "騎",
			"zht": "騎",
			"zhs": "骑"
		},
		"驗": {
			"jp": "験",
			"zht": "驗",
			"zhs": "验"
		},
		"騷": {
			"jp": "騒",
			"zht": "騷",
			"zhs": "骚"
		},
		"驔": {
			"jp": "騨",
			"zht": "驔",
			"zhs": "驔"
		},
		"髓": {
			"jp": "髄",
			"zht": "髓",
			"zhs": "髓"
		},
		"魚": {
			"jp": "魚",
			"zht": "魚",
			"zhs": "鱼"
		},
		"魯": {
			"jp": "魯",
			"zht": "魯",
			"zhs": "鲁"
		},
		"鮮": {
			"jp": "鮮",
			"zht": "鮮",
			"zhs": "鲜"
		},
		"鯨": {
			"jp": "鯨",
			"zht": "鯨",
			"zhs": "鲸"
		},
		"鳥": {
			"jp": "鳥",
			"zht": "鳥",
			"zhs": "鸟"
		},
		"鳴": {
			"jp": "鳴",
			"zht": "鳴",
			"zhs": "鸣"
		},
		"麥": {
			"jp": "麦",
			"zht": "麥",
			"zhs": "麦"
		},
		"黃": {
			"jp": "黄",
			"zht": "黃",
			"zhs": "黄"
		},
		"黑": {
			"jp": "黒",
			"zht": "黑",
			"zhs": "黑"
		},
		"默": {
			"jp": "黙",
			"zht": "默",
			"zhs": "默"
		},
		"齡": {
			"jp": "齢",
			"zht": "齡",
			"zhs": "龄"
		}
	},
	"zhs": {
		"会": {
			"jp": "会",
			"zht": "會",
			"zhs": "会"
		},
		"笺": {
			"jp": "箋",
			"zht": "箋",
			"zhs": "笺"
		},
		"网": {
			"jp": "網",
			"zht": "網",
			"zhs": "网"
		},
		"处": {
			"jp": "処",
			"zht": "處",
			"zhs": "处"
		},
		"话": {
			"jp": "話",
			"zht": "話",
			"zhs": "话"
		},
		"万": {
			"jp": "万",
			"zht": "萬",
			"zhs": "万"
		},
		"与": {
			"jp": "与",
			"zht": "與",
			"zhs": "与"
		},
		"丑": {
			"jp": "醜",
			"zht": "醜",
			"zhs": "丑"
		},
		"专": {
			"jp": "専",
			"zht": "專",
			"zhs": "专"
		},
		"业": {
			"jp": "業",
			"zht": "業",
			"zhs": "业"
		},
		"东": {
			"jp": "東",
			"zht": "東",
			"zhs": "东"
		},
		"两": {
			"jp": "両",
			"zht": "兩",
			"zhs": "两"
		},
		"严": {
			"jp": "厳",
			"zht": "嚴",
			"zhs": "严"
		},
		"并": {
			"jp": "並",
			"zht": "並",
			"zhs": "并"
		},
		"丧": {
			"jp": "喪",
			"zht": "喪",
			"zhs": "丧"
		},
		"丰": {
			"jp": "豊",
			"zht": "豐",
			"zhs": "丰"
		},
		"临": {
			"jp": "臨",
			"zht": "臨",
			"zhs": "临"
		},
		"为": {
			"jp": "為",
			"zht": "為",
			"zhs": "为"
		},
		"丽": {
			"jp": "麗",
			"zht": "麗",
			"zhs": "丽"
		},
		"举": {
			"jp": "挙",
			"zht": "舉",
			"zhs": "举"
		},
		"迺": {
			"jp": "廼",
			"zht": "迺",
			"zhs": "迺"
		},
		"义": {
			"jp": "義",
			"zht": "義",
			"zhs": "义"
		},
		"乐": {
			"jp": "楽",
			"zht": "樂",
			"zhs": "乐"
		},
		"乘": {
			"jp": "乗",
			"zht": "乘",
			"zhs": "乘"
		},
		"习": {
			"jp": "習",
			"zht": "習",
			"zhs": "习"
		},
		"乡": {
			"jp": "郷",
			"zht": "鄉",
			"zhs": "乡"
		},
		"书": {
			"jp": "書",
			"zht": "書",
			"zhs": "书"
		},
		"买": {
			"jp": "買",
			"zht": "買",
			"zhs": "买"
		},
		"乱": {
			"jp": "乱",
			"zht": "亂",
			"zhs": "乱"
		},
		"龟": {
			"jp": "亀",
			"zht": "龜",
			"zhs": "龟"
		},
		"贰": {
			"jp": "弐",
			"zht": "貳",
			"zhs": "贰"
		},
		"云": {
			"jp": "雲",
			"zht": "雲",
			"zhs": "云"
		},
		"亚": {
			"jp": "亜",
			"zht": "亞",
			"zhs": "亚"
		},
		"产": {
			"jp": "産",
			"zht": "產",
			"zhs": "产"
		},
		"亩": {
			"jp": "畝",
			"zht": "畝",
			"zhs": "亩"
		},
		"亲": {
			"jp": "親",
			"zht": "親",
			"zhs": "亲"
		},
		"亿": {
			"jp": "億",
			"zht": "億",
			"zhs": "亿"
		},
		"仆": {
			"jp": "僕",
			"zht": "僕",
			"zhs": "仆"
		},
		"从": {
			"jp": "従",
			"zht": "從",
			"zhs": "从"
		},
		"佛": {
			"jp": "仏",
			"zht": "佛",
			"zhs": "佛"
		},
		"仓": {
			"jp": "倉",
			"zht": "倉",
			"zhs": "仓"
		},
		"仪": {
			"jp": "儀",
			"zht": "儀",
			"zhs": "仪"
		},
		"假": {
			"jp": "仮",
			"zht": "假",
			"zhs": "假"
		},
		"价": {
			"jp": "価",
			"zht": "價",
			"zhs": "价"
		},
		"众": {
			"jp": "衆",
			"zht": "眾",
			"zhs": "众"
		},
		"优": {
			"jp": "優",
			"zht": "優",
			"zhs": "优"
		},
		"传": {
			"jp": "伝",
			"zht": "傳",
			"zhs": "传"
		},
		"伞": {
			"jp": "傘",
			"zht": "傘",
			"zhs": "伞"
		},
		"伟": {
			"jp": "偉",
			"zht": "偉",
			"zhs": "伟"
		},
		"伤": {
			"jp": "傷",
			"zht": "傷",
			"zhs": "伤"
		},
		"伦": {
			"jp": "倫",
			"zht": "倫",
			"zhs": "伦"
		},
		"伪": {
			"jp": "偽",
			"zht": "偽",
			"zhs": "伪"
		},
		"体": {
			"jp": "体",
			"zht": "體",
			"zhs": "体"
		},
		"余": {
			"jp": "余",
			"zht": "餘",
			"zhs": "余"
		},
		"来": {
			"jp": "来",
			"zht": "來",
			"zhs": "来"
		},
		"侦": {
			"jp": "偵",
			"zht": "偵",
			"zhs": "侦"
		},
		"侧": {
			"jp": "側",
			"zht": "側",
			"zhs": "侧"
		},
		"俭": {
			"jp": "倹",
			"zht": "儉",
			"zhs": "俭"
		},
		"俱": {
			"jp": "倶",
			"zht": "俱",
			"zhs": "俱"
		},
		"债": {
			"jp": "債",
			"zht": "債",
			"zhs": "债"
		},
		"倾": {
			"jp": "傾",
			"zht": "傾",
			"zhs": "倾"
		},
		"偿": {
			"jp": "償",
			"zht": "償",
			"zhs": "偿"
		},
		"杰": {
			"jp": "傑",
			"zht": "傑",
			"zhs": "杰"
		},
		"备": {
			"jp": "備",
			"zht": "備",
			"zhs": "备"
		},
		"当": {
			"jp": "当",
			"zht": "當",
			"zhs": "当"
		},
		"尽": {
			"jp": "尽",
			"zht": "盡",
			"zhs": "尽"
		},
		"儿": {
			"jp": "児",
			"zht": "兒",
			"zhs": "儿"
		},
		"党": {
			"jp": "党",
			"zht": "黨",
			"zhs": "党"
		},
		"内": {
			"jp": "内",
			"zht": "內",
			"zhs": "内"
		},
		"关": {
			"jp": "関",
			"zht": "關",
			"zhs": "关"
		},
		"兴": {
			"jp": "興",
			"zht": "興",
			"zhs": "兴"
		},
		"养": {
			"jp": "養",
			"zht": "養",
			"zhs": "养"
		},
		"兽": {
			"jp": "獣",
			"zht": "獸",
			"zhs": "兽"
		},
		"圆": {
			"jp": "円",
			"zht": "圓",
			"zhs": "圆"
		},
		"写": {
			"jp": "写",
			"zht": "寫",
			"zhs": "写"
		},
		"军": {
			"jp": "軍",
			"zht": "軍",
			"zhs": "军"
		},
		"农": {
			"jp": "農",
			"zht": "農",
			"zhs": "农"
		},
		"富": {
			"jp": "冨",
			"zht": "富",
			"zhs": "富"
		},
		"冰": {
			"jp": "氷",
			"zht": "冰",
			"zhs": "冰"
		},
		"冲": {
			"jp": "衝",
			"zht": "衝",
			"zhs": "冲"
		},
		"决": {
			"jp": "決",
			"zht": "決",
			"zhs": "决"
		},
		"冻": {
			"jp": "凍",
			"zht": "凍",
			"zhs": "冻"
		},
		"涂": {
			"jp": "塗",
			"zht": "塗",
			"zhs": "涂"
		},
		"几": {
			"jp": "幾",
			"zht": "幾",
			"zhs": "几"
		},
		"击": {
			"jp": "撃",
			"zht": "擊",
			"zhs": "击"
		},
		"划": {
			"jp": "画",
			"zht": "劃",
			"zhs": "划"
		},
		"画": {
			"jp": "画",
			"zht": "畫",
			"zhs": "画"
		},
		"则": {
			"jp": "則",
			"zht": "則",
			"zhs": "则"
		},
		"刚": {
			"jp": "剛",
			"zht": "剛",
			"zhs": "刚"
		},
		"创": {
			"jp": "創",
			"zht": "創",
			"zhs": "创"
		},
		"别": {
			"jp": "別",
			"zht": "別",
			"zhs": "别"
		},
		"制": {
			"jp": "製",
			"zht": "製",
			"zhs": "制"
		},
		"卷": {
			"jp": "巻",
			"zht": "卷",
			"zhs": "卷"
		},
		"刹": {
			"jp": "刹",
			"zht": "剎",
			"zhs": "刹"
		},
		"剂": {
			"jp": "剤",
			"zht": "劑",
			"zhs": "剂"
		},
		"剑": {
			"jp": "剣",
			"zht": "劍",
			"zhs": "剑"
		},
		"剧": {
			"jp": "劇",
			"zht": "劇",
			"zhs": "剧"
		},
		"剩": {
			"jp": "剰",
			"zht": "剩",
			"zhs": "剩"
		},
		"劝": {
			"jp": "勧",
			"zht": "勸",
			"zhs": "劝"
		},
		"务": {
			"jp": "務",
			"zht": "務",
			"zhs": "务"
		},
		"动": {
			"jp": "動",
			"zht": "動",
			"zhs": "动"
		},
		"励": {
			"jp": "励",
			"zht": "勵",
			"zhs": "励"
		},
		"劳": {
			"jp": "労",
			"zht": "勞",
			"zhs": "劳"
		},
		"势": {
			"jp": "勢",
			"zht": "勢",
			"zhs": "势"
		},
		"勋": {
			"jp": "勲",
			"zht": "勳",
			"zhs": "勋"
		},
		"胜": {
			"jp": "勝",
			"zht": "勝",
			"zhs": "胜"
		},
		"区": {
			"jp": "区",
			"zht": "區",
			"zhs": "区"
		},
		"医": {
			"jp": "医",
			"zht": "醫",
			"zhs": "医"
		},
		"华": {
			"jp": "華",
			"zht": "華",
			"zhs": "华"
		},
		"协": {
			"jp": "協",
			"zht": "協",
			"zhs": "协"
		},
		"单": {
			"jp": "単",
			"zht": "單",
			"zhs": "单"
		},
		"卖": {
			"jp": "売",
			"zht": "賣",
			"zhs": "卖"
		},
		"卫": {
			"jp": "衛",
			"zht": "衛",
			"zhs": "卫"
		},
		"厅": {
			"jp": "庁",
			"zht": "廳",
			"zhs": "厅"
		},
		"压": {
			"jp": "圧",
			"zht": "壓",
			"zhs": "压"
		},
		"县": {
			"jp": "県",
			"zht": "縣",
			"zhs": "县"
		},
		"参": {
			"jp": "参",
			"zht": "參",
			"zhs": "参"
		},
		"双": {
			"jp": "双",
			"zht": "雙",
			"zhs": "双"
		},
		"收": {
			"jp": "収",
			"zht": "收",
			"zhs": "收"
		},
		"发": {
			"jp": "発",
			"zht": "發",
			"zhs": "发"
		},
		"变": {
			"jp": "変",
			"zht": "變",
			"zhs": "变"
		},
		"叠": {
			"jp": "畳",
			"zht": "疊",
			"zhs": "叠"
		},
		"号": {
			"jp": "号",
			"zht": "號",
			"zhs": "号"
		},
		"叹": {
			"jp": "嘆",
			"zht": "嘆",
			"zhs": "叹"
		},
		"吓": {
			"jp": "嚇",
			"zht": "嚇",
			"zhs": "吓"
		},
		"听": {
			"jp": "聴",
			"zht": "聽",
			"zhs": "听"
		},
		"启": {
			"jp": "啓",
			"zht": "啟",
			"zhs": "启"
		},
		"员": {
			"jp": "員",
			"zht": "員",
			"zhs": "员"
		},
		"谘": {
			"jp": "諮",
			"zht": "諮",
			"zhs": "谘"
		},
		"咸": {
			"jp": "鹹",
			"zht": "鹹",
			"zhs": "咸"
		},
		"响": {
			"jp": "響",
			"zht": "響",
			"zhs": "响"
		},
		"问": {
			"jp": "問",
			"zht": "問",
			"zhs": "问"
		},
		"营": {
			"jp": "営",
			"zht": "營",
			"zhs": "营"
		},
		"喷": {
			"jp": "噴",
			"zht": "噴",
			"zhs": "喷"
		},
		"嘱": {
			"jp": "嘱",
			"zht": "囑",
			"zhs": "嘱"
		},
		"苏": {
			"jp": "蘇",
			"zht": "蘇",
			"zhs": "苏"
		},
		"团": {
			"jp": "団",
			"zht": "團",
			"zhs": "团"
		},
		"园": {
			"jp": "園",
			"zht": "園",
			"zhs": "园"
		},
		"国": {
			"jp": "国",
			"zht": "國",
			"zhs": "国"
		},
		"围": {
			"jp": "囲",
			"zht": "圍",
			"zhs": "围"
		},
		"图": {
			"jp": "図",
			"zht": "圖",
			"zhs": "图"
		},
		"圈": {
			"jp": "圏",
			"zht": "圈",
			"zhs": "圈"
		},
		"圣": {
			"jp": "聖",
			"zht": "聖",
			"zhs": "圣"
		},
		"场": {
			"jp": "場",
			"zht": "場",
			"zhs": "场"
		},
		"坏": {
			"jp": "壊",
			"zht": "壞",
			"zhs": "坏"
		},
		"块": {
			"jp": "塊",
			"zht": "塊",
			"zhs": "块"
		},
		"坚": {
			"jp": "堅",
			"zht": "堅",
			"zhs": "坚"
		},
		"坛": {
			"jp": "壇",
			"zht": "壇",
			"zhs": "坛"
		},
		"坟": {
			"jp": "墳",
			"zht": "墳",
			"zhs": "坟"
		},
		"坠": {
			"jp": "墜",
			"zht": "墜",
			"zhs": "坠"
		},
		"垒": {
			"jp": "塁",
			"zht": "壘",
			"zhs": "垒"
		},
		"垦": {
			"jp": "墾",
			"zht": "墾",
			"zhs": "垦"
		},
		"执": {
			"jp": "執",
			"zht": "執",
			"zhs": "执"
		},
		"堕": {
			"jp": "堕",
			"zht": "墮",
			"zhs": "堕"
		},
		"报": {
			"jp": "報",
			"zht": "報",
			"zhs": "报"
		},
		"盐": {
			"jp": "塩",
			"zht": "鹽",
			"zhs": "盐"
		},
		"增": {
			"jp": "増",
			"zht": "增",
			"zhs": "增"
		},
		"壤": {
			"jp": "壌",
			"zht": "壤",
			"zhs": "壤"
		},
		"壮": {
			"jp": "壮",
			"zht": "壯",
			"zhs": "壮"
		},
		"声": {
			"jp": "声",
			"zht": "聲",
			"zhs": "声"
		},
		"壹": {
			"jp": "壱",
			"zht": "壹",
			"zhs": "壹"
		},
		"寿": {
			"jp": "寿",
			"zht": "壽",
			"zhs": "寿"
		},
		"梦": {
			"jp": "夢",
			"zht": "夢",
			"zhs": "梦"
		},
		"头": {
			"jp": "頭",
			"zht": "頭",
			"zhs": "头"
		},
		"夸": {
			"jp": "誇",
			"zht": "誇",
			"zhs": "夸"
		},
		"夺": {
			"jp": "奪",
			"zht": "奪",
			"zhs": "夺"
		},
		"奋": {
			"jp": "奮",
			"zht": "奮",
			"zhs": "奋"
		},
		"奖": {
			"jp": "奨",
			"zht": "獎",
			"zhs": "奖"
		},
		"妆": {
			"jp": "粧",
			"zht": "妝",
			"zhs": "妆"
		},
		"妇": {
			"jp": "婦",
			"zht": "婦",
			"zhs": "妇"
		},
		"姐": {
			"jp": "姉",
			"zht": "姐",
			"zhs": "姐"
		},
		"姬": {
			"jp": "姫",
			"zht": "姬",
			"zhs": "姬"
		},
		"娘": {
			"jp": "嬢",
			"zht": "孃",
			"zhs": "娘"
		},
		"娱": {
			"jp": "娯",
			"zht": "娛",
			"zhs": "娱"
		},
		"孙": {
			"jp": "孫",
			"zht": "孫",
			"zhs": "孙"
		},
		"学": {
			"jp": "学",
			"zht": "學",
			"zhs": "学"
		},
		"宁": {
			"jp": "寧",
			"zht": "寧",
			"zhs": "宁"
		},
		"宝": {
			"jp": "宝",
			"zht": "寶",
			"zhs": "宝"
		},
		"实": {
			"jp": "実",
			"zht": "實",
			"zhs": "实"
		},
		"审": {
			"jp": "審",
			"zht": "審",
			"zhs": "审"
		},
		"宪": {
			"jp": "憲",
			"zht": "憲",
			"zhs": "宪"
		},
		"宫": {
			"jp": "宮",
			"zht": "宮",
			"zhs": "宫"
		},
		"宾": {
			"jp": "賓",
			"zht": "賓",
			"zhs": "宾"
		},
		"秘": {
			"jp": "秘",
			"zht": "祕",
			"zhs": "秘"
		},
		"寝": {
			"jp": "寝",
			"zht": "寢",
			"zhs": "寝"
		},
		"对": {
			"jp": "対",
			"zht": "對",
			"zhs": "对"
		},
		"寻": {
			"jp": "尋",
			"zht": "尋",
			"zhs": "寻"
		},
		"导": {
			"jp": "導",
			"zht": "導",
			"zhs": "导"
		},
		"将": {
			"jp": "将",
			"zht": "將",
			"zhs": "将"
		},
		"层": {
			"jp": "層",
			"zht": "層",
			"zhs": "层"
		},
		"属": {
			"jp": "属",
			"zht": "屬",
			"zhs": "属"
		},
		"岁": {
			"jp": "歳",
			"zht": "歲",
			"zhs": "岁"
		},
		"岛": {
			"jp": "島",
			"zht": "島",
			"zhs": "岛"
		},
		"巖": {
			"jp": "巌",
			"zht": "巖",
			"zhs": "巖"
		},
		"峡": {
			"jp": "峡",
			"zht": "峽",
			"zhs": "峡"
		},
		"险": {
			"jp": "険",
			"zht": "險",
			"zhs": "险"
		},
		"币": {
			"jp": "幣",
			"zht": "幣",
			"zhs": "币"
		},
		"帅": {
			"jp": "帥",
			"zht": "帥",
			"zhs": "帅"
		},
		"师": {
			"jp": "師",
			"zht": "師",
			"zhs": "师"
		},
		"帐": {
			"jp": "帳",
			"zht": "帳",
			"zhs": "帐"
		},
		"归": {
			"jp": "帰",
			"zht": "歸",
			"zhs": "归"
		},
		"广": {
			"jp": "広",
			"zht": "廣",
			"zhs": "广"
		},
		"庆": {
			"jp": "慶",
			"zht": "慶",
			"zhs": "庆"
		},
		"库": {
			"jp": "庫",
			"zht": "庫",
			"zhs": "库"
		},
		"应": {
			"jp": "応",
			"zht": "應",
			"zhs": "应"
		},
		"废": {
			"jp": "廃",
			"zht": "廢",
			"zhs": "废"
		},
		"开": {
			"jp": "開",
			"zht": "開",
			"zhs": "开"
		},
		"辨": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辨"
		},
		"瓣": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "瓣"
		},
		"辩": {
			"jp": "弁",
			"zht": "辨",
			"zhs": "辩"
		},
		"异": {
			"jp": "異",
			"zht": "異",
			"zhs": "异"
		},
		"弃": {
			"jp": "棄",
			"zht": "棄",
			"zhs": "弃"
		},
		"张": {
			"jp": "張",
			"zht": "張",
			"zhs": "张"
		},
		"弥": {
			"jp": "弥",
			"zht": "彌",
			"zhs": "弥"
		},
		"强": {
			"jp": "強",
			"zht": "強",
			"zhs": "强"
		},
		"弹": {
			"jp": "弾",
			"zht": "彈",
			"zhs": "弹"
		},
		"录": {
			"jp": "録",
			"zht": "錄",
			"zhs": "录"
		},
		"彥": {
			"jp": "彦",
			"zht": "彥",
			"zhs": "彥"
		},
		"彻": {
			"jp": "徹",
			"zht": "徹",
			"zhs": "彻"
		},
		"征": {
			"jp": "徴",
			"zht": "徵",
			"zhs": "征"
		},
		"径": {
			"jp": "径",
			"zht": "徑",
			"zhs": "径"
		},
		"德": {
			"jp": "徳",
			"zht": "德",
			"zhs": "德"
		},
		"忆": {
			"jp": "憶",
			"zht": "憶",
			"zhs": "忆"
		},
		"志": {
			"jp": "誌",
			"zht": "誌",
			"zhs": "志"
		},
		"忧": {
			"jp": "憂",
			"zht": "憂",
			"zhs": "忧"
		},
		"怀": {
			"jp": "懐",
			"zht": "懷",
			"zhs": "怀"
		},
		"态": {
			"jp": "態",
			"zht": "態",
			"zhs": "态"
		},
		"总": {
			"jp": "総",
			"zht": "總",
			"zhs": "总"
		},
		"恒": {
			"jp": "恒",
			"zht": "恆",
			"zhs": "恒"
		},
		"恋": {
			"jp": "恋",
			"zht": "戀",
			"zhs": "恋"
		},
		"恳": {
			"jp": "懇",
			"zht": "懇",
			"zhs": "恳"
		},
		"惠": {
			"jp": "恵",
			"zht": "惠",
			"zhs": "惠"
		},
		"恶": {
			"jp": "悪",
			"zht": "惡",
			"zhs": "恶"
		},
		"恼": {
			"jp": "悩",
			"zht": "惱",
			"zhs": "恼"
		},
		"悅": {
			"jp": "悦",
			"zht": "悅",
			"zhs": "悅"
		},
		"悬": {
			"jp": "懸",
			"zht": "懸",
			"zhs": "悬"
		},
		"惊": {
			"jp": "驚",
			"zht": "驚",
			"zhs": "惊"
		},
		"惨": {
			"jp": "惨",
			"zht": "慘",
			"zhs": "惨"
		},
		"惩": {
			"jp": "懲",
			"zht": "懲",
			"zhs": "惩"
		},
		"爱": {
			"jp": "愛",
			"zht": "愛",
			"zhs": "爱"
		},
		"愤": {
			"jp": "憤",
			"zht": "憤",
			"zhs": "愤"
		},
		"愿": {
			"jp": "願",
			"zht": "願",
			"zhs": "愿"
		},
		"虑": {
			"jp": "慮",
			"zht": "慮",
			"zhs": "虑"
		},
		"戏": {
			"jp": "戯",
			"zht": "戲",
			"zhs": "戏"
		},
		"战": {
			"jp": "戦",
			"zht": "戰",
			"zhs": "战"
		},
		"户": {
			"jp": "戸",
			"zht": "戶",
			"zhs": "户"
		},
		"拂": {
			"jp": "払",
			"zht": "拂",
			"zhs": "拂"
		},
		"扩": {
			"jp": "拡",
			"zht": "擴",
			"zhs": "扩"
		},
		"扫": {
			"jp": "掃",
			"zht": "掃",
			"zhs": "扫"
		},
		"扬": {
			"jp": "揚",
			"zht": "揚",
			"zhs": "扬"
		},
		"择": {
			"jp": "択",
			"zht": "擇",
			"zhs": "择"
		},
		"护": {
			"jp": "護",
			"zht": "護",
			"zhs": "护"
		},
		"担": {
			"jp": "担",
			"zht": "擔",
			"zhs": "担"
		},
		"拜": {
			"jp": "拝",
			"zht": "拜",
			"zhs": "拜"
		},
		"拟": {
			"jp": "擬",
			"zht": "擬",
			"zhs": "拟"
		},
		"据": {
			"jp": "拠",
			"zht": "據",
			"zhs": "据"
		},
		"拥": {
			"jp": "擁",
			"zht": "擁",
			"zhs": "拥"
		},
		"挟": {
			"jp": "挟",
			"zht": "挾",
			"zhs": "挟"
		},
		"挥": {
			"jp": "揮",
			"zht": "揮",
			"zhs": "挥"
		},
		"插": {
			"jp": "挿",
			"zht": "插",
			"zhs": "插"
		},
		"损": {
			"jp": "損",
			"zht": "損",
			"zhs": "损"
		},
		"舍": {
			"jp": "捨",
			"zht": "捨",
			"zhs": "舍"
		},
		"揭": {
			"jp": "掲",
			"zht": "揭",
			"zhs": "揭"
		},
		"掴": {
			"jp": "掴",
			"zht": "摑",
			"zhs": "掴"
		},
		"摇": {
			"jp": "揺",
			"zht": "搖",
			"zhs": "摇"
		},
		"敌": {
			"jp": "敵",
			"zht": "敵",
			"zhs": "敌"
		},
		"败": {
			"jp": "敗",
			"zht": "敗",
			"zhs": "败"
		},
		"数": {
			"jp": "数",
			"zht": "數",
			"zhs": "数"
		},
		"齐": {
			"jp": "斉",
			"zht": "齊",
			"zhs": "齐"
		},
		"斋": {
			"jp": "斎",
			"zht": "齋",
			"zhs": "斋"
		},
		"断": {
			"jp": "断",
			"zht": "斷",
			"zhs": "断"
		},
		"旧": {
			"jp": "旧",
			"zht": "舊",
			"zhs": "旧"
		},
		"时": {
			"jp": "時",
			"zht": "時",
			"zhs": "时"
		},
		"昙": {
			"jp": "曇",
			"zht": "曇",
			"zhs": "昙"
		},
		"昼": {
			"jp": "昼",
			"zht": "晝",
			"zhs": "昼"
		},
		"显": {
			"jp": "顕",
			"zht": "顯",
			"zhs": "显"
		},
		"晓": {
			"jp": "暁",
			"zht": "曉",
			"zhs": "晓"
		},
		"晚": {
			"jp": "晩",
			"zht": "晚",
			"zhs": "晚"
		},
		"暂": {
			"jp": "暫",
			"zht": "暫",
			"zhs": "暂"
		},
		"曾": {
			"jp": "曽",
			"zht": "曾",
			"zhs": "曾"
		},
		"术": {
			"jp": "術",
			"zht": "術",
			"zhs": "术"
		},
		"朴": {
			"jp": "樸",
			"zht": "樸",
			"zhs": "朴"
		},
		"机": {
			"jp": "機",
			"zht": "機",
			"zhs": "机"
		},
		"杀": {
			"jp": "殺",
			"zht": "殺",
			"zhs": "杀"
		},
		"杂": {
			"jp": "雑",
			"zht": "雜",
			"zhs": "杂"
		},
		"权": {
			"jp": "権",
			"zht": "權",
			"zhs": "权"
		},
		"条": {
			"jp": "条",
			"zht": "條",
			"zhs": "条"
		},
		"极": {
			"jp": "極",
			"zht": "極",
			"zhs": "极"
		},
		"枢": {
			"jp": "枢",
			"zht": "樞",
			"zhs": "枢"
		},
		"枪": {
			"jp": "槍",
			"zht": "槍",
			"zhs": "枪"
		},
		"查": {
			"jp": "査",
			"zht": "查",
			"zhs": "查"
		},
		"荣": {
			"jp": "栄",
			"zht": "榮",
			"zhs": "荣"
		},
		"标": {
			"jp": "標",
			"zht": "標",
			"zhs": "标"
		},
		"栈": {
			"jp": "桟",
			"zht": "棧",
			"zhs": "栈"
		},
		"栋": {
			"jp": "棟",
			"zht": "棟",
			"zhs": "栋"
		},
		"栏": {
			"jp": "欄",
			"zht": "欄",
			"zhs": "栏"
		},
		"树": {
			"jp": "樹",
			"zht": "樹",
			"zhs": "树"
		},
		"样": {
			"jp": "様",
			"zht": "樣",
			"zhs": "样"
		},
		"樱": {
			"jp": "桜",
			"zht": "櫻",
			"zhs": "樱"
		},
		"桥": {
			"jp": "橋",
			"zht": "橋",
			"zhs": "桥"
		},
		"检": {
			"jp": "検",
			"zht": "檢",
			"zhs": "检"
		},
		"楼": {
			"jp": "楼",
			"zht": "樓",
			"zhs": "楼"
		},
		"欢": {
			"jp": "歓",
			"zht": "歡",
			"zhs": "欢"
		},
		"欧": {
			"jp": "欧",
			"zht": "歐",
			"zhs": "欧"
		},
		"步": {
			"jp": "歩",
			"zht": "步",
			"zhs": "步"
		},
		"齿": {
			"jp": "歯",
			"zht": "齒",
			"zhs": "齿"
		},
		"残": {
			"jp": "残",
			"zht": "殘",
			"zhs": "残"
		},
		"殴": {
			"jp": "殴",
			"zht": "毆",
			"zhs": "殴"
		},
		"气": {
			"jp": "気",
			"zht": "氣",
			"zhs": "气"
		},
		"汉": {
			"jp": "漢",
			"zht": "漢",
			"zhs": "汉"
		},
		"汤": {
			"jp": "湯",
			"zht": "湯",
			"zhs": "汤"
		},
		"沟": {
			"jp": "溝",
			"zht": "溝",
			"zhs": "沟"
		},
		"泽": {
			"jp": "沢",
			"zht": "澤",
			"zhs": "泽"
		},
		"泪": {
			"jp": "涙",
			"zht": "淚",
			"zhs": "泪"
		},
		"泷": {
			"jp": "滝",
			"zht": "瀧",
			"zhs": "泷"
		},
		"洁": {
			"jp": "潔",
			"zht": "潔",
			"zhs": "洁"
		},
		"浅": {
			"jp": "浅",
			"zht": "淺",
			"zhs": "浅"
		},
		"浊": {
			"jp": "濁",
			"zht": "濁",
			"zhs": "浊"
		},
		"测": {
			"jp": "測",
			"zht": "測",
			"zhs": "测"
		},
		"济": {
			"jp": "済",
			"zht": "濟",
			"zhs": "济"
		},
		"浓": {
			"jp": "濃",
			"zht": "濃",
			"zhs": "浓"
		},
		"滨": {
			"jp": "浜",
			"zht": "濱",
			"zhs": "滨"
		},
		"涉": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涉"
		},
		"涩": {
			"jp": "渋",
			"zht": "涉",
			"zhs": "涩"
		},
		"涡": {
			"jp": "渦",
			"zht": "渦",
			"zhs": "涡"
		},
		"润": {
			"jp": "潤",
			"zht": "潤",
			"zhs": "润"
		},
		"渍": {
			"jp": "漬",
			"zht": "漬",
			"zhs": "渍"
		},
		"渐": {
			"jp": "漸",
			"zht": "漸",
			"zhs": "渐"
		},
		"溪": {
			"jp": "渓",
			"zht": "溪",
			"zhs": "溪"
		},
		"渔": {
			"jp": "漁",
			"zht": "漁",
			"zhs": "渔"
		},
		"湾": {
			"jp": "湾",
			"zht": "灣",
			"zhs": "湾"
		},
		"湿": {
			"jp": "湿",
			"zht": "濕",
			"zhs": "湿"
		},
		"满": {
			"jp": "満",
			"zht": "滿",
			"zhs": "满"
		},
		"灭": {
			"jp": "滅",
			"zht": "滅",
			"zhs": "灭"
		},
		"滞": {
			"jp": "滞",
			"zht": "滯",
			"zhs": "滞"
		},
		"滥": {
			"jp": "濫",
			"zht": "濫",
			"zhs": "滥"
		},
		"濑": {
			"jp": "瀬",
			"zht": "瀨",
			"zhs": "濑"
		},
		"灯": {
			"jp": "灯",
			"zht": "燈",
			"zhs": "灯"
		},
		"灵": {
			"jp": "霊",
			"zht": "靈",
			"zhs": "灵"
		},
		"炉": {
			"jp": "炉",
			"zht": "爐",
			"zhs": "炉"
		},
		"点": {
			"jp": "点",
			"zht": "點",
			"zhs": "点"
		},
		"炼": {
			"jp": "錬",
			"zht": "鍊",
			"zhs": "炼"
		},
		"练": {
			"jp": "練",
			"zht": "練",
			"zhs": "练"
		},
		"烟": {
			"jp": "煙",
			"zht": "煙",
			"zhs": "烟"
		},
		"烦": {
			"jp": "煩",
			"zht": "煩",
			"zhs": "烦"
		},
		"烧": {
			"jp": "焼",
			"zht": "燒",
			"zhs": "烧"
		},
		"热": {
			"jp": "熱",
			"zht": "熱",
			"zhs": "热"
		},
		"焰": {
			"jp": "焔",
			"zht": "焰",
			"zhs": "焰"
		},
		"锻": {
			"jp": "鍛",
			"zht": "鍛",
			"zhs": "锻"
		},
		"牺": {
			"jp": "犠",
			"zht": "犧",
			"zhs": "牺"
		},
		"状": {
			"jp": "状",
			"zht": "狀",
			"zhs": "状"
		},
		"犹": {
			"jp": "猶",
			"zht": "猶",
			"zhs": "犹"
		},
		"独": {
			"jp": "独",
			"zht": "獨",
			"zhs": "独"
		},
		"狭": {
			"jp": "狭",
			"zht": "狹",
			"zhs": "狭"
		},
		"狱": {
			"jp": "獄",
			"zht": "獄",
			"zhs": "狱"
		},
		"猎": {
			"jp": "猟",
			"zht": "獵",
			"zhs": "猎"
		},
		"猫": {
			"jp": "猫",
			"zht": "貓",
			"zhs": "猫"
		},
		"献": {
			"jp": "献",
			"zht": "獻",
			"zhs": "献"
		},
		"环": {
			"jp": "環",
			"zht": "環",
			"zhs": "环"
		},
		"现": {
			"jp": "現",
			"zht": "現",
			"zhs": "现"
		},
		"玺": {
			"jp": "璽",
			"zht": "璽",
			"zhs": "玺"
		},
		"电": {
			"jp": "電",
			"zht": "電",
			"zhs": "电"
		},
		"疗": {
			"jp": "療",
			"zht": "療",
			"zhs": "疗"
		},
		"监": {
			"jp": "監",
			"zht": "監",
			"zhs": "监"
		},
		"盖": {
			"jp": "蓋",
			"zht": "蓋",
			"zhs": "盖"
		},
		"盘": {
			"jp": "盤",
			"zht": "盤",
			"zhs": "盘"
		},
		"视": {
			"jp": "視",
			"zht": "視",
			"zhs": "视"
		},
		"著": {
			"jp": "着",
			"zht": "著",
			"zhs": "著"
		},
		"矫": {
			"jp": "矯",
			"zht": "矯",
			"zhs": "矫"
		},
		"矿": {
			"jp": "鉱",
			"zht": "礦",
			"zhs": "矿"
		},
		"碎": {
			"jp": "砕",
			"zht": "碎",
			"zhs": "碎"
		},
		"础": {
			"jp": "礎",
			"zht": "礎",
			"zhs": "础"
		},
		"确": {
			"jp": "確",
			"zht": "確",
			"zhs": "确"
		},
		"礼": {
			"jp": "礼",
			"zht": "禮",
			"zhs": "礼"
		},
		"祸": {
			"jp": "禍",
			"zht": "禍",
			"zhs": "祸"
		},
		"禅": {
			"jp": "禅",
			"zht": "禪",
			"zhs": "禅"
		},
		"离": {
			"jp": "離",
			"zht": "離",
			"zhs": "离"
		},
		"种": {
			"jp": "種",
			"zht": "種",
			"zhs": "种"
		},
		"积": {
			"jp": "積",
			"zht": "積",
			"zhs": "积"
		},
		"称": {
			"jp": "称",
			"zht": "稱",
			"zhs": "称"
		},
		"稻": {
			"jp": "稲",
			"zht": "稻",
			"zhs": "稻"
		},
		"稳": {
			"jp": "穏",
			"zht": "穩",
			"zhs": "稳"
		},
		"谷": {
			"jp": "穀",
			"zht": "穀",
			"zhs": "谷"
		},
		"穗": {
			"jp": "穂",
			"zht": "穗",
			"zhs": "穗"
		},
		"穷": {
			"jp": "窮",
			"zht": "窮",
			"zhs": "穷"
		},
		"窃": {
			"jp": "窃",
			"zht": "竊",
			"zhs": "窃"
		},
		"窗": {
			"jp": "窓",
			"zht": "窗",
			"zhs": "窗"
		},
		"龙": {
			"jp": "竜",
			"zht": "龍",
			"zhs": "龙"
		},
		"竞": {
			"jp": "競",
			"zht": "競",
			"zhs": "竞"
		},
		"笃": {
			"jp": "篤",
			"zht": "篤",
			"zhs": "笃"
		},
		"笔": {
			"jp": "筆",
			"zht": "筆",
			"zhs": "笔"
		},
		"筑": {
			"jp": "築",
			"zht": "築",
			"zhs": "筑"
		},
		"简": {
			"jp": "簡",
			"zht": "簡",
			"zhs": "简"
		},
		"节": {
			"jp": "節",
			"zht": "節",
			"zhs": "节"
		},
		"范": {
			"jp": "範",
			"zht": "範",
			"zhs": "范"
		},
		"类": {
			"jp": "類",
			"zht": "類",
			"zhs": "类"
		},
		"粹": {
			"jp": "粋",
			"zht": "粹",
			"zhs": "粹"
		},
		"肃": {
			"jp": "粛",
			"zht": "肅",
			"zhs": "肃"
		},
		"粮": {
			"jp": "糧",
			"zht": "糧",
			"zhs": "粮"
		},
		"纠": {
			"jp": "糾",
			"zht": "糾",
			"zhs": "纠"
		},
		"纪": {
			"jp": "紀",
			"zht": "紀",
			"zhs": "纪"
		},
		"约": {
			"jp": "約",
			"zht": "約",
			"zhs": "约"
		},
		"红": {
			"jp": "紅",
			"zht": "紅",
			"zhs": "红"
		},
		"纹": {
			"jp": "紋",
			"zht": "紋",
			"zhs": "纹"
		},
		"纳": {
			"jp": "納",
			"zht": "納",
			"zhs": "纳"
		},
		"纯": {
			"jp": "純",
			"zht": "純",
			"zhs": "纯"
		},
		"纸": {
			"jp": "紙",
			"zht": "紙",
			"zhs": "纸"
		},
		"级": {
			"jp": "級",
			"zht": "級",
			"zhs": "级"
		},
		"纷": {
			"jp": "紛",
			"zht": "紛",
			"zhs": "纷"
		},
		"纺": {
			"jp": "紡",
			"zht": "紡",
			"zhs": "纺"
		},
		"紧": {
			"jp": "緊",
			"zht": "緊",
			"zhs": "紧"
		},
		"细": {
			"jp": "細",
			"zht": "細",
			"zhs": "细"
		},
		"绅": {
			"jp": "紳",
			"zht": "紳",
			"zhs": "绅"
		},
		"绍": {
			"jp": "紹",
			"zht": "紹",
			"zhs": "绍"
		},
		"绀": {
			"jp": "紺",
			"zht": "紺",
			"zhs": "绀"
		},
		"终": {
			"jp": "終",
			"zht": "終",
			"zhs": "终"
		},
		"组": {
			"jp": "組",
			"zht": "組",
			"zhs": "组"
		},
		"经": {
			"jp": "経",
			"zht": "經",
			"zhs": "经"
		},
		"结": {
			"jp": "結",
			"zht": "結",
			"zhs": "结"
		},
		"绝": {
			"jp": "絶",
			"zht": "絕",
			"zhs": "绝"
		},
		"绞": {
			"jp": "絞",
			"zht": "絞",
			"zhs": "绞"
		},
		"络": {
			"jp": "絡",
			"zht": "絡",
			"zhs": "络"
		},
		"给": {
			"jp": "給",
			"zht": "給",
			"zhs": "给"
		},
		"统": {
			"jp": "統",
			"zht": "統",
			"zhs": "统"
		},
		"绘": {
			"jp": "絵",
			"zht": "繪",
			"zhs": "绘"
		},
		"绢": {
			"jp": "絹",
			"zht": "絹",
			"zhs": "绢"
		},
		"继": {
			"jp": "継",
			"zht": "繼",
			"zhs": "继"
		},
		"续": {
			"jp": "続",
			"zht": "續",
			"zhs": "续"
		},
		"绿": {
			"jp": "緑",
			"zht": "綠",
			"zhs": "绿"
		},
		"线": {
			"jp": "線",
			"zht": "線",
			"zhs": "线"
		},
		"维": {
			"jp": "維",
			"zht": "維",
			"zhs": "维"
		},
		"纲": {
			"jp": "綱",
			"zht": "綱",
			"zhs": "纲"
		},
		"绵": {
			"jp": "綿",
			"zht": "綿",
			"zhs": "绵"
		},
		"绪": {
			"jp": "緒",
			"zht": "緒",
			"zhs": "绪"
		},
		"缔": {
			"jp": "締",
			"zht": "締",
			"zhs": "缔"
		},
		"缘": {
			"jp": "縁",
			"zht": "緣",
			"zhs": "缘"
		},
		"编": {
			"jp": "編",
			"zht": "編",
			"zhs": "编"
		},
		"缓": {
			"jp": "緩",
			"zht": "緩",
			"zhs": "缓"
		},
		"纬": {
			"jp": "緯",
			"zht": "緯",
			"zhs": "纬"
		},
		"绳": {
			"jp": "縄",
			"zht": "繩",
			"zhs": "绳"
		},
		"缚": {
			"jp": "縛",
			"zht": "縛",
			"zhs": "缚"
		},
		"纵": {
			"jp": "縦",
			"zht": "縱",
			"zhs": "纵"
		},
		"缝": {
			"jp": "縫",
			"zht": "縫",
			"zhs": "缝"
		},
		"缩": {
			"jp": "縮",
			"zht": "縮",
			"zhs": "缩"
		},
		"纤": {
			"jp": "繊",
			"zht": "纖",
			"zhs": "纤"
		},
		"绩": {
			"jp": "績",
			"zht": "績",
			"zhs": "绩"
		},
		"织": {
			"jp": "織",
			"zht": "織",
			"zhs": "织"
		},
		"缮": {
			"jp": "繕",
			"zht": "繕",
			"zhs": "缮"
		},
		"茧": {
			"jp": "繭",
			"zht": "繭",
			"zhs": "茧"
		},
		"缲": {
			"jp": "繰",
			"zht": "繰",
			"zhs": "缲"
		},
		"罐": {
			"jp": "缶",
			"zht": "罐",
			"zhs": "罐"
		},
		"钵": {
			"jp": "鉢",
			"zht": "鉢",
			"zhs": "钵"
		},
		"罗": {
			"jp": "羅",
			"zht": "羅",
			"zhs": "罗"
		},
		"罚": {
			"jp": "罸",
			"zht": "罰",
			"zhs": "罚"
		},
		"罢": {
			"jp": "罷",
			"zht": "罷",
			"zhs": "罢"
		},
		"骂": {
			"jp": "罵",
			"zht": "罵",
			"zhs": "骂"
		},
		"职": {
			"jp": "職",
			"zht": "職",
			"zhs": "职"
		},
		"闻": {
			"jp": "聞",
			"zht": "聞",
			"zhs": "闻"
		},
		"聪": {
			"jp": "聡",
			"zht": "聰",
			"zhs": "聪"
		},
		"肠": {
			"jp": "腸",
			"zht": "腸",
			"zhs": "肠"
		},
		"肤": {
			"jp": "膚",
			"zht": "膚",
			"zhs": "肤"
		},
		"胀": {
			"jp": "脹",
			"zht": "脹",
			"zhs": "胀"
		},
		"胁": {
			"jp": "脅",
			"zht": "脅",
			"zhs": "胁"
		},
		"胆": {
			"jp": "胆",
			"zht": "膽",
			"zhs": "胆"
		},
		"脏": {
			"jp": "臓",
			"zht": "臟",
			"zhs": "脏"
		},
		"脑": {
			"jp": "脳",
			"zht": "腦",
			"zhs": "脑"
		},
		"脚": {
			"jp": "脚",
			"zht": "腳",
			"zhs": "脚"
		},
		"腾": {
			"jp": "騰",
			"zht": "騰",
			"zhs": "腾"
		},
		"铺": {
			"jp": "舗",
			"zht": "舖",
			"zhs": "铺"
		},
		"馆": {
			"jp": "館",
			"zht": "館",
			"zhs": "馆"
		},
		"舰": {
			"jp": "艦",
			"zht": "艦",
			"zhs": "舰"
		},
		"艺": {
			"jp": "芸",
			"zht": "藝",
			"zhs": "艺"
		},
		"茎": {
			"jp": "茎",
			"zht": "莖",
			"zhs": "茎"
		},
		"荐": {
			"jp": "薦",
			"zht": "薦",
			"zhs": "荐"
		},
		"药": {
			"jp": "薬",
			"zht": "藥",
			"zhs": "药"
		},
		"萤": {
			"jp": "蛍",
			"zht": "螢",
			"zhs": "萤"
		},
		"蒋": {
			"jp": "蒋",
			"zht": "蔣",
			"zhs": "蒋"
		},
		"藏": {
			"jp": "蔵",
			"zht": "藏",
			"zhs": "藏"
		},
		"虏": {
			"jp": "虜",
			"zht": "虜",
			"zhs": "虏"
		},
		"虚": {
			"jp": "虚",
			"zht": "虛",
			"zhs": "虚"
		},
		"虫": {
			"jp": "虫",
			"zht": "蟲",
			"zhs": "虫"
		},
		"蚀": {
			"jp": "蝕",
			"zht": "蝕",
			"zhs": "蚀"
		},
		"蚕": {
			"jp": "蚕",
			"zht": "蠶",
			"zhs": "蚕"
		},
		"蛮": {
			"jp": "蛮",
			"zht": "蠻",
			"zhs": "蛮"
		},
		"补": {
			"jp": "補",
			"zht": "補",
			"zhs": "补"
		},
		"袭": {
			"jp": "襲",
			"zht": "襲",
			"zhs": "袭"
		},
		"装": {
			"jp": "装",
			"zht": "裝",
			"zhs": "装"
		},
		"里": {
			"jp": "裏",
			"zht": "裡",
			"zhs": "里"
		},
		"霸": {
			"jp": "覇",
			"zht": "霸",
			"zhs": "霸"
		},
		"见": {
			"jp": "見",
			"zht": "見",
			"zhs": "见"
		},
		"观": {
			"jp": "観",
			"zht": "觀",
			"zhs": "观"
		},
		"规": {
			"jp": "規",
			"zht": "規",
			"zhs": "规"
		},
		"觉": {
			"jp": "覚",
			"zht": "覺",
			"zhs": "觉"
		},
		"览": {
			"jp": "覧",
			"zht": "覽",
			"zhs": "览"
		},
		"触": {
			"jp": "触",
			"zht": "觸",
			"zhs": "触"
		},
		"订": {
			"jp": "訂",
			"zht": "訂",
			"zhs": "订"
		},
		"计": {
			"jp": "計",
			"zht": "計",
			"zhs": "计"
		},
		"讨": {
			"jp": "討",
			"zht": "討",
			"zhs": "讨"
		},
		"训": {
			"jp": "訓",
			"zht": "訓",
			"zhs": "训"
		},
		"记": {
			"jp": "記",
			"zht": "記",
			"zhs": "记"
		},
		"讼": {
			"jp": "訟",
			"zht": "訟",
			"zhs": "讼"
		},
		"访": {
			"jp": "訪",
			"zht": "訪",
			"zhs": "访"
		},
		"设": {
			"jp": "設",
			"zht": "設",
			"zhs": "设"
		},
		"许": {
			"jp": "許",
			"zht": "許",
			"zhs": "许"
		},
		"译": {
			"jp": "訳",
			"zht": "譯",
			"zhs": "译"
		},
		"诉": {
			"jp": "訴",
			"zht": "訴",
			"zhs": "诉"
		},
		"诊": {
			"jp": "診",
			"zht": "診",
			"zhs": "诊"
		},
		"证": {
			"jp": "証",
			"zht": "證",
			"zhs": "证"
		},
		"诈": {
			"jp": "詐",
			"zht": "詐",
			"zhs": "诈"
		},
		"诏": {
			"jp": "詔",
			"zht": "詔",
			"zhs": "诏"
		},
		"评": {
			"jp": "評",
			"zht": "評",
			"zhs": "评"
		},
		"诅": {
			"jp": "詛",
			"zht": "詛",
			"zhs": "诅"
		},
		"词": {
			"jp": "詞",
			"zht": "詞",
			"zhs": "词"
		},
		"试": {
			"jp": "試",
			"zht": "試",
			"zhs": "试"
		},
		"诗": {
			"jp": "詩",
			"zht": "詩",
			"zhs": "诗"
		},
		"诘": {
			"jp": "詰",
			"zht": "詰",
			"zhs": "诘"
		},
		"该": {
			"jp": "該",
			"zht": "該",
			"zhs": "该"
		},
		"详": {
			"jp": "詳",
			"zht": "詳",
			"zhs": "详"
		},
		"誉": {
			"jp": "誉",
			"zht": "譽",
			"zhs": "誉"
		},
		"誊": {
			"jp": "謄",
			"zht": "謄",
			"zhs": "誊"
		},
		"认": {
			"jp": "認",
			"zht": "認",
			"zhs": "认"
		},
		"诞": {
			"jp": "誕",
			"zht": "誕",
			"zhs": "诞"
		},
		"诱": {
			"jp": "誘",
			"zht": "誘",
			"zhs": "诱"
		},
		"语": {
			"jp": "語",
			"zht": "語",
			"zhs": "语"
		},
		"诚": {
			"jp": "誠",
			"zht": "誠",
			"zhs": "诚"
		},
		"误": {
			"jp": "誤",
			"zht": "誤",
			"zhs": "误"
		},
		"说": {
			"jp": "説",
			"zht": "說",
			"zhs": "说"
		},
		"读": {
			"jp": "読",
			"zht": "讀",
			"zhs": "读"
		},
		"谁": {
			"jp": "誰",
			"zht": "誰",
			"zhs": "谁"
		},
		"课": {
			"jp": "課",
			"zht": "課",
			"zhs": "课"
		},
		"调": {
			"jp": "調",
			"zht": "調",
			"zhs": "调"
		},
		"谈": {
			"jp": "談",
			"zht": "談",
			"zhs": "谈"
		},
		"请": {
			"jp": "請",
			"zht": "請",
			"zhs": "请"
		},
		"论": {
			"jp": "論",
			"zht": "論",
			"zhs": "论"
		},
		"谕": {
			"jp": "諭",
			"zht": "諭",
			"zhs": "谕"
		},
		"诸": {
			"jp": "諸",
			"zht": "諸",
			"zhs": "诸"
		},
		"诺": {
			"jp": "諾",
			"zht": "諾",
			"zhs": "诺"
		},
		"谋": {
			"jp": "謀",
			"zht": "謀",
			"zhs": "谋"
		},
		"谒": {
			"jp": "謁",
			"zht": "謁",
			"zhs": "谒"
		},
		"谜": {
			"jp": "謎",
			"zht": "謎",
			"zhs": "谜"
		},
		"谦": {
			"jp": "謙",
			"zht": "謙",
			"zhs": "谦"
		},
		"讲": {
			"jp": "講",
			"zht": "講",
			"zhs": "讲"
		},
		"谢": {
			"jp": "謝",
			"zht": "謝",
			"zhs": "谢"
		},
		"谣": {
			"jp": "謡",
			"zht": "謠",
			"zhs": "谣"
		},
		"谨": {
			"jp": "謹",
			"zht": "謹",
			"zhs": "谨"
		},
		"识": {
			"jp": "識",
			"zht": "識",
			"zhs": "识"
		},
		"谱": {
			"jp": "譜",
			"zht": "譜",
			"zhs": "谱"
		},
		"议": {
			"jp": "議",
			"zht": "議",
			"zhs": "议"
		},
		"让": {
			"jp": "譲",
			"zht": "讓",
			"zhs": "让"
		},
		"贝": {
			"jp": "貝",
			"zht": "貝",
			"zhs": "贝"
		},
		"贞": {
			"jp": "貞",
			"zht": "貞",
			"zhs": "贞"
		},
		"负": {
			"jp": "負",
			"zht": "負",
			"zhs": "负"
		},
		"财": {
			"jp": "財",
			"zht": "財",
			"zhs": "财"
		},
		"贡": {
			"jp": "貢",
			"zht": "貢",
			"zhs": "贡"
		},
		"贫": {
			"jp": "貧",
			"zht": "貧",
			"zhs": "贫"
		},
		"货": {
			"jp": "貨",
			"zht": "貨",
			"zhs": "货"
		},
		"贩": {
			"jp": "販",
			"zht": "販",
			"zhs": "贩"
		},
		"贪": {
			"jp": "貪",
			"zht": "貪",
			"zhs": "贪"
		},
		"责": {
			"jp": "責",
			"zht": "責",
			"zhs": "责"
		},
		"贮": {
			"jp": "貯",
			"zht": "貯",
			"zhs": "贮"
		},
		"贵": {
			"jp": "貴",
			"zht": "貴",
			"zhs": "贵"
		},
		"贷": {
			"jp": "貸",
			"zht": "貸",
			"zhs": "贷"
		},
		"费": {
			"jp": "費",
			"zht": "費",
			"zhs": "费"
		},
		"贸": {
			"jp": "貿",
			"zht": "貿",
			"zhs": "贸"
		},
		"贺": {
			"jp": "賀",
			"zht": "賀",
			"zhs": "贺"
		},
		"赁": {
			"jp": "賃",
			"zht": "賃",
			"zhs": "赁"
		},
		"贿": {
			"jp": "賄",
			"zht": "賄",
			"zhs": "贿"
		},
		"资": {
			"jp": "資",
			"zht": "資",
			"zhs": "资"
		},
		"贼": {
			"jp": "賊",
			"zht": "賊",
			"zhs": "贼"
		},
		"贱": {
			"jp": "賎",
			"zht": "賤",
			"zhs": "贱"
		},
		"赞": {
			"jp": "賛",
			"zht": "贊",
			"zhs": "赞"
		},
		"赐": {
			"jp": "賜",
			"zht": "賜",
			"zhs": "赐"
		},
		"赏": {
			"jp": "賞",
			"zht": "賞",
			"zhs": "赏"
		},
		"赔": {
			"jp": "賠",
			"zht": "賠",
			"zhs": "赔"
		},
		"贤": {
			"jp": "賢",
			"zht": "賢",
			"zhs": "贤"
		},
		"赋": {
			"jp": "賦",
			"zht": "賦",
			"zhs": "赋"
		},
		"质": {
			"jp": "質",
			"zht": "質",
			"zhs": "质"
		},
		"赖": {
			"jp": "頼",
			"zht": "賴",
			"zhs": "赖"
		},
		"赠": {
			"jp": "贈",
			"zht": "贈",
			"zhs": "赠"
		},
		"赃": {
			"jp": "贓",
			"zht": "贓",
			"zhs": "赃"
		},
		"跃": {
			"jp": "躍",
			"zht": "躍",
			"zhs": "跃"
		},
		"践": {
			"jp": "践",
			"zht": "踐",
			"zhs": "践"
		},
		"踪": {
			"jp": "踪",
			"zht": "蹤",
			"zhs": "踪"
		},
		"车": {
			"jp": "車",
			"zht": "車",
			"zhs": "车"
		},
		"轨": {
			"jp": "軌",
			"zht": "軌",
			"zhs": "轨"
		},
		"轩": {
			"jp": "軒",
			"zht": "軒",
			"zhs": "轩"
		},
		"软": {
			"jp": "軟",
			"zht": "軟",
			"zhs": "软"
		},
		"转": {
			"jp": "転",
			"zht": "轉",
			"zhs": "转"
		},
		"轴": {
			"jp": "軸",
			"zht": "軸",
			"zhs": "轴"
		},
		"轻": {
			"jp": "軽",
			"zht": "輕",
			"zhs": "轻"
		},
		"较": {
			"jp": "較",
			"zht": "較",
			"zhs": "较"
		},
		"载": {
			"jp": "載",
			"zht": "載",
			"zhs": "载"
		},
		"辉": {
			"jp": "輝",
			"zht": "輝",
			"zhs": "辉"
		},
		"辈": {
			"jp": "輩",
			"zht": "輩",
			"zhs": "辈"
		},
		"轮": {
			"jp": "輪",
			"zht": "輪",
			"zhs": "轮"
		},
		"输": {
			"jp": "輸",
			"zht": "輸",
			"zhs": "输"
		},
		"辖": {
			"jp": "轄",
			"zht": "轄",
			"zhs": "辖"
		},
		"辞": {
			"jp": "辞",
			"zht": "辭",
			"zhs": "辞"
		},
		"边": {
			"jp": "辺",
			"zht": "邊",
			"zhs": "边"
		},
		"达": {
			"jp": "達",
			"zht": "達",
			"zhs": "达"
		},
		"迁": {
			"jp": "遷",
			"zht": "遷",
			"zhs": "迁"
		},
		"过": {
			"jp": "過",
			"zht": "過",
			"zhs": "过"
		},
		"运": {
			"jp": "運",
			"zht": "運",
			"zhs": "运"
		},
		"还": {
			"jp": "還",
			"zht": "還",
			"zhs": "还"
		},
		"进": {
			"jp": "進",
			"zht": "進",
			"zhs": "进"
		},
		"远": {
			"jp": "遠",
			"zht": "遠",
			"zhs": "远"
		},
		"违": {
			"jp": "違",
			"zht": "違",
			"zhs": "违"
		},
		"连": {
			"jp": "連",
			"zht": "連",
			"zhs": "连"
		},
		"迟": {
			"jp": "遅",
			"zht": "遲",
			"zhs": "迟"
		},
		"适": {
			"jp": "適",
			"zht": "適",
			"zhs": "适"
		},
		"选": {
			"jp": "選",
			"zht": "選",
			"zhs": "选"
		},
		"递": {
			"jp": "逓",
			"zht": "遞",
			"zhs": "递"
		},
		"遗": {
			"jp": "遺",
			"zht": "遺",
			"zhs": "遗"
		},
		"遥": {
			"jp": "遥",
			"zht": "遙",
			"zhs": "遥"
		},
		"邮": {
			"jp": "郵",
			"zht": "郵",
			"zhs": "邮"
		},
		"邻": {
			"jp": "隣",
			"zht": "鄰",
			"zhs": "邻"
		},
		"醉": {
			"jp": "酔",
			"zht": "醉",
			"zhs": "醉"
		},
		"酿": {
			"jp": "醸",
			"zht": "釀",
			"zhs": "酿"
		},
		"释": {
			"jp": "釈",
			"zht": "釋",
			"zhs": "释"
		},
		"针": {
			"jp": "針",
			"zht": "針",
			"zhs": "针"
		},
		"钓": {
			"jp": "釣",
			"zht": "釣",
			"zhs": "钓"
		},
		"钝": {
			"jp": "鈍",
			"zht": "鈍",
			"zhs": "钝"
		},
		"铃": {
			"jp": "鈴",
			"zht": "鈴",
			"zhs": "铃"
		},
		"铁": {
			"jp": "鉄",
			"zht": "鐵",
			"zhs": "铁"
		},
		"铅": {
			"jp": "鉛",
			"zht": "鉛",
			"zhs": "铅"
		},
		"鉴": {
			"jp": "鑑",
			"zht": "鑑",
			"zhs": "鉴"
		},
		"银": {
			"jp": "銀",
			"zht": "銀",
			"zhs": "银"
		},
		"铳": {
			"jp": "銃",
			"zht": "銃",
			"zhs": "铳"
		},
		"铜": {
			"jp": "銅",
			"zht": "銅",
			"zhs": "铜"
		},
		"铣": {
			"jp": "銑",
			"zht": "銑",
			"zhs": "铣"
		},
		"铭": {
			"jp": "銘",
			"zht": "銘",
			"zhs": "铭"
		},
		"钱": {
			"jp": "銭",
			"zht": "錢",
			"zhs": "钱"
		},
		"锐": {
			"jp": "鋭",
			"zht": "鋭",
			"zhs": "锐"
		},
		"铸": {
			"jp": "鋳",
			"zht": "鑄",
			"zhs": "铸"
		},
		"钢": {
			"jp": "鋼",
			"zht": "鋼",
			"zhs": "钢"
		},
		"锤": {
			"jp": "錘",
			"zht": "錘",
			"zhs": "锤"
		},
		"锭": {
			"jp": "錠",
			"zht": "錠",
			"zhs": "锭"
		},
		"错": {
			"jp": "錯",
			"zht": "錯",
			"zhs": "错"
		},
		"钟": {
			"jp": "鍾",
			"zht": "鍾",
			"zhs": "钟"
		},
		"锁": {
			"jp": "鎖",
			"zht": "鎖",
			"zhs": "锁"
		},
		"镇": {
			"jp": "鎮",
			"zht": "鎮",
			"zhs": "镇"
		},
		"镜": {
			"jp": "鏡",
			"zht": "鏡",
			"zhs": "镜"
		},
		"长": {
			"jp": "長",
			"zht": "長",
			"zhs": "长"
		},
		"门": {
			"jp": "門",
			"zht": "門",
			"zhs": "门"
		},
		"闭": {
			"jp": "閉",
			"zht": "閉",
			"zhs": "闭"
		},
		"闲": {
			"jp": "閑",
			"zht": "閒",
			"zhs": "闲"
		},
		"间": {
			"jp": "間",
			"zht": "間",
			"zhs": "间"
		},
		"阁": {
			"jp": "閣",
			"zht": "閣",
			"zhs": "阁"
		},
		"阀": {
			"jp": "閥",
			"zht": "閥",
			"zhs": "阀"
		},
		"阅": {
			"jp": "閲",
			"zht": "閲",
			"zhs": "阅"
		},
		"队": {
			"jp": "隊",
			"zht": "隊",
			"zhs": "队"
		},
		"阳": {
			"jp": "陽",
			"zht": "陽",
			"zhs": "阳"
		},
		"阴": {
			"jp": "陰",
			"zht": "陰",
			"zhs": "阴"
		},
		"阵": {
			"jp": "陣",
			"zht": "陣",
			"zhs": "阵"
		},
		"阶": {
			"jp": "階",
			"zht": "階",
			"zhs": "阶"
		},
		"际": {
			"jp": "際",
			"zht": "際",
			"zhs": "际"
		},
		"陆": {
			"jp": "陸",
			"zht": "陸",
			"zhs": "陆"
		},
		"陈": {
			"jp": "陳",
			"zht": "陳",
			"zhs": "陈"
		},
		"陷": {
			"jp": "陥",
			"zht": "陷",
			"zhs": "陷"
		},
		"随": {
			"jp": "随",
			"zht": "隨",
			"zhs": "随"
		},
		"隐": {
			"jp": "隠",
			"zht": "隱",
			"zhs": "隐"
		},
		"隶": {
			"jp": "隷",
			"zht": "隸",
			"zhs": "隶"
		},
		"难": {
			"jp": "難",
			"zht": "難",
			"zhs": "难"
		},
		"雾": {
			"jp": "霧",
			"zht": "霧",
			"zhs": "雾"
		},
		"静": {
			"jp": "静",
			"zht": "靜",
			"zhs": "静"
		},
		"顶": {
			"jp": "頂",
			"zht": "頂",
			"zhs": "顶"
		},
		"项": {
			"jp": "項",
			"zht": "項",
			"zhs": "项"
		},
		"顺": {
			"jp": "順",
			"zht": "順",
			"zhs": "顺"
		},
		"顽": {
			"jp": "頑",
			"zht": "頑",
			"zhs": "顽"
		},
		"颁": {
			"jp": "頒",
			"zht": "頒",
			"zhs": "颁"
		},
		"领": {
			"jp": "領",
			"zht": "領",
			"zhs": "领"
		},
		"频": {
			"jp": "頻",
			"zht": "頻",
			"zhs": "频"
		},
		"题": {
			"jp": "題",
			"zht": "題",
			"zhs": "题"
		},
		"额": {
			"jp": "額",
			"zht": "額",
			"zhs": "额"
		},
		"颜": {
			"jp": "顔",
			"zht": "顏",
			"zhs": "颜"
		},
		"风": {
			"jp": "風",
			"zht": "風",
			"zhs": "风"
		},
		"飞": {
			"jp": "飛",
			"zht": "飛",
			"zhs": "飞"
		},
		"饥": {
			"jp": "飢",
			"zht": "饑",
			"zhs": "饥"
		},
		"饭": {
			"jp": "飯",
			"zht": "飯",
			"zhs": "饭"
		},
		"饮": {
			"jp": "飲",
			"zht": "飲",
			"zhs": "饮"
		},
		"饲": {
			"jp": "飼",
			"zht": "飼",
			"zhs": "饲"
		},
		"饱": {
			"jp": "飽",
			"zht": "飽",
			"zhs": "饱"
		},
		"饰": {
			"jp": "飾",
			"zht": "飾",
			"zhs": "饰"
		},
		"饿": {
			"jp": "餓",
			"zht": "餓",
			"zhs": "饿"
		},
		"马": {
			"jp": "馬",
			"zht": "馬",
			"zhs": "马"
		},
		"驿": {
			"jp": "駅",
			"zht": "驛",
			"zhs": "驿"
		},
		"驱": {
			"jp": "駆",
			"zht": "驅",
			"zhs": "驱"
		},
		"驻": {
			"jp": "駐",
			"zht": "駐",
			"zhs": "驻"
		},
		"骑": {
			"jp": "騎",
			"zht": "騎",
			"zhs": "骑"
		},
		"验": {
			"jp": "験",
			"zht": "驗",
			"zhs": "验"
		},
		"骚": {
			"jp": "騒",
			"zht": "騷",
			"zhs": "骚"
		},
		"驔": {
			"jp": "騨",
			"zht": "驔",
			"zhs": "驔"
		},
		"髓": {
			"jp": "髄",
			"zht": "髓",
			"zhs": "髓"
		},
		"鱼": {
			"jp": "魚",
			"zht": "魚",
			"zhs": "鱼"
		},
		"鲁": {
			"jp": "魯",
			"zht": "魯",
			"zhs": "鲁"
		},
		"鲜": {
			"jp": "鮮",
			"zht": "鮮",
			"zhs": "鲜"
		},
		"鲸": {
			"jp": "鯨",
			"zht": "鯨",
			"zhs": "鲸"
		},
		"鸟": {
			"jp": "鳥",
			"zht": "鳥",
			"zhs": "鸟"
		},
		"鸣": {
			"jp": "鳴",
			"zht": "鳴",
			"zhs": "鸣"
		},
		"麦": {
			"jp": "麦",
			"zht": "麥",
			"zhs": "麦"
		},
		"黄": {
			"jp": "黄",
			"zht": "黃",
			"zhs": "黄"
		},
		"黑": {
			"jp": "黒",
			"zht": "黑",
			"zhs": "黑"
		},
		"默": {
			"jp": "黙",
			"zht": "默",
			"zhs": "默"
		},
		"龄": {
			"jp": "齢",
			"zht": "齡",
			"zhs": "龄"
		}
	}
};

